import React from 'react'

import { EsDescription, EnDescription } from './termsAndCond'

export default {
	options: {
		suppress_warnings: true
	},
	es: {
		'tour-step-0':
			'Sus instrucciones de desafío se encontrarán aquí. Revisa cuidadosamente las instrucciones cuando comiences.',
		'tour-step-1':
			'Esta es la sección de Visión General. En esta sección, podrá acceder al desafío mismo y a los recursos que se le proporcionan.',
		'tour-step-2':
			'Este es un icono de soporte. Haga clic aquí para leer más sobre cómo completar el desafío.',
		'tour-step-3':
			'Este es tu lienzo. Hay cuatro contenedores que le piden que identifique el problema, recopile información, haga una lluvia de ideas y recomiende una solución.',
		'tour-step-4':
			'Estás siendo evaluado sobre qué tan bien entiendes el desafío y los recursos. Resalte texto y arrástrelo a la sección.',
		'tour-step-5':
			'Coloque el texto en la sección de destino. "Recopilar información" se trata de mostrarnos que comprende el desafío y los conceptos clave de los recursos.',
		'tour-step-6':
			'La evaluación está siendo cronometrada, así que tenga cuidado de no correr el tiempo. Una vez que haya terminado, presione el botón Finalizar para enviar sus resultados.',
		'start-test-title': '¿Seguro que quieres empezar?',
		'start-test-content':
			'Asegúrese de que el navegador esté abierto a pantalla completa y no cierre la pestaña o tendrá que reiniciar. ¡Buena suerte!',
		start: 'Comenzar',
		'show-me-again-u': '¡Muestrame de nuevo!',
		consultant: 'Consulting',
		next: 'Siguiente',
		prev: 'Anterior',
		finish: 'Finalizar',
		login_to_sandbox: 'LOGIN TO SANDBOX',
		'how-can-we-help': '¿Cómo podemos ayudar?',
		'how-can-we-help-explain':
			'Esta es tu guía para completar el desafío. No pierdas, el temporizador sigue funcionando!',
		application: 'Aplicación',
		other: 'Otro',
		help: 'Ayuda',
		'add-new-section': 'Añadir nueva sección',
		'identify-the-problem': 'Identificar el problema',
		'highlight-key-sentences':
			'Resalte frases clave del artículo que se destacan a usted. Es tan simple como arrastrar y soltar',
		'brainstorm-viable':
			'Haga una lluvia de ideas de ideas viables que se ajusten al alcance del problema',
		'use-your-creativity': 'Usa tu creatividad y recomienda una solución',
		problem: 'Problema',
		'collect-information-title': 'Recopilar información',
		ideas: 'Ideas',
		solution: 'Solución',
		resource: 'Recurso',
		'no-card-name': 'Sin nombre de tarjeta',
		'challenge-instructions': 'Instrucciones del desafío',
		'test-name-not-found': 'Nombre de la prueba no encontrado',
		'drop-the-text-here': 'Suelta el texto aquí',
		'type-away-what': 'Escribe... ¿qué más quiere que sepamos?',
		title: 'Titulo',
		'are-you-sure': '¿Estás seguro?',
		'content-exit-challenge':
			'Parece que estás tratando de salir del desafío. Todo tu progreso se perderá si decides hacer esto.',
		'continue-the-challenge': 'Continuar el desafío',
		'content-finish-challenge': 'Parece que estás a punto de enviar tus resultados',
		'time-up': '¡Se acabó el tiempo!',
		'hard-part-over':
			'La parte dificil ya paso. Solo siéntate y espera a que lleguen los resultados',
		'great-job-u': '¡Gran trabajo!',
		'u-finished-it': '¡Gran trabajo!',
		'sit-tight-well':
			'¡Tranquilo! Te haremos saber cuándo esten disponibles los resultados. Aquí hay algunos números para tener una idea de tus resultados.',
		'sit-tight-well-short':
			'¡Tranquilo! Te haremos saber cuándo esten disponibles los resultados.',
		'want-to-improve-ex': '¿Quieres mejorar la experiencia? Completa esto rápido',
		survey: 'Encuesta',
		minutes: 'Minutos',
		'pace-of-writing': 'Ritmo de escritura',
		'words-per-minute': 'Palabras por minuto',
		'head-start': 'Inicio',
		'how-long-takes': '¿Cuánto tiempo (en segundos) le tomo escribir la primera palabra?',
		'quick-fix': 'Solución rápida',
		'number-times-deleting':
			'Número de veces que borra dentro de los 3 segundos de escritura',
		'run-on': 'Corriendo sobre',
		'number-long-sentences': 'Número de oraciones largas de más de 30 palabras',
		'select-an-assessment': 'Seleccione una evaluación',
		'select-from-pre-built':
			'Seleccione evaluaciones pre-construidas. Nos encargaremos del contenido y las perspectivas.',
		'business-to-business-sales': 'Ventas de empresa a empresa',
		'business-to-business-sales-description':
			'Usted es un representante de ventas de empresa a empresa (B2B). Su gerente le ha informado acerca de un posible nuevo cliente, una empresa que busca desarrollar un sitio web de la empresa. Dentro de este desafío, identifique las necesidades de su nuevo cliente, recopile información de los recursos proporcionados, cree posibles opciones para su nuevo cliente y luego recomiende la mejor opción para este nuevo cliente.',
		'email-thread-between':
			'Hilo de correo electrónico entre el administrador y el cliente',
		'descriptions-services-provided':
			'Descripciones de los servicios prestados por la empresa',
		'actionablet-tips-closing': 'Consejos útiles para cerrar más ventas B2B',
		'data-science': 'Ciencia de los datos',
		'data-science-description':
			'Usted es un científico de datos que trabaja con un nuevo cliente, un negocio prometedor en la industria tecnológica con 150 empleados. El cliente acaba de terminar su primera ronda de recopilación de datos internos sobre sus empleados y sus experiencias laborales. El cliente se está acercando a usted para obtener su ayuda para darle sentido a sus datos. Quieren usar sus datos para realizar algunos cambios en sus políticas, prácticas y / o capacitación. Dentro de este desafío, identifique los problemas clave, recopile información de los datos que se compartieron con usted, haga una lluvia de ideas sobre las posibles opciones para el cliente y luego haga las recomendaciones finales al cliente.',
		'interview-findings': 'Hallazgos de la entrevista',
		'correlation-table': 'Tabla de correlación',
		'multiple-regression-table': 'Tabla de Regresión Múltiple',
		'business-strategy-proposal': 'Propuesta de estrategia empresarial',
		'business-strategy-proposal-description':
			'Usted trabaja como empleado a tiempo completo para una empresa mediana. En los últimos dos años, su compañía ha experimentado una disminución constante en las ganancias operativas. Esta disminución se debe tanto a una disminución en las ventas promedio como a un aumento en los gastos promedio. Con el deseo de aprovechar los recursos internos para ayudar con este problema, los ejecutivos de la compañía han decidido formar un equipo multifuncional con los empleados existentes seleccionados para ayudar a corregir este problema. Fuiste seleccionado para unirte a este equipo multifuncional. Como grupo, tuvo su primera reunión y acordó que antes de volver a reunirse como grupo y discutir el tema más a fondo, cada uno generará ideas individuales sobre cuál es el problema, por qué hay un problema y qué se puede hacer. para abordarlo. ¡Tu presentación es en 20 minutos!',
		'customer-client-feedback': 'Consumidor/Client Comentarios',
		'performance-management-results': 'Resultados de la gestión del rendimiento',
		'profits-chart': 'Tabla de beneficios',
		'get-started': 'Comienza',
		welcome: 'Bienvenido',
		name: 'Nombre',
		email: 'Correo',
		age: 'Edad',
		gender: 'Genero',
		male: 'Masculino',
		female: 'Femenino',
		'prefer-not-to-say': 'Prefiero no decirlo',
		continue: 'Continuar',
		'what-ethnicity-cultural-group': '¿Con qué grupo étnico/cultural te identificas?',
		caucasian: 'Caucásica',
		'latin-american': 'Latinoamericano',
		african: 'Africano',
		profile_image: 'Foto de Perfil',
		caribbean: 'Caribe',
		'middle-east': 'Medio Oriente',
		'south-asian': 'Sur de Asia (por ejemplo, indio del este, de Sri Lanka)',
		'southeast-asian': 'Sudeste asiático (por ejemplo, vietnamita, chino, filipino)',
		'west-asian': 'Asia occidental (por ejemplo, iraní, afgano)',
		aboriginal: 'Aborígenes (por ejemplo, indios norteamericanos, inuit)',
		mixed: 'Mezclado',
		'what-is-your-marital': 'Cuál es tu estado civil?',
		'how-do-you-want-to-create': '¿Cómo quieres crear?',
		'pre-built-assessment': 'Evaluación Pre Construida',
		'create-your-own': 'Crealo tu mismo',
		'please-select-role-type': 'Por favor seleccione el tipo de rol!',
		'please-select-position-type': 'Por favor seleccione el tipo de posición!',
		'what-are-you-hiring-for': '¿Para qué estás contratando?',
		'help-us-define-your-role':
			'Ayúdenos a definir su rol para que podamos sugerir la mejor evaluación',
		'role-type': 'Tipo de rol',
		none: 'Ninguno',
		marketing: 'Márketing',
		'customer-service': 'Servicio al cliente',
		sales: 'Ventas',
		'product-management': 'Gestión de producto',
		'business-management': 'Administración de Empresas',
		'business-strategy': 'Estrategia de negocios',
		'position-type': 'Tipo de Posición',
		'co-op-internship': 'Cooperativa/Pasantía',
		'entry-level': 'Nivel de entrada',
		'junior-manager': 'Gerente Junior',
		'middle-manager': 'Gerente de nivel medio',
		'add-the-keywords': 'Añadir las palabras clave',
		cancel: 'Cancelar',
		'please-select-the-assessment': 'Por favor seleccione la evaluación!',
		'create-your-benchmark': 'Crea tu punto de referencia',
		'create-a-benchmark-by-sending':
			'Cree un punto de referencia enviando la evaluación a los empleados con mejor desempeño primero',
		'share-the-link-below': 'Comparte el siguiente enlace',
		launch: 'Lanzar',
		'create-challenge': 'Crear desafío',
		search: 'Buscar',
		'example-challenge': 'Ejemplo de desafío',
		'single-never-married': 'Soltero nunca casado',
		widowed: 'Viudo/Viuda',
		separated: 'Separado',
		divorced: 'Divorciado',
		married: 'Casado/Casada',
		'living-common-law': 'Conviviendo',
		'what-is-the-highest-degree':
			'¿Cuál es el grado o nivel más alto de escuelas que tienes?',
		'less-than-high-school-diploma': 'Menos de diploma de escuela secundaria',
		'high-school-degree-or-equivalent':
			'Título de escuela secundaria o equivalente (por ejemplo, GED)',
		'some-scollege-no-degree': 'Alguna universidad, sin título',
		'associate-degree': 'Grado asociado (por ejemplo, AA, AS)',
		'bachelors-degree': 'Licenciatura (por ejemplo, BA, BS)',
		'masters-degree': 'Maestría (por ejemplo, MA, MS)',
		'professional-degree': 'Título profesional (por ejemplo, MD, DDS)',
		doctorate: 'Doctorado (por ejemplo, PhD, EdD)',
		'what-is-your-current-employment-status': '¿Cuál es su situación laboral actual?',
		'employed-full-time-40': 'Empleado a tiempo completo (40 o más horas por semana)',
		'employed-part-time-39': 'Empleado a tiempo parcial (hasta 39 horas por semana)',
		'unemployed-and-currently-looking': 'Desempleado y actualmente en busca de trabajo.',
		'Unemployed-and-currently-not-looking': 'Desempleado y actualmente no busca trabajo.',
		student: 'Estudiante',
		retired: 'Retirado',
		'self-employed': 'Por cuenta propia',
		'unable-to-work': 'Incapaz de trabajar',
		'to-tutorial': 'con el Tutorial',
		'please-do-not-take-this-assessment-on-phone':
			'Por favor no haga esta evaluación en su teléfono',
		company: 'Compañia',
		'company-would-like':
			'Me gustaría ver si encaja bien con su equipo. Para esto, se le pide que complete este desafío que debe usar y su resolución en 4 pasos.',
		'company-to-prepare':
			'Para prepararte para el desafío, se te presentará un tutorial que te guiará a través de la interfaz. Le recomendamos que lea nuestros consejos.',
		'company-following-tutorial':
			'Siguiendo este tutorial, tienes {n} minutos para completar el desafío. ¡Buena suerte!',
		'assess-learn-evolve': 'Evaluar. Aprender. Evolucionar',
		'discover-your-soft-skills':
			'Descubre tus habilidades debiles a través de desafíos relacionados con el rol.',
		'n-challenges-available': '{n} Desafíos disponibles',
		'search-challenge': 'Buscar Desafío',
		'hi-{name}': 'Hola {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, vas a los lugares!',
		'discover-nuggets-about-your-soft-skills':
			'Descubre los nuggets de tus habilidades debiles',
		'register-login': 'Entrar',
		'add-pipeline-label': 'Add new talent pool',
		'nugget-ai-science': 'Nugget.ai Ciencia',
		'our-prediction-models':
			'Nuestros modelos de predicción están respaldados por grados de investigación académica en Psicología de E / S.',
		'performance-nugget': 'Nugget de rendimiento',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'Marca tu enfoque y encuentra tus huecos para mejorar',
		'discover-your-path': 'Descubre tu camino',
		'keep-an-open-mind-and-try-something-new':
			'¡Mantén la mente abierta y prueba algo nuevo!',
		'compare-to': 'Comparar con',
		'growth-tips': 'Consejos de crecimiento',
		'machine-drive-advice-subtitle': 'Máquina-impulsada del 10% superior de profesionales.',
		'growth-tips-1':
			'“La atención a los detalles ha sido el factor más importante para el éxito o el fracaso en el trabajo.”',
		'growth-tips-2':
			'“La gestión de una cartera de soluciones tecnológicas donde la industria está cambiando rápidamente lo mantiene en pie en todo momento...”',
		'growth-tips-3':
			'“Blockchain tiene el potencial de interrumpir todas las industrias, tal como lo está haciendo Machine Learning ahora. La capacidad de pensar creativamente para liderar nuevos descubrimientos es fundamental para el éxito de su carrera”',
		'what-does-this-mean': '¿Qué significa esto?',
		'project-coodinator': 'Coordinador de Proyecto',
		'financial-analyst': 'Analista Financiero',
		'project-manager': 'Gerente de Proyectos',
		'blue-sky-music-proposal': 'Blue-sky Propuesta musical',
		'blue-sky-music-proposal-description':
			'Usted es un artista titular firmado con uno de los sellos discográficos que actualmente dominan la industria de la música. El sello discográfico organiza reuniones mensuales denominadas reuniones de "cielo azul" en las que se anima a los asistentes (artistas como usted) a presentar un plan detallado para una nueva canción, que puede ser de cualquier género, composición y sobre cualquier tema. Se anima a los asistentes a pensar en grande. Dentro de este desafío, identifique los componentes que le gustaría incluir en su plan, recopile información de los recursos proporcionados, genere algunas ideas para seleccionar al formular su plan y recomiende su gran idea en un plan que presentará en esta reunión',
		'blue-sky-music-proposal-resource-1':
			'Recurso 1: Colores verdaderos - Elementos generales',
		'blue-sky-music-proposal-resource-2': 'Recurso 2: Colores verdaderos - Letra',
		'help-a-first-time-homebuyer': 'Ayudar a un comprador de casa por primera vez',
		'help-a-first-time-homebuyer-description':
			'Usted es un representante de ventas de bienes raíces. Un comprador potencial se ha acercado a usted, expresando interés en comprar su primera casa. Dentro de este desafío, identifique las necesidades de su nuevo cliente, recopile información de los recursos proporcionados, genere ideas posibles para su nuevo cliente y luego recomiende la mejor opción y razonamiento.',
		emails: 'Correos',
		'property-listings-table': 'Tabla de listado de propiedades',
		'find-your-perfect-home': 'Encuentra tu casa perfecta',
		'marketing-description':
			'Usted es un especialista en marketing. Trabaja para una empresa minorista de tamaño mediano que vende ropa exterior y ropa exterior de alta calidad, operando dentro de este espacio de la industria durante cinco años. Su empresa vende productos principalmente en línea, pero recientemente, el equipo de alta gerencia ha comenzado a considerar alejarse de un modelo de ventas solo para comercio electrónico. Le han pedido que haga una recomendación en función de su experiencia y los datos a los que tiene acceso.',
		'customer-demographics': 'Demografía del cliente',
		'customer-satisfaction-survey': 'Encuesta de satisfacción del cliente',
		'our-science': 'Nuestra ciencia',
		'{number}-assessments-take-so-far': '{number} Evaluaciones tomadas hasta el momento',
		'built-with-love-in-toronto': 'Construido con amor en Toronto',
		whoops: '¡Vaya!',
		'404-message': 'El enlace que ingresaste está roto o ya no existe',
		'take-me-home': 'Llévame a casa',
		'what-does-this-mean-s1':
			'Con el desafío que completó, se le pidió que demostrara sus habilidades de comunicación y resolución de problemas en un rol de ventas, ¡y así lo hizo! Desde el momento en que comenzó el desafío, seguimos sus respuestas y los pasos que tomó para llegar a sus respuestas. Aquí, puede ver algunas pepitas de información que pudimos extraer de nuestros análisis.',
		'what-does-this-mean-s2':
			'Obviamente no podemos compartir nuestra salsa secreta, pero aquí hay un ejemplo para hacerle pensar.',
		'what-does-this-mean-s3-bold': 'Velocidad y reflexión:',
		'what-does-this-mean-s3':
			'ser rápido para comenzar a escribir desde el primer momento y luego simplemente eliminar, agregar y revisar su trabajo a medida que abrían los correos electrónicos y leían el artículo, es cómo los desafiantes pudieron obtener una puntuación alta en velocidad y reflexión.',
		'what-does-this-mean-s4':
			'Un ejemplo de una tarea en la que esta característica sería beneficiosa: cuando tiene una tarea urgente que debe abordarse de inmediato.',
		speed: 'Velocidad',
		'meticulousness-assertiveness': 'Meticulosidad y Asertividad',
		'attention-to-detail': 'Atencion al detalle',
		'clarity-reasoning': 'Claridad y razonamiento',
		export: 'Exportar',
		archieve: 'Archivar',
		delete: 'Borrar',
		'are-you-sure-you-want-to-delete': '¿Estas seguro que quieres borrarlo?',
		'pick-a-challenge': 'Elige un desafío',
		'confirm-pick': 'Confirmar selección',
		'challenge-added': 'Desafío añadido!',
		'sharable-link': 'Enlace Compartido',
		'sharable-link-copy': 'Enlace compartido Copiado',
		music: 'Música',
		lyrics: 'Letra',
		artist: 'Artista',
		'creative-industries': 'Industrias creativas',
		'song-proposal': 'Propuesta de canción',
		voice: 'Voz',
		'real-estate': 'Bienes raíces',
		'customer-success': 'Éxito del cliente',
		software: 'Software',
		customer: 'Cliente',
		experience: 'Experiencia',
		regression: 'Regresión',
		'data-analysis': 'Análisis de datos',
		'data-mining': 'Minería de datos',
		'digital-marketing': 'Marketing digital',
		'e-commernce': 'Comercio electrónico',
		retail: 'Al detalle',
		strategy: 'Estrategia',
		financial: 'Financiero',
		analysis: 'Análisis',
		role: 'Rol',
		rolelevel: 'Nivel de rol',
		function: 'Función',
		organization: 'Organización',
		industry: 'Industria',
		'team-size': 'Tamaño del equipo',
		'update-profile': 'Actualizar perfil',
		'sign-out': 'Cerrar sesión',
		'delete-account': 'Borrar cuenta',
		'change-password': 'Cambiar contraseña',
		'Edit-profile': 'Edit Profile',
		login: 'Entrar',
		signup: 'Registrarse',
		'enter-your-email': 'Introduce tu correo electrónico',
		'enter-your-password': 'Ingresa tu contraseña',
		'Ask-your-friend-to-get-one': 'Ask your friend to get one',
		'referral-Code': 'Referral Code',
		password: 'Contraseña',
		'login-as-employee': 'Iniciar sesión como usuario',
		'loggin-as-employer': 'Iniciar sesión como administrador',
		'forgot-password': '¿Olvidé mi contraseña',
		username: 'Nombre de usuario',
		firstname: 'Nombre',
		lastname: 'Apellido',
		'enter-your-firstname': 'Ponga su primer nombre',
		'enter-your-lastname': 'Ingresa tu apellido',
		'enter-your-username': 'Ingrese su nombre de usuario',
		'auth-no-user': 'El nombre de usuario o la contraseña no se corrigen',
		'signup-as-employer': 'Registrarse como administrador',
		'signup-as-employee': 'Registrarse como Usuario',
		'invalid-username': 'Nombre de usuario no válido!',
		'invalid-email': 'Email inválido!',
		'invalid-password': 'Contraseña invalida!',
		'confirm-password': 'Confirmar contraseña',
		'signup-failed1': 'Signup failed',
		'signup-failed2': 'Your email exists now',
		'verify-email-title': 'Verifique su correo electrónico',
		'verify-email-content':
			'Gracias por registrarte. Por favor revise su correo electrónico para verificar su cuenta antes de que pueda comenzar.',
		'repeat-your-password': 'Repita su contraseña',
		'password-not-match': 'La contraseña no coincide',
		'password-reset': 'Restablecimiento de contraseña',
		'enter-your-email-and-well':
			'Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña',
		'answer-some-questions': 'Responder algunas preguntas',
		'tell-us-about-yourself': 'Cuéntanos acerca de tí',
		'tell-us-about-yourself-description':
			'Los datos recopilados de este formulario están destinados únicamente a fines de investigación.Ningún dato privado será guardado o distribuido a ninguna parte.',
		'we-want-your-feedback': '¡Queremos sus comentarios!',
		'we-want-your-feedback-description':
			'Nuestro objetivo con esta encuesta es comprender su experiencia, ¡mientras nos esforzamos por ofrecer la mejor experiencia para usted!Estimamos que la duración es inferior a 3 minutos.',
		'we-want-your-feedback-note': 'Las preguntas marcadas con un * son obligatorias.',
		'how-this-assessment-colleague':
			'¿Qué tan probable es que recomiende esta evaluación a un amigo de un colega ?',
		'above-score-reason': '¿Cuál es tu razón para la puntuación anterior ?',
		'what-think-content-of-challenge': '¿Qué te pareció el contenido de este desafío? *',
		'additional-feedback-to-product-team':
			'Nuestro equipo de productos está trabajando arduamente para brindar la mejor experiencia posible.¿Tiene comentarios adicionales para llevar a casa ?',
		'enter-your-email-address': 'Por favor, introduzca su dirección de correo electrónico',
		'go-take-a-look': 'Ve a echar un vistazo!',
		'for-2-minutes':
			'Durante 2 minutos, póngase cómodo con la interfaz y juegue con los elementos.',
		'your-data-will-not-saved-in-the-preview':
			'Sus datos no serán guardados en la vista previa.',
		'neat-let-me-see-it': 'Ordenado, dejame verlo',
		'preview-mode': 'Modo de vista previa',
		skip: 'Omitir',
		userlist: 'Lista de usuarios',
		challengelist: 'Lista de desafíos',
		pipelinelist: 'Lista de oleoductos',
		'challenge-result-list': 'Lista de resultados del desafío',
		download: 'Descargar',
		count: 'Contar',
		'finance-accounting': 'Contabilidad financiera',
		'general-management': 'Administración General',
		'human-resources': 'Recursos humanos',
		'information-technology': 'Tecnologías de la información',
		operations: 'Operaciones',
		'individual-contributor': 'Colaborador individual',
		'expert-individual-contributor': 'Experto colaborador individual',
		manager: 'Gerente',
		'senior-manager': 'Gerente senior',
		executive: 'Ejecutivo',
		'about-the-role': 'Sobre el rol',
		'role-level': 'Nivel de rol',
		'mid-level-manager': 'Gerente de nivel medio',
		create: 'Crear',
		'solve-three-steps':
			'Me gustaría ver si usted es un buen ajuste para el programa. Le daremos un desafío y le pediremos que lo resuelva en tres pasos.',
		'important-instructions': 'INSTRUCCIONES IMPORTANTES ',
		instructions:
			'Hay cuatro contenedores en los que se le pedirá que "identifique el problema", "recopile información importante" (puede arrastrar y soltar texto), "genere ideas (extraiga hasta 3 alternativas)" y "recomiende una solución" .Utilice viñetas u oraciones completas, depende de usted. Estamos midiendo su proceso de toma de decisiones y sus habilidades para resolver problemas.',
		'confirmation-message':
			'Aparecerá un mensaje de confirmación justo después de esta pantalla antes de comenzar.Tendrás 20 minutos para completar el desafí!',
		'start-test': 'PRUEBA DE INICIO ',
		'customize-your-assessment': 'personalizar su evaluación',
		'control-assessment': 'Controla la evaluación añadiendo tu propio contenido.',
		'assessment-name': 'Nombre de la evaluación ',
		'assessment-description': 'Descripción de la evaluación',
		'input-timer': 'Temporizador de entrada',
		'upload-image-challenge': 'Subir imagen para desafío',
		'plain-text': 'Texto sin formato',
		'audio-link': 'Enlace de audio',
		'video-link': 'Enlace de video',
		'image-link': 'Enlace de imágen',
		'add-card': 'Agregar tarjeta',
		'thank-you': 'Gracias',
		'challenge-submission': '¡Eso es! Hemos recibido su presentación de desafío',
		'feedback-your-assessment':
			'Si desea recibir comentarios sobre su evaluación, ingrese su dirección de correo electrónico a continuación',
		'your-voice':
			'Necesitamos tu voz!¿Qué consejo le darías a alguien a partir de tu carrera ?',
		save: 'SALVAR',
		success_time_feedback: '¡Éxito!Apreciamos su tiempo y comentarios',
		'supposed-to-do': '¿Que se supone que haga?',
		'supposed-to-do-answer':
			'Con el desafío Nugget.ai, se le solicita que asuma el rol que se describe en la descripción del desafío. Al asumir el rol de Desafío, le pedimos que simule mejor cómo pensaría, qué haría, qué información consideraría y qué recomendaría si estuviera trabajando en ese rol.',
		'what-challenge': '¿Cuál es el reto?',
		'what-challenge-answer':
			'El Desafío es una descripción que incluye el rol que se supone que debes asumir y el contexto en el que todo esto se desarrolla.Lo más importante es que el Desafío establece tu misión, es decir, el problema que debes resolver',
		'retake-challenge': '¿Puedo volver a tomar el reto?',
		'retake-challenge-answer':
			'No, no hay oportunidades para volver a tomar el Reto después de que lo completes la primera vez.Por esta razón, le pedimos que se imagine a sí mismo en el rol de Desafío la primera vez y simule el procedimiento que seguiría si intentara resolver el problema del Desafío en la vida real.',
		'purpose-whole-activity': '¿Cuál es el propósito de toda esta actividad?',
		'purpose-whole-activity-answer':
			'El propósito de esta actividad es obtener una idea, una instantánea, de cómo se vería si estuviera en el trabajo, realizando una actividad laboral típica de ese trabajo.',
		'challenge-problem':
			'¿El desafío se basa en un evento / situación / problema / empresa real ?',
		'challenge-problem-answer':
			'Los desafíos de Nugget.ai no se basan en eventos, problemas y / o empresas reales.Cualquier parecido con una empresa o situación del mundo real no es intencional.',
		'content-information': '¿Qué contenido / información debo incluir ? ',
		'content-information-answer':
			'En términos de cantidad o tipo de contenido / información, no existe un enfoque correcto establecido.Simplemente piense en qué contenido / información se enfocaría si realmente estuviera trabajando en esta función.',
		'what-resources': '¿Qué son los recursos ?',
		'what-resources-answer':
			'Los Recursos son ejemplos de recursos reales a los que las personas en el trabajo tendrían acceso cuando realizan tareas de trabajo similares a la misión del Desafío.Los recursos pueden incluir una amplia gama de contenido y pueden tomar varios formatos, con el fin de simular la información y el formato que las personas en el trabajo verían.No ofrecemos información adicional, más allá de lo que se incluye en los recursos, lo que hay allí.',
		'what-i-do-resources': '¿Qué hago con los recursos?',
		'what-i-do-resources-answer':
			'De manera similar a lo que sucede en el trabajo, puede usar tanta o poca información de los Recursos para ayudarlo a completar el Reto.Tiene las opciones para leer la información y arrastrar y soltar las secciones de la información en el área de trabajo del desafío.',
		'do-use-resources': '¿Tengo que usar todos los recursos ? ',
		'do-use-resources-answer':
			'No necesariamente, no. Puede usar todos los recursos si lo desea, y de la misma manera, puede elegir usar solo un subconjunto. Las personas tienen sus razones para adoptar diferentes enfoques. Una vez más, simplemente haga lo posible por simular lo que haría si fuera un empleado que trabaja en esta función.',
		'inform-outside-resources': '¿Puedo usar otra información, fuera de los Recursos?',
		'inform-outside-resources-answer':
			'Le pedimos que base sus respuestas al Desafío en información directamente de los Recursos.Le invitamos a utilizar cualquier conocimiento adquirido previamente que pueda recuperar de la cabeza, siempre y cuando no abra ningún documento específico, artículos, lecturas u otras fuentes.Si hay motivos para creer que utilizó recursos externos, más allá de los proporcionados como parte del Desafío, para ayudarlo con sus respuestas, sus respuestas pueden retirarse del grupo de aplicaciones.',
		'identify-problem': '¿Qué hago en "Identificar el problema"?',
		'identify-problem-answer':
			'En esta sección, puede identificar y discutir el problema de la raíz en el desafío que debe resolver como parte de su misión.',
		'collect-information': '¿Qué hago en "Recopilar información"?',
		'collect-information-answer':
			'En esta sección, puede extraer y almacenar información de los recursos proporcionados.',
		'engender-ideas': '¿Qué hago en“ Engender Ideas” ?',
		'engender-ideas-answer':
			'En esta sección, puede discutir diferentes opciones / direcciones / enfoques que está considerando.',
		'recommend-solution': '¿Qué hago en "Recomendar una solución" ?',
		'recommend-solution-answer':
			'En esta sección, puede presentar y discutir una solución / producto / servicio final que lo ayude a completar el desafío.',
		'complete-all-sections': '¿Tengo que completar todas las secciones ?',
		'complete-all-sections-answer':
			'No necesariamente, no. Recuerde, el objetivo es simular lo que haría si fuera un empleado que trabaja en esta función. Si hay secciones que considera menos relevantes, entonces no necesariamente tiene que completar esta sección.',
		'format-responses': '¿Cómo debo formatear mis respuestas?',
		'format-responses-answer':
			'No hay una forma correcta o incorrecta de dar formato a sus respuestas.Trate de pensar en cómo dar formato a sus respuestas si realmente estuviera trabajando en este rol presentándolo a un gerente.',
		'complete-challenge-time': '¿Qué pasa si no completo el desafío a tiempo ?',
		'complete-challenge-time-answer':
			'Esta bien!El temporizador está ahí para mantener el proceso estandarizado entre los participantes del Reto pero no es el caso de que sus respuestas se desechen simplemente porque no sintió que completó la tarea dentro del marco de tiempo asignado.analice las respuestas que pudo presentar y presente resultados basados​​ en estos datos',
		'browser-continue-later': '¿Puedo cerrar el navegador y continuar más tarde ? ',
		'browser-continue-later-answer':
			'No, se le pide que complete el desafío en una sola sesión.',
		'interface-accommodations':
			'¿Qué pasa si necesito más tiempo u otras adaptaciones de interfaz?',
		'interface-accommodations-answer':
			'No hay funciones integradas que le permitan ampliar su período de tiempo. Por este motivo, le pedimos que supervise de cerca el tiempo a medida que completa el desafío. No obstante, si usted es una persona que necesita un alojamiento basado en el tiempo o en otra interfaz, póngase en contacto con la persona de contacto que le envió el enlace a nuestro Desafío para solicitudes de esta naturaleza. A su vez, esta persona de contacto se comunicará con nosotros para resolver los detalles de cualquier alojamiento basado en el tiempo u otro tipo de interfaz.',
		'activity-chances-job':
			'¿Cómo afecta mi desempeño en esta actividad mis posibilidades de obtener el trabajo ? ',
		'activity-chances-job-answer':
			'El Reto se puede usar como una medida independiente en el proceso de contratación o como una medida dentro de un conjunto más amplio de medidas de contratación. Además, aunque podemos ofrecer pautas recomendadas a nuestros clientes, no tenemos control directo sobre cómo las organizaciones usan los resultados para guiar sus decisiones de contratación. Como tal, aconsejamos que cualquier pregunta relacionada con este asunto sea redirigida a la persona de contacto que le envió el enlace a nuestro desafío..',
		'own-your-personal-space': 'Posee tu espacio personal',
		'already-have-an-account': 'Ya tienes una cuenta',
		'employer-login': 'Inicio de sesión del empleador',
		'post-have-an-account': 'Don y apost tienen una cuenta',
		register: 'Registro',
		'export-to-csv': 'Exportar a CSV',
		type: 'TIPO',
		data: 'DATOS',
		'select-pipeline': 'Seleccione Pipeline',
		rank: 'Rango',
		'characteristic-reflects':
			'Esta característica refleja lo rápido que es para comenzar a trabajar y revisar su propio trabajo.Ser rápido para comenzar a escribir desde el primer momento y luego simplemente eliminar, agregar y revisar su trabajo cuando abrieron los correos electrónicos y leyeron el artículo.Cómo los que tomaron el desafío pudieron obtener una puntuación alta en Velocidad y Reflectividad',
		'characteristic-reflects_example':
			'Un ejemplo de una tarea en la que esta característica sería beneficiosa: cuando tiene una tarea urgente que debe abordarse de inmediato ',
		'characteristic-reflects-two':
			'Esta característica refleja cómo tiende a pensar y planificar con anticipación, enfocándose en estructurar sus ideas de manera efectiva.Tomarse el tiempo para leer el hilo del correo electrónico y el artículo antes de comenzar a elaborar sus respuestas es una forma de obtener una mayor puntuación en Planificación y Organización',
		'characteristic-reflects-two-example':
			'Un ejemplo de una tarea donde esta característica sería beneficiosa: cuando tiene una tarea importante que requiere un trabajo que se acerca a la perfección',
		'characteristic-reflects-three':
			'Esta característica refleja la cantidad de detalles que incluye en su trabajo y cómo lo usa para demostrar confianza. Tomar las necesidades de los clientes del hilo de correo electrónico y reiterar estas necesidades en las respuestas es cómo los que tomaron el desafío pudieron hacer bien en Atención a los detalles Asertividad',
		'characteristic-reflects-three-example':
			'Un ejemplo de una tarea donde esta característica sería beneficiosa: cuando tiene una tarea que requiere que aproveche su conocimiento para convencer a otra persona de sus ideas ',
		'characteristic-reflects-four':
			'Esta característica refleja la cantidad de cuidado que pone en la correcta redacción de sus ideas y el mantenimiento de su objetivo.Tener cuidado con el lenguaje utilizado y asegurarse de que las respuestas sean neutrales en su tono es un ejemplo de cómo los desafiantes obtuvieron una calificación alta en Neutralidad y cuidado.',
		'characteristic-reflects-four-example':
			'Un ejemplo de una tarea en la que esta característica sería beneficiosa: cuando tiene una tarea que se beneficia de usted, debe demostrar profesionalidad a través de la imparcialidad y la objetividad.',
		'characteristic-reflects-five':
			'Esta característica refleja la claridad con la que comunica sus ideas y las conecta de una manera lógica.Pasar el tiempo asegurándose de que las ideas que se presentan al cliente siguen una lógica de la otra en la forma en que se combinan y el tipo de palabras de transición que se utilizan es el desafío tomadores hicieron bien en claridad y razonamiento',
		'characteristic-reflects-five-example':
			'Un ejemplo de una tarea en la que esta característica sería beneficiosa: cuando tiene una tarea que requiere que establezca de manera clara y lógica los detalles de la situación y su proceso de pensamiento detrás de todo',
		'alert-dialog':
			'Deje que las aplicaciones de ayuda de Google determinen la ubicación. Esto significa enviar datos de ubicación anónimos a Google, incluso cuando no se están ejecutando aplicaciones',
		disagree: 'Discrepar',
		agree: 'De acuerdo',
		'talent-relationships': 'Relaciones de talento',
		'talent-relationships-subtitle':
			'Descubre las relaciones ocultas entre tu grupo de talentos. Arrastra la habilidad al eje para ver cómo se compara tu talento',
		'talent-funnel-title': 'Embudo de talentos',
		'talent-funnel-subtitle':
			'Descubre tu talento clasificado en el desafío. Selecciona una categoría para ver los resultados.',
		'team-dynamic-title': 'Equipo dinámico',
		'team-dynamic-subtitle':
			'Mejore el rendimiento de su equipo simulando cómo los individuos de otras tuberías contribuyen a su equipo. Combine y combine para optimizar el rendimiento',
		'almost-there': 'Casi ahi',
		'users-pipeline':
			'Los resultados aparecerán una vez que tenga al menos 50 usuarios en una tubería',
		'copied-invite': 'Copiado con éxito el enlace de invitación a',
		'about-one':
			'Con el desafío Nugget.ai, se le pidió que asumiera un rol de trabajo específico y que simulase mejor cómo pensaría, qué haría, qué información consideraría y qué recomendaría si estuviera completando el desafío en ese trabajo papel. Desde el mismo momento en que abrió la página de Desafío, hacemos un seguimiento de las diferentes facetas de la forma en que interactuó con los recursos y la forma en que completó el desafío, todo para ayudarnos a comprender cómo demuestra sus habilidades de resolución de problemas y comunicación en un contexto específico. contexto de trabajo. Luego analizamos estas diferentes facetas para ver qué patrones emergieron. Los resultados en esta página reflejan los patrones que pudimos identificar y cómo lo hizo en relación con otras personas que aceptaron el desafío.',
		'about-two':
			'Tus puntuaciones se fijan junto a todo el grupo de usuarios que aceptaron el desafío.Estamos creando una forma única de analizar el rendimiento del usuario comparándolo con diferentes puntos de referencia de la industria y el mercado hasta la compañía y el equipo.Diferentes puntos de referencia se comportan de manera diferente como una representación de la diversidad que existe en el talento en diferentes segmentos demográficos',
		'about-three':
			'Tener un puntaje más bajo que el índice de referencia no significa necesariamente que esté peor que todos los demás: cada compañía está buscando diferentes combinaciones de características.',
		'about-four':
			'Nuestro objetivo es ayudarlo a descubrir nuggets de información sobre sus habilidades sociales que lo ayudan a descubrir trayectorias profesionales que actualmente se alinean con su forma de pensar, cómo se comunica y cómo resuelve problemas. Descubra rutas profesionales que quizás nunca haya considerado que podrían ser adecuadas para usted al explorar estos resultados',
		'account-details': 'detalles de la cuenta',
		'success-redirect': 'Guardado exitosamente y redirigido',
		'usecase-one':
			'GE Appliances anunció una actualización de sus aparatos domésticos conectados a Wi-Fi, que ahora funcionan directamente con el Asistente de Google, el asistente digital de búsqueda de gigantes de voz. La gente puede decir comandos como, Hey, Google, precalentar el horno a 425 grados, o preguntar, Hey, Google, ¿mis platos están limpios?',
		'usecase-two':
			'La conexión directa con el Asistente de Google elimina la necesidad de agregar un comando adicional al hablar con los dispositivos de GE.Anteriormente, los propietarios del producto tenían que usar la Acción de Inicio de Ginebra para los comandos de voz, como Google, pedirle al Hogar de Ginebra que precaliente el horno a 425 grados',
		'usecase-three':
			'El cambio funciona con refrigeradores, hornos, lavavajillas y lavadoras conectados a los electrodomésticos GE, entre otros electrodomésticos, todos vinculados a la aplicación U + Connect para administrar los dispositivos.',
		'usecase-four':
			'La integración más cercana de GE Appliances con el Asistente de Google se presenta cuando el gigante de la búsqueda compite con Amazon por el dominio en el mercado de servicios para el hogar inteligente. La conexión directa con el asistente digital podría hacer que los electrodomésticos de GE sean un poco más fáciles de usar que con Alexa, el asistente digital de Amazon que ha trabajado con productos de GE durante los últimos dos años. Amazon y GE en 2016 introdujeron una habilidad de Ginebra para Alexa que requiere que los usuarios digan comandos como, Alexa, que le digan a Geneva que precaliente el horno a 350 grados, por CNet. Este paso adicional puede agregar cierta fricción a los usuarios que buscan un método conveniente para controlar sus dispositivos inteligentes de cocinas',
		'usecase-five':
			'El anuncio de GE Appliances se produce cuando Electrolux, el fabricante sueco de electrodomésticos, comenzó a integrar sus productos de cocina conectados con el Asistente de Google.La integración de voz comenzará en los hornos inteligentes el próximo año, anunció Electrolux la semana pasada.Con más fabricantes de electrodomésticos que experimentan con dispositivos domésticos conectados, la tecnología seguirá evolucionando y creciendo de manera cada vez más sofisticada y fácil de usar para los consumidores.',
		'usecase-six':
			'El asistente digital y el espacio de los altavoces inteligentes continúan calentándose. Los envíos globales de parlantes inteligentes con alimentación de voz aumentaron 278% a 9.2 millones de unidades en el primer trimestre de 2018 respecto al año anterior. Aunque Amazon envió 4 millones de ellos durante el trimestre, su participación de mercado cayó a 43.6% desde 81.8% año con año, De acuerdo con Strategy Analytics. El mercado mundial de dispositivos inteligentes para el hogar, compuesto por parlantes inteligentes, adaptadores de medios digitales, iluminación, termostatos y otros dispositivos conectados como electrodomésticos GE, se prevé que crezca un 26.8% este año a 549.5 millones de envíos totales, estima la International Data Corporation.',
		note:
			'Nota: estos recursos son documentos que se entregan con anticipación a todos los asistentes a la reunión. Con estos recursos, a los asistentes se les presenta la letra de una canción seleccionada al azar de la lista de la etiqueta. Aparte de la letra, se identifican los elementos generales de la canción. Además, los elementos específicos de la canción están identificados y estos elementos no son necesariamente elementos que los ejecutivos de la etiqueta están buscando, pero deberían darle una idea de qué tipo de información debe tener en cuenta al desarrollar su plan.',
		'song-title': 'Título de la canción',
		'true-colours': 'Colores verdaderos',
		unnamed: 'Sin nombre',
		instrumentals: 'Instrumentales',
		'no-decription-provided': 'No se proporciona descripción',
		'vocal-type': 'Tipo vocal',
		'single-vocal-male': 'Solo vocal vocal masculino',
		'theme-song': 'Tema de la canción',
		'love-relationships': 'Amor y relaciones ',
		'storyline-song': 'Storyline de la canción',
		'storyline-song-description':
			'El cantante expresa a su amante su deseo de conocerla y conectarse con ella en un nivel más profundo.Artísticamente, el cantante utiliza la metáfora de los colores y las imágenes para comunicar este sentimiento a su amante.',
		insight: 'Visión',
		talent: 'Talento',
		'your-talent-pipelines': 'Sus tuberías de talento',
		'add-challenge':
			'Añade tu objetivo / descripción de desafío aquí. ¡Todos en el equipo podrán ver esto!',
		'digital-team': 'Equipo digital',
		send: 'Enviar',
		'terms-and-condition': <EsDescription />,
		'send-email-again-text': '¿Aún no has recibido el email?',
		'send-email-again': 'Enviar de nuevo',
		'create-new-password': 'Crear nueva contraseña',
		'create-new-password-info':
			'Elegir una contraseña segura y no reutilizarla para otras cuentas. Cambiar su contraseña lo cerrará en todos los dispositivos con los que haya iniciado sesión. Deberá volver a ingresar su nueva contraseña.',
		'new-password': 'Nueva contraseña',
		'change-your-password': 'Cambia tu contraseña',
		'current-password': 'contraseña actual',
		'mail-sent': 'Correo enviado con éxito',
		'error-mail-sent': 'Se ha producido un error al enviar el correo',
		'profile-update': 'Tú perfil ha sido actualizado satisfactoriamente',
		'delete-confirmation': '¿Estás seguro, quieres borrar tu cuenta?',
		'current-password-incorrect': 'Contraseña actual incorrecta',
		'password-change': 'Contraseña cambiada con éxito',
		'accept-the': 'Acepto los',
		'terms-conditions': 'términos y condiciones',
		resume: 'Currículum'
	},
	en: {
		'tour-step-0':
			'Assessment overview and background will be located here. Carefully review this when you start',
		'tour-step-1':
			'Resources are helper items. In this section, you will find resources to help you better understand the scenario',
		'tour-step-2':
			'You will solve the assessment by typing in here. You may find 1 or more boxes that need a response',
		'tour-step-3': '',
		'tour-step-4': '',
		'tour-step-5':
			'Your assessment won’t be static, but new information will be presented through the notification icon here. Turn up your volume to hear the bell ring',
		'tour-step-6':
			'Each assessment is timed, so keep an eye out on the clock! When you’re ready, hit ‘Next’ to continue.',
		'start-test-title': 'Are you sure you want to start?',
		'start-test-content': `Make sure the browser is open at full screen and don't close the tab or you'll have to restart. Good luck!`,

		start: 'Start',
		'show-me-again-u': 'Show me again',
		consultant: 'Consulting',
		endPreview: 'END PREVIEW',
		next: 'Next',
		back: 'Back',
		prev: 'Prev',
		finish: 'Finish',
		'how-can-we-help': 'How can we help?',
		'how-can-we-help-explain': `This is your guide to completing the assessment. Don't get lost, the timer is still running!`,
		application: 'Application',
		other: 'Other',
		help: 'Help',
		'add-new-section': 'Add new section',
		'identify-the-problem': 'Identify the problem',
		'highlight-key-sentences': `Highlight key sentences from the article that stand out to you. It's as simple as drag and drop`,
		'brainstorm-viable': 'Brainstorm viable ideas that fit the scope of the problem',
		'use-your-creativity': 'Use your creativity and recommend a solution',
		problem: 'Problem',
		'collect-information-title': 'Collect Information',
		ideas: 'Ideas',
		solution: 'Solution',
		resource: 'Resource',
		'no-card-name': 'No Card Name',
		'challenge-description': 'Challenge Description',
		'test-name-not-found': 'Test name not found',
		'drop-the-text-here': 'Drag & Drop the text here',
		'type-away-what': 'Type away... what else do you want us to know?',
		title: 'Title',
		'are-you-sure': 'Are you sure?',
		'content-exit-challenge':
			"Looks like you're trying to exit the assessment. All of your progress will be lost if you decide to do this.",
		'continue-the-challenge': 'Continue the assessment',
		'continue-challenge': 'Continue assessment',
		'content-finish-challenge': "Looks like you're about to send your results",
		'time-up': "Time's Up!",
		'hard-part-over':
			'The hard part is over. Just sit back and wait for the results to come in',
		'great-job-u': 'Great Job!',
		'u-finished-it': 'You Finished It!',
		'sit-tight-well':
			"Sit tight! We'll let you know when the results are in. In the meantime, here are some numbers to get a sense of your results",
		'sit-tight-well-short': "Sit tight! We'll let you know when the results are in.",
		'sign-up-in-msg': 'Sign up or sign in below to see your results!',
		'assess-congratulations-sandbox':
			'Congratulations! You finished it. Head over to your profile page to see your results.',
		// 'assess-congratulations-analytics': `Congratulations! You finished it. We are now analyzing your results. Want to take a peak? Sign up or sign in below to see your results!`,
		'assess-congratulations-analytics':
			'Congratulations! You finished it. We are now analyzing your results and curating best-fit matches. Stay put and someone will be in touch soon',
		'companies-are-also':
			'Companies are also looking for complementary skills, so don’t sweat it! You may just be what they are looking for, either way!',
		'let-you-know-over-email':
			'We’ll let you know over e-mail as we process your results! In the meantime, here’s some fun calculations out of curiosity.',
		'want-to-improve-ex': 'Want to improve the experience? Fill out this quick ',
		'questionniare-err-msg': 'Looks like you missed one. Values must be between 1-7',
		survey: 'Survey',
		minutes: 'Minutes',
		'pace-of-writing': 'Pace of writing',
		'words-per-minute': 'Words per minute',
		'head-start': 'Head start',
		'how-long-takes': 'How long (seconds) it takes you to write the first word',
		'quick-fix': 'Quick fix',
		'number-times-deleting': 'Number of times deleting happens within 3 seconds of writing',
		'run-on': 'Run-On',
		'number-long-sentences': 'Number of long sentences over 30 words',
		'select-an-assessment': 'Select An Assessment',
		'select-from-pre-built':
			"Select from pre-built assessments. We'll take care of the content and insights.",
		'business-to-business-sales': 'Sell the right web service to a client',
		'business-to-business-sales-description':
			'You are a business-to-business (B2B) sales representative. Your manager has let you know about a prospective new client - a business looking to develop a company website. Within this assessment, identify the needs of your new client, collect information from provided resources, come up with possible options for your new client, and then recommend the best option to this new client.',
		'email-thread-between': 'Email thread between the manager and the client',
		'descriptions-services-provided': 'Descriptions of services provided by the company',
		'actionablet-tips-closing': 'Actionable Tips For Closing More B2B Sales',
		'data-science': 'Help a company interpret employee data',
		'data-science-description':
			'You are a data scientist working with a new client, an up-and-coming business in the tech industry with 150 employees. The client just finished their first round of collecting internal data on their employees and their work experiences. The client is reaching out to you to get your help with making sense of their data. They want to use their data to make some changes to their policies, practices, and/or training. Within this challenge, identify key problems, collect information from the data that was shared with you, brainstorm possible options for the client, and then make final recommendations to the client.',
		'interview-findings': 'Interview Findings',
		'correlation-table': 'Correlation Table',
		'multiple-regression-table': 'Multiple Regression Table',
		'business-strategy-proposal': 'Help a company turn a profit',
		'business-strategy-proposal-description':
			'You work as a full-time employee for a medium-sized company. Over the last two years, your company has been experiencing a steady decline in operating profit. This decline is due to both a decrease in average sales and increase in average expenses. With the desire to tap into internal resources to help with this issue, company executives have decided to form a cross-functional team with selected existing employees to help rectify this problem. You were selected to join this cross-functional team. As a group, you had your first meeting and have agreed that prior to meeting as a group again and discussing the issue further, you will each first generate individual ideas for what the problem is, why there is a problem, and what can be done to address it. Your presentation is in 20 minutes!',
		'software-engineering-challenge': 'Develop a plan for a new product',
		'software-engineering-challenge-description':
			'You work as a full-time software engineer on a team that is responsible for designing, developing, and troubleshooting new software for the country’s leading product innovation firm. The product innovation firm that you work for has decided on “Learning from Failures” as a company-wide strategic priority this year. Your team’s current project is to look for past failed projects, “learn” from these failures, and build something that you believe can be successful. Your team has agreed to work independently first and have everyone generate ideas on their own before meeting again as a group. Look through the cases and identify a problem you want to focus on, collect information from these cases, generate some cool ideas, and then recommend one final product that you would pitch to your group.',
		'software-engineering': 'Software Engineering',
		'product-design': 'Product Design',
		'product-development': 'Product Development',
		innovation: 'Innovation',
		'case-1-drama': 'Case #1: Drama',
		'case-2-highlighter': 'Case #2: Highlighter',
		'case-3-screenrest': 'Case #3: Screenrest',
		'customer-client-feedback': 'Customer/Client Feedback',
		'performance-management-results': 'Performance Management Results',
		'profits-chart': 'Profits Chart',
		'get-started': 'GET STARTED',
		welcome: 'Welcome',
		name: 'Name',
		email: 'Email',
		age: 'Age',
		gender: 'Gender',
		male: 'Male',
		female: 'Female',
		'prefer-not-to-say': 'Prefer not to say',
		continue: 'Continue',
		'what-ethnicity-cultural-group': 'What ethnicity/cultural group do you identify with?',
		caucasian: 'Caucasian',
		'latin-american': 'Latin American',
		african: 'African',
		caribbean: 'Caribbean',
		'middle-east': 'Middle East',
		'south-asian': 'South Asian (e.g., East Indian, Sri Lankan)',
		'southeast-asian': 'Southeast Asian (e.g., Vietnamese, Chinese, Filipino)',
		'west-asian': 'West Asian (e.g., Iranian, Afghan)',
		aboriginal: 'Aboriginal (e.g., North American Indian, Inuit)',
		mixed: 'Mixed',
		'what-is-your-marital': 'What is your marital status?',
		'how-do-you-want-to-create': 'How do you want to create?',
		'pre-built-assessment': 'Pre Built Assessment',
		'create-your-own': 'Create your own',
		'please-select-role-type': 'Please select role type!',
		'please-select-position-type': 'Please select position type!',
		'what-are-you-hiring-for': 'What are you hiring for?',
		'help-us-define-your-role':
			'Help us define your role so we can suggest the best assessment',
		'role-type': 'Role Type',
		none: 'None',
		'customer-service': 'Customer Service',
		sales: 'Sales',
		'product-management': 'Product Management',
		'business-management': 'Business Management',
		'business-strategy': 'Business Strategy',
		'position-type': 'Position Type',
		'co-op-internship': 'Co-op/Internship',
		'entry-level': 'Entry Level',
		'junior-manager': 'Junior Manager',
		'middle-manager': 'Middle Manager',
		'add-the-keywords': 'Add the keywords',
		Editprofile: 'Edit profile',
		cancel: 'Cancel',
		'please-select-the-assessment': 'Please select the assessment!',
		'create-your-benchmark': 'Create your benchmark',
		'create-a-benchmark-by-sending':
			'Create a benchmark by sending the assessment to top performing employees first',
		'share-the-link-below': 'Share the link below',
		launch: 'Launch',
		'Add-team': 'Add team',
		search: 'Search',
		'example-challenge': 'Demo',
		'single-never-married': 'Single, never married',
		widowed: 'Widowed',
		separated: 'Separated',
		divorced: 'Divorced',
		married: 'Married',
		'living-common-law': 'Living common-law',
		'what-is-the-highest-degree': 'What is the highest degree or level of schools you have',
		'less-than-high-school-diploma': 'Less than high school diploma',
		'high-school-degree-or-equivalent': 'High school degree or equivalent (e.g., GED)',
		'some-scollege-no-degree': 'Some college, no degree',
		'associate-degree': 'Associate degree (e.g., AA, AS)',
		'bachelors-degree': 'Bachelor’s degree (e.g., BA, BS)',
		'masters-degree': 'Master’s degree (e.g., MA, MS)',
		'professional-degree': 'Professional degree (e.g., MD, DDS)',
		doctorate: 'Doctorate (e.g., PhD, EdD)',
		'what-is-your-current-employment-status': 'What is your current employment status?',
		'employed-full-time-40': 'Employed full time (40 or more hours per week)',
		'employed-part-time-39': 'Employed part time (up to 39 hours per week)',
		'unemployed-and-currently-looking': 'Unemployed and currently looking for work',
		'Unemployed-and-currently-not-looking': 'Unemployed and currently not looking for work',
		student: 'Student',
		retired: 'Retired',
		'self-employed': 'Self-employed',
		'unable-to-work': 'Unable to work',
		'to-tutorial': 'To Tutorial',
		'please-do-not-take-this-assessment-on-phone':
			'Please do not take this assessment on your phone',
		company: 'Company',
		'mobile-device-prompt':
			'Looks like you are trying to take this assessment on mobile device. For the best experience, please access this assessment from your desktop or laptop.',
		'company-would-like':
			'You have been invited to take part in a nugget.ai challenge. With this challenge, you are being asked to demonstrate your soft skills by working through an online mini-job simulation.',
		'we-are-assessing':
			'We are assessing your soft skills based on your process - so, how you approach the job simulation, how you interact with the different interface components, and what decisions you make along the way. By focusing on the process, we are looking more at the patterns of how you complete the challenge, not scoring how right or wrong the end result is.',
		'we-at-nugget.ai':
			' We at nugget.ai believe there is no right or wrong answer so we encourage you to just go with the flow and do your best!',
		'company-following-tutorial':
			'To prepare you for the challenge, you will be presented with a tutorial to walk you through the interface. We highly recommend that you read our tips carefully. Following this tutorial, you have ',
		'minutes-to-complete': ' to complete the challenge.',
		'good-luck': 'Good luck!',
		goodluck: 'Goodluck',
		'assess-learn-evolve': 'Assess. Learn. Evolve',
		'discover-your-soft-skills':
			'Discover your soft skills through role-relavant challenges',
		'n-challenges-available': '{n} Challenges Available',
		'search-challenge': 'Search challenge',
		'hi-{name}': 'hi {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, you’re going places!',
		'discover-nuggets-about-your-soft-skills': 'Discover nuggets about your soft skills',
		'register-login': 'Login',
		'nugget-ai-science': 'Nugget.ai Science',
		'our-prediction-models':
			'Our prediction models are supported by degrees of academic research in I / O Psychology',
		performance: 'Performance',
		'people-skills': 'People Skills',
		'view-submission': 'View submission',
		'domain-skills': 'Domain Skills',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'Mark your focus and find your gaps to improve',
		'discover-your-path': 'Discover your Path',
		'keep-an-open-mind-and-try-something-new': 'Keep an open mind, and try something new!',
		'compare-to': 'Compare to',
		'growth-tips': 'Growth Tips',
		'machine-drive-advice-subtitle':
			'Machine-driven advice from the top 10% of professionals',
		'growth-tips-1':
			'“Attention to detail has been the most important factor leading to success or failure on the job.”',
		'growth-tips-2':
			'“Managing a portfolio of technology solutions where the industry is changing rapidly keeps you on your feet at all times…”',
		'growth-tips-3':
			'“Blockchain has the potential to disrupt every industry just as Machine Learning is doing now. You’re ability to think creatively to lead new discoveries is pivotal to your career success”',
		'what-does-this-mean': 'What does this mean?',
		'project-coodinator': 'Project Coodinator',
		'financial-analyst': 'Financial Analyst',
		'project-manager': 'Project Manager',
		'blue-sky-music-proposal': 'Write a blue-sky music proposal',
		'blue-sky-music-proposal-description':
			'You are a tenured artist signed to one of the record labels currently dominating the music industry. The record label hosts monthly meetings called “blue-sky” meetings where attendees - artists like you - are encouraged to present a detailed plan for a new song, that can be of any genre, any composition, and on any topic. Attendees are encouraged to think big. Within this challenge, identify the components that you would like to include in your plan, collect information from the provided resources, engender some ideas to select from when formulating your plan, and recommend your big idea in a plan that you will present in this meeting',
		'blue-sky-music-proposal-resource-1': 'Resource 1: True Colours - General Elements',
		'blue-sky-music-proposal-resource-2': 'Resource 2: True Colours - Lyrics',
		'help-a-first-time-homebuyer': 'Help a first-time homebuyer',
		'help-a-first-time-homebuyer-description':
			'You are a real estate sales representative. A potential buyer has reached out to you, expressing interest in buying their first home. Within this challenge, identify the needs of your new client, collect information from the provided resources, engender possible ideas for your new client, and then recommend the best option and reasoning.',
		emails: 'Emails',
		'property-listings-table': 'Property listings Table',
		'find-your-perfect-home': 'Find your Perfect Home',
		'marketing-description':
			'You are a marketing specialist. You work for a medium-sized retail company that sells high-quality outdoor gear and outerwear clothing, operating within this industry space for five years. Your company sells products primarily online but recently, the top management team has started considering moving away from an ecommerce-only sales model. They have asked you to make a recommendation based on your expertise and the data to which you have access.',
		'customer-demographics': 'Customer Demographics',
		'customer-satisfaction-survey': 'Customer Satisfaction Survey',
		'our-science': 'Our Science',
		'{number}-assessments-take-so-far': '{number} Assessments take so far',
		whoops: 'Whoops!',
		'404-message': 'The link you entered is either broken or no longer exists',
		'take-me-home': 'Take me Home',
		'what-does-this-mean-s1':
			'With the challenge you completed, you were asked to demonstrate your problem solving and communication skills in a sales role - and you did just that! From the second you started the challenge, we were tracking your responses and the steps you took to get to your answers. Here, you can see some nuggets of information that we were able to extract from our analyses.',
		'what-does-this-mean-s2':
			'We obviously can not share our secret sauce, but here’s an example to get you thinking.',
		'what-does-this-mean-s3-bold': 'Speed and Reflectiveness:',
		'what-does-this-mean-s3':
			'Being quick to start writing from the get-go and then just deleting, adding to, and revising their work as they opened the emails and read through the article is how challenge takers were able to score high on Speed and Reflectiveness.',
		'what-does-this-mean-s4':
			'An example of a task where this characteristic would be beneficial: When you have an urgent task that needs to be tackled right away.',
		speed: 'Speed',
		'meticulousness-assertiveness': 'Meticulousness & Assertiveness',
		'attention-to-detail': 'Attention to Detail',
		'clarity-reasoning': 'Clarity & Reasoning',
		export: 'Export',
		archieve: 'Archieve',
		delete: 'Delete',
		'are-you-sure-you-want-to-delete': 'Are you sure you want to delete?',
		'are-you-sure-you-want-to-delete-this': 'Are you sure you want to delete this?',
		'pick-a-challenge': 'Pick a Challenge',
		'confirm-pick': 'Confirm Pick',
		'challenge-added': 'Challenge Added!',
		'sharable-link': 'Sharable Link',
		'sharable-link-copy': 'Sharable Link Copied',
		music: 'Music',
		lyrics: 'Lyrics',
		artist: 'Artist',
		'creative-industries': 'Creative industries',
		'song-proposal': 'Song proposal',
		voice: 'Voice',
		'real-estate': 'Real estate',
		'customer-success': 'Customer success',
		software: 'Software',
		customer: 'Customer',
		experience: 'Experience',
		regression: 'Regression',
		'data-analysis': 'Data analysis',
		'data-mining': 'Data mining',
		'digital-marketing': 'Digital marketing',
		'e-commernce': 'E-commernce',
		retail: 'Retail',
		strategy: 'Strategy',
		financial: 'Financial',
		analysis: 'analysis',
		role: 'Role',
		rolelevel: 'Role Level',
		function: 'Role Function',
		organization: 'Organization',
		industry: 'Industry',
		'team-size': 'Team size',
		'update-profile': 'Update profile',
		'sign-out': 'Sign out',
		'delete-account': 'Delete account',
		'change-password': 'Change password',
		'Edit-profile': 'Edit profile',
		login: 'Sign In',
		googleLogin: 'Sign in with Google',
		googleSignup: 'Sign up with Google',
		facebookLogin: 'Sign in with Facebook',
		facebookSignup: 'Sign up with Facebook',
		signup: 'Sign Up',
		'enter-your-email': 'Enter your email',
		'enter-your-password': 'Enter your password',
		'referral-Code': 'Referral Code',
		'Ask-your-friend-to-get-one': 'Ask your friend to get one',
		'signin-click': 'or click here to sign in',
		'csignin-help': 'Want to help us out? Your feedback will improve our experience',
		'btn-provide-feedback': 'Provice feedback',
		password: 'Password',
		'login-as-employee': 'Login as User',
		'loggin-as-employer': 'Login as admin',
		'forgot-password': 'Forgot Password?',
		username: 'Username',
		'enter-your-firstname': 'Enter your first name',
		'enter-your-lastname': 'Enter your last name',
		'enter-your-username': 'Enter your username',
		'auth-no-user': 'Your email does not exist in our database. Please check again.',
		'signup-as-employer': 'Sign up as Admin',
		'signup-as-employee': 'Sign up as User',
		'invalid-username': 'Invalid Username!',
		'invalid-email': 'Invalid Email!',
		'invalid-password': 'Invalid Password!',
		'confirm-password': 'Confirm password',
		'verify-email-title': 'Verify Your Email',
		'verify-email-content':
			'Thanks for signing up. Please check your email to verify your account before you can get started.',
		'repeat-your-password': 'Repeat your password',
		'password-not-match': 'Password not match',
		'password-reset': 'Password Reset',
		'enter-your-email-and-well':
			'Enter your email and we’ll send you a password reset link',
		'answer-some-questions': 'ANSWER SOME QUESTIONS',
		'tell-us-about-yourself': 'Talk to us!',
		'tell-us-about-yourself-description':
			'This form is intended for research purposes only. Your information is kept confidential and will not be redistributed without your prior consent. This form is optional and you may volunteer to to keep any question unanswered.',
		'we-want-your-feedback': 'We want your feedback!',
		'we-want-your-feedback-description':
			'Our goal with this survey is to understand your experience, while we strive to deliver the best experience for you! We estimate the duration is less than 3 minutes.',
		'we-want-your-feedback-note': 'Questions marked with an * are required.',
		'how-this-assessment-colleague':
			'How likely are you to recommend this assessment to a friend of colleague',
		'poor-excellent': '1 = poor ; 7 = Excellent',
		'above-score-reason': 'What is your reason for the score above?',
		'what-think-content-of-challenge':
			'What did you think of the content of this challenge?',
		'additional-feedback-to-product-team':
			'Our product team is working hard to provide the best experience possible. Do you have additional feedback for us to take home?',
		'enter-your-email-address': 'Please enter your email address',
		'go-take-a-look': 'Go take a look!',
		'for-2-minutes':
			'For 2 minutes, get yourself comfortable with the interface and play around with the elements.',
		'your-data-will-not-saved-in-the-preview':
			'You will not be able to type or drag/drop elements.',
		'neat-let-me-see-it': 'Neat, let me see it',
		'preview-mode': 'Preview Mode',
		skip: 'Skip',
		userlist: 'User List',
		challengelist: 'Challenge List',
		pipelinelist: 'Pipeline List',
		'challenge-result-list': 'Challenge Result List',
		download: 'Download',
		count: 'Count',
		'finance-accounting': 'Finance & Accounting',
		'general-management': 'General Management',
		'human-resources': 'Human Resources',
		'information-technology': 'Information Technology',
		operations: 'Operations',
		'individual-contributor': 'Individual Contributor',
		'expert-individual-contributor': 'Expert Individual Contributor',
		manager: 'Manager',
		'senior-manager': 'Senior Manager',
		executive: 'Executive',
		'junior-analyst': 'Junior Analyst',
		'senior-analyst': 'Senior Analyst',
		'actively-looking': 'Actively looking',
		'passively-looking': 'Passively looking',
		'not-looking': 'Not looking',
		associate: 'Associate',
		'senior-associate': 'Senior Associate',
		'vice-president': 'Vice President',
		'senior-vice-president': 'Senior Vice President',
		'about-the-role': 'About the Role',
		'mid-level-manager': 'Mid-level Manager',
		create: 'Create',
		'solve-three-steps':
			'would like to see if you are a good fit for the program. We are going to give you a challenge and ask you to solve it in three steps',
		'important-instructions': 'IMPORTANT INSTRUCTIONS',
		instructions:
			'There are four containers which you will be asked to“ identify the problem”, “collect important information”(you can drag and drop text), “engender ideas(brainstrom up to 3 alternatives)”, and“ recommend a solution”.Use bullet points or full sentences, it’ s up to you!We’ re measuring your decision - making process and problem solving skills',
		'confirmation-message':
			'A confirmation message will pop up just after this screen before you get started.You will have 20 minutes to complete the challenge.Goodluck!',
		'start-test': 'START TEST',
		instruction: 'Instructions',
		'customize-your-assessment': 'Customize Your Assessment',
		'control-assessment': 'Control the assessment by adding your own content',
		'assessment-name': 'Assessment Name',
		'assessment-description': 'Assessment Description',
		'input-timer': 'Input Timer',
		'upload-image-challenge': 'Upload Image for challenge',
		'plain-text': 'Plain Text',
		'audio-link': 'Audio Link',
		'video-link': 'Video Link',
		'image-link': 'Image Link',
		'add-card': 'Add Card',
		'thank-you': 'Thank you',
		'challenge-submission': 'Thats it! We have received your challenge submission',
		'feedback-your-assessment':
			'If you would like to receive feedback on your assessment, please enter your email address below',
		'your-voice':
			'We need your voice! What advice would you give to someone starting in your career?',
		save: 'SAVE',
		saving: 'Saving...',
		saved: 'Saved!',
		success_time_feedback: 'Success! We appreciate your time and feedback',
		'supposed-to-do': 'What am I supposed to do?',
		'supposed-to-do-answer':
			'With the Nugget.ai challenge, you are asked to take on the role that is described in the Challenge description. While taking on the Challenge role, we ask that you best simulate how you would think, what you would do, what information you would consider, and what you would recommend if you were working in that role',
		'what-challenge': 'What is the Challenge?',
		'what-challenge-answer':
			'The Challenge is a description that includes the role that you’re supposed to take on and the context that this is all taking place in. Most importantly, the Challenge lays out your mission – that is, the problem that you have to solve',
		'retake-challenge': 'Can I re-take the challenge?',
		'retake-challenge-answer':
			'No, there are no opportunities to re-take the Challenge after you complete it the first time. For this reason, we ask that you deeply imagine yourself in the Challenge role the first time around and simulate the procedure that you would follow if you were trying to solve the Challenge problem in real life.',
		'purpose-whole-activity': 'What is the purpose of this whole activity?',
		'purpose-whole-activity-answer':
			'The purpose of this activity is to get an idea – a quick snapshot – of what it would look like if you were on the job, performing a work activity that is typical of that job.',
		'challenge-problem':
			'Is the Challenge based on a real event/situation/problem/company?',
		'challenge-problem-answer':
			'Nugget.ai challenges are not based on real events, problems, and/or companies. Any resemblance to a real-world company or situation is unintentional.',
		'content-information': 'What content/information should I include?',
		'content-information-answer':
			'In terms of amount or type of content/information, there is no established correct approach. Simply think about what content/information you would focus on if you were truly working in this role.',
		'what-resources': 'What are the Resources?',
		'what-resources-answer':
			'The Resources are examples of real resources that people on the job would have access to when they perform work duties similar to the Challenge mission. The resources can include a wide range of content and can take on various formats – with the purpose of simulating the information and formatting that people on the job would see. We do not offer additional information, beyond what is included in the resources – what’s there is there.',
		'what-i-do-resources': 'What do I do with the Resources?',
		'what-i-do-resources-answer':
			'Similar to what happens on the job, you may use as much or as little of the information in the Resources to help you with completing the Challenge. You have the options to read the information and drag-and-drop sections of the information over to the challenge workspace.',
		'do-use-resources': 'Do I have to use all of the Resources?',
		'do-use-resources-answer':
			'Not necessarily, no. You can use all of the resources if you like, and likewise, you can choose to use only a subset. People have their reasons for taking different approaches. Again, just try your best to simulate what you would do if you were an employee working in this role.',
		'inform-outside-resources': 'Can I use other information, outside of the Resources?',
		'inform-outside-resources-answer':
			'We ask that you base your responses to the Challenge on information directly from the Resources. You are welcome to use any previously acquired knowledge that you can recall off the top of your head, as long as you do not open up any specific documents, articles, readings, or other sources. If there is reason to believe that you used external resources, beyond the ones provided as part of the Challenge, to help with your responses, your responses may be withdrawn from the application pool.',
		'identify-problem': 'What do I do in “Identify the Problem”?',
		'identify-problem-answer':
			'In this section, you may identify and discuss the root problem in the Challenge that you are meant to solve as part of your mission.',
		'collect-information': 'Collect Information',
		'collect-information-answer':
			'In this section, you may pull and store pieces of information from the provided Resources.',
		'engender-ideas': 'What do I do in “Engender Ideas”?',
		'engender-ideas-answer':
			'In this section, you may discuss different options/directions/approaches that you are considering.',
		'recommend-solution': 'What do I do in “Recommend a Solution”?',
		'recommend-solution-answer':
			'In this section, you may present and discuss a final solution/product/service that helps you complete the Challenge.',
		'complete-all-sections': 'Do I have to complete all of the sections?',
		'complete-all-sections-answer':
			'Not necessarily, no. Remember, the goal is to simulate what you would do if you were an employee working in this role. If there are sections that you deem less relevant, then you do not necessarily have to complete this section.',
		'format-responses': 'How should I format my responses?',
		'format-responses-answer':
			'There is no right or wrong way to format your responses. Try to think about how you would format your responses if you were actually working in this role presenting it to a manager.',
		'complete-challenge-time': 'What if I don’t complete the challenge in time?',
		'complete-challenge-time-answer':
			'That is okay!The timer is there to keep to the process standardized between Challenge - takers but it is not the case that your responses get thrown out just because you did not feel as if you completed the task within the allotted time frame.We still analyze the responses you were able to come up with and present results based on this data.',
		'browser-continue-later': 'Can I close the browser and continue at a later time?',
		'browser-continue-later-answer':
			'No, you are asked to complete the challenge in one sitting.',
		'interface-accommodations':
			'What if I need more time or other interface accommodations?',
		'interface-accommodations-answer':
			'There are no built-in features that will allow you to extend your timeframe. For this reason, we ask that you closely monitor the time as you complete the Challenge. Nonetheless, if you are an individual in need of a time-based or other interface accommodations, please get in touch with the contact person that sent you the link to our Challenge for requests of this nature. In turn, this contact person will touch base with us to work out the details of any time-based or other interface accommodations.',
		'activity-chances-job':
			'How does my performance on this activity affect my chances of getting the job?',
		'activity-chances-job-answer':
			'The Challenge may be used as a stand-alone measure in the hiring process or used as one measure within a larger set of hiring measures. Furthermore, although we can offer recommended guidelines to our clients, we have no direct control over how organizations use the results to guide their hiring decisions. As such, we advise that any questions related to this matter please be redirected to the contact person that sent you the link to our Challenge.',
		'wild-card': 'Wild Card',
		'wild-card-header-description':
			'New information is being presented to you and you must decide your course of action',
		'consulting-card-header-description':
			'You notice a missed call from a past client. Immediately after, you see that they are calling again. You decide to:',
		'certifier-card-header-description':
			'Incoming email: “Hello, This is the Lab Technician assigned to Project #45667, regarding the electric vehicle charging component. I’m emailing to confirm that you received the test results and ask if you need any more information from me about the product. Please let me know and I’d be happy to provide.” What would you like to do? ',
		'you-just-noticed':
			'You just noticed a missed call from a client. Immediately after, you see that they are calling again…',
		'dont-pick': "Don't pick up",
		'take-the-call': 'Take the call because useful information may be presented to you.',
		'take-the-call-later': 'Take the call and set up a meeting later to continue working.',
		'nothing-for-you': 'Nothing for you here. You’ve got work to do - carry on.',
		'the-client-tells-you-06':
			'The client tells you that they are experiencing a critical issue with a product that you helped develop in a past project. You stay on the phone to help them work through the issue.',
		'the-client-tells-you-1-30':
			'The client tells you that they are experiencing a critical issue with a product that you helped develop in a past project. You schedule another meeting to discuss the issue ',
		'time-desc': 'minutes subtracted from the challenge',
		'consult-card-desc-1': 'Let it go to voicemail once more',
		'consult-card-desc-2':
			'Pick up the call. A past client tells you that they are experiencing a critical issue with a product that you helped develop in a past project. You stay on the phone to help them work through the issue.',
		'consult-card-desc-3':
			'Pick up the call. A past client tells you that they are experiencing a critical issue with a product that you helped develop in a past project. You schedule another meeting to discuss the issue',
		'why-software-development': 'Why software development projects fail',
		'own-your-personal-space': 'Own your personal space',
		'already-have-an-account': 'Already have an account',
		'employer-login': 'Employer Login',
		'post-have-an-account': 'Don&apost have an account',
		register: 'Register',
		'export-to-csv': 'Export To CSV',
		type: 'TYPE',
		'l-type': 'Type',
		data: 'DATA',
		'select-pipeline': 'Select Pipeline',
		rank: 'Rank',
		'characteristic-reflects':
			'This characteristic reflects how quick you are to start working and to revise your own work.Being quick to start writing from the get - go and then just deleting, adding to, and revising their work as they opened the emails and read through the article is how challenge takers were able to score high on Speed and Reflectiveness',
		'characteristic-reflects_example':
			'An example of a task where this characteristic would be beneficial: When you have an urgent task that needs to be tackled right away ',
		'characteristic-reflects-two':
			'This characteristic reflects how you tend to think and plan ahead, focusing on structuring your ideas effectively.Taking your time to read through the email thread and the article before starting to craft your responses is one way to get a higher score on Planning and Organization ',
		'characteristic-reflects-two-example':
			'An example of a task where this characteristic would be beneficial: When you have an important task that requires work that comes close to perfection ',
		'characteristic-reflects-three':
			'This characteristic reflects how much detail you include in your work and how you use this to demonstrate confidence.Taking the clients needs from the email thread and reiterating these needs strongly in the responses is how challenge takers were able to do well in Attention to Detail and Assertiveness',
		'characteristic-reflects-three-example':
			'An example of a task where this characteristic would be beneficial: when you have a task that requires you to leverage your knowledge to convince another person of your ideas',
		'characteristic-reflects-four':
			'This characteristic reflects how much care you put into proper phrasing of your ideas and maintaining objective.Being careful about the language used and ensuring that the responses are neutral in tone is an example of how challenge takers scored high on Neutrality and Carefulness',
		'characteristic-reflects-four-example':
			'An example of a task where this characteristic would be beneficial: when you have a task that benefits from you demonstrating professionalism through impartiality and objectivity ',
		'characteristic-reflects-five':
			'This characteristic reflects how clearly you communicate your ideas and connect them in a logical way.Spending time making sure that ideas that are presented to the client follow logically from one another in how they are put together and the kinds of transition words used is how challenge takers did well on Clarity and Reasoning',
		'characteristic-reflects-five-example':
			'An example of a task where this characteristic would be beneficial: when you have a task that requires you to clearly and logically lay out the details of the situation and your thought process behind it all',
		'alert-dialog':
			'Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running ',
		disagree: 'Disagree',
		agree: 'Agree',
		'talent-relationships': 'Talent Relationships',
		'talent-relationships-subtitle':
			'Uncover hidden relationships between your talent pool. Drag the skill to the axis to see how your talent compares',
		'talent-funnel-title': 'Talent Funnel',
		'talent-funnel-subtitle':
			'Discover your talent ranked on the challenge. Select a category to see the results',
		'team-dynamic-title': 'Team Dynamic',
		'team-dynamic-subtitle':
			'Enhance your team performance by simulating how individuals from other pipelines contribute to your team.Mix and match to optimize for performance',
		'almost-there': 'Almost there',
		'users-pipeline': 'Results will appear once you have at least 50 users in a pipeline',
		'copied-invite': 'Successfully copied invite link to',
		'about-one':
			'With the Nugget.ai challenge, you were asked to take on a specific job role and best simulate how you would think, what you would do, what information you would consider, and what you would recommend if you were completing the Challenge in that job role. From the very moment you opened the Challenge page, we track different facets of the way you were interacting with the resources and the way you were completing of the challenge - all to help us understand how you demonstrate your problem solving and communication skills in a specific work context. We then analyzed these different facets to see what patterns emerged. The results on this page reflect the patterns we were able to identify, and how you did in relation to other people who took the challenge',
		'about-two':
			'Your scores are pinned next to the entire pool of users who took the challenge. We’re creating a unique way of analyzing user performance benchmarked to different benchmarks from industry and market all the way down to company and team. Different benchmarks behave differently as a representation of the diversity that exists in talent across different demographic segments',
		'about-three':
			'Having a score that’s lower than the benchmark doesn’t necessarily mean that you are worse off than everybody else - each company is looking for different combinations of characteristics',
		'about-four':
			'Our objective is to help you discover nuggets of information about your soft skills that help you uncover career paths that currently align with how you think, how you communicate, and how you solve problems. Discover career paths you might have never considered that might be right for you by exploring these results',
		'account-details': 'Account Details',
		'success-redirect': 'Successfully saved. Now redirecting you to nugget.ai',
		'usecase-one':
			'GE Appliances announced an update to its Wi-Fi connected home appliances, which now work directly with Google Assistant, the search giants voice-powered digital assistant. People can say commands like, Hey, Google, preheat the oven to 425 degrees, or ask, Hey, Google, are my dishes clean?',
		'usecase-two':
			'The direct connection with Google Assistant removes the need to add an additional command when talking to GE appliances.Previously, product owners had to use the Geneva Home Action for voice commands, such as ey Google, ask Geneva Home to preheat the oven to 425 degrees.',
		'usecase-three':
			'The change works with GE Appliances connected refrigerators, ovens, dishwashers and washing machines, among other home appliances, all linked to the U + Connect app to manage the devices ',
		'usecase-four':
			'GE Appliances closer integration with Google Assistant comes as the search giant vies with Amazon for dominance in the market for smart home services. The direct connection with the digital assistant could make GE home appliances slightly easier to use than with Alexa, Amazons digital assistant that has worked with GE products for the past couple of years. Amazon and GE in 2016 introduced a Geneva skill for Alexa that requires users say commands such as, Alexa, tell Geneva to preheat the oven to 350 degrees, per CNet. This additional step may add some friction for users looking for a convenient method of controlling their kitchens smart devices',
		'usecase-five':
			'GE Appliances announcement comes as Electrolux, the Swedish maker of home appliances, started integrating its connected kitchen products with Google Assistant. The voice integration will begin in smart ovens next year, Electrolux announced last week. With more appliance makers experimenting with connected home devices, the technology will continue to evolve and grow increasingly sophisticated and easy to use for consumers.',
		'usecase-six':
			'The digital assistant and smart speaker space continues to heat up. Global shipments of voice - powered smart speakers surged 278 % to 9.2 million units in Q1 2018 from a year earlier.While Amazon shipped 4 million of those during the quarter, its market share slipped to 43.6 % from 81.8 % year - over - year, according to Strategy Analytics. The worldwide smart home devices market, comprised of smart speakers, digital media adapters, lighting, thermostats and other connected gadgets like GEs appliances, is forecast to grow 26.8% this year to 549.5 million total shipments, the International Data Corporation estimates ',
		note:
			'Note: These resources are documents provided in advance to all meeting attendees.With these resources, attendees are presented lyrics of a randomly selected song from the label’ s roster. Aside from the lyrics, the general elements of the song are identified. As well, the specific elements of the song are identified and these elements are not necessarily elements that the label executives are looking for, but they should give you an idea of what kinds of information to consider when developing your plan',
		'song-title': 'Song Title',
		'true-colours': 'True Colours',
		unnamed: 'Unnamed',
		instrumentals: 'Instrumentals',
		'no-decription-provided': 'No description provided',
		'vocal-type': 'Vocal type',
		'single-vocal-male': 'Single lead vocal male',
		'theme-song': 'Theme of song',
		'love-relationships': 'Love and relationships',
		'storyline-song': 'Storyline of song',
		'storyline-song-description':
			'The singer is expressing to his lover his desire to know and connect to her on a deeper level.Artistically, the singer uses the metaphor of colours and imagery to communicate this sentiment to his lover ',
		insight: 'Insight',
		talent: 'Talent',
		'your-talent-pipelines': 'Your Talent Pipelines',
		'add-challenge':
			'Add your challenge objective/description here. Everyone on the team will be able to see this!',
		'digital-team': 'Employees',
		send: 'SEND',
		'terms-and-condition': <EnDescription />,
		merger: 'Merger',
		'm-a': 'M&A',
		teamwork: 'Teamwork',
		'consulting-description':
			'You are a management consultant. Your new client is a promising healthcare tech company that is the result of a merger between two up-and-coming healthcare tech startups. The client has reached out to your consulting firm to help them with teamwork issues that started to become noticeable to the executive team two months into the merger. The company has attempted to resolve the issues on their own but has not seen much improvement. With the provided resources, try to identify the problem, collect key information, and recommend a solution to your new client.',
		acquisition: 'Acquisition',
		'organize-culture': 'Organizational culture',
		'consulting-resource-1': 'Employee Feedback',
		'consulting-resource-2': 'Merger Strategy',
		'consulting-resource-3': 'A new email from a co-worker',
		'send-email-again-text': 'Did not receive the email yet?',
		'send-email-again': 'Send Again',
		'create-new-password': 'Create New Password',
		'create-new-password-info':
			'Choosing a strong password and dont reuse it for other accounts. Changing your password will sign you out on all the devices you signed in. You will need to re-enter your new password.',
		'new-password': 'New Password',
		'change-your-password': 'Change Your Password',
		'current-password': 'Current Password',
		'mail-sent': 'Email sent successfully',
		'error-mail-sent': 'There was an error sending the email',
		'profile-update': 'Your profile has been successfully updated',
		'delete-confirmation': 'Are you sure, You want to delete your account?',
		'current-password-incorrect': 'Current Password Incorrect',
		'password-change': 'Password changed successfully',
		'accept-the': 'Accept the',
		'terms-conditions': 'Terms and Conditions',
		training: 'Training',
		'crisis-manage': "Resolve a company's employee issues",
		'crisis-description':
			'You are a management consultant. Your new client is a growing healthcare tech company that has reached out to you with concerns about their customer service employees. Over the past year, customer complaints have doubled, with 39% of customers rating the service they received as unsatisfactory. The organization has offered additional training sessions to these employees but has not seen improvements. With the provided resources, try to identify the problem, collect key information, and recommend a solution to your new client.',
		'crisis-res-1': 'Customer Complaints',
		'crisis-res-2': 'Agenda',
		'crisis-res-3': 'A new email from a co-worker',
		close: 'Close',
		notifications: 'Notifications',
		'caught-all': 'You’re all caught up!',
		'comment-taketest':
			'As you complete this chapter, we are tracking variable to help us understand how you solve the task. Keep an eye out on timer above and good luck!',
		'new-information': 'New information is able to you.',
		now: 'now',
		chapters: 'Chapters',
		'wildcard-name': 'Wild Card: Inbound phone call',
		'wildcard-notify':
			'Important decisions are made all the time. You have a trade off to make',
		'mins-ago': '{time}mins ago',
		'min-ago': '1min ago',
		'take-other-challnge': 'SANDBOX - TAKE ANOTHER CHALLENGE',
		'preview-desc':
			'Here you will find the Challenge description. This description includes the role that you’re supposed to take on and the context that the challenge is taking place in. Most importantly, the Challenge lays out the purpose of your mission.',
		'preview-res1':
			'Here you will find Resource 1. The Resources are examples of real resources that people on the job would have access to when they perform work duties similar to the Challenge mission. The resources can include a wide range of content and can take on various formats – with the purpose of simulating the information and formatting that people on the job would see. We do not offer additional information, beyond what is included in the resources – what’s there is there',
		'preview-res2':
			'Here you will find Resource 2. The Resources are examples of real resources that people on the job would have access to when they perform work duties similar to the Challenge mission. The resources can include a wide range of content and can take on various formats – with the purpose of simulating the information and formatting that people on the job would see. We do not offer additional information, beyond what is included in the resources – what’s there is there.',
		language: 'Language',
		english: 'English',
		spanish: 'Spanish',
		french: 'French (coming soon)',
		'you-will-be-redirected':
			'You will be redirected to Sandbox after you submit this form.',
		'tell-us-about-the-function':
			'Tell us about the function you’re currently in. If applying, think of the role you’d like to be in',
		'tell-us-about-the-role':
			'Tell us about the role level you’re currently in. If not employed, select “I’m Searching”',
		'success-copied': 'Successfully copied',
		'looks-like-you':
			"Looks like you're trying to go back. You have already submitted your challenge and there is nothing left to do.",
		keywords: 'Keywords',
		analytics: 'Analytics',
		'create-account-info': 'Create an account or sign in to see your results',
		'create-account-info-signin': 'Sign in to see your results',
		'create-account-info-signup': 'Sign up to see your results',
		'you-about-submit':
			'You’re about to submit your results, are you sure you want to do this?',
		'iam-searching': "I'm looking for a job",
		'keep-edit': 'Keep Editing',
		'assess-content':
			'This assessment is one directional only. Once you finish a section you can not go back.',
		'submit-sentence': 'Are you sure you you want to submit your results?',
		'verify-email-success': 'Verification email has been successfully sent',
		'click-for-submission': 'Click for submission',
		'looks-like-you-not-150-words':
			"Looks like you didn't meet the minimum 150 words requirement yet.",
		'you-will-solve-a-problem':
			'With the online experience that awaits you on the next pages, our goal is to set the scene for the role in this job domain. Based on your responses, we will extract skills that are relevant to the context of the job. You’ll be asked to respond to scenarios that are likely to come up in the role as if you were dealing with the situation in the moment. You can expect to be in character and write message responses, compose emails, develop plan outlines, and more job-relevant tasks! You may also be asked more technical questions that are specific to the role and we just ask that you try your best with these questions so we can be as accurate as possible with the results we give you',
		'believe-there-is':
			'At nugget.ai, we use real job simulations to measure people’s skills and abilities in situations that are actually work-relevant.',
		'if-challenge': 'If this is your first time taking the challenge, ',
		'click-tutorial': 'click here to see a tutorial',
		first: ' first.',
		'to-prepare-you-for-the-challenge': 'Following the tutorial, you will have ',
		min: 'minutes',
		'to-complete': ' to complete the assessment. You got this!',
		'dont-take-this-one-your-phone': 'Do not take this assessment on your phone',
		'minimum-words': 'Minimum word limit: ',
		'150-words': '150 words',
		'you-have-hidden-talent-external':
			'You have hidden talents, and we help quantify those. How we figure out which opportunities to show you starts long before you even open the challenge, and is guided by a commitment to provide you with the best career matching engine.',
		'you-have-hidden-talent-internal':
			'You have hidden talents, and we help quantify those. How we figure out which opportunities to show you starts long before you even open the challenge, and is guided by our mission to help you navigate career paths through up(re)skilling insights.',
		linkedin_profile: 'LinkedIn Profile',
		'i-am-ready': 'I’M READY',
		'i-am-authorized':
			'I am authorized to work in Canada or can obtain authorization within 30 days. If not, leave the box unchecked and we will connect you with sponsoring companies.',
		'add-a-skill': 'Add a skill and press enter',
		'select-roles': 'Select roles you’re interested in',
		'add-a-role': 'Add a role and press enter',
		'add-a-lang': 'Add a language and press enter',
		'add-a-jobtype': 'Add a job type and press enter',
		'click-here-or-drag-drop': 'Click here or drag and drop your file to upload',
		'this-step-is-optional':
			'This step is optional, but helps our recommendation engine provide you with the best experience possible. Your information is used to deliver valuable insights back to you.',
		'how-was-your-experience': 'How was your experience?',
		'question-title': 'Competency Questionnaire',
		'question-comment':
			'The following questionnaire is for research purpose only.  Please answer the following questions as honest as you can.  Note that your answers to the following questions will not affect your results and will not be revealed to the employers. However, a validity test will be run: if a major discrepancy from your challenge performance and your questionnaire response is flagged, your response to both the challenge and the questionnaire will be voided.',
		'very-bad': 'Very bad',
		'very-good': 'Very good',
		'we-appreciate-feedback': 'We appreciate your feedback!',
		internal: 'Internal',
		external: 'External',
		'challenge-experience':
			'The challenge experience for employees and candidates will be unique to each group.',
		'must-input-pipeline-name': 'You must input Pipeline Name',
		// 'upload-resume': 'Upload resume. Click or drag/drop file here',
		'raw-results': 'Text',
		'product-certifier': 'Product Safety Certifier Challenge',
		'product-certifier-description':
			'You are a Product Safety Certifier. Your client is a top supplier of electric vehicles, wanting CSA Group’s stamp of approval on their electric vehicle charging station. With the provided resources, try to figure out if the charging station meets the CSA Group’s standards.',
		'electric-car': 'Electric Car',
		energy: 'Energy',
		'lab-testing': 'Lab Testing',
		certification: 'Certification',
		timestamp: 'Timestamp',
		wildCardOption: 'WildCard Option',
		'sliderpane-lock-tooltip':
			'You can’t unlock this feature because we don’t have enough data on each role!',
		inspection: 'Inspection',
		'client-communication': 'Client Communication',
		certifier: 'Certifier',
		inspector: 'Inspector',
		'product-safety-certifier-challenge-1': 'Product Safety Certifier Challenge - Part 1',
		'product-safety-certifier-description-1':
			'You are a Product Safety Certifier. Your client is a Toronto-based footwear company that has a new model of men’s safety shoes that they would like to be tested and compared against the CSA Group’s standards. For this challenge, please write an email to be sent to the client to inform them of the test results. ',
		'leadership-title': 'Executive Leadership',
		'leadership-desc':
			'You are a leader in your organization and in charge of a sales team. In monthly meetings, the key players in the organization update the board on organizational performance. The goal of these meetings is to ensure everyone is working towards the monthly and quarterly goals. The organization focuses on collaboration, growth and development, and respect of one’s colleagues and clients. The organization is typically a strong competitor in the industry and employs individuals with high performance. However, in the past year, your team has been experiencing some issues. You have been asked to bring recommendations for your team to today’s board meeting to ensure performance does not continue to decline. Using the resources provided, you must formulate recommendations to present at the board meeting in 25 minutes.',
		leadership: 'Leadership',
		'employee-conflicts': 'Employee Conflicts',
		'managing-teams': 'Managing Teams',
		'executive-leadership': 'Executive Leadership',
		'executive-leadership-res-1': 'Team Performance Appraisal',
		'executive-leadership-res-2': 'Human Resources Complaint - Employee Complaint Form',
		'executive-leadership-res-3': 'Alternative Complaint - Employee Complaint Form',
		'executive-leadership-res-6': 'Email Thread',
		'take-a-quick-look-at-all-the-skills-we-can-measure':
			'Take a quick look at all the skills we can measure',
		'hospitality-title': 'Hospitality Service',
		'hospitality-desc':
			'You are a Service Associate for Wonderful Hotels. Today, you are coming in for your regular shift and during this challenge, you will be asked to complete tasks that can come up during a typical day on the job. You will find these tasks below.',
		'hospitality-res1': 'Co-Worker on early leave',
		'hospitality-res2': 'Client confrontation',
		hospitality: 'Hospitality',
		service: 'Service',
		'linkedin-profile': 'LinkedIn Profile',
		fullname: 'Full Name',
		'analysis-data': 'Analyze Data',
		firstname: 'First Name',
		lastname: 'Last Name',
		location: 'Location',
		'add-skills': 'Add skills',
		'add-role-interests': 'Add role interests',
		'add-job-type': 'Add Job Types',
		'add-certication': 'Add Certification',
		'add-industry': 'Add Industry',
		'add-other-experience': 'Add Other Experiences',
		'other-experience': 'Other Experiences',
		industry: 'Industry',
		'role-function': 'Role function',
		'role-level': 'Role level',
		'highest-edu-achieved': 'Highest education achieved',
		'year-profess-exp': 'Years of professional experience',
		status: 'Job Status',
		resume: 'Resume',
		'upload-resume': 'Upload Resume',
		'add-new': 'Add New',
		'edit-title': 'Edit',
		'setup-profile': 'Set up your profile',
		logout: 'Logout',
		Announcements: 'Announcements',
		FAQ: 'FAQ',
		Notifications: 'Notifications',
		roles: 'Roles',
		skills: 'Skills',
		general: 'General',
		profile_image: 'Profile Picture',
		'complete-challenge': 'Complete a challenge',
		'to-see-your-fit': ' to see your fit and get matched to job opportunities.',
		'enough-data': 'Not enough data to show you anything meaningful.',
		'user-tab-stories': 'Challenges',
		'user-tab-profile': 'Profile',
		'user-tab-Assessments': 'Assessments',
		'user-tab-coins': 'Coins',
		'other-category-view': 'Looking for something else?',
		'stories-sub-title': 'Click on a career path to explore',
		'test-sentence':
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
		consulting: 'Consulting',
		marketing: 'Marketing',
		'career-fit': 'Career fit',
		'score-strength': 'Score strength',
		submission: 'Submissions',
		management: 'Mangement',
		'click-domain': 'Click on a domain to explore your results',
		'all-apply': 'Select all that apply',
		'single-apply': 'Select a single response',
		'already-exist': 'Already have an account? Sign in',
		'dont-exist': "Don't have an account? Sign up",
		signin: 'Sign in',
		singup: 'Sign up',
		institutions: 'Name of Institution',
		'add-new-group': 'Add new group',
		'delete-group': 'Delete group',
		jobtype: 'What type of job are you looking for?',
		edu_type: 'Education',
		textarea_comment: 'Click here to start typing',
		'all-sum-100': 'All values must sum to 100%. Please check again',
		'benchmark-update': 'Benchmark profile successfully updated',
		'create-profile': 'CREATE YOUR PROFILE TODAY!',
		'badge-unlock-message':
			'Unlock badges by completing unique requirements that showcase your career achievements. Employers are 10x more likely to hire candidates with badges',
		badges: 'Badges',
		'register-success': 'Successfully registered!',
		'register-failure': 'Register failure!',
		'enter-fullname': 'Please enter your full name',
		'enter-firstname': 'Please enter your first name',
		'enter-lastname': 'Please enter your last name',
		'enter-location': 'Please enter your location',
		'': 'Please enter a valid LinkedIn Profile',
		'use-point': 'Ways to use your points are coming soon!',
		'working-on':
			"In the meantime, we're working hard to match you with top companies. Once a match is made, you'll receive an email from us",
		'overall-fit': 'Overall Fit',
		'setup-profile-desc':
			'Our engines are geared towards helping you discover your talents to unlock your true skills. Tell us a little bit about you, so we know where to start',
		'role-interests': 'Role interests',
		languages: 'Languages',
		'we-are-glad': 'We’re glad you’re here!',
		'sand-on-board-modal-content':
			'You have hidden talents and Nugget will help you find them. Start by creating your profile and choose from hundreds of challenges to uncover your SuperTalent',
		'opt-check':
			'Opt-in to our mailing list to be the first to receive updates on new corporate partners, product features and updates.',
		'let-get-it': 'LET’S GET TO IT',
		'complement-fit': 'Complementary Fit',
		'close-fit': 'Close Fit',
		'target-fit': 'Target Fit',
		'best-fit': 'Best Fit',
		'user-no-exist': 'User no exist',
		'create-password': 'Create password',
		'pwd-reset-success':
			'An email has been sent. Check your inbox for password reset instructions',
		'salary-range': 'Salary Range',
		'Assessment title': 'Assessment title'
	},
	gu: {
		'tour-step-0':
			'તમારા ચેલેન્જ સૂચનો અહીં મળશે. જ્યારે તમે શરૂ કરો ત્યારે સૂચનો ધ્યાનથી સમીક્ષો.',
		'tour-step-1':
			'આ વિહંગાવલોકન વિભાગ છે. આ વિભાગમાં, તમે ચેલેન્જ અને તમને આપવામાં આવેલા સંસાધનોમાં પ્રવેશ મેળવી શકો છો.',
		'tour-step-2':
			'આ સપોર્ટ ચિહ્ન છે. ચેલેન્જ કેવી રીતે પૂર્ણ કરવી તે વિશે વધુ વાંચવા માટે અહીં ક્લિક કરો.',
		'tour-step-3':
			'આ તમારું કેન્વાસ છે. અહીં ચાર કન્ટેનર છે જે તમને સમસ્યા ઓળખવા, માહિતી એકત્રિત કરવા, વિચાર મंथન કરવા અને ઉકેલની ભલામણ કરવા માટે કહે છે.',
		'tour-step-4':
			'તમે ચેલેન્જ અને સંસાધનોને કેટલું સારું સમજો છો તે આધાર પર તમારું મૂલ્યાંકન કરવામાં આવશે. ટેક્સ્ટ હાઇલાઇટ કરો અને તેને વિભાગમાં ખેંચો.',
		'tour-step-5':
			"ટેક્સ્ટને લક્ષિત વિભાગમાં મૂકો. 'માહિતિ એકત્રિત કરો' એ બતાવવાનું છે કે તમે ચેલેન્જ અને સંસાધનોના મુખ્ય ખ્યાલોને કેટલી સારી રીતે સમજો છો.",
		'tour-step-6':
			"આસેસમેન્ટને સમયબદ્ધ બનાવાયું છે, તેથી સમય પૂરતો હોવો જોઈએ. એકવાર તમે પૂર્ણ કરો, તો તમારા પરિણામો સબમિટ કરવા માટે 'ફિનિશ' બટન દબાવો.",
		'start-test-title': 'શું તમે ખરેખર શરૂ કરવા માંગો છો?',
		'start-test-content':
			'ખાતરી કરો કે બ્રાઉઝર ફુલ સ્ક્રીનમાં ખુલ્લું છે અને તમે ટૅબ બંધ કરશો નહીં નહીં તો તમારે ફરીથી શરૂ કરવું પડશે. શુભેચ્છાઓ!',
		start: 'શરૂ કરો',
		'show-me-again-u': 'મને ફરી બતાવો!',
		consultant: 'સલાહકાર',
		next: 'આગળ',
		prev: 'પાછળ',
		finish: 'પૂર્ણ કરો',
		login_to_sandbox: 'સૅન્ડબૉક્સમાં લૉગિન કરો',
		'how-can-we-help': 'અમે કેવી રીતે મદદ કરી શકીએ?',
		'how-can-we-help-explain':
			'આ તમારી ચેલેન્જ પૂર્ણ કરવાની માર્ગદર્શિકા છે. સમયગાળો ચાલુ છે, તેથી સમય બગાડશો નહીં!',
		application: 'અરજી',
		other: 'અન્ય',
		help: 'મદદ',
		'add-new-section': 'નવું વિભાગ ઉમેરો',
		'identify-the-problem': 'સમસ્યા ઓળખો',
		'highlight-key-sentences':
			'લેખમાંથી મહત્વપૂર્ણ વાક્યો હાઇલાઇટ કરો. તેને ખેંચો અને છોડી દો એટલું જ સરળ છે',
		'brainstorm-viable': 'સમસ્યાની હદમાં સમાઈ જાય એવી શક્ય વિચારો માટે વિચાર મंथન કરો',
		'use-your-creativity': 'તમારી સર્જનાત્મકતાનો ઉપયોગ કરો અને ઉકેલની ભલામણ કરો',
		problem: 'સમસ્યા',
		'collect-information-title': 'માહિતી એકત્રિત કરો',
		ideas: 'વચ્ચાર',
		solution: 'ઉકેલ',
		resource: 'સંસાધન',
		'no-card-name': 'કાર્ડનું નામ નથી',
		'challenge-instructions': 'ચેલેન્જ સૂચનો',
		'test-name-not-found': 'ટેસ્ટનું નામ મળ્યું નથી',
		'drop-the-text-here': 'ટેક્સ્ટ અહીં છોડો',
		'type-away-what': 'લખો... તમે બીજું શું જણાવવા માંગો છો?',
		title: 'શીર્ષક',
		'are-you-sure': 'શું તમે ખાતરીપૂર્વક કહી શકો?',
		'content-exit-challenge':
			'તમારું ચેલેન્જ છોડવાનો પ્રયાસ લાગી રહ્યો છે. જો તમે આવી રીતે બહાર નીકળશો તો તમારું બધું પ્રગતિ ખોવાઈ જશે.',
		'continue-the-challenge': 'ચેલેન્જ ચાલુ રાખો',
		'content-finish-challenge': 'તમારું પરિણામ સબમિટ કરવા માટે તમે તૈયાર લાગો છો',
		'time-up': 'સમય પૂરો થયો!',
		'hard-part-over': 'કઠિન ભાગ પૂર્ણ થયો. હવે આરામથી બેસો અને પરિણામોની રાહ જુઓ',
		'great-job-u': 'શાનદાર કામ!',
		'u-finished-it': 'શાનદાર કામ!',
		'sit-tight-well':
			'શાંતિ રાખો! પરિણામ ઉપલબ્ધ થતાં જ અમે તમને જણાવીશું. અહીં કેટલીક સંખ્યાઓ છે તમારા પરિણામની રૂપરેખા આપવા માટે.',
		'sit-tight-well-short': 'શાંતિ રાખો! પરિણામ ઉપલબ્ધ થતાં જ અમે તમને જણાવીશું.',
		'want-to-improve-ex': 'અનુભવ સુધારવા માંગો છો? આ ઝડપી પૂરું કરો',
		survey: 'સર્વે',
		minutes: 'મિનિટ',
		'pace-of-writing': 'લખાણની ગતિ',
		'words-per-minute': 'પ્રતિ મિનિટ શબ્દો',
		'head-start': 'શરુઆત',
		'how-long-takes': 'પ્રથમ શબ્દ લખવા માટે તમારું કેટલો સમય (સેકંડમાં) લાગ્યો?',
		'quick-fix': 'ઝડપી ઉકેલ',
		'number-times-deleting': 'લખાણના 3 સેકંડની અંદર કેટલી વાર તમે લખેલું કાઢ્યું',
		'run-on': 'ચાલુ છે',
		'number-long-sentences': '30થી વધુ શબ્દો ધરાવતી લાંબી વાક્યોની સંખ્યા',
		'select-an-assessment': 'એક મૂલ્યાંકન પસંદ કરો',
		'select-from-pre-built':
			'તૈયાર મૂલ્યાંકનમાંથી પસંદ કરો. અમે સામગ્રી અને દૃષ્ટિકોણો સંભાળશું.',
		'business-to-business-sales': 'વ્યવસાયથી વ્યવસાય વેચાણ',
		'business-to-business-sales-description':
			'તમે B2B (બિઝનેસ-ટુ-બિઝનેસ) સેલ્સ રિપ્રેઝન્ટેટિવ છો. તમારા મેનેજરે તમને એક સંભવિત નવા ક્લાઈન્ટ વિશે જાણકારી આપી છે, જે તેની કંપની માટે એક વેબસાઈટ વિકસાવવા માગે છે. આ પડકારમાં, નવા ક્લાઈન્ટની જરૂરિયાતો ઓળખો, આપેલા સ્ત્રોતોમાંથી માહિતી એકત્ર કરો, સંભવિત વિકલ્પો વિકસાવો અને શ્રેષ્ઠ વિકલ્પની ભલામણ કરો.',
		'email-thread-between': 'મેનેજર અને ક્લાઈન્ટ વચ્ચે ઈમેઈલ થ્રેડ',
		'descriptions-services-provided': 'કંપની દ્વારા આપવામાં આવતા સેવાઓના વર્ણન',
		'actionablet-tips-closing': 'વધુ B2B વેચાણ બંધ કરવા માટે અમલમાં મૂકવા યોગ્ય સૂચનો',
		'data-science': 'ડેટા વિજ્ઞાન',
		'data-science-description':
			'તમે એક ડેટા વૈજ્ઞાનિક છો જે ટેક્નોલોજી ઉદ્યોગમાં 150 કર્મચારીઓ ધરાવતી એક ઉદયમાન કંપની સાથે કામ કરો છો. ક્લાઈન્ટે તાજેતરમાં તેમના કર્મચારીઓ અને તેમની નોકરીના અનુભવ અંગે આંતરિક માહિતી એકત્રિત કરી છે. તેઓ તમને તેમના ડેટાનું વિશ્લેષણ કરવા માટે કહી રહ્યા છે જેથી તેઓ તેમની નીતિઓ, પ્રથાઓ અથવા તાલીમમાં ફેરફાર કરી શકે. આ પડકારમાં, મુખ્ય સમસ્યાઓ ઓળખો, ડેટા પરથી માહિતી એકત્ર કરો, વિકલ્પો માટે વિચાર કરો અને છેલ્લે ભલામણો આપો.',
		'interview-findings': 'ઇન્ટરવ્યૂમાં થયેલ શોધો',
		'correlation-table': 'સાંખ્શિક સંબંધોની કોષ્ટક',
		'multiple-regression-table': 'મલ્ટિપલ રિગ્રેશન કોષ્ટક',
		'business-strategy-proposal': 'વ્યવસાય રણનીતિ માટેનો પ્રસ્તાવ',
		'business-strategy-proposal-description':
			'તમે એક મધ્યમ કદની કંપની માટે પૂર્ણ સમયકાળના કર્મચારી તરીકે કામ કરો છો. ગયા બે વર્ષથી કંપનીની ઓપરેટિંગ નફામાં સતત ઘટાડો થયો છે. વેચાણમાં ઘટાડો અને ખર્ચમાં વધારો આ માટે જવાબદાર છે. આ સમસ્યા હલ કરવા માટે કંપનીએ આંતરિક કર્મચારીઓમાંથી એક મલ્ટિફંક્શનલ ટીમ બનાવવાનો નિર્ણય કર્યો છે, જેમાં તમને પણ સામેલ કરવામાં આવ્યા છે. ટીમે પહેલાની બેઠકમાં નક્કી કર્યું છે કે આગળ વધતા પહેલા દરેક સભ્યએ વ્યક્તિગત રીતે વિચાર કરવો જોઈએ કે સમસ્યા શું છે, શા માટે છે અને તેને કેવી રીતે હલ કરી શકાય. તમારું પ્રેઝેન્ટેશન હવે 20 મિનિટમાં છે!',
		'customer-client-feedback': 'ગ્રાહક / ક્લાઈન્ટ પ્રતિસાદ',
		'performance-management-results': 'કાર્યક્ષમતા વ્યવસ્થાપનના પરિણામો',
		'profits-chart': 'નફાની કોષ્ટક',
		'get-started': 'શરુ કરો',
		welcome: 'સ્વાગત છે',
		name: 'નામ',
		email: 'ઇમેઇલ',
		age: 'ઉંમર',
		gender: 'લિંગ',
		male: 'પુરુષ',
		female: 'સ્ત્રી',
		'prefer-not-to-say': 'કહેવું પસંદ નથી',
		continue: 'ચાલુ રાખો',
		'what-ethnicity-cultural-group': 'તમે કયા જાતિ/સાંસ્કૃતિક જૂથ સાથે ઓળખો છો?',
		caucasian: 'કોકેસિયન',
		'latin-american': 'લેટિન અમેરિકન',
		african: 'આફ્રિકન',
		profile_image: 'પ્રોફાઇલ ફોટો',
		caribbean: 'કેરિબિયન',
		'middle-east': 'મધ્ય પૂર્વ',
		'south-asian': 'દક્ષિણ એશિયન (જેમ કે, પૂર્વ ભારતીય, શ્રીલંકન)',
		'southeast-asian': 'દક્ષિણપૂર્વ એશિયન (જેમ કે, વિયેતનામી, ચીની, ફિલીપીનોઇ)',
		'west-asian': 'પશ્ચિમી એશિયન (જેમ કે, ઇરાનિયન, અફઘાની)',
		aboriginal: 'મૂળનિવાસી (જેમ કે, ઉત્તર અમેરિકન ઇન્ડિયન, ઇન્યુઇટ)',
		mixed: 'મિશ્રિત',
		'what-is-your-marital': 'તમારું વૈવાહિક દરજ્જો શું છે?',
		'how-do-you-want-to-create': 'તમે કેવી રીતે બનાવવું પસંદ કરો છો?',
		'pre-built-assessment': 'તૈયાર કરેલું મૂલ્યાંકન',
		'create-your-own': 'તમારું પોતાનું બનાવો',
		'please-select-role-type': 'કૃપા કરીને ભૂમિકા પ્રકાર પસંદ કરો!',
		'please-select-position-type': 'કૃપા કરીને સ્થાન પ્રકાર પસંદ કરો!',
		'what-are-you-hiring-for': 'તમે કોને માટે નોકરી માટે રાખી રહ્યા છો?',
		'help-us-define-your-role':
			'કૃપા કરીને તમારી ભૂમિકા વ્યાખ્યાયિત કરવામાં અમને મદદ કરો જેથી અમે શ્રેષ્ઠ મૂલ્યાંકન સૂચવી શકીએ.',
		'role-type': 'ભૂમિકા પ્રકાર',
		none: 'કશું નહીં',
		marketing: 'માર્કેટિંગ',
		'customer-service': 'ગ્રાહક સેવા',
		sales: 'વેચાણ',
		'product-management': 'ઉત્પાદન વ્યવસ્થાપન',
		'business-management': 'વ્યાપાર વ્યવસ્થાપન',
		'business-strategy': 'વ્યાપારની રણનીતિ',
		'position-type': 'સ્થાન પ્રકાર',
		'co-op-internship': 'કો-ઑપ/ઇન્ટર્નશીપ',
		'entry-level': 'પ્રારંભિક સ્તર',
		'junior-manager': 'જુનિયર મેનેજર',
		'middle-manager': 'મધ્યમ સ્તરના મેનેજર',
		'add-the-keywords': 'મુખ્ય શબ્દો ઉમેરો',
		cancel: 'રદ કરો',
		'please-select-the-assessment': 'કૃપા કરીને મૂલ્યાંકન પસંદ કરો!',
		'create-your-benchmark': 'તમારું બેન્ચમાર્ક બનાવો',
		'create-a-benchmark-by-sending':
			'સૌથી સારા પ્રદર્શન કરનારા કર્મચારીઓને મૂલ્યાંકન મોકલીને બેન્ચમાર્ક બનાવો',
		'share-the-link-below': 'નીચે આપેલ લિંક શેર કરો',
		launch: 'પ્રારંભ કરો',
		'create-challenge': 'ચેલેન્જ બનાવો',
		search: 'શોધો',
		'example-challenge': 'ઉદાહરણ ચેલેન્જ',
		'single-never-married': 'અવિવાહિત (ક્યારેય લગ્ન ન કર્યા હોય)',
		widowed: 'વિધવા/વિધુર',
		separated: 'અલગ થયેલ',
		divorced: 'છૂટાછેડા થયેલ',
		married: 'લગ્ન થયેલ',
		'living-common-law': 'સાથે રહીને લગ્ન સિવાય સંબંધ',
		'what-is-the-highest-degree': 'તમારું સૌથી ઉંચું શિક્ષણ કયું છે?',
		'less-than-high-school-diploma': 'હાઈ સ્કૂલ ડિપ્લોમા કરતાં ઓછું',
		'high-school-degree-or-equivalent': 'હાઈ સ્કૂલ ડિગ્રી અથવા સમકક્ષ (જેમ કે GED)',
		'some-scollege-no-degree': 'કેટલીક કોલેજ કરી છે, પણ ડિગ્રી નથી',
		'associate-degree': 'એસોસિએટ ડિગ્રી (જેમ કે AA, AS)',
		'bachelors-degree': 'સ્નાતક ડિગ્રી (જેમ કે BA, BS)',
		'masters-degree': 'માસ્ટર ડિગ્રી (જેમ કે MA, MS)',
		'professional-degree': 'વ્યાવસાયિક ડિગ્રી (જેમ કે MD, DDS)',
		doctorate: 'ડોક્ટરેટ (જેમ કે PhD, EdD)',
		'what-is-your-current-employment-status': 'તમારું હાલનું નોકરીની સ્થિતિ શું છે?',
		'employed-full-time-40': 'પૂર્ણ સમય માટે નોકરી (હفتામાં 40 કે તેથી વધુ કલાક)',
		'employed-part-time-39': 'અર્ધ સમય માટે નોકરી (હفتામાં 39 કલાક સુધી)',
		'unemployed-and-currently-looking': 'બેરોજગાર અને હાલમાં નોકરી શોધી રહ્યા છે',
		'Unemployed-and-currently-not-looking': 'બેરોજગાર અને હાલમાં નોકરી શોધી રહ્યા નથી',
		student: 'વિદ્યાર્થી',
		retired: 'નિવૃત્ત',
		'self-employed': 'સ્વનિર્ભર (સ્વરોજગારી)',
		'unable-to-work': 'કામ કરવામાં અસમર્થ',
		'to-tutorial': 'ટ્યુટોરીયલ સાથે',
		'please-do-not-take-this-assessment-on-phone': 'કૃપા કરીને આ મૂલ્યાંકન ફોન પર ન આપો',
		company: 'કંપની',
		'company-would-like':
			'તમે તેમની ટીમમાં કેટલાં યોગ્ય છો તે જોવા કંપની ઈચ્છે છે. આ માટે, તમારે 4 પગલાંની પ્રક્રિયા સાથે ચેલેન્જ પૂર્ણ કરવી પડશે.',
		'company-to-prepare':
			'ચેલેન્જ માટે તૈયાર થવા માટે, તમને ઇન્ટરફેસ દ્વારા માર્ગદર્શન આપતું ટ્યુટોરીયલ મળશે. અમે ભલામણ કરીએ છીએ કે તમે અમારી ટીપ્સ વાંચો.',
		'company-following-tutorial':
			'આ ટ્યુટોરીયલ બાદ, તમારી પાસે ચેલેન્જ પૂર્ણ કરવા માટે {n} મિનિટ હશે. શુભેચ્છાઓ!',
		'assess-learn-evolve': 'મૂલ્યાંકન કરો. શીખો. વિકાસ કરો.',
		'discover-your-soft-skills':
			'ભૂમિકા સંબંધિત ચેલેન્જો દ્વારા તમારી નમૃત્તા ક્ષમતાઓ શોધો.',
		'n-challenges-available': '{n} ચેલેન્જો ઉપલબ્ધ છે',
		'search-challenge': 'ચેલેન્જ શોધો',
		'hi-{name}': 'નમસ્તે {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, તમે આગળ વધી રહ્યા છો!',
		'discover-nuggets-about-your-soft-skills': 'તમારી નમ્રતા ક્ષમતાઓ વિશેના નગેટ્સ શોધો',
		'register-login': 'લૉગિન કરો',
		'add-pipeline-label': 'નવું ટેલેન્ટ પુલ ઉમેરો',
		'nugget-ai-science': 'Nugget.ai વિજ્ઞાન',
		'our-prediction-models':
			'અમારા અનુમાન મોડેલો એ ઉદ્યોગ અને સંગઠન મનોચિકિત્સા પર આધારિત શૈક્ષણિક સંશોધનથી આધારિત છે.',
		'performance-nugget': 'કાર્યક્ષમતા નગેટ',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'તમારું ધ્યાન નિર્ધારિત કરો અને સુધારવા માટે ખામીઓ શોધો',
		'discover-your-path': 'તમારું માર્ગ શોધો',
		'keep-an-open-mind-and-try-something-new':
			'મૂળ્યાંકન વિના ખૂલેલા મનથી રહો અને કંઈક નવું અજમાવો!',
		'compare-to': 'સાથે સરખાવો',
		'growth-tips': 'વિકાસ માટેના સૂચનો',
		'machine-drive-advice-subtitle': 'ટોચના 10% વ્યાવસાયિકોના મશીન આધારિત સૂચનો.',
		'growth-tips-1':
			'“વિગતો તરફ ધ્યાન જ કામમાં સફળતા કે નિષ્ફળતાનું સૌથી મોટું કારણ રહ્યું છે.”',
		'growth-tips-2':
			'“ટેકનોલોજી ઉકેલો સાથેના પોર્ટફોલિયોને સંભાળવું જ્યાં ઉદ્યોગ ઝડપથી બદલાઈ રહ્યો છે, એ તમને હંમેશા સજાગ રાખે છે...”',
		'growth-tips-3':
			'“બ્લોકચેન દરેક ઉદ્યોગને બદલવાનો સંભાવિત સામર્થ્ય ધરાવે છે, એજ રીતે જે રીતે મશીન લર્નિંગ આજે કરી રહ્યું છે. નવી શોધો માટે સર્જનાત્મક રીતે વિચારવાની ક્ષમતા તમારી કારકિર્દી માટે નિર્માણાત્મક છે.”',
		'what-does-this-mean': 'આનો અર્થ શું થાય છે?',
		'project-coodinator': 'પ્રોજેક્ટ કોઓર્ડિનેટર',
		'financial-analyst': 'આર્થિક વિશ્લેષક',
		'project-manager': 'પ્રોજેક્ટ મેનેજર',
		'blue-sky-music-proposal': 'બ્લ્યુ-સ્કાય સંગીત પ્રસ્તાવ',
		'blue-sky-music-proposal-description':
			"તમે સંગીત ઉદ્યોગ પર રાજ કરી રહેલા એક રેકોર્ડ લેબલ સાથે સંકળાયેલા કલાકાર છો. આ રેકોર્ડ લેબલ દર મહિને 'બ્લ્યુ સ્કાય' બેઠકનું આયોજન કરે છે જ્યાં કલાકારોએ (તમારા જેવા) નવી ગીત માટેની યોજનાનું વિસ્તૃત પ્રસ્તાવ રજૂ કરવાનું ઉત્સાહિત કરવામાં આવે છે. આ ગીત કોઈપણ શૈલીનું, બંધારણવાળું અને વિષય પર આધારિત હોઈ શકે છે. આ પડકાર દરમિયાન, તમે તમારી યોજના માટે શામેલ કરવા માંગો છો એવા ઘટકોની ઓળખ કરો, આપેલા સાધનોમાંથી માહિતી ભેગી કરો, કેટલાક વિચારો શોધો અને તમારા પ્રસ્તાવ તરીકે મોટી વિચારણા રજૂ કરો.",
		'blue-sky-music-proposal-resource-1': 'સાધન 1: સાચા રંગો - સામાન્ય ઘટકો',
		'blue-sky-music-proposal-resource-2': 'સાધન 2: સાચા રંગો - ગીતના શબ્દો',
		'help-a-first-time-homebuyer': 'પ્રથમ વખત ઘર ખરીદનારને મદદ કરો',
		'help-a-first-time-homebuyer-description':
			'તમે રિયલ એસ્ટેટ વેચાણ પ્રતિનિધિ છો. એક સંભાવિત ગ્રાહકે પોતાનું પહેલું ઘર ખરીદવાની રુચિ દર્શાવી છે. આ પડકારમાં, નવા ગ્રાહકની જરૂરિયાતોને ઓળખો, આપેલા સાધનોમાંથી માહિતી ભેગી કરો, શક્ય વિકલ્પો તૈયાર કરો અને અંતે શ્રેષ્ઠ વિકલ્પ અને કારણસર ભલામણ કરો.',
		emails: 'ઈમેઇલ્સ',
		'property-listings-table': 'જમિનની યાદીની ટેબલ',
		'find-your-perfect-home': 'તમારું આદર્શ ઘર શોધો',
		'marketing-description':
			'તમે માર્કેટિંગ સ્પેશિયાલિસ્ટ છો. તમે મધ્યમ કદની રિટેલ કંપની માટે કામ કરો છો જે ઉચ્ચ ગુણવત્તાવાળી આઉટડોર કપડાં વેચે છે અને ગયા પાંચ વર્ષથી આ ઉદ્યોગમાં કાર્યરત છે. આ કંપની મુખ્યત્વે ઓનલાઈન વેચાણ કરે છે, પરંતુ તાજેતરમાં ઉચ્ચ મેનેજમેન્ટ ટીમે માત્ર ઈ-કોમર્સ મોડલથી દૂર જવાની સંભાવના પર વિચાર કર્યો છે. તમને આપેલી માહિતી અને તમારા અનુભવના આધારે ભલામણ આપવા માટે પૂછવામાં આવ્યું છે.',
		'customer-demographics': 'ગ્રાહક ડેમોગ્રાફિક્સ',
		'customer-satisfaction-survey': 'ગ્રાહક સંતોષ સર્વે',
		'our-science': 'અમારું વિજ્ઞાન',
		'{number}-assessments-take-so-far': 'અત્યાર સુધીમાં લેવાયેલું મૂલ્યાંકન: {number}',
		'built-with-love-in-toronto': 'ટોરોન્ટોમાં પ્રેમપૂર્વક બનાવેલું',
		whoops: 'અરે બાપરે!',
		'404-message': 'તમે દાખલ કરેલ લિંક તૂટી ગઈ છે અથવા હવે અસ્તિત્વમાં નથી',
		'take-me-home': 'મને હોમ પેજ પર લઈ જાવ',
		'what-does-this-mean-s1':
			'તમે પૂર્ણ કરેલા પડકારમાં, તમારી પાસેથી વેચાણની ભૂમિકામાં સંવાદ અને સમસ્યા હલ કરવાની કળા દર્શાવવાનું કહેવામાં આવ્યું હતું – અને તમે કર્યું પણ! જ્યારે તમે પડકાર શરૂ કર્યો ત્યારથી, અમે તમારી જવાબો અને તે જવાબો સુધી પહોંચવા માટે તમે લીધેલા પગલાંઓ પર નજર રાખી. અહીં, તમે અમારાં વિશ્લેષણમાંથી મળેલી કેટલીક માહિતીની ઝાંખી જોઈ શકો છો.',
		'what-does-this-mean-s2':
			'અમે, સ્પષ્ટપણે, અમારી ગુપ્ત રીત શેર કરી શકતા નથી, પરંતુ તમને વિચારવુ બનાવે તેવા ઉદાહરણ અહીં છે.',
		'what-does-this-mean-s3-bold': 'ઝડપ અને વિચારવી:',
		'what-does-this-mean-s3':
			'પ્રથમ ક્ષણથી લખવાનું શરૂ કરવું અને પછી ઈમેઇલ ખોલીને અને લેખ વાંચીને તમારું કામ કાઢવું, ઉમેરવું અને સમીક્ષા કરવું એ રીતે પડકાર આપનારોએ ઝડપ અને ચિંતન પર ઉચ્ચ સ્કોર મેળવ્યો.',
		'what-does-this-mean-s4':
			'આ લાક્ષણિકતા લાભદાયી સાબિત થાય તેવી કાર્યની એક ઉદાહરણઃ જ્યારે તમારું કાર્ય તાત્કાલિક ધ્યાન માંગતું હોય.',
		speed: 'ઝડપ',
		'meticulousness-assertiveness': 'સચોટતા અને આત્મવિશ્વાસ',
		'attention-to-detail': 'વિગતો પ્રત્યે ધ્યાન',
		'clarity-reasoning': 'પારદર્શકતા અને તર્કશક્તિ',
		export: 'નિકાસ કરો',
		archieve: 'આર્કાઇવ કરો',
		delete: 'કાઢી નાખો',
		'are-you-sure-you-want-to-delete': 'શું તમે ખરેખર તેને કાઢી નાંખવા માંગો છો?',
		'pick-a-challenge': 'એક પડકાર પસંદ કરો',
		'confirm-pick': 'પસંદગીની પુષ્ટિ કરો',
		'challenge-added': 'પડકાર ઉમેરાયો!',
		'sharable-link': 'શેર કરી શકાય તેવો લિંક',
		'sharable-link-copy': 'શેર કરી શકાય તેવો લિંક કોપી થયો',
		music: 'સંગીત',
		lyrics: 'ગીતના શબ્દો',
		artist: 'કલાકાર',
		'creative-industries': 'સર્જનાત્મક ઉદ્યોગો',
		'song-proposal': 'ગીતની રજૂઆત',
		voice: 'અવાજ',
		'real-estate': 'સ્થાવર મિલકત',
		'customer-success': 'ગ્રાહક સફળતા',
		software: 'સોફ્ટવેર',
		customer: 'ગ્રાહક',
		experience: 'અનુભવ',
		regression: 'રિગ્રેશન',
		'data-analysis': 'ડેટા વિશ્લેષણ',
		'data-mining': 'ડેટા ખનન',
		'digital-marketing': 'ડિજિટલ માર્કેટિંગ',
		'e-commernce': 'ઈ-કોમર્સ',
		retail: 'પરચૂર્ની વેચાણ',
		strategy: 'ยุદ્ધનીતિ',
		financial: 'નાણાકીય',
		analysis: 'વિશ્લેષણ',
		role: 'ભૂમિકા',
		rolelevel: 'ભૂમિકા સ્તર',
		function: 'કાર્ય',
		organization: 'સંસ્થા',
		industry: 'ઉદ્યોગ',
		'team-size': 'ટીમનું કદ',
		'update-profile': 'પ્રોફાઇલ અપડેટ કરો',
		'sign-out': 'લૉગઆઉટ',
		'delete-account': 'એકાઉન્ટ ડિલીટ કરો',
		'change-password': 'પાસવર્ડ બદલો',
		'Edit-profile': 'પ્રોફાઇલ સંપાદિત કરો',
		login: 'પ્રવેશ કરો',
		signup: 'નોંધણી કરો',
		'enter-your-email': 'તમારું ઇમેઇલ દાખલ કરો',
		'enter-your-password': 'તમારો પાસવર્ડ દાખલ કરો',
		'Ask-your-friend-to-get-one': 'તમારા મિત્રને એક મેળવવા કહો',
		password: 'પાસવર્ડ',
		'login-as-employee': 'કર્મચારી તરીકે લૉગિન કરો',
		'loggin-as-employer': 'નિયામક તરીકે લૉગિન કરો',
		'forgot-password': 'પાસવર્ડ ભૂલી ગયા છો?',
		username: 'વપરાશકર્તા નામ',
		firstname: 'પ્રથમ નામ',
		lastname: 'છેલ્લું નામ',
		'enter-your-firstname': 'તમારું પહેલું નામ દાખલ કરો',
		'enter-your-lastname': 'તમારું છેલ્લું નામ દાખલ કરો',
		'enter-your-username': 'તમારું યુઝરનેમ દાખલ કરો',
		'auth-no-user': 'વપરાશકર્તા નામ અથવા પાસવર્ડ ખોટો છે',
		'signup-as-employer': 'નિયામક તરીકે સાઇન અપ કરો',
		'signup-as-employee': 'કર્મચારી તરીકે સાઇન અપ કરો',
		'invalid-username': 'અમાન્ય યુઝરનેમ!',
		'invalid-email': 'અમાન્ય ઇમેઇલ!',
		'invalid-password': 'અમાન્ય પાસવર્ડ!',
		'confirm-password': 'પાસવર્ડની પુષ્ટિ કરો',
		'signup-failed1': 'સાઇનઅપ નિષ્ફળ',
		'signup-failed2': 'તમારું ઇમેઇલ પહેલેથી અસ્તિત્વમાં છે',
		'verify-email-title': 'તમારું ઇમેઇલ ચકાસો',
		'verify-email-content':
			'તમારું નોંધણી બદલ આભાર. કૃપા કરીને તમારું એકાઉન્ટ ચકાસવા માટે તમારું ઇમેઇલ તપાસો પહેલાં તમે શરૂ કરી શકો.',
		'repeat-your-password': 'તમારો પાસવર્ડ ફરી લખો',
		'password-not-match': 'પાસવર્ડ મેળ ખાતો નથી',
		'password-reset': 'પાસવર્ડ રીસેટ',
		'enter-your-email-and-well':
			'તમારું ઇમેઇલ દાખલ કરો અને અમે તમને પાસવર્ડ રીસેટ કરવા માટે એક લિંક મોકલશું',
		'answer-some-questions': 'થોડીક પ્રશ્નોના જવાબ આપો',
		'tell-us-about-yourself': 'અમને તમારા વિશે કહો',
		'tell-us-about-yourself-description':
			'આ ફોર્મમાંથી એકત્રિત માહિતી માત્ર સંશોધન હેતુઓ માટે છે. કોઈપણ ખાનગી માહિતી ન તો સાચવવામાં આવશે કે ન જ વહેંચવામાં આવશે.',
		'we-want-your-feedback': 'અમે તમારી ટિપ્પણીઓ ઈચ્છીયે છીએ!',
		'we-want-your-feedback-description':
			'આ સર્વેના ઉદ્દેશ્ય તમારા અનુભવને સમજવાનો છે, કારણ કે અમે તમને શ્રેષ્ઠ અનુભવ આપવા માટે પ્રયત્નશીલ છીએ! અંદાજે સમય 3 મિનિટથી ઓછો છે.',
		'we-want-your-feedback-note': '* સાથેના પ્રશ્નો ફરજિયાત છે.',
		'how-this-assessment-colleague':
			'તમે આ મૂલ્યાંકન તમારા મિત્ર કે સહકર્મી ને ભલામણ કરશો તેવી સંભાવના કેટલી છે?',
		'above-score-reason': 'પર્યાપ્ત સ્કોર માટે તમારું કારણ શું છે?',
		'what-think-content-of-challenge': 'આ ચેલેન્જની સામગ્રી વિશે તમારું શું મંતવ્ય છે? *',
		'additional-feedback-to-product-team':
			'અમારું ઉત્પાદન ટીમ શ્રેષ્ઠ અનુભવ આપવા માટે કામ કરી રહી છે. શું તમારી પાસે વધારાની ટિપ્પણીઓ છે?',
		'enter-your-email-address': 'કૃપા કરીને તમારું ઇમેઇલ સરનામું દાખલ કરો',
		'go-take-a-look': 'જાઓ ને એક નજર નાખો!',
		'for-2-minutes': '2 મિનિટ માટે, ઈન્ટરફેસ સાથે આરામદાયક થાઓ અને તત્વો સાથે રમો.',
		'your-data-will-not-saved-in-the-preview':
			'પ્રિવ્યૂ મોડમાં તમારું ડેટા સાચવવામાં નહીં આવે.',
		'neat-let-me-see-it': 'વાહ! મને બતાવો',
		'preview-mode': 'પ્રિવ્યૂ મોડ',
		skip: 'છોડી દો',
		userlist: 'વપરાશકર્તા સૂચિ',
		challengelist: 'ચેલેન્જ સૂચિ',
		pipelinelist: 'પાઇપલાઇન સૂચિ',
		'challenge-result-list': 'ચેલેન્જ પરિણામોની સૂચિ',
		download: 'ડાઉનલોડ',
		count: 'ગણતરી',
		'finance-accounting': 'આર્થિક અને હિસાબી વ્યવસ્થાપન',
		'general-management': 'સામાન્ય વ્યવસ્થાપન',
		'human-resources': 'માનવ સંસાધનો',
		'information-technology': 'માહિતી પ્રૌદ્યોગિકી',
		operations: 'ઓપરેશન્સ',
		'individual-contributor': 'વ્યક્તિગત યોગદાનકાર',
		'expert-individual-contributor': 'વિશેષજ્ઞ વ્યક્તિગત યોગદાનકાર',
		manager: 'વ્યવસ્થાપક',
		'senior-manager': 'સીનિયર વ્યવસ્થાપક',
		executive: 'એગ્ઝિક્યુટિવ',
		'about-the-role': 'ભૂમિકાની માહિતી',
		'role-level': 'ભૂમિકા સ્તર',
		'mid-level-manager': 'મધ્ય સ્તરના વ્યવસ્થાપક',
		create: 'બનાવો',
		'solve-three-steps':
			'હું જોઈ શકું કે તમે પ્રોગ્રામ માટે યોગ્ય છો કે કેમ. અમે તમને એક પડકાર આપીશું અને તેને ત્રણ પગલાંમાં ઉકેલવા કહેશું.',
		'important-instructions': 'મહત્વપૂર્ણ સૂચનાઓ',
		instructions:
			"તમને ચાર કન્ટેનરમાં કામ કરવા માટે પૂછવામાં આવશે: 'સમસ્યા ઓળખો', 'મહત્વપૂર્ણ માહિતી એકત્રિત કરો' (તમે લખાણને ડ્રેગ અને ડ્રોપ કરી શકો છો), '아이ડિયાઝ જનરેટ કરો (બધામાંથી 3 વિકલ્પો પસંદ કરો)', અને 'એક ઉકેલ ભલામણ કરો'. તમે બુલેટ પોઈન્ટ્સ અથવા સંપૂર્ણ વાક્યોનો ઉપયોગ કરી શકો છો — તમારા પર છે. અમે તમારું નિર્ણય લેવાનું અને સમસ્યા ઉકેલવાની પ્રક્રિયા માપી રહ્યા છીએ.",
		'confirmation-message':
			'આ સ્ક્રીન પછી તરત જ એક પુષ્ટિ સંદેશ દેખાશે. તમારે પડકાર પૂરું કરવા માટે 20 મિનિટ મળશે!',
		'start-test': 'ટેસ્ટ શરૂ કરો',
		'customize-your-assessment': 'તમારું મૂલ્યાંકન કસ્ટમાઈઝ કરો',
		'control-assessment': 'તમારું પોતાનું સામગ્રી ઉમેરી મૂલ્યાંકનને નિયંત્રિત કરો.',
		'assessment-name': 'મૂલ્યાંકનનું નામ',
		'assessment-description': 'મૂલ્યાંકનની વર્ણના',
		'input-timer': 'ટાઈમર દાખલ કરો',
		'upload-image-challenge': 'પડકાર માટે છબી અપલોડ કરો',
		'plain-text': 'સાધારણ લખાણ',
		'audio-link': 'ઓડિઓ લિંક',
		'video-link': 'વિડિઓ લિંક',
		'image-link': 'છબી લિંક',
		'add-card': 'કાર્ડ ઉમેરો',
		'thank-you': 'આભાર',
		'challenge-submission': 'બસ એવુ જ! અમે તમારું પડકાર સબમિશન પ્રાપ્ત કર્યું છે',
		'feedback-your-assessment':
			'જો તમે તમારા મૂલ્યાંકન વિશે પ્રતિસાદ મેળવવા ઇચ્છો છો, તો નીચે તમારું ઇમેઇલ સરનામું દાખલ કરો',
		'your-voice':
			'અમે તમારી અવાજની જરૂર છે! તમારું અનુભવ જોતા તમે બીજા કોઇને શું સલાહ આપશો?',
		save: 'સંગ્રહ કરો',
		success_time_feedback: 'સફળતા! અમે તમારો સમય અને પ્રતિસાદની કદર કરીએ છીએ',
		'supposed-to-do': 'મારે શું કરવું છે?',
		'supposed-to-do-answer':
			'Nugget.ai પડકારમાં, તમને આપેલી ભૂમિકાને ગ્રહણ કરવાની વિનંતી કરવામાં આવે છે જે પડકારના વર્ણનમાં આપવામાં આવી છે. આ ભૂમિકા અપનાવીને, અમે ઇચ્છીએ છીએ કે તમે બતાવો કે તમે કેવી રીતે વિચારશો, શું કરશો, કઈ માહિતી પર ધ્યાન આપશો અને શું ભલામણ કરશો.',
		'what-challenge': 'પડકાર શું છે?',
		'what-challenge-answer':
			'પડકાર એ એક વર્ણન છે જેમાં તમારી અપનાવવાની ભૂમિકા અને પરિસ્થિતિ જણાવવામાં આવે છે. મહત્વપૂર્ણ રીતે, પડકાર તમારું મિશન પણ સ્પષ્ટ કરે છે — એટલે કે, તમે કઈ સમસ્યા ઉકેલવી છે.',
		'retake-challenge': 'શું હું પડકાર ફરીથી લઈ શકું?',
		'retake-challenge-answer':
			'ના, તમે પડકાર પ્રથમ વખત પૂરું કર્યા પછી તેને ફરીથી લેવા માટે કોઈ તક મળતી નથી. આ કારણે, અમે તમારી第一次 જ વખતે પડકારની ભૂમિકા ધારણ કરીને એ રીતે વિચારવાનું અને કામ કરવાનો પ્રયાસ કરવા વિનંતી કરીએ છીએ જેમ તમે આ સમસ્યાનો ઉકેલ વર્ચ્યુઅલ નહી પરંતુ હકીકતમાં કામ પર હોત તો શોધતા.',
		'purpose-whole-activity': 'આ સમગ્ર પ્રવૃત્તિનો ઉદ્દેશ શું છે?',
		'purpose-whole-activity-answer':
			'આ પ્રવૃત્તિનો ઉદ્દેશ એ છે કે જો તમે આ નોકરીમાં હોત તો તમારું કામ કઈ રીતે દેખાય એનું એક સ્પષ્ટ તાસ્વીર મેળવવી.',
		'challenge-problem':
			'શું પડકાર કોઈ વાસ્તવિક ઘટના / પરિસ્થિતિ / સમસ્યા / કંપની પર આધારિત છે?',
		'challenge-problem-answer':
			'Nugget.ai ના પડકારો વાસ્તવિક ઘટનાઓ, સમસ્યાઓ અને / અથવા કંપનીઓ પર આધારિત નથી. જો કંઈક વાસ્તવિક ઘટના કે કંપની જેવી લાગતી હોય, તો તે સુયોજિત નથી.',
		'content-information': 'મારે કઈ માહિતી / સામગ્રી સમાવવી જોઈએ?',
		'content-information-answer':
			'માત્રા કે પ્રકારના દ્રષ્ટિએ કોઈ નિશ્ચિત યોગ્ય રીત નથી. ફક્ત એ વિચારો કે તમે આ ભૂમિકામાં હોત તો કઈ માહિતી મહત્વપૂર્ણ માનતા.',
		'what-resources': 'સાંસાધનો શું છે?',
		'what-resources-answer':
			'સાંસાધનો એ એવા ઉદાહરણો છે જે લોકો કામ દરમિયાન મળતા હોય છે જ્યારે તેઓ પડકાર જેવી કામગીરી કરતા હોય છે. તેમાં વિવિધ પ્રકારની માહિતી હોય શકે છે અને વિવિધ સ્વરૂપમાં હોય શકે છે — એજ રીતે જેમ તમે કામ પર જોતા હોત.',
		'what-i-do-resources': 'હું સંસાધનો સાથે શું કરું?',
		'what-i-do-resources-answer':
			'જેમ તમે હકીકતમાં નોકરીમાં હોવ ત્યારે કરશો, તેમ તમે ઇચ્છા મુજબ ઓછા કે વધારે પ્રમાણમાં સંસાધનોનો ઉપયોગ કરી શકો છો. તમે વાંચી શકો છો અને તમે જરૂરી વિગતોને ચેલેન્જ વિસ્તાર પર ડ્રેગ અને ડ્રોપ પણ કરી શકો છો.',
		'do-use-resources': 'શું મને બધા સંસાધનો ઉપયોગ કરવો ફરજિયાત છે?',
		'do-use-resources-answer':
			'નહીં, જરૂરી નથી. તમે બધા ઉપયોગ કરી શકો છો જો ઈચ્છો તો, પણ તમે માત્ર કેટલાક પસંદ કરી શકો છો. લોકો જુદી જુદી રીતો અપનાવે છે. ફરીથી, એમ જ વર્તો જેમ તમે હકીકતમાં આ ભૂમિકામાં હોત.',
		'inform-outside-resources': 'શું હું સંસાધનો બહારની માહિતીનો ઉપયોગ કરી શકું?',
		'inform-outside-resources-answer':
			'અમે તમને વિનંતી કરીએ છીએ કે તમે તમારા જવાબો માત્ર સંસાધનોના આધાર પર આપો. જો તમારું કોઈ પહેલાનું જ્ઞાન હોય જે તમે યાદ કરી શકો છો, તો તે ઉપયોગ કરી શકો છો, પણ તમે કોઈ દસ્તાવેજ, લેખ કે અન્ય ઉલ્લેખિત સામગ્રી ખોલી શકતા નથી. જો અમને લાગે કે તમે બહારની માહિતીનો ઉપયોગ કર્યો છે, તો તમારું જવાબ સમૂહમાંથી દૂર કરી શકાય છે.',
		'identify-problem': "મારે 'સમસ્યા ઓળખો' વિભાગમાં શું કરવું છે?",
		'identify-problem-answer':
			'આ વિભાગમાં, તમે પડકારમાં મૌલિક સમસ્યા ઓળખી શકો છો અને એ વિશે ચર્ચા કરી શકો છો જે તમારું મિશન છે.',
		'collect-information': "હું 'માહિતી એકત્રિત કરો' વિભાગમાં શું કરું?",
		'collect-information-answer':
			'આ વિભાગમાં, તમે આપેલા સંસાધનોમાંથી માહિતી કાઢી અને સાચવી શકો છો.',
		'engender-ideas': "હું 'વિચારો પેદા કરો' વિભાગમાં શું કરું?",
		'engender-ideas-answer':
			'આ વિભાગમાં, તમે વિવિધ વિકલ્પો / દિશાઓ / અભિગમો વિશે ચર્ચા કરી શકો છો જે તમે વિચારતા હો.',
		'recommend-solution': "હું 'ઉકેલ ભલામણ કરો' વિભાગમાં શું કરું?",
		'recommend-solution-answer':
			'આ વિભાગમાં, તમે કોઈ સમાપ્ત ઉકેલ / ઉત્પાદન / સેવા રજૂ કરી શકો છો અને તેના પર ચર્ચા કરી શકો છો જે તમને પડકાર પૂર્ણ કરવામાં મદદ કરે.',
		'complete-all-sections': 'શું મને બધા વિભાગો પૂરા કરવા જરૂરી છે?',
		'complete-all-sections-answer':
			'નહીં, જરૂરી નથી. યાદ રાખો કે હેતુ એ છે કે તમે આ ભૂમિકામાં કર્મચારી હોત તો શું કરત – એનું અનુસરણ કરો. જો તમને કેટલાક વિભાગો ગૌણ લાગતા હોય, તો તમારે એ પૂર્ણ કરવો ફરજિયાત નથી.',
		'format-responses': 'હું મારા જવાબો કઈ રીતે ફોર્મેટ કરું?',
		'format-responses-answer':
			'તમારા જવાબોને ફોર્મેટ કરવાનો કોઇ સાચો કે ખોટો રસ્તો નથી. એ વિચારો કે તમે હકીકતમાં મેનેજરને તમારા જવાબો રજૂ કરતા તો તેમને કઈ રીતે રજૂ કરતાં.',
		'complete-challenge-time': 'શું થાય જો હું સમયમર્યાદા અંદર પડકાર પૂરો ન કરી શકું?',
		'complete-challenge-time-answer':
			'કોઈ સમસ્યા નથી! સમયમર્યાદા એ દરેક ઉમેદવાર માટે પ્રક્રિયાને ધોરણીય બનાવવા માટે છે. જો તમે પુર્ણ ન પણ કરી શકો તો પણ તમારાં જવાબો ધ્યાનથી વિમર્શમાં લેવામાં આવશે.',
		'browser-continue-later': 'શું હું બ્રાઉઝર બંધ કરી પછી ફરીથી ચાલુ રાખી શકું?',
		'browser-continue-later-answer': 'ના, તમારે પડકાર એક જ સત્રમાં પૂર્ણ કરવો પડે છે.',
		'interface-accommodations':
			'શું થાય જો મને વધુ સમય અથવા ઇન્ટરફેસમાં બીજું કશુંક જરૂરી હોય?',
		'interface-accommodations-answer':
			'અમે કોઈ પણ બિલ્ટ-ઇન સુવિધાઓ ન આપતા કે જેથી તમે સમય વધારી શકો. તેથી, તમારે સમય ધ્યાનમાં રાખવો જરૂરી છે. જો તમને સમય કે અન્ય પ્રકારની ઍક્સેસિબિલિટી સંબંધિત સહાયની જરૂર હોય, તો કૃપા કરીને તમારું લિંક મોકલનારી વ્યક્તિનો સંપર્ક કરો – તેઓ અમારી સાથે જોડાઈને જરૂરી વ્યવસ્થા કરશે.',
		'activity-chances-job':
			'આ પ્રવૃત્તિમાં મારી કામગીરી મારા નોકરી મળવાની શક્યતાઓને કેવી રીતે અસર કરે છે?',
		'activity-chances-job-answer':
			'પડકારનો ઉપયોગ ક્યારેક હિરિંગ પ્રક્રિયામાં સ્વતંત્ર માપ તરીકે અથવા હિરિંગ માટેના વિવિધ માપદંડોના સમૂહનો એક ભાગ તરીકે થાય છે. જો કે અમે અમારા ક્લાયન્ટને સૂચનાઓ આપી શકીએ, અમે નિયંત્રિત નથી કરતા કે સંગઠનો આ પરિણામો કેવી રીતે ઉપયોગ કરે છે. તેથી, આવી કોઈ પણ પ્રશ્નો માટે, કૃપા કરીને એ વ્યક્તિનો સંપર્ક કરો જેમણે તમને પડકાર માટેનો લિંક મોકલ્યો હતો.',
		'own-your-personal-space': 'તમારું અંગત સ્થાન ભાળો',
		'already-have-an-account': 'તમે પહેલેથી જ એક ખાતું ધરાવ છો',
		'employer-login': 'નિયામક માટે લોગિન',
		'post-have-an-account': 'Don અને apost પાસે પહેલેથી જ ખાતું છે',
		register: 'નોંધણી કરો',
		'export-to-csv': 'CSV તરીકે નિકાસ કરો',
		type: 'પ્રકાર',
		data: 'માહિતી',
		'select-pipeline': 'પાઇપલાઇન પસંદ કરો',
		rank: 'ક્રમ',
		'characteristic-reflects':
			'આ લક્ષણ દર્શાવે છે કે તમે કેવી ઝડપથી કામ શરૂ કરો છો અને તમારું કાર્ય સમીક્ષિત કરો છો. જેમણે પડકાર લીધો તેઓએ પહેલેથી જ લખવાનું શરૂ કર્યું અને પછી અવલોકન કરીને સુધારાઓ કર્યા — એટલે જ તેઓ ઝડપ અને પ્રતિબિંબમાં ઊંચો સ્કોર મેળવી શક્યા.',
		'characteristic-reflects_example':
			'આ લક્ષણ માટે ઉપયોગી કામનું ઉદાહરણ: જ્યારે તમારી પાસે તાત્કાલિક કામ હોય જેને તરત જ હાથમાં લેવું હોય.',
		'characteristic-reflects-two':
			'આ લક્ષણ દર્શાવે છે કે તમે અગાઉથી વિચારો છો અને યોગ્ય રીતે વિચાર ગોઠવો છો. તમારાં જવાબો લખતાં પહેલાં ઈમેલ થ્રેડ અને લેખ વાંચવો એ પ્લાનિંગ અને ઓર્ગેનાઈઝેશન માટે ઊંચા સ્કોર મેળવવાનો રસ્તો છે.',
		'characteristic-reflects-two-example':
			'આ લક્ષણ માટે ઉપયોગી કામનું ઉદાહરણ: જ્યારે કામ સંપૂર્ણતાની નજીક પહોંચે તેવું હોવું જોઈએ.',
		'characteristic-reflects-three':
			'આ લક્ષણ દર્શાવે છે કે તમે તમારા કામમાં કેટલા વિગતવાર વિગતો ઉમેરો છો અને કેવી રીતે તે આત્મવિશ્વાસ બતાવે છે. ગ્રાહકની જરૂરિયાતો પ્રકાશિત કરવી અને તેમને તમારા જવાબમાં પુનરાવૃત્તિ કરવી એ ‘વિગતો અને દૃઢતા’માં ઊંચા સ્કોર મેળવવાનું એક રીત છે.',
		'characteristic-reflects-three-example':
			'આ લક્ષણ માટે ઉપયોગી કામનું ઉદાહરણ: જ્યારે કામમાં તમારું જ્ઞાન ઉપયોગ કરીને બીજા વ્યક્તિને માનવામાં લાવવું પડે.',
		'characteristic-reflects-four':
			'આ લક્ષણ દર્શાવે છે કે તમે તમારા વિચારોને વ્યાકરણ પૂરતું અને ઉદ્દેશ પૂરતું કેવી રીતે રજૂ કરો છો. ભાષાના ચિંતન સાથે ચળવું અને નિષ્પક્ષ ટોન જાળવવો એ છે જેમણે ન્યુટ્રાલિટી અને કાળજીમાં ઊંચી રેટિંગ મેળવી.',
		'characteristic-reflects-four-example':
			'આ લક્ષણ માટે ઉપયોગી કામનું ઉદાહરણ: જ્યારે તમારી વ્યાવસાયિકતા અને નિષ્પક્ષતા દર્શાવવી જરૂરી હોય.',
		'characteristic-reflects-five':
			'આ લક્ષણ દર્શાવે છે કે તમે તમારા વિચારોને કેટલા સ્પષ્ટ અને લોજિકલ રીતે રજૂ કરો છો. દરેક વિચારમાં સુસંગતતા રાખવી અને ટ્રાંઝિશન શબ્દોનો યોગ્ય ઉપયોગ કરવો એ સ્પષ્ટતા અને દલીલ માટે અગત્યનું છે.',
		'characteristic-reflects-five-example':
			'આ લક્ષણ માટે ઉપયોગી કામનું ઉદાહરણ: જ્યારે કામમાં તમારે પરિસ્થિતિના દરેક પાસાને સ્પષ્ટપણે અને લોજિકલ રીતે રજૂ કરવો પડે.',
		'alert-dialog':
			'Google ની સહાયક એપ્લિકેશનોને સ્થાન નિર્ધારિત કરવા દો. આનો અર્થ એ છે કે Google ને અનામ સ્થાન ડેટા મોકલવો—even જ્યારે એપ્લિકેશનો ચાલી રહી ન હોય ત્યારે પણ.',
		disagree: 'અસહમત',
		agree: 'સહમત',
		'talent-relationships': 'ટેલેન્ટ સંબંધો',
		'talent-relationships-subtitle':
			'તમારા ટેલેન્ટ જૂથ વચ્ચેના છુપાયેલા સંબંધો શોધો. તમે કેવી રીતે તમારી ક્ષમતાને તુલનાત્મક રીતે દર્શાવો છો એ જોવા માટે ક્ષમતા-ધોરી પર ખેંચો.',
		'talent-funnel-title': 'ટેલેન્ટ ફનલ',
		'talent-funnel-subtitle':
			'પડકારમાં તમારું શ્રેણીબદ્ધ ટેલેન્ટ શોધો. પરિણામ જોવા માટે એક શ્રેણી પસંદ કરો.',
		'team-dynamic-title': 'ટીમ ગતિશીલતા',
		'team-dynamic-subtitle':
			'બાકીની પાઇપલાઇનના વ્યક્તિઓ કેવી રીતે તમારી ટીમમાં ફાળો આપી શકે છે તેનું અનુસરણ કરીને ટીમનું પ્રદર્શન સુધારો. પ્રદર્શનના ઓપ્ટિમાઇઝ માટે મેળવો અને જોડો.',
		'almost-there': 'લગભગ પહોંચી ગયા છો',
		'users-pipeline':
			'પરિણામો ત્યારે જ દેખાશે જ્યારે તમારી પાઇપલાઇનમાં ઓછામાં ઓછા 50 યૂઝર્સ હશે',
		'copied-invite': 'આમંત્રણ લિંક સફળતાપૂર્વક નકલ કરવામાં આવી',
		'about-one':
			'Nugget.ai પડકાર સાથે, તમને એક ખાસ નોકરીની ભૂમિકા સ્વીકારવાની અને તે રીતે વિચારવાની, શું કરવાનું, કઈ માહિતીનું ધ્યાન રાખવાનું અને શું ભલામણ કરવી તેનું અનુસરણ કરવાની વિનંતી કરવામાં આવી હતી—as if you were truly doing that job. પડકારના પેજ ખોલ્યા એ જ ક્ષણથી, અમે તમારા ઈન્ટરએકશનના વિવિધ પાસાઓનો ટ્રેક રાખ્યો—કેવી રીતે તમે માહિતીનો ઉપયોગ કર્યો અને પડકાર પૂર્ણ કર્યો. આ અમને તમારી સમસ્યા હલ કરવાની અને સંવાદ ક્ષમતાની સમજ મેળવવામાં મદદ કરે છે.',
		'about-two':
			'તમારા સ્કોર એ તમામ યૂઝર્સ સાથે તુલનાત્મક છે જેમણે પડકાર લીધો હતો. અમે વપરાશકર્તાના પ્રદર્શનનું વિશ્લેષણ કરવાનો એક અનોખો રસ્તો બનાવી રહ્યા છીએ—જે ઉદ્યોગ, બજાર, કંપની અને ટીમ સ્તરનાં બેન્ચમાર્ક સાથે તુલના કરે છે. દરેક બેન્ચમાર્ક વિવિધ ડેમોગ્રાફિક્સમાં રહેલા ટેલેન્ટના વિવિધતાનું પ્રતિનિધિત્વ કરે છે.',
		'about-three':
			'જો તમારું સ્કોર બેન્ચમાર્ક કરતાં ઓછું હોય, તો એનો અર્થ આવશ્યક રીતે એવું નથી કે તમે ખરાબ કરો છો: દરેક કંપનીએ વિશિષ્ટ લક્ષણોની જુદી જોડાણોની શોધ હોય છે.',
		'about-four':
			'અમારું લક્ષ્ય એ છે કે તમારા સમાજિક ક્ષમતા વિશે એવી nuggets શોધવામાં તમારી મદદ કરીએ જે તમારી વિચારશક્તિ, સંવાદશૈલી અને સમસ્યા હલ કરવાની પદ્ધતિ સાથે મેળ ખાતી કારકિર્દી માર્ગોને શોધવામાં મદદ કરે. આવી કારકિર્દીઓ શોધો જેને તમે કદાચ વિચાર્યું પણ ન હોય કે તે તમારા માટે યોગ્ય હોઈ શકે.',
		'account-details': 'એકાઉન્ટ વિગતો',
		'success-redirect': 'સફળતાપૂર્વક સંગ્રહિત થયું અને ફરીથી દિશામાન કર્યું',
		'usecase-one':
			"GE Appliances એ જાહેરાત કરી છે કે તેમના Wi-Fi જોડાયેલ ઘરગથ્થુ ઉપકરણોમાં અપડેટ આવ્યું છે, જે હવે સીધા Google Assistant સાથે કામ કરે છે — Google નો અવાજ આધારિત ડિજિટલ સહાયક. લોકો હવે કહી શકે છે, 'હે Google, ઓવન 425 ડિગ્રી પર પ્રીહીટ કરો,' અથવા પૂછે શકે છે, 'હે Google, શું મારી વાસણો સાફ છે?'",
		'usecase-two':
			"Google Assistant સાથે સીધી કનેક્ટિવિટી હવે ઉપયોગકર્તાઓને જૂના કમાન્ડ જેવી કે 'Google, જીનેવા હોમને કહો કે ઓવન 425 ડિગ્રી પર પ્રીહીટ કરે' ની જરૂરિયાત વગર જ કમાન્ડ આપવા દે છે.",
		'usecase-three':
			"આ ફેરફાર Refrigerators, Ovens, Dishwashers અને Washers સહિતના GE ના Wi-Fi જોડાયેલા ઉપકરણો સાથે કામ કરે છે — બધા 'U+ Connect' એપ્લિકેશન સાથે જોડાયેલા છે જે ઉપકરણો મેનેજ કરવા માટે વપરાય છે.",
		'usecase-four':
			"GE Appliances અને Google Assistant વચ્ચે વધુ નજીકની ઈન્ટિગ્રેશન ત્યારે આવી રહી છે જ્યારે Google અને Amazon સ્માર્ટ હોમ સેવાઓના બજારમાં અગ્રસ્થાન માટે સ્પર્ધા કરી રહ્યા છે. Google સહાયક સાથે સીધી કનેક્ટિવિટી GE ઉપકરણોને Alexa કરતા વધુ ઉપયોગી બનાવી શકે છે. 2016 માં, Amazon અને GE એ Alexa માટે Geneva skill રજૂ કરી હતી, જેમાં યૂઝર્સને આવું કહેવું પડતું: 'Alexa, Geneva ને કહો કે ઓવન 350 ડિગ્રી પર પ્રીહીટ કરે' — જે એક વધારાની કડી હતી.",
		'usecase-five':
			'GE Appliances ની આ જાહેરાત ત્યારે આવી છે જ્યારે Swedish ઉત્પાદક Electrolux એ પણ તેમના સંકળાયેલા રસોડા ઉપકરણોમાં Google Assistant ની ઇન્ટિગ્રેશન શરૂ કરી છે. Electrolux એ ગયા અઠવાડિયે જણાવ્યું કે આ વોઇસ ઇન્ટિગ્રેશન આગલા વર્ષે સ્માર્ટ ઓવનથી શરૂ થશે. વધુ ઉત્પાદકો આ પ્રકારના ઉપકરણો સાથે પ્રયોગ કરે છે, તેમે ટેક્નોલોજી વધુ ચતુર અને વપરાશકર્તા માટે અનુકૂળ બની રહી છે.',
		'usecase-six':
			'ડિજિટલ સહાયક અને સ્માર્ટ સ્પીકર જગત ગરમાઈ રહ્યો છે. 2018 ના પહેલા ક્વાર્ટરમાં, અવાજ આધારિત સ્માર્ટ સ્પીકર શિપમેન્ટ 278% વધીને 9.2 મિલિયન યુનિટ્સ પહોંચી હતી. Amazon એ ભલે 4 મિલિયન યુનિટ્સ મોકલ્યા હોય, તેમ છતાં તેમનો માર્કેટ શેર 81.8% માંથી ઘટીને 43.6% થયો હતો — Strategy Analytics અનુસાર. આંતરરાષ્ટ્રીય ડેટા કોર્પોરેશન અનુસાર, 2024 સુધીમાં સ્માર્ટ હોમ ડિવાઈસિસનો વૈશ્વિક બજાર — જેમાં સ્પીકર, ડિજિટલ મીડિયા એડેપ્ટર, લાઇટિંગ, થર્મોસ્ટેટ્સ અને GE જેવા ઉપકરણો શામેલ છે — 26.8% નો વધારો જોઈ શકે છે અને કુલ 549.5 મિલિયન યુનિટ સુધી પહોંચી શકે છે.',
		note:
			'નોટ: આ સંસાધનો એ દસ્તાવેજો છે જે બેઠકના તમામ હાજર લોકોને અગાઉથી આપવામાં આવે છે. આ સંસાધનો સાથે, ઉપસ્થિત લોકો પાસે એક રેન્ડમ રીતે પસંદ કરાયેલ ગીતના શબ્દો હોય છે. શબ્દોથી વિના, ગીતના સામાન્ય ઘટકો ઓળખવામાં આવ્યા છે. ઉપરાંત, ગીતના ખાસ ઘટકો પણ દર્શાવવામાં આવ્યા છે — અને તેઓ જરૂરી નથી કે લેબલના કાર્યકારીના દૃષ્ટિકોણથી ઇચ્છિત હોય, પણ તમને આઈડિયા આપશે કે પ્લાન તૈયાર કરતી વખતે કઈ માહિતી ધ્યાનમાં લેવી.',
		'song-title': 'ગીતનું શીર્ષક',
		'true-colours': 'સાચા રંગો',
		unnamed: 'નામ વગર',
		instrumentals: 'સંગીતમય ભાગ',
		'no-decription-provided': 'કોઈ વર્ણન આપેલ નથી',
		'vocal-type': 'વોકલ પ્રકાર',
		'single-vocal-male': 'એકલ પુરૂષ વોકલ',
		'theme-song': 'ગીતનો વિષય',
		'love-relationships': 'પ્રેમ અને સંબંધો',
		'storyline-song': 'ગીતની વાર્તાલાઇન',
		'storyline-song-description':
			'ગાયક પોતાની પ્રેમિકા પ્રત્યે તેને જાણવાની અને ઊંડા સ્તરે જોડાવાની ઈચ્છા વ્યક્ત કરે છે. કલા રૂપે, ગાયક આ લાગણીને પોતાની પ્રેમિકાને વ્યક્ત કરવા રંગો અને છબીઓની ઉપમા ઉપયોગ કરે છે.',
		insight: 'અંતર્દૃષ્ટિ',
		talent: 'ટેલેન્ટ',
		'your-talent-pipelines': 'તમારી ટેલેન્ટ પાઈપલાઈનો',
		'add-challenge':
			'તમારું લક્ષ્ય / ચેલેન્જનું વર્ણન અહીં ઉમેરો. ટીમમાં દરેક જણ આ જોઈ શકશે!',
		'digital-team': 'ડિજિટલ ટીમ',
		send: 'મોકલો',
		'terms-and-condition': '<EsDescription />',
		'send-email-again-text': 'હજી સુધી ઈમેલ નથી મળ્યો?',
		'send-email-again': 'ફરીથી મોકલો',
		'create-new-password': 'નવી પાસવર્ડ બનાવો',
		'create-new-password-info':
			'મજબૂત પાસવર્ડ પસંદ કરો અને તેને બીજી અકાઉન્ટ માટે ફરીથી ઉપયોગ ન કરો. તમારું પાસવર્ડ બદલવાથી બધા ઉપકરણો પર તમારું લોગિન બંધ થઈ જશે. તમારે નવો પાસવર્ડ ફરીથી દાખલ કરવો પડશે.',
		'new-password': 'નવી પાસવર્ડ',
		'change-your-password': 'તમારું પાસવર્ડ બદલો',
		'current-password': 'હાલનો પાસવર્ડ',
		'mail-sent': 'ઈમેલ સફળતાપૂર્વક મોકલાઈ ગયો છે',
		'error-mail-sent': 'ઈમેલ મોકલતી વખતે ભૂલ આવી છે',
		'profile-update': 'તમારું પ્રોફાઇલ સફળતાપૂર્વક અપડેટ થયું',
		'delete-confirmation': 'શું તમે ખાતરીપૂર્વક તમારું અકાઉન્ટ કાઢી નાખવા માંગો છો?',
		'current-password-incorrect': 'હાલનો પાસવર્ડ ખોટો છે',
		'password-change': 'પાસવર્ડ સફળતાપૂર્વક બદલાઈ ગયો',
		'accept-the': 'હું સ્વીકારું છું',
		'terms-conditions': 'નિયમો અને શરતો',
		resume: 'રિઝ્યૂમે'
	},
	gu: {
		'tour-step-0':
			'અસેસમેન્ટની સમીક્ષા અને પૃષ્ઠભૂમિ અહીં ઉપલબ્ધ રહેશે. શરુઆતમાં આને ધ્યાનપૂર્વક વાંચો',
		'tour-step-1':
			'સાંદર્ભ સામગ્રી સહાયક વસ્તુઓ છે. આ વિભાગમાં તમને દ્રશ્યપટ સમજવામાં મદદરૂપ સંસાધનો મળશે',
		'tour-step-2':
			'તમે અહીં લખીને અસેસમેન્ટનો ઉકેલ આપી શકશો. અહીં એક કે તેથી વધુ જવાબ બોક્સ હોઈ શકે છે',
		'tour-step-3': '',
		'tour-step-4': '',
		'tour-step-5':
			'તમારું અસેસમેન્ટ સ્થિર નહીં હોય, અહીં સૂચનાઓ آئકન દ્વારા નવી માહિતી રજૂ થશે. ઘંટડી વાગે ત્યારે સાંભળવા માટે અવાજ ચાલુ રાખો',
		'tour-step-6':
			'દરેક અસેસમેન્ટ સમયમર્યાદામાં હોય છે, એટલે ઘડિયાળ પર નજર રાખો! તૈયાર હોય ત્યારે ‘આગળ’ ક્લિક કરો',
		'start-test-title': 'શું તમે ખરેખર શરૂ કરવા માંગો છો?',
		'start-test-content':
			'ખાતરી કરો કે બ્રાઉઝર ફુલ સ્ક્રીનમાં છે અને તમે ટૅબ બંધ નહીં કરો, નહીં તો તમારે ફરીથી શરૂ કરવું પડશે. શુભેચ્છા!',
		start: 'શરૂ કરો',
		'show-me-again-u': 'મને ફરીથી બતાવો',
		consultant: 'કન્સલ્ટિંગ',
		endPreview: 'પૂર્વદર્શન પૂરૂં કરો',
		next: 'આગળ',
		back: 'પાછળ',
		prev: 'પાછલું',
		finish: 'પૂર્ણ કરો',
		'how-can-we-help': 'અમે કેવી રીતે મદદ કરી શકીએ?',
		'how-can-we-help-explain':
			'આ તમારું અસેસમેન્ટ પૂરું કરવાની માર્ગદર્શિકા છે. ખોવાઈ ન જશો, સમયગાળો હજુ ચાલુ છે!',
		application: 'અરજી',
		other: 'અન્ય',
		help: 'મદદ',
		'add-new-section': 'નવો વિભાગ ઉમેરો',
		'identify-the-problem': 'સમસ્યાની ઓળખ કરો',
		'highlight-key-sentences':
			'આલેખમાંથી મુખ્ય વાક્યોને હાઇલાઇટ કરો જે તમને ખાસ લાગે. બસ ડ્રેગ અને ડ્રોપ કરો!',
		'brainstorm-viable': 'સંભવિત વિચારોના મंथન કરો જે સમસ્યાની ವ್ಯಾಪ્તિમાં હોય',
		'use-your-creativity': 'તમારી રચનાત્મકતાનો ઉપયોગ કરો અને ઉકેલ સૂચવો',
		problem: 'સમस्या',
		'collect-information-title': 'માહિતી એકત્રિત કરો',
		ideas: 'વિચારો',
		solution: 'ઉકેલ',
		resource: 'સાંદર્ભ સામગ્રી',
		'no-card-name': 'કાર્ડનું નામ નથી',
		'challenge-description': 'ચેલેન્જ વર્ણન',
		'test-name-not-found': 'ટેસ્ટનું નામ મળ્યું નથી',
		'drop-the-text-here': 'લખાણને અહીં ડ્રેગ અને ડ્રોપ કરો',
		'type-away-what': 'ટાઇપ કરો... તમે બીજું શું જણાવવા માંગો છો?',
		title: 'શીર્ષક',
		'are-you-sure': 'શું તમે ખરેખર ખાતરી કરો છો?',
		'content-exit-challenge':
			'એવું લાગે છે કે તમે અસેસમેન્ટમાંથી બહાર નીકળવાનો પ્રયાસ કરી રહ્યા છો. જો તમે એવું કરો છો તો તમારું તમામ પ્રગતિ ગુમાઈ જશે.',
		'continue-the-challenge': 'અસેસમેન્ટ ચાલુ રાખો',
		'continue-challenge': 'અસેસમેન્ટ ચાલુ રાખો',
		'content-finish-challenge': 'એવું લાગે છે કે તમે તમારા પરિણામ મોકલવા જઈ રહ્યા છો',
		'time-up': 'સમય સમાપ્ત!',
		'hard-part-over': 'કઠિન ભાગ પૂરો થયો. હવે આરામથી બેસો અને પરિણામની રાહ જુઓ',
		'great-job-u': 'શાનદાર કામ કર્યું!',
		'u-finished-it': 'તમે એ પૂરુ કરી દીધું!',
		'sit-tight-well':
			'જરા રાહ જુઓ! પરિણામ આવે ત્યારે અમે તમને જાણ કરીએશું. એ દરમિયાન અહીં થોડાં આંકડા છે જેથી તમે તમારા પરિણામોની ઝાંખી મેળવી શકો',
		'sit-tight-well-short': 'જરા રાહ જુઓ! પરિણામ આવે ત્યારે અમે તમને જાણ કરીએશું.',
		'sign-up-in-msg': 'તમારા પરિણામ જોવા માટે નીચે સાઇન અપ કરો અથવા લોગ ઇન કરો!',
		'assess-congratulations-sandbox':
			'અભિનંદન! તમે આ પુરૂ કરી દીધું. તમારું પરિણામ જોવા માટે તમારા પ્રોફાઇલ પેજ પર જાઓ.',
		// 'assess-congratulations-analytics': `Congratulations! You finished it. We are now analyzing your results. Want to take a peak? Sign up or sign in below to see your results!`,
		'assess-congratulations-analytics':
			'અભિનંદન! તમે તેને પૂરૂં કર્યું છે. અમે હવે તમારા પરિણામોનું વિશ્લેષણ કરી રહ્યા છીએ અને શ્રેષ્ઠ મળતાં પરિણામો પસંદ કરી રહ્યાં છીએ. રાહ જુઓ, કોઇجل્દી સંપર્ક કરશે.',
		'companies-are-also':
			'કંપનીઓ પણ પૂરક કુશળતાઓ શોધી રહી છે, તેથી ચિંતા ના કરો! તમે કદાચ એ જ છો જેને તેઓ શોધી રહ્યા છે!',
		'let-you-know-over-email':
			'અમે તમારા પરિણામો પ્રક્રિયા કરતી વખતે તમને ઈમેઇલ મારફતે જાણ કરીશું! એ દરમિયાન, રસપ્રદ ગણતરીઓ અહીં જુઓ.',
		'want-to-improve-ex': 'અનુભવ સુધારવો હોય તો? આ ઝડપી ફોર્મ ભરો',
		'questionniare-err-msg':
			'લાગે છે કે તમે એક પ્રશ્ન ચૂકી ગયા છો. મૂલ્યો 1 થી 7 વચ્ચે હોવા જોઈએ.',
		survey: 'સર્વે',
		minutes: 'મિનિટ',
		'pace-of-writing': 'લખવાની ગતિ',
		'words-per-minute': 'શબ્દો પ્રતિ મિનિટ',
		'head-start': 'શરૂઆતનો સમય',
		'how-long-takes': 'પ્રથમ શબ્દ લખવા માટે કેટલો સમય (સેકંડ) લાગ્યો',
		'quick-fix': 'ઝડપી સુધારો',
		'number-times-deleting': 'લખ્યા પછી 3 સેકંડની અંદર કેટલી વખત લખાણ ડિલીટ થયું',
		'run-on': 'રન-ઓન',
		'number-long-sentences': '30 શબ્દો કરતાં લાંબી કેટલીઁ વાક્યો લખાયા',
		'select-an-assessment': 'અસેસમેન્ટ પસંદ કરો',
		'select-from-pre-built':
			'પૂર્વનિર્મિત અસેસમેન્ટમાંથી પસંદ કરો. સામગ્રી અને વિઝન અમે sambhaali લઈશું.',
		'business-to-business-sales': 'ગ્રાહકને યોગ્ય વેબ સેવા વેચો',
		'business-to-business-sales-description':
			'તમે બિઝનેસ-ટુ-બિઝનેસ (B2B) વેચાણ પ્રતિનિધી છો. તમારું મેનેજર તમને નવા સંભવિત ક્લાયન્ટ વિશે જણાવી રહ્યું છે - એક એવું બિઝનેસ જે પોતાની વેબસાઇટ બનાવાવા ઈચ્છે છે. આ અસેસમેન્ટમાં, નવા ક્લાયન્ટની જરૂરિયાતો ઓળખો, આપેલ સંસાધનોમાંથી માહિતી મેળવો, શક્ય વિકલ્પો ભાંવો અને પછી શ્રેષ્ઠ વિકલ્પની ભલામણ કરો.',
		'email-thread-between': 'મેનેજર અને ક્લાયન્ટ વચ્ચેની ઈમેઇલ વાતચીત',
		'descriptions-services-provided': 'કંપની દ્વારા પૂરી પાડવામાં આવતી સેવાઓનો વર્ણન',
		'actionablet-tips-closing': 'વધુ B2B વેચાણ માટે ઉપયોગી ટીપ્સ',
		'data-science': 'કંપનીને કર્મચારી ડેટાનું વિશ્લેષણ કરવામાં મદદ કરો',
		'data-science-description':
			'તમે ટેક ઇન્ડસ્ટ્રીની નવી કંપની માટે કામ કરતા ડેટા સાયન્ટિસ્ટ છો જેમાં 150 કર્મચારીઓ છે. ક્લાયન્ટે તાજેતરમાં જ પોતાના કર્મચારીઓ અને તેમના કામના અનુભવ વિશે આંતરિક ડેટા એકત્ર કર્યો છે અને હવે તે ડેટાને સમજવા માટે તમારી મદદ માગે છે. તેઓ પોતાના નીતિ, અભ્યાસક્રમો અને તાલીમમાં સુધારા કરવા માંગે છે. આ ચેલેન્જમાં, મુખ્ય સમસ્યાઓ ઓળખો, આપેલા ડેટાથી માહિતી મેળવો, વિકલ્પો વિચારો અને છેલ્લે તમારા ભલામણો આપો.',
		'interview-findings': 'ઈન્ટરવ્યૂમાં મળેલી માહિતી',
		'correlation-table': 'સંબંધક તફાવત કોષ્ટક',
		'multiple-regression-table': 'મલ્ટિપલ રિગ્રેશન કોષ્ટક',
		'business-strategy-proposal': 'કંપનીને નફો કમાવવા માટે મદદ કરો',
		'business-strategy-proposal-description':
			'તમે એક મધ્યમ કદની કંપનીમાં ફુલ ટાઈમ કર્મચારી તરીકે કામ કરો છો. ગયા બે વર્ષથી કંપનીનો ઓપરેટિંગ નફો સતત ઘટી રહ્યો છે — વેચાણ ઘટી રહ્યું છે અને ખર્ચ વધી રહ્યા છે. આ સમસ્યાને ઉકેલવા માટે, મેનેજમેન્ટે આંતરિક સંસાધનોનો ઉપયોગ કરીને એક ક્રોસ-ફંક્શનલ ટીમ બનાવવાનો નિર્ણય કર્યો છે. આ ટીમમાં તમને સામેલ કરવામાં આવ્યા છો. પ્રથમ બેઠકમાં નક્કી થયું છે કે જૂથ ફરી મળી ચર્ચા કરે તે પહેલા દરેક સભ્ય પોતપોતાની વિચારો તૈયાર કરશે — સમસ્યા શું છે, કેમ છે અને ઉકેલ શું હોઈ શકે છે. તમારી પ્રેઝેન્ટેશન 20 મિનિટમાં છે!',
		'software-engineering-challenge': 'નવું ઉત્પાદન વિકસાવવા માટે યોજના બનાવો',
		'software-engineering-challenge-description':
			'તમે દેશની અગ્રણી પ્રોડક્ટ ઇનોવેશન ફર્મ માટે નવું સોફ્ટવેર ડિઝાઇન અને ડેવલપ કરતી ટીમના સોફ્ટવેર એન્જિનિયર છો. આ વર્ષે કંપનીની વ્યૂહાત્મક પ્રાથમિકતા તરીકે ‘અસફળતામાંથી શીખવું’ નક્કી કરવામાં આવ્યું છે. તમારી ટીમને અગાઉના નિષ્ફળ પ્રોજેક્ટ્સમાંથી શીખી, એક સફળ ઉત્પાદન બનાવવાનો ઉદ્દેશ આપ્યો છે. દરેક સભ્યે પહેલા સ્વતંત્ર રીતે વિચારો તૈયાર કરવા છે. કેસ અભ્યાસ વાંચો, સમસ્યા ઓળખો, વિચારો ભાંવો અને છેલ્લે તમારી ભલામણ કરો.',
		'software-engineering': 'સોફ્ટવેર એન્જિનિયરિંગ',
		'product-design': 'ઉત્પાદન ડિઝાઇન',
		'product-development': 'ઉત્પાદન વિકાસ',
		innovation: 'નવપ્રવર્તન',
		'case-1-drama': 'કેસ #1: ડ્રામા',
		'case-2-highlighter': 'કેસ #2: હાઇલાઇટર',
		'case-3-screenrest': 'કેસ #3: સ્ક્રીનરેસ્ટ',
		'customer-client-feedback': 'ગ્રાહક / ક્લાયન્ટ પ્રતિસાદ',
		'performance-management-results': 'કાર્યક્ષમતા વ્યવસ્થાપન પરિણામો',
		'profits-chart': 'નફા ચાર્ટ',
		'get-started': 'શરૂ કરો',
		welcome: 'સ્વાગત છે',
		name: 'નામ',
		email: 'ઈમેઇલ',
		age: 'ઉંમર',
		gender: 'લિંગ',
		male: 'પુરુષ',
		female: 'સ્ત્રી',
		'prefer-not-to-say': 'કહેવું નથી ઇચ્છતું',
		continue: 'ચાલુ રાખો',
		'what-ethnicity-cultural-group': 'તમે કઈ જાતિ / સાંસ્કૃતિક જૂથ સાથે ઓળખાતા છો?',
		caucasian: 'કોકેશિયન',
		'latin-american': 'લેટિન અમેરિકન',
		african: 'આફ્રિકન',
		caribbean: 'કેરિબિયન',
		'middle-east': 'મધ્ય પૂર્વ',
		'south-asian': 'દક્ષિણ એશિયન (દા.ત. ભારતીય, શ્રીલંકન)',
		'southeast-asian': 'દક્ષિણપૂર્વ એશિયન (દા.ત. વિયેતનામી, ચાઈનીઝ, ફિલિપિનો)',
		'west-asian': 'પશ્ચિમ એશિયન (દા.ત. ઈરાનિયન, અફઘાન)',
		aboriginal: 'મૂળ નિવાસી (દા.ત. ઉત્તર અમેરિકન ઇન્ડિયન, ઈન્યુઇટ)',
		mixed: 'મિશ્ર',
		'what-is-your-marital': 'તમારું વૈવાહિક સ્થિતિ શું છે?',
		'how-do-you-want-to-create': 'તમે કેવી રીતે બનાવવું ઇચ્છો છો?',
		'pre-built-assessment': 'પૂર્વ-તૈયાર મૂલ્યાંકન',
		'create-your-own': 'તમારું પોતાનું બનાવો',
		'please-select-role-type': 'મહેરબાની કરીને ભૂમિકા પ્રકાર પસંદ કરો!',
		'please-select-position-type': 'મહેરબાની કરીને સ્થાનનો પ્રકાર પસંદ કરો!',
		'what-are-you-hiring-for': 'તમે ક્યા માટે નોકરી માટે ભરતી કરી રહ્યા છો?',
		'help-us-define-your-role': 'મદદ કરો જેથી અમે શ્રેષ્ઠ મૂલ્યાંકન સૂચવી શકીਏ',
		'role-type': 'ભૂમિકા પ્રકાર',
		none: 'કોઈ નથી',
		'customer-service': 'ગ્રાહક સેવા',
		sales: 'વેચાણ',
		'product-management': 'ઉત્પાદન વ્યવસ્થાપન',
		'business-management': 'વ્યાપાર વ્યવસ્થાપન',
		'business-strategy': 'વ્યાપાર નીતિ',
		'position-type': 'સ્થાનનો પ્રકાર',
		'co-op-internship': 'કોપ/ઈન્ટરનશિપ',
		'entry-level': 'પ્રારંભિક સ્તર',
		'junior-manager': 'જ્યૂનિયર મેનેજર',
		'middle-manager': 'મધ્ય સ્તર મેનેજર',
		'add-the-keywords': 'કીવર્ડ્સ ઉમેરો',
		cancel: 'રદ કરો',
		'please-select-the-assessment': 'મહેરબાની કરીને મૂલ્યાંકન પસંદ કરો!',
		'create-your-benchmark': 'તમારું બેંચમાર્ક બનાવો',
		'create-a-benchmark-by-sending':
			'શ્રેષ્ઠ કામગીરી કરનાર કર્મચારીઓના મૂલ્યાંકન દ્વારા બેંચમાર્ક બનાવો',
		'share-the-link-below': 'નીચેનો લિંક શેર કરો',
		launch: 'પ્રારંભ કરો',
		'Add-team': 'ટીમ ઉમેરો',
		search: 'શોધો',
		'example-challenge': 'ડેમો',
		'single-never-married': 'અવિવાહિત, ક્યારેય લગ્ન ન કરેલા',
		widowed: 'વિધવા/વિધુર',
		separated: 'અલગ રહેનાર',
		divorced: 'છૂટાછેડા લીધેલા',
		married: 'લગ્ન થયેલ',
		'living-common-law': 'સાથે રહેતા હોય (કાયદેસર લગ્ન વિના)',
		'what-is-the-highest-degree': 'તમારું શૈક્ષણિક લાયકાતમાં સૌથી ઊંચું પદ કયું છે?',
		'less-than-high-school-diploma': 'હાઈ સ્કૂલ ડિપ્લોમા કરતાં ઓછી લાયકાત',
		'high-school-degree-or-equivalent': 'હાઈ સ્કૂલ ડિગ્રી અથવા સમકક્ષ (જેમ કે GED)',
		'some-scollege-no-degree': 'કોલેજનો અમુક અભ્યાસ, પણ ડિગ્રી પ્રાપ્ત નથી',
		'associate-degree': 'એસોસિયેટ ડિગ્રી (જેમ કે AA, AS)',
		'bachelors-degree': 'સ્નાતક ડિગ્રી (જેમ કે BA, BS)',
		'masters-degree': 'માસ્ટર્સ ડિગ્રી (જેમ કે MA, MS)',
		'professional-degree': 'વ્યાવસાયિક ડિગ્રી (જેમ કે MD, DDS)',
		doctorate: 'ડોક્ટરેટ (જેમ કે PhD, EdD)',
		'what-is-your-current-employment-status': 'હાલમાં તમારું રોજગાર સ્થિતિ શું છે?',
		'employed-full-time-40': 'પૂરું સમય નોકરીમાં (દર અઠવાડિયે 40 કલાક કે વધુ)',
		'employed-part-time-39': 'અર્ધ સમય નોકરીમાં (દર અઠવાડિયે 39 કલાક સુધી)',
		'unemployed-and-currently-looking': 'બેરોજગાર અને હાલમાં નોકરી શોધી રહ્યા છો',
		'Unemployed-and-currently-not-looking': 'બેરોજગાર અને હાલમાં નોકરી શોધી રહ્યા નથી',
		student: 'વિદ્યાર્થી',
		retired: 'નિવૃત',
		'self-employed': 'સ્વરોજગારી',
		'unable-to-work': 'કામ કરવા અસમર્થ',
		'to-tutorial': 'ટ્યુટોરીયલ તરફ',
		'please-do-not-take-this-assessment-on-phone': 'કૃપા કરીને આ મૂલ્યાંકન ફોન પર ન આપો',
		company: 'કંપની',
		'mobile-device-prompt':
			'તમું મૂલ્યાંકન મોબાઇલ ડિવાઇસ પર આપવા પ્રયત્ન કરી રહ્યા છો એવું લાગે છે. શ્રેષ્ઠ અનુભવ માટે, કૃપા કરીને ડેસ્કટોપ અથવા લેપટોપથી આ મૂલ્યાંકન કરો.',
		'company-would-like':
			'તમને nugget.ai ચેલેન્જમાં ભાગ લેવા માટે આમંત્રિત કરવામાં આવ્યા છે. આ ચેલેન્જમાં, તમારી સોફ્ટ સ્કિલ્સ દર્શાવવા માટે તમારી પાસે ઑનલાઇન મિની-જૉબ સિમ્યુલેશનમાંથી કામ કરવાનું રહેશે.',
		'we-are-assessing':
			'અમે તમારા સોફ્ટ સ્કિલ્સનું મૂલ્યાંકન તમારી પ્રક્રિયા પરથી કરીએ છીએ - એટલે કે તમે જૉબ સિમ્યુલેશનને કેવી રીતે અભિગમ આપો છો, તમે ઇન્ટરફેસના વિવિધ ઘટકો સાથે કેવી રીતે ક્રિયાપ્રતિક્રિયા કરો છો, અને તમે શું નિર્ણયો લો છો. અમે અંતિમ પરિણામ કેટલુ સાચું કે ખોટું છે એ બદલે, તમે ચેલેન્જ કેવી રીતે પૂર્ણ કરો છો તે નમૂનાઓ પર ધ્યાન આપીએ છીએ.',
		'we-at-nugget.ai':
			'અમે nugget.aiમાં માનીએ છીએ કે કોઈ પણ જવાબ યોગ્ય કે ખોટો નથી, તેથી અમે તમને પ્રેરણા આપીએ છીએ કે સ્વાભાવિક રીતે આગળ વધો અને શ્રેષ્ઠ પ્રયાસ કરો!',
		'company-following-tutorial':
			'ચેલેન્જ માટે તમારી તૈયારી માટે, તમને ઇન્ટરફેસ દ્વારા માર્ગદર્શન આપતું ટ્યુટોરીયલ રજૂ કરવામાં આવશે. અમે દરખાસ્ત કરીએ છીએ કે તમે અમારાં સૂચનો ધ્યાનપૂર્વક વાંચો. આ ટ્યુટોરીયલ પછી, તમારી પાસે છે',
		'minutes-to-complete': 'મૂલ્યાંકન પૂરું કરવા માટે મિનિટ.',
		'good-luck': 'સારા નસીબની કામના!',
		goodluck: 'સારા નસીબ!',
		'assess-learn-evolve': 'મૂલ્યાંકન કરો. શીખો. વિકસો',
		'discover-your-soft-skills': 'ભૂમિકા સંબંધિત ચેલેન્જ દ્વારા તમારી સોફ્ટ સ્કિલ્સ શોધો',
		'n-challenges-available': '{n} ચેલેન્જ ઉપલબ્ધ છે',
		'search-challenge': 'ચેલેન્જ શોધો',
		'hi-{name}': 'હાય {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, તમે ખૂબ આગળ જઈ રહ્યા છો!',
		'discover-nuggets-about-your-soft-skills': 'તમારી સોફ્ટ સ્કિલ્સ વિશે નવલકથા શોધો',
		'register-login': 'લૉગિન',
		'nugget-ai-science': 'Nugget.ai વિજ્ઞાન',
		'our-prediction-models':
			'અમારા ભવિષ્યવાણી મોડેલ્સ I/O સાયકોલોજીમાં શૈક્ષણિક સંશોધનના આધાર પર બનાવવામાં આવ્યા છે',
		performance: 'પ્રદર્શન',
		'people-skills': 'માણસોની સ્કિલ્સ',
		'view-submission': 'સબમિશન જુઓ',
		'domain-skills': 'ડોમેન સ્કિલ્સ',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'તમારું ધ્યાન નિશ્ચિત કરો અને સુધારાના ખૂણાઓ શોધો',
		'discover-your-path': 'તમારું માર્ગ શોધો',
		'keep-an-open-mind-and-try-something-new': 'મૂક્ત ચિત્ત રાખો અને કંઈક નવી કોશિશ કરો!',
		'compare-to': 'તુલના કરો',
		'growth-tips': 'વિકાસની ટીપ્સ',
		'machine-drive-advice-subtitle': 'ટોપ 10% વ્યાવસાયિકોના આધારે મશીન દ્વારા સંચાલિત સલાહ',
		'growth-tips-1':
			'“જોબમાં સફળતા કે નિષ્ફળતાનું મુખ્ય કારણ વિવરણની બારીકી તરફ ધ્યાન આપવું રહ્યું છે.”',
		'growth-tips-2':
			'“ટેકનોલોજી સોલ્યુશન્સના પોર્ટફોલિયોને મેનેજ કરવું જ્યાં ઉદ્યોગ ઝડપથી બદલાઈ રહ્યો હોય, એ તમને સતત ચેતન રહેવા માટે મજબૂર કરે છે…”',
		'growth-tips-3':
			'“મશીન લર્નિંગની જેમ બ્લોકચેઇન દરેક ઉદ્યોગને બદલવાની શક્તિ રાખે છે. નવી શોધ માટે સર્જનાત્મક રીતે વિચારવાની તમારી ક્ષમતા તમારા કારકિર્દી માટે નિર્ણાયક બની શકે છે”',
		'what-does-this-mean': 'આનો અર્થ શું થાય છે?',
		'project-coodinator': 'પ્રોજેક્ટ કોઓર્ડિનેટર',
		'financial-analyst': 'ફાઇનાન્શિયલ એનાલિસ્ટ',
		'project-manager': 'પ્રોજેક્ટ મેનેજર',
		'blue-sky-music-proposal': 'બ્લુ-સ્કાય મ્યુઝિક પ્રસ્તાવ લખો',
		'blue-sky-music-proposal-description':
			'તમે એક અનુભવી કલાકાર છો જે એક એવા રેકોર્ડ લેબલ સાથે સંકળાયેલા છો જે હાલના સંગીત ઉદ્યોગમાં આગેવાન છે. રેકોર્ડ લેબલ દર મહિને “બ્લુ-સ્કાય” મીટિંગનું આયોજન કરે છે જેમાં કલાકારોએ નવા ગીત માટે વિગતો સાથેનો એક યોજના પ્રસ્તાવ રજૂ કરવાનો હોય છે — કોઈપણ શૈલીમાં, કોઈપણ વિષય પર. આ ચેલેન્જમાં, તમે તમારા યોજના માટે સમાવિષ્ટ ઘટકો ઓળખો, આપેલ સંસાધનોમાંથી માહિતી એકત્ર કરો, વિચારો વિકસાવો અને અંતે તમારી મોટી કલ્પના સાથે એક પ્રસ્તાવ તૈયાર કરો.',
		'blue-sky-music-proposal-resource-1': 'સ્રોત 1: ટ્રૂ કલર્સ - સામાન્ય તત્વો',
		'blue-sky-music-proposal-resource-2': 'સ્રોત 2: ટ્રૂ કલર્સ - ગીતોના શબ્દો',
		'help-a-first-time-homebuyer': 'પ્રથમ વખત ઘરની ખરીદી કરવા ઈચ્છતા ગ્રાહકને મદદ કરો',
		'help-a-first-time-homebuyer-description':
			'તમે રિયલ એસ્ટેટ વેચાણ પ્રતિનિધિ છો. એક સંભવિત ખરીદદારે તમારા સંપર્કમાં આવીને પોતાનું પહેલું ઘર ખરીદવા માટે રસ દર્શાવ્યો છે. આ ચેલેન્જમાં, તમારા નવા ગ્રાહકની જરૂરિયાતો ઓળખો, આપેલ સંસાધનોમાંથી માહિતી મેળવો, વિવિધ વિકલ્પો વિચારો અને શ્રેષ્ઠ વિકલ્પ અને તેના પાછળનું કારણ ભલામણ કરો.',
		emails: 'ઇમેઇલ્સ',
		'property-listings-table': 'મિલકત યાદી ટેબલ',
		'find-your-perfect-home': 'તમારું પરફેક્ટ ઘર શોધો',
		'marketing-description':
			'તમે માર્કેટિંગ વિશેષજ્ઞ છો. તમે એક મધ્યમ કદની રિટેલ કંપની માટે કામ કરો છો જે પાચ વર્ષથી ઉચ્ચ ગુણવત્તાવાળા આઉટડોર ગિયર અને આઉટરવેર કપડાં વેચે છે. તમારી કંપની મુખ્યત્વે ઓનલાઈન વેચાણ કરતી હતી પરંતુ તાજેતરમાં, મેનેજમેન્ટ ટીમે ecommerce આધારિત મોડેલમાંથી આગળ વધવાની વિચારણા શરૂ કરી છે. તમારા નિષ્ણાત અભિપ્રાય અને ઉપલબ્ધ ડેટાની આધાર પર ભલામણ માંગવામાં આવી છે.',
		'customer-demographics': 'ગ્રાહક ડેમોગ્રાફિક્સ',
		'customer-satisfaction-survey': 'ગ્રાહક સંતોષ સર્વે',
		'our-science': 'અમારું વિજ્ઞાન',
		'{number}-assessments-take-so-far': 'આ સુધીમાં {number} મૂલ્યાંકનો લીધા છે',
		whoops: 'અરે!',
		'404-message': 'તમે દાખલ કરેલો લિંક ખોટો છે અથવા હવે ઉપલબ્ધ નથી',
		'take-me-home': 'મૂળ પેજ પર લઈ જાવ',
		'what-does-this-mean-s1':
			'તમે પૂરી કરેલી ચેલેન્જમાં, તમારું સમસ્યા હલ કરવાની ક્ષમતા અને સંવાદકૌશલ્ય વેચાણના ભૂમિકા માટે રજૂ કરવું求 હતુ — અને તમે એ સુંદર રીતે કર્યું! તમે ચેલેન્જ શરૂ કરી તે ક્ષણથી, અમે તમારી પ્રતિસાદ પ્રક્રિયા અને પગલાંઓનો ટ્રેક રાખ્યો. અહીં તમને અમારાં વિશ્લેષણમાંથી મળેલ કેટલીક ઉપયોગી માહિતી બતાવવામાં આવી છે.',
		'what-does-this-mean-s2':
			"અમે અમારી 'ગોપનીય રેસીપી' શેર કરી શકતા નથી, પણ વિચાર માટે આ એક ઉદાહરણ છે.",
		'what-does-this-mean-s3-bold': 'ઝડપ અને ચિંતનશીલતા:',
		'what-does-this-mean-s3':
			"ઝડપથી લખવાનું શરૂ કરવું, પછી ઇમેઇલ્સ ખોલી વાંચતી વખતે લખાણમાં ફેરફાર કરવો, ઉમેરવું અને સુધારવું — આ રીતે ચેલેન્જ પૂરી કરનારા લોકો 'ઝડપ અને ચિંતનશીલતા'માં ઊંચો સ્કોર મેળવી શક્યા.",
		'what-does-this-mean-s4':
			'જ્યાં તાત્કાલિક કાર્ય તાત્કાલિક શરૂ કરવું પડે ત્યારે આ લક્ષણ ખૂબ ઉપયોગી સાબિત થાય છે.',
		speed: 'ઝડપ',
		'meticulousness-assertiveness': 'સચોટતા અને આત્મવિશ્વાસ',
		'attention-to-detail': 'વિગતો પ્રત્યે ધ્યાન',
		'clarity-reasoning': 'સ્ફટિકતા અને તાર્કિકતા',
		export: 'નિર्यात કરો',
		archieve: 'આર્કાઇવ કરો',
		delete: 'કાઢી નાખો',
		'are-you-sure-you-want-to-delete': 'શું તમે ખરેખર કાઢી નાંખવા માંગો છો?',
		'are-you-sure-you-want-to-delete-this': 'શું તમે ખરેખર આને કાઢી નાંખવા માંગો છો?',
		'pick-a-challenge': 'એક ચેલેન્જ પસંદ કરો',
		'confirm-pick': 'પસંદગીની પુષ્ટિ કરો',
		'challenge-added': 'ચેલેન્જ ઉમેરાઈ ગઈ છે!',
		'sharable-link': 'શેર કરી શકાય તેવો લિંક',
		'sharable-link-copy': 'લિંક કોપી કરી દીધો છે',
		music: 'સંગીત',
		lyrics: 'ગીતના શબ્દો',
		artist: 'કલાકાર',
		'creative-industries': 'સર્જનાત્મક ઉદ્યોગો',
		'song-proposal': 'ગીતનો પ્રસ્તાવ',
		voice: 'અવાજ',
		'real-estate': 'રિયલ એસ્ટેટ',
		'customer-success': 'ગ્રાહક સફળતા',
		software: 'સોફ્ટવેર',
		customer: 'ગ્રાહક',
		experience: 'અનુભવ',
		regression: 'રીગ્રેશન',
		'data-analysis': 'ડેટા વિશ્લેષણ',
		'data-mining': 'ડેટા માઈનિંગ',
		'digital-marketing': 'ડિજિટલ માર્કેટિંગ',
		'e-commernce': 'ઈ-કોમર્સ',
		retail: 'ચોખ્ખુ વેચાણ',
		strategy: 'રીતિનીતિ',
		financial: 'આર્થિક',
		analysis: 'વિશ્લેષણ',
		role: 'ભૂમિકા',
		rolelevel: 'ભૂમિકા સ્તર',
		function: 'ભૂમિકા કાર્ય',
		organization: 'સંસ્થા',
		industry: 'ઉદ્યોગ',
		'team-size': 'ટીમનો કદ',
		'update-profile': 'પ્રોફાઇલ સુધારો',
		'sign-out': 'સાઇન આઉટ',
		'delete-account': 'એકાઉન્ટ કાઢી નાખો',
		'change-password': 'પાસવર્ડ બદલો',
		'Edit-profile': 'પ્રોફાઇલ સંપાદિત કરો',
		login: 'સાઇન ઇન',
		googleLogin: 'ગૂગલ વડે સાઇન ઇન કરો',
		googleSignup: 'ગૂગલ વડે સાઇન અપ કરો',
		facebookLogin: 'ફેસબુક વડે સાઇન ઇન કરો',
		facebookSignup: 'ફેસબુક વડે સાઇન અપ કરો',
		signup: 'સાઇન અપ',
		'enter-your-email': 'તમારું ઇમેઇલ દાખલ કરો',
		'enter-your-password': 'તમારો પાસવર્ડ દાખલ કરો',
		'referral-Code': 'રેફરલ કોડ',
		'Ask-your-friend-to-get-one': 'તમારા મિત્રને એક મેળવવા કહો',
		'signin-click': 'અથવા સાઇન ઇન કરવા અહીં ક્લિક કરો',
		'csignin-help': 'અમે તમારી મદદ ઇચ્છીએ છીએ! તમારું પ્રતિસાદ અમારું અનુભવ સુધારી શકે છે',
		'btn-provide-feedback': 'પ્રતિસાદ આપો',
		password: 'પાસવર્ડ',
		'login-as-employee': 'વપરાશકર્તા તરીકે લૉગિન કરો',
		'loggin-as-employer': 'એડમિન તરીકે લૉગિન કરો',
		'forgot-password': 'પાસવર્ડ ભૂલી ગયા છો?',
		username: 'વપરાશકર્તા નામ',
		'enter-your-firstname': 'તમારું પ્રથમ નામ દાખલ કરો',
		'enter-your-lastname': 'તમારું છેલ્લું નામ દાખલ કરો',
		'enter-your-username': 'તમારું યુઝરનેમ દાખલ કરો',
		'auth-no-user': 'તમારું ઇમેઇલ અમારી ડેટાબેઝમાં હાજર નથી. કૃપા કરીને ફરી તપાસો.',
		'signup-as-employer': 'એડમિન તરીકે સાઇન અપ કરો',
		'signup-as-employee': 'વપરાશકર્તા તરીકે સાઇન અપ કરો',
		'invalid-username': 'અમાન્ય વપરાશકર્તા નામ!',
		'invalid-email': 'અમાન્ય ઇમેઇલ!',
		'invalid-password': 'અમાન્ય પાસવર્ડ!',
		'confirm-password': 'પાસવર્ડની પુષ્ટિ કરો',
		'verify-email-title': 'તમારું ઇમેઇલ ચકાસો',
		'verify-email-content':
			'સાઇન અપ માટે આભાર. શરૂ કરવાથી પહેલાં, કૃપા કરીને તમારું એકાઉન્ટ ચકાસવા માટે તમારા ઇમેઇલની તપાસ કરો.',
		'repeat-your-password': 'તમારો પાસવર્ડ ફરીથી લખો',
		'password-not-match': 'પાસવર્ડ મેળ ખાતો નથી',
		'password-reset': 'પાસવર્ડ ફરીથી સેટ કરો',
		'enter-your-email-and-well':
			'તમારું ઇમેઇલ દાખલ કરો અને અમે તમને પાસવર્ડ રીસેટ લિંક મોકલશું',
		'answer-some-questions': 'થોડા પ્રશ્નોના જવાબ આપો',
		'tell-us-about-yourself': 'અમને તમારી વિશે કહો!',
		'tell-us-about-yourself-description':
			'આ ફોર્મ માત્ર સંશોધન હેતુ માટે છે. તમારી માહિતી ગુપ્ત રાખવામાં આવશે અને તમારી પૂર્વમંજુરી વિના શેર કરવામાં نہیں આવશે. આ ફોર્મ વૈકલ્પિક છે અને તમે કોઈપણ પ્રશ્નનો જવાબ ન આપવા માટે સ્વયંસેવક બની શકો છો.',
		'we-want-your-feedback': 'અમે તમારું પ્રતિસાદ ઈચ્છીએ છીએ!',
		'we-want-your-feedback-description':
			'આ સર્વેનો ઉદ્દેશ્ય તમારા અનુભવને સમજવો છે, જ્યારે અમે તમને શ્રેષ્ઠ અનુભવ આપવા પ્રયત્ન કરીએ છીએ! આનો સમયગાળો 3 મિનિટથી ઓછો છે.',
		'we-want-your-feedback-note': '* વિનંતી થયેલા પ્રશ્નો જરૂરી છે.',
		'how-this-assessment-colleague':
			'તમે તમારા મિત્ર અથવા સહકર્મી ને આ મૂલ્યાંકન ભલામણ કરવાની શક્યતા કેટલી છે?',
		'poor-excellent': '1 = નબળું ; 7 = ઉત્તમ',
		'above-score-reason': 'ઉપર આપેલા સ્કોરનું કારણ શું છે?',
		'what-think-content-of-challenge': 'આ ચેલેન્જની સામગ્રી વિશે તમે શું વિચારો?',
		'additional-feedback-to-product-team':
			'અમારી પ્રોડક્ટ ટીમ શ્રેષ્ઠ અનુભવ આપવા માટે કટિબદ્ધ છે. શું તમારી પાસે અમારું દિશાનિર્દેશ સુધારવા માટે કોઈ વધારાનો પ્રતિસાદ છે?',
		'enter-your-email-address': 'કૃપા કરીને તમારું ઇમેઇલ સરનામું દાખલ કરો',
		'go-take-a-look': 'ચાલો જુઓ!',
		'for-2-minutes': '2 મિનિટ માટે, ઇન્ટરફેસ સાથે આરામદાયક બની જાઓ અને તત્વો સાથે રમો.',
		'your-data-will-not-saved-in-the-preview':
			'આ પૂર્વાવલોકનમાં તમે લખી અથવા ડ્રેગ/ડ્રોપ કરી શકશો નહીં.',
		'neat-let-me-see-it': 'સરસ, મને તે જોવા દો',
		'preview-mode': 'પૂર્વાવલોકન મોડ',
		skip: 'છોડી દો',
		userlist: 'વપરાશકર્તા યાદી',
		challengelist: 'ચેલેન્જ યાદી',
		pipelinelist: 'પાઇપલાઇન યાદી',
		'challenge-result-list': 'ચેલેન્જ પરિણામ યાદી',
		download: 'ડાઉનલોડ',
		count: 'ગણતરી',
		'finance-accounting': 'ફાઇનાન્સ અને અકાઉન્ટિંગ',
		'general-management': 'જનરલ મેનેજમેન્ટ',
		'human-resources': 'હ્યુમન રિસોર્સેસ',
		'information-technology': 'માહિતી તકનીક (આઇટી)',
		operations: 'ઓપરેશન્સ',
		'individual-contributor': 'અ فردગત યોગદાનદાતા',
		'expert-individual-contributor': 'નિષ્ણાત વ્યક્તિગત યોગદાનદાતા',
		manager: 'મેનેજર',
		'senior-manager': 'સીનિયર મેનેજર',
		executive: 'એગ્ઝિક્યુટિવ',
		'junior-analyst': 'જ્યૂનિયર એનાલિસ્ટ',
		'senior-analyst': 'સીનિયર એનાલિસ્ટ',
		'actively-looking': 'સક્રિય રીતે શોધી રહ્યો છે',
		'passively-looking': 'નિષ્ક્રિય રીતે શોધી રહ્યો છે',
		'not-looking': 'શોધી રહ્યો નથી',
		associate: 'એસોસિએટ',
		'senior-associate': 'સીનિયર એસોસિએટ',
		'vice-president': 'ઉપપ્રમુખ',
		'senior-vice-president': 'સીનિયર ઉપપ્રમુખ',
		'about-the-role': 'રૂપના વિશે',
		'mid-level-manager': 'મધ્ય-સ્તર મેનેજર',
		create: 'બનાવો',
		'solve-three-steps':
			'આપણને આ યાદી માટે યોગ્ય છે તે જોવામાં મદદ કરવા માટે, અમે તમને એક પડકાર આપીશું અને તે ત્રીકુટમાં હલ કરવા માટે કહીએ છીએ.',
		'important-instructions': 'મહત્વપૂર્ણ સૂચનાઓ',
		instructions:
			'તમારા માટે ચાર કન્ટેનરો છે, જેમાં તમને "સમસ્યા ઓળખો", "મહત્વપૂર્ણ માહિતી એકત્રિત કરો" (તમારા દ્વારા લખી શકાય છે), "વિચારણા માટે આલ્કટિક વિચારો બનાવો (અલગ-અલગ વિકલ્પો માટે 3 સુધી વિચારતા રહો)" અને "સમાધાન ભલામણ કરો". તમે બુલેટ પોઈન્ટ્સ અથવા સંપૂર્ણ વાક્યોનો ઉપયોગ કરી શકો છો, તે તમારું પસંદગી છે! અમે તમારો નિર્ણય-બનાવટ પ્રક્રિયા અને સમસ્યા ઉકેલવાની કૌશલ્યો માપી રહ્યા છીએ',
		'confirmation-message':
			'તમને આ સ્ક્રીન પછી એક પુષ્ટિ સંદેશો મળશે. તમારે 20 મિનિટમાં આ પડકાર પૂર્ણ કરવાનો છે. શુભકામનાઓ!',
		'start-test': 'પરિક્ષા શરૂ કરો',
		instruction: 'સૂચના',
		'customize-your-assessment': 'તમારી મૂલ્યાંકનને અનુકૂળ કરો',
		'control-assessment': 'તમારા પોતાના સામગ્રીને ઉમેરવા દ્વારા મૂલ્યાંકન પર નિયંત્રણ કરો',
		'assessment-name': 'મુલ્યાંકન નામ',
		'assessment-description': 'મુલ્યાંકન વર્ણન',
		'input-timer': 'ઇનપુટ ટાઈમર',
		'upload-image-challenge': 'પડકાર માટે છબી અપલોડ કરો',
		'plain-text': 'સાદો લખાણ',
		'audio-link': 'ઓડિયો લિંક',
		'video-link': 'વિડીયો લિંક',
		'image-link': 'છબી લિંક',
		'add-card': 'કાર્ડ ઉમેરો',
		'thank-you': 'આભાર',
		'challenge-submission': 'અત્યારે! અમે તમારી પડકાર સબમિશન પ્રાપ્ત કરી છે',
		'feedback-your-assessment':
			'જો તમે તમારી મૂલ્યાંકન પર પ્રતિસાદ પ્રાપ્ત કરવા માંગતા હો, તો કૃપા કરીને નીચે તમારું ઈમેલ એડ્રેસ દાખલ કરો',
		'your-voice':
			'અમને તમારી અવાજની જરૂર છે! તમારે તમારા કારકિર્દીમાં શરૂઆત કરવા માટે કઈ સલાહ આપશો?',
		save: 'સાચવો',
		saving: 'સાચવાઈ રહ્યું છે...',
		saved: 'સાચવાઈ ગયું!',
		success_time_feedback: 'સફળતા! અમે તમારા સમય અને પ્રતિસાદ માટે આભારી છીએ',
		'supposed-to-do': 'હું શું કરવાનું છું?',
		'supposed-to-do-answer':
			'Nugget.ai પડકાર સાથે, તમારે તે ભૂમિકા આહલાદિત કરવાની વિનંતી કરવામાં આવી છે જે પડકાર વર્ણનમાં વર્ણવવામાં છે. પડકાર ભૂમિકા લઈ રહ્યા હો, અમે તમારી પાસેથી તે જોવા માટે વિનંતી કરીએ છીએ કે તમે કેવી રીતે વિચારો છો, તમે શું કરશો, કઈ માહિતી તમે વિચારશો અને તમે શું ભલામણ કરશો જો તમે આ ભૂમિકા પર કામ કરી રહ્યા હોત',
		'what-challenge': 'આ પડકાર શું છે?',
		'what-challenge-answer':
			'આ પડકાર એક વર્ણન છે જેમાં તે ભૂમિકા સમાવેશ થાય છે જેને તમે કરવાની જરૂરી છે અને આ બધું કયા સંદર્ભમાં થાય છે. સૌથી મહત્વપૂર્ણ વાત એ છે કે, પડકાર એ તમારું મિશન રજૂ કરે છે – તે છે, તમારે જે સમસ્યા ઉકેલવી છે',
		'retake-challenge': 'શું હું પડકાર ફરીથી લઈ શકું છું?',
		'retake-challenge-answer':
			'નહીં, એકવાર તમે પડકાર પૂર્ણ કરી દીધો છે, ત્યારે તેને ફરીથી લેવા માટે કોઈ તક નથી. આથી, અમે તમારી પાસેથી વિનંતી કરીએ છીએ કે તમે પ્રથમ વાર પડકાર ભૂમિકા દરમિયાન તે ઘણી રીતે કલ્પના કરો અને તે પ્રક્રિયાને અનુરૂપ રીતે અનુસરો જે તમે યોગ્યપણે કરશો જો તમે આ પડકારની સમસ્યાને વાસ્તવિક જીવનમાં ઉકેલવાનું હતા.',
		'purpose-whole-activity': 'આ સમગ્ર પ્રવૃત્તિનો ઉદ્દેશ શું છે?',
		'purpose-whole-activity-answer':
			'આ પ્રવૃત્તિનો ઉદ્દેશ એ છે કે તે કેવો દેખાય તે ઝડપી ઝલક પ્રાપ્ત કરવી જ્યારે તમે નોકરી પર હો, એવી નોકરીની પ્રવૃત્તિ કરવા જે આ નોકરી માટે સામાન્ય હોય.',
		'challenge-problem': 'શું પડકાર કોઈ વાસ્તવિક ઘટના/પરિસ્થિતિ/સમસ્યા/કંપની પર આધારિત છે?',
		'challenge-problem-answer':
			'Nugget.ai પડકારો વાસ્તવિક ઘટનાઓ, સમસ્યાઓ, અને/અથવા કંપનીઓ પર આધારિત નથી. કોઈ પણ સાદ્ગી આકારવું અથવા સાક્ષાત્કાર એ નક્કી કરેલું નથી.',
		'content-information': 'મને કઈ સામગ્રી/માહિતી સમાવિષ્ટ કરવી જોઈએ?',
		'content-information-answer':
			'સામગ્રી/માહિતીની માત્રા અથવા પ્રકારના સંદર્ભમાં, કોઈ નિર્ધારિત યોગ્ય દ્રષ્ટિકોણ નથી. વિચારો કે, જો તમે ખરેખર આ ભૂમિકા પર કામ કરી રહ્યા હો, તો તમે કઈ સામગ્રી/માહિતી પર ધ્યાન આપશો.',
		'what-resources': 'સાધનો શું છે?',
		'what-resources-answer':
			'સાધનો એ વાસ્તવિક ઉદાહરણો છે જેમને લોકો નોકરી દરમિયાન ઉપયોગ કરે છે જ્યારે તેઓ પડકાર મિશન જેવી કામકાજી ફરજ કરે છે. આ સાધનો વિવિધ પ્રકારની સામગ્રી અને વિવિધ સ્વરૂપોમાં હોઈ શકે છે - અને તે એ લોકોને નોકરી પર જોઈ શકાય તે રીતે માહિતી અને સ્વરૂપોને અનુરૂપ બનાવવા માટેનો હેતુ ધરાવે છે. અમે સામગ્રીની પરિપૂર્ણતા સિવાય કોઈ વધારાની માહિતી પૂરી પાડતા નથી - જે છે તે છે.',
		'what-i-do-resources': 'સાધનો સાથે હું શું કરું?',
		'what-i-do-resources-answer':
			'જે રીતે નોકરી પર થાય છે, તમે પડકાર પૂર્ણ કરવા માટે સાધનોમાં થી જેટલું અથવા નમ્ર રીતે ઉપયોગ કરી શકો છો. તમારી પાસે માહિતી વાંચવાની અને તેને પડકાર કાર્યસ્થળ પર ખેંચીને છોડવાની પસંદગીઓ છે.',
		'do-use-resources': 'શું હું બધાં સાધનોનો ઉપયોગ કરવો જ જોઈએ?',
		'do-use-resources-answer':
			'આ unbedingt નથી. તમે બધાં સાધનોનો ઉપયોગ કરી શકો છો, અને તેમ જ, તમે ફક્ત એક ભાગનો ઉપયોગ કરવાનો વિકલ્પ પસંદ કરી શકો છો. લોકો વિવિધ દ્રષ્ટિકોણ અપનાવવાના કારણો હોય છે. ફરીથી, શ્રેષ્ઠ રીતે કલીપના જેવો અનુભવ કરવા માટે, તમે તમારા શ્રેષ્ઠ પ્રયાસો કરશો.',
		'inform-outside-resources':
			'શું હું Resources સિવાયની અન્ય માહિતીનો ઉપયોગ કરી શકું છું?',
		'inform-outside-resources-answer':
			'અમે વિનંતી કરીએ છીએ કે તમે ચેલેન્જ માટેની તમારી જવાબદારી આધારે, માત્ર Resources માંથી માહિતી પર આધાર રાખી રહ્યા હો. તમે જે કોઈપણ પૂર્વ-પ્રાપ્ત જ્ઞાન યાદ રાખી શકો છો તેનો ઉપયોગ કરવા માટે સ્વાગત છે, પરંતુ ખાસ દસ્તાવેજો, લેખો, વાંચનો અથવા અન્ય સ્ત્રોતો ખોલતા નથી. જો આવા કોઈ ખાસ સ્ત્રોતોનો ઉપયોગ કર્યો હોય, તો આ સંકેત આપવા માટે તમારી જવાબદારી તરીકે તમને ખ્યાલ આવે છે. આ માટે, તમારા જવાબો પુલમાંથી ખોલી શકે છે.',
		'identify-problem': "'સમસ્યા ઓળખો'માં હું શું કરું?",
		'identify-problem-answer':
			'આ વિભાગમાં, તમે એ પડકારની મૂળ સમસ્યા ઓળખી અને ચર્ચા કરી શકો છો જેને તમારે તમારા મિશનમાં ઉકેલવું છે.',
		'collect-information': 'માહિતી એકત્ર કરો',
		'collect-information-answer':
			'આ વિભાગમાં, તમે આપેલા સાધનોમાંથી માહિતી એકત્ર કરી અને સંગ્રહ કરી શકો છો.',
		'engender-ideas': '‘વિચારો ઉત્પન્ન કરો’માં હું શું કરું?',
		'engender-ideas-answer':
			'આ વિભાગમાં, તમે વિવિધ વિકલ્પો/દિશાઓ/દૃષ્ટિકોણોને ચર્ચા કરી શકો છો જે તમે વિચારતા છો.',
		'recommend-solution': '‘ઉકેલ સૂચવવા’માં હું શું કરું?',
		'recommend-solution-answer':
			'આ વિભાગમાં, તમે એક અંતિમ ઉકેલ/ઉત્પાદન/સેવા રજૂ કરી અને ચર્ચા કરી શકો છો જે તમારે પડકાર પૂર્ણ કરવામાં મદદ કરે છે.',
		'complete-all-sections': 'શું મને તમામ વિભાગો પૂર્ણ કરવા પડશે?',
		'complete-all-sections-answer':
			'આ unbedingt નથી. યાદ રાખો, હેતુ એ છે કે તમે કેવી રીતે કામ કરી રહ્યા હો તે અનુરૂપ વિચારો. જો કેટલીક વિભાગો તમારા માટે ઓછું સંબંધિત લાગે, તો તમે આ વિભાગને પૂર્ણ કરવાની જરૂર નથી.',
		'format-responses': 'મારા પ્રતિસાદોને કેવી રીતે સ્વરૂપ આપવું?',
		'format-responses-answer':
			'તમારા પ્રતિસાદોને સ્વરૂપ આપવા માટે કોઈ સાચો અથવા ખોટો માર્ગ નથી. કઇ રીતે સ્વરૂપ આપવું તે વિચારો જ્યારે તમે ખરેખર આ ભૂમિકા પર કામ કરી રહ્યા હો અને મેનેજરને રજૂ કરી રહ્યા હો.',
		'complete-challenge-time': 'શું જો હું સમયમાં પડકાર પૂર્ણ ન કરી શકું?',
		'complete-challenge-time-answer':
			'કોઈ વાત નથી! ઘડીયાળ છે જેથી પડકાર-લેનારા માટે પ્રક્રિયાને માનક બનાવવામાં આવે, પરંતુ એવું નથી કે તમારા પ્રતિસાદો ખારિજ થઇ જશે કે માત્ર તમે નક્કી કરેલું સમય મર્યાદામાં કાર્ય પૂર્ણ ન કરી શકતા હો. અમે તે જવાબો હજુ પણ વિશ્લેષણ કરીએ છીએ જે તમે આપી શક્યા અને આ ડેટા પર આધારિત પરિણામો પ્રસ્તુત કરીએ છીએ.',
		'browser-continue-later': 'શું હું બ્રાઉઝર બંધ કરી ને પછીથી ચાલુ કરી શકું?',
		'browser-continue-later-answer':
			'ના, તમે એ desafchallenge પૂર્ણ કરવા માટે એક જ બેસવું પડશે.',
		'interface-accommodations':
			'જો મને વધુ સમય અથવા અન્ય ઇન્ટરફેસ સગવડતા જોઈએ તો શું કરું?',
		'interface-accommodations-answer':
			'અત્રે-built મફત સમય વધારવાના વિકલ્પો ઉપલબ્ધ નથી. આ માટે, અમે વિનંતી કરીએ છીએ કે તમે પડકાર પૂર્ણ કરતાં પહેલાં સમય પર સાવચેત હોવ. તેમ છતાં, જો તમે એક એવું વ્યક્તિ છો જેને સમય આધારિત અથવા અન્ય ઇન્ટરફેસ સગવડતા જરૂર છે, તો કૃપા કરીને તે વ્યક્તિ સાથે સંપર્ક કરો જેમણે આપને અમારું ચેલેન્જ લિંક મોકલ્યું. તે વ્યક્તિ પછી અમારો સંપર્ક કરશે અને સગવડતાઓ સાથે સંકળાયેલા મુદ્દા પર ચર્ચા કરશે.',
		'activity-chances-job':
			'આ પ્રવૃત્તિ પર ჩემი કાર્યક્ષમતા મારા નોકરી મેળવવાના અવસરોને કેવી રીતે અસર કરે છે?',
		'activity-chances-job-answer':
			'પડકારને નોકરી પ્રક્રિયામાં એક સ્વતંત્ર માપ તરીકે ઉપયોગ કરવામાં આવી શકે છે અથવા તે નોકરી અપાવવાની પ્રક્રિયાના એક ભાગ તરીકે ઉપયોગ કરવામાં આવી શકે છે. વધુમાં, તેમ છતાં અમે અમારા ક્લાયંટ માટે સૂચવેલી માર્ગદર્શિકાઓ આપી શકીએ છીએ, અમે સંસ્થાઓ કેવી રીતે પરિણામોનો ઉપયોગ કરે છે તે નિયમિત રીતે નિયંત્રિત નથી. તેથી, અમે વિનંતી કરીએ છીએ કે આ મુદ્દો સંબંધિત પ્રશ્નો કૃપા કરીને તે વ્યક્તિને પુછો જેમણે તમને અમારી ચેલેન્જ લિંક મોકલ્યો.',
		'wild-card': 'વિલ્ડ કાર્ડ',
		'wild-card-header-description':
			'તમને નવી માહિતી રજૂ કરવામાં આવી રહી છે અને તમારે તમારી ક્રિયા પસંદ કરવાની છે',
		'consulting-card-header-description':
			'તમે ભૂતપૂર્વ ક્લાયન્ટ પાસેથી એક મિસ્ડ કૉલ જોયો છે. તરત પછી, તમે જોઈ રહ્યા છો કે તેઓ ફરીથી કૉલ કરી રહ્યા છે. તમે નક્કી કરો છો:',
		'certifier-card-header-description':
			'Incoming email: “હેલ્લો, હું લેબ ટેકનિકિયન છું જે પ્રોજેક્ટ #45667 સાથે જોડાયેલો છે, વીજળી વાહન ચાર્જિંગ ઘટક વિશે. હું ઇમેઇલ મોકલ્યો છું આ પુષ્ટિ કરવા માટે કે શું તમને પરીક્ષણ પરિણામો મળ્યા છે અને જો તમને પ્રોડક્ટ વિશે કોઈ વધુ માહિતી જોઈએ છે. કૃપા કરીને મને જાણો, હું તેને પૂરી પાડવામાં ખુશીથી મદદ કરશ છું.” તમે શું કરવા માંગો છો?',
		'you-just-noticed':
			'તમે તાજેતરમાં એક ક્લાયન્ટ પાસેથી મિસ્ડ કૉલ જોયો છે. તરત પછી, તમે જોઈ રહ્યા છો કે તેઓ ફરીથી કૉલ કરી રહ્યા છે…',
		'dont-pick': 'કૉલ ઉપંધી ન કરો',
		'take-the-call': 'કૉલ લો કારણ કે ઉપયોગી માહિતી તમને આપવામાં આવી શકે છે.',
		'take-the-call-later': 'કૉલ લો અને પછી એક મીટિંગ સેટ કરો આગળ કામ માટે.',
		'nothing-for-you': 'અહીં તમારા માટે કશું નથી. તમારે કામ કરવા જવું છે - ચાલુ રાખો.',
		'the-client-tells-you-06':
			'ક્લાયન્ટ તમને કહે છે કે તેઓ ભૂતપૂર્વ પ્રોજેક્ટમાં તમે મદદ કરેલા પ્રોડક્ટ સાથે એક ગંભીર સમસ્યા અનુભવતા છે. તમે ફોન પર રહેને તેમને સમસ્યાને હલ કરવામાં મદદ કરો છો.',
		'the-client-tells-you-1-30':
			'ક્લાયન્ટ તમને કહે છે કે તેઓ ભૂતપૂર્વ પ્રોજેક્ટમાં તમે મદદ કરેલા પ્રોડક્ટ સાથે એક ગંભીર સમસ્યા અનુભવી રહ્યા છે. તમે આ મુદ્દાને ચર્ચા કરવા માટે બીજું મીટિંગ સેટ કરો છો',
		'time-desc': 'ચેલેન્જમાંથી મિનિટો ઘટાડવામાં આવ્યા',
		'consult-card-desc-1': 'ફરીથી વોઈસમેઇલ પર જવા દો',
		'consult-card-desc-2':
			'કૉલ લો. ભૂતપૂર્વ ક્લાયન્ટ તમને કહે છે કે તેઓ ભૂતપૂર્વ પ્રોજેક્ટમાં તમે મદદ કરેલા પ્રોડક્ટ સાથે એક ગંભીર સમસ્યા અનુભવતા છે. તમે ફોન પર રહેને તેમને સમસ્યાને હલ કરવામાં મદદ કરો છો.',
		'consult-card-desc-3':
			'કૉલ લો. ભૂતપૂર્વ ક્લાયન્ટ તમને કહે છે કે તેઓ ભૂતપૂર્વ પ્રોજેક્ટમાં તમે મદદ કરેલા પ્રોડક્ટ સાથે એક ગંભીર સમસ્યા અનુભવતા છે. તમે આ મુદ્દાને ચર્ચા કરવા માટે બીજું મીટિંગ સેટ કરો છો.',
		'why-software-development': 'સોફ્ટવેર વિકાસ પ્રોજેક્ટ્સ કેમ નિષ્ફળ થાય છે',
		'own-your-personal-space': 'તમારો વ્યક્તિગત જગ્યા મોંઘવારી કરો',
		'already-have-an-account': 'જો પહેલેથી એક ખાતું છે',
		'employer-login': 'નોકરી આપનાર લોગિન',
		'post-have-an-account': 'ખાતું નથી?',
		register: 'રીજીસ્ટર',
		'export-to-csv': 'CSV માં નિકાસ કરો',
		type: 'પ્રકાર',
		'l-type': 'પ્રકાર',
		data: 'ડેટા',
		'select-pipeline': 'પાઇપલાઇન પસંદ કરો',
		rank: 'રેંક',
		'characteristic-reflects':
			'આ લક્ષણ તે દર્શાવે છે કે તમે કેટલાય ઝડપથી કાર્ય શરૂ કરો છો અને તમારું કાર્ય પુનઃસમીક્ષણ કરવા માટે કેટલાય તૈયારી કરો છો. તમે શરૂઆતથી લખવાનું ઝડપી શરૂ કરો અને પછી તમારું કાર્ય ડિલીટ, ઉમેરો અને સુધારો કરો છો, જ્યારે તમે ઈમેઇલ ખોલો અને લેખ વાંચો છો, તે રીતે ચેલેન્જ લેનારાઓએ ઝડપ અને પ્રતિસાદી પર ઉચ્ચ ગુણ મેળવ્યા હતા.',
		'characteristic-reflects_example':
			'આ લક્ષણ જે કાર્યમાં લાભકારી બની શકે છે તે છે: જ્યારે તમને તાત્કાલિક કાર્ય હોય જે તરત જ હાથ ધરવું પડે.',
		'characteristic-reflects-two':
			'આ લક્ષણ તે દર્શાવે છે કે તમે કેટલાય રીતે વિચાર કરો છો અને આયોજન કરતા હો, તમારા વિચારોને અસરકારક રીતે ઢાંચો બનાવવાનો પ્રયત્ન કરો છો. ઈમેઇલ થ્રેડ અને લેખને વાંચીને અને પછી તમારી જવાબો બનાવવા માટે તમારો સમય લેવામાં તેને પ્લાનિંગ અને સંસ્થાનીમાં ઊંચા ગુણ મેળવવા માટે એક રીત છે.',
		'characteristic-reflects-two-example':
			'આ લક્ષણ જે કાર્યમાં લાભકારી બની શકે છે તે છે: જ્યારે તમને મહત્વપૂર્ણ કાર્ય હોય જે પૂર્ણતાની નજીક કામ કરવાની જરૂર હોય.',
		'characteristic-reflects-three':
			'આ લક્ષણ તે દર્શાવે છે કે તમે તમારા કાર્યમાં કેટલાય વિગતવાર અને કેવી રીતે તેનો ઉપયોગ આત્મવિશ્વાસ બતાવવાનું. ઈમેઇલ થ્રેડમાંથી ક્લાયન્ટની જરૂરિયાતોને લીધે તે પસંદ કરવું અને તેને પટ્ટાવવાના જવાબોમાં પુનરાવર્તિત કરવું એ એ રીતે છે જેમણે ચેલેન્જ લેનારાઓએ ધ્યાન અને દમ દેખાવાના પર ઊંચા ગુણ મેળવ્યા હતા.',
		'characteristic-reflects-three-example':
			'આ લક્ષણ જે કાર્યમાં લાભકારી બની શકે છે તે છે: જ્યારે તમને એવી કાર્ય હોય જે તમારા વિચારોને બીજા લોકો પર માનો બનાવવા માટે તમારા જ્ઞાનનો ઉપયોગ કરવું પડે.',
		'characteristic-reflects-four':
			'આ લક્ષણ તે દર્શાવે છે કે તમે તમારી વિચારોને યોગ્ય રીતે ફ્રેઝ અને સ્વતંત્રતા જાળવવા માટે કેટલાય સંભાળ રાખો છો. ભાષાને યોગ્ય રીતે ઉપયોગ કરવા અને જવાબોને નિષ્પક્ષ રીતે જાળવવા માટે સાવચેતી રાખવી એ એ રીતે છે જેમણે ચેલેન્જ લેનારાઓએ નિષ્પક્ષતા અને કાળજી પર ઊંચા ગુણ મેળવ્યા હતા.',
		'characteristic-reflects-four-example':
			'આ લક્ષણ જે કાર્યમાં લાભકારી બની શકે છે તે છે: જ્યારે તમારે એવી કાર્ય હોય જે નિષ્પક્ષતા અને ઉત્કૃષ્ટતા દ્વારા વ્યાવસાયિકતા પ્રદર્શિત કરવાની જરૂર હોય.',
		'characteristic-reflects-five':
			'આ લક્ષણ તે દર્શાવે છે કે તમે કેવી રીતે સ્પષ્ટ રીતે તમારા વિચારોને સંદેશાવ્યવહાર કરો છો અને તેમને તાર્કિક રીતે જોડો છો. ક્લાયન્ટને રજૂ કરેલા વિચારોને તેમના પર લગાડવામાં અને કિસ્સાઓ માટે ટ્રાંઝિશન શબ્દોનો ઉપયોગ કરીને વિચાર કરીને ચેલેન્જ લેનારાઓએ સ્પષ્ટતા અને ચિંતન પર ઉચ્ચ ગુણ મેળવ્યા હતા.',
		'characteristic-reflects-five-example':
			'આ લક્ષણ જે કાર્યમાં લાભકારી બની શકે છે તે છે: જ્યારે તમારે એવી કાર્ય હોય જે તમને પરિસ્થિતિ અને તમારી વિચાર પ્રક્રિયાને સ્પષ્ટ અને તર્ક સાથે મૂકવાની જરૂર હોય.',
		'alert-dialog':
			'એપ્લિકેશનને સ્થાન નિર્ધારણમાં મદદ કરવા માટે ગુગલને સહાય કરો. આનો અર્થ એ છે કે ગુગલને અનામિકા સ્થાનીક માહિતી મોકલવી, અહીં સુધી કે કોઈ એપ્લિકેશન ન ચાલતી હોવામાં.',
		disagree: 'અસહમત',
		agree: 'સહમત',
		'talent-relationships': 'પ્રતિભા સંબંધો',
		'talent-relationships-subtitle':
			'તમારા પ્રતિભા પૂલ વચ્ચે છુપાયેલા સંબંધોને શોધો. સ્કિલને ધ્રુજ પર ખેંચો અને જુઓ કે તમારા પ્રતિભા સાથે કેટલાય લોકોની તુલના કેવી છે.',
		'talent-funnel-title': 'પ્રતિભા ફનલ',
		'talent-funnel-subtitle':
			'તમારા પ્રતિભાને પડકાર પર શ્રેણીબદ્ધ કરાવો. પરિણામો જોવા માટે શ્રેણી પસંદ કરો.',
		'team-dynamic-title': 'ટીમ ગતિશીલતા',
		'team-dynamic-subtitle':
			'અન્ય પાઇપલાઇનમાંથી વ્યક્તિઓની ટીમમાં યોગદાન આપવા માટેની સિમ્યુલેશન દ્વારા તમારી ટીમની કાર્યક્ષમતા વધારાઓ. પ્રદર્શન માટે મિશ્રિત અને મેળવો.',
		'almost-there': 'લગભગ પહોંચી ગયા છો',
		'users-pipeline':
			'પરिणામ તે સમયે દેખાશે જ્યારે તમે પાઇપલાઇનમાં ઓછામાં ઓછા 50 વપરાશકર્તાઓને મૂકો.',
		'copied-invite': 'સફળતાપૂર્વક આમંત્રણ લિંકને કોપી કરી',
		'about-one':
			'Nugget.ai ચેલેન્જ સાથે, તમે એક નિર્ધારિત નોકરીની ભૂમિકા પર થવા માટે જણાવ્યું હતું અને શ્રેષ્ઠ રીતે સિમ્યુલેટ કરો કે તમે કેવી રીતે વિચારો છો, તમે શું કરો છો, તમે કયા માહિતી પર વિચાર કરો છો, અને તમે એ નોકરીની ભૂમિકામાં ચેલેન્જ પૂર્ણ કરતા કેટલી સારા રીતે ભલામણ કરશો. જેમણે પૃષ્ઠ ખોલ્યું ત્યારથી અમે તમારી સંસાધનો સાથેની ક્રિયાઓ અને ચેલેન્જ પૂર્ણ કરતી વખતે તમે જે રીતે ક્રિયાવલીઓ કરી રહ્યા હતા તે પ્રત્યેના વિવિધ પાસાઓને ટ્રેક કરી રહ્યા છીએ - આ બધું અમને મદદ કરે છે તમારી સમસ્યા હલ કરવાનો અને સંવાદ કૌશલ્ય પ્રદર્શિત કરવાની પદ્ધતિઓ સમજવામાં. ત્યારબાદ, અમે આ વિવિધ પાસાઓનું વિશ્લેષણ કર્યું અને કયા પેટર્ન બહાર આવ્યાં તે જોવાનું. આ પૃષ્ઠ પરના પરિણામો તે પેટર્નને દર્શાવે છે અને તમે બીજા લોકો સાથે કેવી રીતે પ્રક્રિયા કરી રહ્યા છો જેમણે ચેલેન્જ લીધી.',
		'about-two':
			'તમારા સ્કોર્સને એન્ક્સ સાથે ચિહ્નિત કરવામાં આવ્યા છે જેમણે ચેલેન્જ લીધી. અમે એક અનોખો માર્ગ તૈયાર કરી રહ્યા છીએ જે વપરાશકર્તા પ્રદર્શનને આંકવા માટે ઉદ્યોગ અને બજારની વિવિધ માવજતોથી લઈને કંપની અને ટીમ માટેના વિવિધ માવજત સુધી. વિવિધ માવજતો વિવિધ રીતે વર્તે છે કારણકે વિવિધ ડેમોગ્રાફિક સેગમેન્ટોમાં પ્રતિભામાં વિવિધતા છે.',
		'about-three':
			'માવજત કરતાં ઓછા સ્કોર હોવાનો અર્થ એ નથી કે તમે બાકીના લોકો કરતાં ખરાબ છો - દરેક કંપની વિવિધ લક્ષણોના સંયોજનને શોધી રહી છે.',
		'about-four':
			'આપણે હેતુ એ છે કે તમે તમારા નમ્ર કૌશલ્ય વિશે એવી માહિતી શોધો જે તમને તેવા કારકિર્દી માર્ગોને શોધવામાં મદદ કરે છે જે હાલમાં તમારા વિચાર, સંવાદ અને સમસ્યા હલ કરવાની રીત સાથે મેળ ખાય છે. તમે તેવા કારકિર્દી માર્ગોને શોધી શકો છો જે તમે ક્યારેય વિચાર્યા નથી પણ કદાચ તમારા માટે યોગ્ય હોઈ શકે છે, આ પરિણામોને શોધી જુઓ.',
		'account-details': 'ખાતાની વિગતો',
		'success-redirect':
			'સફળતાપૂર્વક સાચવવામાં આવ્યું. હવે તમને nugget.ai પર રીડિરેક્ટ કરી રહ્યા છીએ.',
		'usecase-one':
			"GE એપ્લાયંસિસે તેના Wi-Fi કનેક્ટેડ હોમ એપ્લાયંસિસ માટે અપડેટ જાહેર કર્યો છે, જે હવે સીધો ગૂગલ એસિસ્ટન્ટ સાથે કામ કરે છે, જે શોધ જાયન્ટનો વોઇસ-પાવર્ડ ડિજીટલ એસિસ્ટન્ટ છે. લોકો આહું કહીને આદેશ આપી શકે છે જેમ કે, 'હે, ગુગલ, ઓવનને 425 ડિગ્રી પર પ્રિહીટ કરો,' અથવા પૂછે છે, 'હે, ગુગલ, શું મારા પાટલાં સાફ છે?'",
		'usecase-two':
			"ગૂગલ એસિસ્ટન્ટ સાથેનો સીધો કનેક્શન GE એપ્લાયંસિસ સાથે વાત કરતાં એડિશનલ આદેશ આપવા કરવાની જરૂરિયાત દૂર કરે છે. અગાઉ, ઉત્પાદન માલિકોને જીનેવા હોમ એક્શનનો ઉપયોગ કરવો પડતો હતો વોઇસ આદેશો માટે, જેમ કે 'હે ગુગલ, જીનેવા હોમને કહો કે ઓવનને 425 ડિગ્રી પર પ્રિહીટ કરો.'",
		'usecase-three':
			'આ ફેરફાર GE એપ્લાયંસિસ સાથે કનેક્ટેડ ફ્રિજ, ઓવન, ડિશવોશર અને વોશિંગ મશીનો સહિત ઘણા હોમ એપ્લાયંસિસ સાથે કામ કરે છે, બધા U + કનેક્ટ એપથી સંલગ્ન છે જેથી ઉપકરણોને વ્યવસ્થિત કરી શકાય.',
		'usecase-four':
			"GE એપ્લાયંસિસની ગૂગલ એસિસ્ટન્ટ સાથેની નજીકની સંકલન એ સમયે આવી રહી છે જ્યારે શોધ જાયન્ટ એલેક્સા સાથે સ્પર્ધા કરી રહી છે માર્કેટમાં સ્માર્ટ હોમ સેવાઓ માટે. ડિજીટલ એસિસ્ટન્ટ સાથેનો સીધો કનેક્શન GE હોમ એપ્લાયંસિસને એલેક્સાની તુલનામાં થોડું સરળ બનાવી શકે છે, એલેક્સા, એમેઝોનનો ડિજીટલ એસિસ્ટન્ટ, જે છેલ્લા કેટલાક વર્ષોથી GE ઉત્પાદનો સાથે કામ કરી રહ્યો છે. એમેઝોન અને GE એ 2016માં એલેક્સા માટે જીનેવા સ્કિલ રજૂ કર્યો હતો, જેમાં વપરાશકર્તાઓએ આદેશો આપવાના જેવા, 'એલેક્સા, જીનેવા કહો કે ઓવનને 350 ડિગ્રી પર પ્રિહીટ કરો,' CNet મુજબ. આ એડિશનલ પગલું વપરાશકર્તાઓ માટે થોડીવાર અસૌલભ થવારી શકે છે જેનો હેતુ કિચનનાં સ્માર્ટ ડિવાઈસીસને કંટ્રોલ કરવા માટે સરળ રીત શોધવું છે.",
		'usecase-five':
			'GE એપ્લાયંસિસની જાહેરાત એ સમયે આવી રહી છે જ્યારે સ્વીડિશ એપ્લાયંસ મેકર ઇલેક્ટ્રોલક્સએ તેના કનેક્ટેડ કિચન ઉત્પાદનોને ગૂગલ એસિસ્ટન્ટ સાથે સંકલિત કરવાનો પ્રારંભ કર્યો છે. વોઇસ સંકલન ચોતરફ સ્માર્ટ ઓવનમાં આગામી વર્ષમાં શરૂ થશે, ઇલેક્ટ્રોલક્સે ગયા અઠવાડિયે જાહેર કર્યું હતું. વધુ એપ્લાયંસ મેકર્સ કનેક્ટેડ હોમ ઉપકરણો સાથે પ્રયાસ કરી રહ્યા છે, ટેકનોલોજી પ્રગતિ અને વૃદ્ધિ થતી જશે, ગ્રાહકો માટે વધુ સરળ અને સુવિધાજનક બની રહી છે.',
		'usecase-six':
			'ડિજીટલ એસિસ્ટન્ટ અને સ્માર્ટ સ્પીકર જગત ગરમ થાય છે. વોઇસ-પાવર્ડ સ્માર્ટ સ્પીકર્સના વૈશ્વિક શિપમેન્ટ Q1 2018માં 278% વધીને 9.2 મિલિયન યુનિટ્સ પહોંચી ગઈ છે ગયા વર્ષે તુલનામાં. જ્યારે એમેઝોનએ આ ત્રિમાસિક સમય દરમિયાન 4 મિલિયન શિપ કર્યા, ત્યારે તેનો બજાર હિસ્સો 43.6% પર ઘટી ગયો હતો, 81.8% થી વર્ષ પ્રતિ વર્ષ, સ્ટ્રેટેજી એનાલિટિક્સ મુજબ. વૈશ્વિક સ્માર્ટ હોમ ઉપકરણો બજાર, જેમાં સ્માર્ટ સ્પીકર્સ, ડિજીટલ મીડિયા એડેપ્ટર્સ, લાઇટિંગ, થર્મોસ્ટેટ અને અન્ય કનેક્ટેડ ગેજેટ્સ જેવા GE એપ્લાયંસિસ છે, અંદાજ છે કે આ વર્ષે 26.8% વધીને કુલ 549.5 મિલિયન શિપમેન્ટ્સ થશે, આંદરણ ડેટા કોર્પોરેશનના અનુમાન મુજબ.',
		note:
			'ટિપ્પણી: આ સંસાધનો એ મીટિંગના તમામ સભ્યો માટે અગાઉથી આપવામાં આવેલી દસ્તાવેજો છે. આ સંસાધનો સાથે, સભ્યોને લેબલની રોસ્ટરમાંથી એક ઇચ્છિત ગીતના ગીતો પ્રદાન કરવામાં આવ્યા છે. ગીતો સિવાય, ગીતના સામાન્ય તત્વોને ઓળખવામાં આવ્યા છે. ઉપરાંત, ગીતના વિશિષ્ટ તત્વોને ઓળખવામાં આવ્યા છે અને આ તત્વો એણે જરૂર નથી કે લેબલના વિશિષ્ટ અધિકારીઓની જરૂરિયાત હોય, પરંતુ આ તત્વો તમને તમારી યોજના વિકસાવતી વખતે કયા પ્રકારની માહિતી પર વિચાર કરવાની જરૂર છે તે સમજાવવામાં મદદ કરશે.',
		'song-title': 'ગીતનો શીર્ષક',
		'true-colours': 'સાચી રંગો',
		unnamed: 'અશીર્ષિત',
		instrumentals: 'ઇન્સ્ટ્રુમેન્ટલ્સ',
		'no-decription-provided': 'કોઈ વર્ણન પ્રદાન કરવામાં આવ્યું નથી',
		'vocal-type': 'ગાયકી પ્રકાર',
		'single-vocal-male': 'એકલ લીડ વોકલ પુરુષ',
		'theme-song': 'ગીતનો થીમ',
		'love-relationships': 'પ્રેમ અને સંબંધો',
		'storyline-song': 'ગીતની વાર્તા',
		'storyline-song-description':
			'ગાયક પોતાના પ્રેમીથી આકાંક્ષા વ્યક્ત કરે છે કે તે તેની સાથે વધુ ઊંડા સ્તરે જોડાઈને સમજવા માંગે છે. કલા રૂપે, ગાયક આ ભાવનાને પોતાની પ્રેમિકા સાથે શેર કરવા માટે રંગો અને છબીઓનો ઉપમા તરીકે ઉપયોગ કરે છે.',
		insight: 'ઊજાગર',
		talent: 'પ્રતિભા',
		'your-talent-pipelines': 'તમારા પ્રતિભા પાઈપલાઈનો',
		'add-challenge':
			'તમારા ચેલેન્જનો ઉદ્દેશ/વર્ણન અહીં ઉમેરો. ટીમના દરેક સભ્યને આ દેખાયશકશે!',
		'digital-team': 'કર્મચારીઓ',
		send: 'પ્રતિસાદ',
		'terms-and-condition': '<EnDescription />',
		merger: 'મર્જર',
		'm-a': 'M&A',
		teamwork: 'ટીમવર્ક',
		'consulting-description':
			'તમે એક મેનેજમેન્ટ કન્સલ્ટન્ટ છો. તમારા નવા ક્લાયન્ટ એ એક આશાવादी હેલ્થકેર ટેક કંપની છે, જે બે ઉન્નતિશીલ હેલ્થકેર ટેક સ્ટાર્ટઅપ્સના મર્જરનું પરિણામ છે. ક્લાયન્ટે તમારા કન્સલ્ટિંગ ફર્મને એમના ટીમવર્ક મુદ્દાઓમાં મદદ કરવા માટે સંકેત આપ્યો છે, જે મર્જરની શરૂઆતના બે મહિનામાં એક્ઝિક્યુટિવ ટીમ માટે સ્પષ્ટ થઈ ગયા હતા. કંપનીએ સ્વતંત્ર રીતે આ મુદ્દાઓને સુધારવાનો પ્રયાસ કર્યો છે પરંતુ વધુ સુધારો જોવા મળ્યો નથી. પ્રદાન કરેલી સંસાધનો સાથે, સમસ્યાનું નિદાન કરવાનો પ્રયાસ કરો, મુખ્ય માહિતી એકઠી કરો, અને તમારા નવા ક્લાયન્ટને સોલ્યુશન ભલામણ કરો.',
		acquisition: 'અધિગમ',
		'organize-culture': 'સંસ્થા સંસ્કૃતિ',
		'consulting-resource-1': 'કર્મચારી પ્રતિસાદ',
		'consulting-resource-2': 'મર્જર રણનીતિ',
		'consulting-resource-3': 'સહકર્મચારી પાસેથી નવી ઈમેલ',
		'send-email-again-text': 'એમેલ હજુ પ્રાપ્ત નથી થયો?',
		'send-email-again': 'ફરીથી મોકલો',
		'create-new-password': 'નવી પાસવર્ડ બનાવો',
		'create-new-password-info':
			'એક મજબૂત પાસવર્ડ પસંદ કરો અને તેને અન્ય ખાતાઓ માટે પુનઃઉપયોગ ન કરો. તમારો પાસવર્ડ બદલવાથી તમે તમામ ડિવાઇસમાંથી સાઇનઆઉટ થઈ જશો. તમને તમારો નવો પાસવર્ડ ફરીથી દાખલ કરવાની જરૂર પડશે.',
		'new-password': 'નવી પાસવર્ડ',
		'change-your-password': 'તમારો પાસવર્ડ બદલો',
		'current-password': 'વર્તમાન પાસવર્ડ',
		'mail-sent': 'ઇમેલ સફળતાપૂર્વક મોકલવામાં આવ્યો',
		'error-mail-sent': 'ઇમેલ મોકલવામાં ભૂલ આવી',
		'profile-update': 'તમારું પ્રોફાઈલ સફળતાપૂર્વક અપડેટ કરવામાં આવ્યું છે',
		'delete-confirmation': 'શું તમે ખાતું કાઢવા માટે ખાતરી કરો છો?',
		'current-password-incorrect': 'વર્તમાન પાસવર્ડ ખોટો છે',
		'password-change': 'પાસવર્ડ સફળતાપૂર્વક બદલાયો',
		'accept-the': 'સ્વીકારો',
		'terms-conditions': 'નીતિઓ અને શરતો',
		training: 'પ્રશિક્ષણ',
		'crisis-manage': 'કંપનીના કર્મચારી મુદ્દાઓનો ઉકેલ લાવો',
		'crisis-description':
			'તમે એક મેનેજમેન્ટ કન્સલ્ટન્ટ છો. તમારા નવા ક્લાયન્ટ એ એક વૃદ્ધિ પામતી હેલ્થકેર ટેક કંપની છે જે ગ્રાહક સેવા કર્મચારીઓ વિશે ચિંતાઓ સાથે તમારા પાસેથી સંપર્ક કર્યો છે. ગયા વર્ષે, ગ્રાહકની ફરિયાદો દબલ થઈ ગઈ છે, જેમાં 39% ગ્રાહકોએ આપવામાં આવેલ સેવા અસંતોષજનક માની છે. સંસ્થાએ આ કર્મચારીઓ માટે વધુ પ્રશિક્ષણ સત્રો પ્રદાન કર્યા છે પરંતુ કોઈ સુધારો જોવાયો નથી. પ્રદાન કરેલી સંસાધનો સાથે, સમસ્યાનું નિદાન કરવાનો પ્રયાસ કરો, મુખ્ય માહિતી એકઠી કરો, અને તમારા નવા ક્લાયન્ટને સોલ્યુશન ભલામણ કરો.',
		'crisis-res-1': 'ગ્રાહક ફરિયાદો',
		'crisis-res-2': 'એજન્ડા',
		'crisis-res-3': 'સહકર્મચારી પાસેથી નવી ઈમેલ',
		close: 'બંધ કરો',
		notifications: 'અધિકૃત સૂચના',
		'caught-all': 'તમામ માહિતી મેળવી લીધી છે!',
		'comment-taketest':
			'જ્યારે તમે આ અધ્યાય પૂરો કરો છો, અમે કરેલા કાર્યને સમજીને ચરિત્રો ટ્રેક કરી રહ્યા છીએ. Timer ઉપર નજર રાખો અને શુભકામના!',
		'new-information': 'તમારા માટે નવી માહિતી ઉપલબ્ધ છે.',
		now: 'હવે',
		chapters: 'અધ્યાય',
		'wildcard-name': 'વાઇલ્ડ કાર્ડ: આવતી ફોન કોલ',
		'wildcard-notify': 'પ્રમુખ નિર્ણયો સતત લેવામાં આવે છે. તમારે એક વિકલ્પ પસંદ કરવાનો છે',
		'mins-ago': '{time} મિનિટ પહેલા',
		'min-ago': '1 મિનિટ પહેલા',
		'take-other-challnge': 'સેન્ડબોક્સ - બીજું ચેલેન્જ લો',
		'preview-desc':
			'અહીં તમને ચેલેન્જનું વર્ણન મળશે. આ વર્ણન તેમાં આપેલ ભૂમિકા અને જ્યાં ચેલેન્જ થઈ રહી છે એનો પરિપ્રેક્ષ્ય શામેલ છે. સૌથી મહત્વપૂર્ણ વાત એ છે કે ચેલેન્જ તમારા મિશનના ઉદ્દેશ્યને રજૂ કરે છે.',
		'preview-res1':
			'અહીં તમને સંસાધન 1 મળશે. સંસાધનો એવા સાચા સંસાધનોના ઉદાહરણ છે જે લોકો જોબ પર કામ કરતાં સમયે ચેલેન્જ મિશન સાથે સમાન કાર્ય કરતી વખતે પ્રાપ્ય થશે. સંસાધનો વિવિધ પ્રકારના સામગ્રી હોઈ શકે છે અને વિવિધ ફોર્મેટોમાં હોઈ શકે છે – જે લોકો જોબ પર જોવા જેવી માહિતી અને ફોર્મેટિંગને અનુરૂપ છે. અમે વધુ માહિતી પ્રદાન નથી કરતા, જે છે તે જ છે.',
		'preview-res2':
			'અહીં તમને સંસાધન 2 મળશે. સંસાધનો એવા સાચા સંસાધનોના ઉદાહરણ છે જે લોકો જોબ પર કામ કરતાં સમયે ચેલેન્જ મિશન સાથે સમાન કાર્ય કરતી વખતે પ્રાપ્ય થશે. સંસાધનો વિવિધ પ્રકારના સામગ્રી હોઈ શકે છે અને વિવિધ ફોર્મેટોમાં હોઈ શકે છે – જે લોકો જોબ પર જોવા જેવી માહિતી અને ફોર્મેટિંગને અનુરૂપ છે. અમે વધુ માહિતી પ્રદાન નથી કરતા, જે છે તે જ છે.',
		language: 'ભાષા',
		english: 'અંગ્રેજી',
		spanish: 'સ્પેનિશ',
		french: 'ફ્રેન્ચ (જલદી જ આવશે)',
		'you-will-be-redirected':
			'તમને આ ફોર્મ સબમિટ કર્યા પછી સેન્ડબોક્સ પર રીડાયરેક્ટ કરવામાં આવશે.',
		'tell-us-about-the-function':
			'તમારા હાલમાં કયા કાર્યમાં છો તે અમને જણાવો. જો તમે અરજી કરી રહ્યા છો, તો તમે જે ભૂમિકા લેવી ઇચ્છો છો તે વિશે વિચાર કરો.',
		'tell-us-about-the-role':
			'તમારા હાલમાં કયા ભૂમિકા સ્તરે છો તે અમને જણાવો. જો તમે રોજગારમાં નથી, તો “હું શોધી રહ્યો છું” પસંદ કરો.',
		'success-copied': 'સફળતાપૂર્વક નકલ કરવામાં આવી',
		'looks-like-you':
			'આ લાગે છે કે તમે પાછા જવા નીકળ્યા છો. તમે પહેલેથી જ તમારું ચેલેન્જ સબમિટ કરી દીધું છે અને હવે કરવાનું કશું બાકી નથી.',
		keywords: 'કીવર્ડ્સ',
		analytics: 'એનલિટિક્સ',
		'create-account-info': 'એકાઉન્ટ બનાવો અથવા તમારા પરિણામો જોવા માટે સાઇન ઇન કરો',
		'create-account-info-signin': 'તમારા પરિણામો જોવા માટે સાઇન ઇન કરો',
		'create-account-info-signup': 'તમારા પરિણામો જોવા માટે સાઇન અપ કરો',
		'you-about-submit':
			'તમારા પરિણામો સબમિટ કરવા જઈ રહ્યા છો, શું તમને આ કરવાનું નિશ્ચિત છે?',
		'iam-searching': 'હું નોકરી શોધી રહ્યો છું',
		'keep-edit': 'સંપાદન ચાલુ રાખો',
		'assess-content':
			'આ મૂલ્યાંકન માત્ર એક દિશામાં છે. એક વિભાગ પૂરો થયા પછી, તમે પાછા જઈ શકો છો નહીં.',
		'submit-sentence': 'શું તમને તમારા પરિણામો સબમિટ કરવા માટે નિશ્ચિત છે?',
		'verify-email-success': 'સत्यાપન ઈમેઇલ સફળતાપૂર્વક મોકલવામાં આવી છે',
		'click-for-submission': 'સબમિટ માટે ક્લિક કરો',
		'looks-like-you-not-150-words': 'લાગે છે કે તમે હજી 150 શબ્દોનો લક્ષ્ય પૂર્ણ કરી નથી.',
		'you-will-solve-a-problem':
			'આオンライン અનુભવ સાથે, જે આગળના પાનું પર તમારા માટે રાહ જોઈ રહ્યું છે, અમારા લક્ષ્ય એ છે કે આ કામ ક્ષેત્રમાં ભૂમિકાને પરિપ્રેક્ષ્ય આપે. તમારા જવાબો આધારિત, અમે તે પ્રતિકૃતિની વ્યવસાયિક રીતે સંબંધિત કુશળતાઓ કાઢીશુ. તમને તે પરિસ્થિતિમાં એક્શન લેવાનો અનુસંધાન કરી જવાબ આપવાનો સંજોગ આવશે, જેમ કે સંદેશાઓ લખી, ઇમેઇલ તૈયાર કરવાની, યોજના રૂપરેખાઓ તૈયાર કરવી, અને અન્ય વ્યવસાયિક કાર્ય! તમને એવી ટેકનિકલ પ્રશ્નો પૂછવામાં આવી શકે છે જે ભૂમિકાને વિશિષ્ટ છે અને અમે માત્ર તમારી શ્રેષ્ઠ પ્રયાસ કરવા માંગતા છીએ જેથી અમે તમને પ્રદાન કરેલા પરિણામોમાં સચોટ હોઈ શકીએ.',
		'believe-there-is':
			'nugget.ai પર, અમે વાસ્તવિક જોબ સિમ્યુલેશનોનો ઉપયોગ કરીને લોકોની કુશળતાઓ અને ક્ષમતાઓની માપણી કરીએ છીએ જે વાસ્તવિક કામ માટે સંલગ્ન પરિસ્થિતિઓમાં છે.',
		'if-challenge': 'જો આ તમારું પહેલું સમયે ચેલેન્જ લેવા છે, ',
		'click-tutorial': 'ટ્યુટોરીયલ જોવા માટે અહીં ક્લિક કરો',
		first: ' પહેલું.',
		'to-prepare-you-for-the-challenge': 'ટ્યુટોરીયલને અનુસરીને, તમારે ',
		min: 'મિનિટ',
		'to-complete': ' આ મૂલ્યાંકન પૂર્ણ કરવા માટે મળશે. તમે આ કરી શકો છો!',
		'dont-take-this-one-your-phone': 'આ મૂલ્યાંકન તમારું ફોન પર ન લો',
		'minimum-words': 'કમથી કમ શબ્દ મર્યાદા: ',
		'150-words': '150 શબ્દો',
		'you-have-hidden-talent-external':
			'તમારા પાસે છુપાયેલા પ્રતિભાઓ છે, અને અમે તેને સંખ્યાંકિત કરવામાં મદદ કરીએ છીએ. અમે તમને કઈ તક દર્શાવવી તે નક્કી કરવાનું શરૂઆતમાં જ કરે છે, જ્યારે તમે ચેલેન્જ ખોલતા નથી, અને તે તમારે શ્રેષ્ઠ કારકિર્દી મેળવનાર એન્જિન પ્રદાન કરવાનો પ્રતિબદ્ધતા દ્વારા માર્ગદર્શિત થાય છે.',
		'you-have-hidden-talent-internal':
			'તમારા પાસે છુપાયેલા પ્રતિભાઓ છે, અને અમે તેને સંખ્યાંકિત કરવામાં મદદ કરીએ છીએ. અમે તમને કઈ તક દર્શાવવી તે નક્કી કરવાનું શરૂઆતમાં જ કરે છે, જ્યારે તમે ચેલેન્જ ખોલતા નથી, અને તે અમારી મિશન દ્વારા માર્ગદર્શિત થાય છે જે તમને અપ(રી)સ્કિલિંગ દ્રષ્ટિ દ્વારા કારકિર્દી માર્ગોને નાવિગેટ કરવામાં મદદ કરે છે.',
		linkedin_profile: 'LinkedIn પ્રોફાઇલ',
		'i-am-ready': 'હું તૈયાર છું',
		'i-am-authorized':
			'મને કેનેડા માં કામ કરવાની અનુમતિ છે અથવા 30 દિવસની અંદર આ અનુમતિ મેળવી શકું છું. જો નહીં, તો બોક્સ અંકિત ન કરો અને અમે તમને પ્રાયોજક કંપનીઓ સાથે જોડાશે.',
		'add-a-skill': 'એક કુશળતા ઉમેરો અને એન્ટર દબાવો',
		'select-roles': 'જે ભૂમિકાઓમાં તમારી રસ ધરાવ છો, તે પસંદ કરો',
		'add-a-role': 'એક ભૂમિકા ઉમેરો અને એન્ટર દબાવો',
		'add-a-lang': 'એક ભાષા ઉમેરો અને એન્ટર દબાવો',
		'add-a-jobtype': 'એક નોકરીનો પ્રકાર ઉમેરો અને એન્ટર દબાવો',
		'click-here-or-drag-drop':
			'અહીં ક્લિક કરો અથવા તમારું ફાઇલ અપલોડ કરવા માટે ડ્રેગ અને ડ્રોપ કરો',
		'this-step-is-optional':
			'આ પગલું વૈકલ્પિક છે, પરંતુ તે અમારી ભલામણ એન્જિનને શ્રેષ્ઠ અનુભવ પ્રદાન કરવામાં મદદ કરે છે. તમારી માહિતીનો ઉપયોગ મૂલ્યવાન દ્રષ્ટિ આપવાનો માટે થાય છે.',
		'how-was-your-experience': 'તમારા અનુભવ કયો હતો?',
		'question-title': 'ક્ષમતાવાળી પ્રશ્નાવલી',
		'question-comment':
			'નીચેની પ્રશ્નાવલી ફક્ત સંશોધનના માટે છે. કૃપા કરીને આ પ્રશ્નો પર જેટલું સચ્ચાઈથી શક્ય હોય તે જવાબ આપો. નોંધો કે તમારી જવાબો ચેલેન્જના પરિણામોને પ્રભાવિત નથી કરશે અને નોકરીદાતાઓને જાહેર નહીં થશે. તેમ છતાં, એક વેલિડિટી ટેસ્ટ ચલાવાશે: જો ચેલેન્જના પ્રદર્શન અને તમારી પ્રશ્નાવલીના જવાબમાં મોટો વિરોધ સંકેત મળે છે, તો તમારી બંને ચેલેન્જ અને પ્રશ્નાવલીના જવાબ અમાન્ય ઠરાવવામાં આવશે.',
		'very-bad': 'ખૂબ બુરો',
		'very-good': 'ખૂબ સારો',
		'we-appreciate-feedback': 'અમે તમારી પ્રતિસાદનો આભાર માનતા છીએ!',
		internal: 'આંતરિક',
		external: 'બાહ્ય',
		'challenge-experience':
			'કર્મચારીઓ અને ઉમેદવારો માટે ચેલેન્જનો અનુભવ દરેક જૂથ માટે અનન્ય હશે.',
		'must-input-pipeline-name': 'તમારે પાઇપલાઇન નામ દાખલ કરવું અનિવાર્ય છે',
		// 'upload-resume': 'Upload resume. Click or drag/drop file here',
		'raw-results': 'ટેક્સ્ટ',
		'product-certifier': 'ઉત્પાદન સલામતી પ્રમાણપત્ર ચેલેન્જ',
		'product-certifier-description':
			'તમે એક ઉત્પાદન સલામતી પ્રમાણકર્તા છો. તમારા ક્લાયંટ એ ઇલેક્ટ્રિક વાહનોનો ટોપ સપ્લાયર છે, જે CSA Groupના મંજુરીના છાપા માટે તેમના ઇલેક્ટ્રિક વાહન ચાર્જિંગ સ્ટેશનને મંજુરી આપવા માંગે છે. પૂરી પાડવામાં આવેલી સંસાધનો સાથે, CSA Groupના માનક પરિસ્થિતિઓ સાથે ચાર્જિંગ સ્ટેશન મેળવે છે કે કેમ તે શોધવા માટે પ્રયત્ન કરો.',
		'electric-car': 'ઇલેક્ટ્રિક કાર',
		energy: 'એર્જી',
		'lab-testing': 'લેબ ટેસ્ટિંગ',
		certification: 'પ્રમાણપત્ર',
		timestamp: 'ટાઈમસ્ટેમ્પ',
		wildCardOption: 'વાઇલ્ડકાર્ડ વિકલ્પ',
		'sliderpane-lock-tooltip':
			'આ સુવિધાને અનલોક કરી શકતા નથી કેમ કે દરેક ભૂમિકા પર પૂરતા ડેટા ઉપલબ્ધ નથી!',
		inspection: 'ઓડિટ',
		'client-communication': 'ક્લાયંટ સંચાર',
		certifier: 'પ્રમાણકર્તા',
		inspector: 'ઓડિટર',
		'product-safety-certifier-challenge-1': 'ઉત્પાદન સલામતી પ્રમાણકર્તા ચેલેન્જ - ભાગ 1',
		'product-safety-certifier-description-1':
			'તમે એક ઉત્પાદન સલામતી પ્રમાણકર્તા છો. તમારા ક્લાયંટ એ ટોરોન્ટો આધારિત ફૂટવેર કંપની છે જે માટે તેમણે એક નવી પેનિક શક્તિના પુરુષોની સલામતી બૂટ મોડલ બનાવ્યાં છે અને તે CSA Groupના માનક સામે પરીક્ષણ અને સરખાવવી માંગે છે. આ ચેલેન્જ માટે, કૃપા કરીને ક્લાયંટને પરીક્ષણ પરિણામો વિશે જાણકારી આપવા માટે ઈમેઇલ લખો.',
		'leadership-title': 'એગ્ઝીક્યુટિવ લીડરશિપ',
		'leadership-desc':
			'તમે તમારા સંસ્થામાં નેતા છો અને એક સેલ્સ ટીમના负责人 છો. માસિક બેઠકોમાં, સંસ્થામાં મુખ્ય ખેલાડીઓ સંસ્થાકીય કાર્યક્ષમતાની યાદી પર બોર્ડને અપડેટ કરે છે. આ બેઠકોનો લક્ષ્ય એ છે કે બધા લોકો માસિક અને ત્રિમાસિક લક્ષ્યો તરફ કાર્ય કરી રહ્યા છે. સંસ્થા સહયોગ, વૃદ્ધિ અને વિકાસ, અને સહકર્મીઓ અને ક્લાયંટ્સનો આદર પર ફોકસ કરે છે. સંસ્થા સામાન્ય રીતે ઉદ્યોગમાં મજબૂત પ્રતિસ્પર્ધક છે અને ઉચ્ચ કાર્યક્ષમતા ધરાવતા individuosને emprega કરે છે. પરંતુ ગયા વર્ષે, તમારી ટીમે કેટલીક સમસ્યાઓનો સામનો કર્યો છે. તમારું આભાર માટે તમારી ટીમ માટે સુચનો લાવવાનું કહ્યું છે. આપેલ સંસાધનોનો ઉપયોગ કરીને, તમારે 25 મિનિટમાં બોર્ડ બેઠક પર રજૂ કરવા માટે સુચનો તૈયાર કરવા છે.',
		leadership: 'લીડરશિપ',
		'employee-conflicts': 'કર્મચારી વિસંગતીઓ',
		'managing-teams': 'ટીમોનું સંચાલન',
		'executive-leadership': 'એગ્ઝીક્યુટિવ લીડરશિપ',
		'executive-leadership-res-1': 'ટીમ કાર્યક્ષમતા મૂલ્યાંકન',
		'executive-leadership-res-2': 'માનવ સંસાધન ફરિયાદ - કર્મચારી ફરિયાદ ફોર્મ',
		'executive-leadership-res-3': 'વિકલ્પિક ફરિયાદ - કર્મચારી ફરિયાદ ફોર્મ',
		'executive-leadership-res-6': 'ઈમેઇલ થ્રેડ',
		'take-a-quick-look-at-all-the-skills-we-can-measure':
			'આવશ્યક તમામ કુશળતાઓને ઝડપથી જાખોળો જે આપણે માપી શકીએ છીએ',
		'hospitality-title': 'હૉસ્પિટાલિટી સર્વિસ',
		'hospitality-desc':
			'તમે Wonderful Hotels માટે સર્વિસ અસોસિએટ છો. આજે, તમે તમારા નિયમિત શિફ્ટ માટે આવી રહ્યા છો અને આ ચેલેન્જમાં, તમને તમારા રોજિંદા કામ દરમિયાન આવી શકે એવા કાર્ય કરવા માટે પૂછવામાં આવશે. તમે આ કાર્ય નીચે આપેલા છે.',
		'hospitality-res1': 'કર્મચારી પહેલા છોડે છે',
		'hospitality-res2': 'ક્લાયન્ટ મோதવો',
		hospitality: 'હૉસ્પિટાલિટી',
		service: 'સર્વિસ',
		'linkedin-profile': 'LinkedIn પ્રોફાઇલ',
		fullname: 'પૂરું નામ',
		'analysis-data': 'ડેટા વિશ્લેષણ કરો',
		firstname: 'પ્રથમ નામ',
		lastname: 'આખરી નામ',
		location: 'સ્થળ',
		'add-skills': 'કુશળતાઓ ઉમેરો',
		'add-role-interests': 'ભૂમિકા રુચિઓ ઉમેરો',
		'add-job-type': 'નોકરી પ્રકાર ઉમેરો',
		'add-certication': 'પ્રમાણપત્ર ઉમેરો',
		'add-industry': 'ઊદ્યોગ ઉમેરો',
		'add-other-experience': 'અન્ય અનુભવ ઉમેરો',
		'other-experience': 'અન્ય અનુભવ',
		industry: 'ઊદ્યોગ',
		'role-function': 'ભૂમિકા કાર્ય',
		'role-level': 'ભૂમિકા સ્તર',
		'highest-edu-achieved': 'સર્વોચ્ચ શિક્ષણ પ્રાપ્ત',
		'year-profess-exp': 'વ્યાવસાયિક અનુભવ વર્ષ',
		status: 'જોબ સ્થિતિ',
		resume: 'રેઝ્યુમ',
		'upload-resume': 'રેઝ્યુમ અપલોડ કરો',
		'add-new': 'નવી ઉમેરો',
		'edit-title': 'સંપાદિત કરો',
		'setup-profile': 'તમારો પ્રોફાઇલ સેટ કરો',
		logout: 'લોગઆઉટ',
		Announcements: 'વિજ્ઞાપન',
		FAQ: 'પ્રશ્નો',
		Notifications: 'સૂચનાઓ',
		roles: 'ભૂમિકાઓ',
		skills: 'કુશળતાઓ',
		general: 'સામાન્ય',
		profile_image: 'પ્રોફાઇલ છબી',
		'complete-challenge': 'ચેલેન્જ પૂર્ણ કરો',
		'to-see-your-fit': 'તમારા માટે યોગ્ય જોવા અને નોકરીના અવસર સાથે મેળ ખાવા માટે.',
		'enough-data': 'તમારા માટે કોઇ મહત્વપૂર્ણ માહિતી બતાવા માટે પૂરતું ડેટા ઉપલબ્ધ નથી.',
		'user-tab-stories': 'ચેલેન્જ',
		'user-tab-profile': 'પ્રોફાઇલ',
		'user-tab-Assessments': 'મૂલ્યાંકન',
		'user-tab-coins': 'કોઇન્સ',
		'other-category-view': 'કૂઈક બીજું જોઈ રહ્યા છો?',
		'stories-sub-title': 'કેરિયર પાથ પર ક્લિક કરો અને અન્વેષણ કરો',
		'test-sentence':
			'લોરમ ઈપ્સમ ડોલોર સિટ અમેટ, કન્સેક્ટેટુર એડિપિસિંગ એલિટ, સેડ ડો ઈયૂસમોડ ટેમ્પોર ઈનસિડિડન્ટ ઉત લાબોર એટ ડોલોર મેગ્ના અલિક્વા. ઉત એનિમ એડ મિનીમ વિનીયમ, ક્વિસ નોસ્ટ્રુડ એક્સર્સિટેશન ઉલ્લામકો લેબોરિસ નિસિ ઉત આલિકિપ એક્સ ઈએ કોમોડો કોન્સેક્વાત. ડુઇસ ઍઉટે ઇરુરે ડોલોર ઇન રેહપ્રેઝેન્ટ ડોલોર ઇન વોલૂપટેટ વેલિટ એસ્સે સિલ્લમ ડોલોર યૂ ફૂગિયાત નુલ્લા પેરિયેટુર. એક્ષેપ્ટુર સિંટ ઓકેસેપટ ક્યુપીડાટ નોન પ્રોઈડેન્ટ, સુંટ ઇન culpa ક્વી ઓફિસિયા ડેસેરુંટ મોલિટ એનિમ આઇડ એસ્ટ લેબોરમ.',
		consulting: 'કન્સલ્ટિંગ',
		marketing: 'માર્કેટિંગ',
		'career-fit': 'કેરિયર ફિટ',
		'score-strength': 'સ્કોર શક્તિ',
		submission: 'સબમિશન',
		management: 'મેનેજમેન્ટ',
		'click-domain': 'તમારા પરિણામોને અન્વેષણ કરવા માટે ડોમેન પર ક્લિક કરો',
		'all-apply': 'સંપૂર્ણ પસંદ કરો જે લાગુ પડે',
		'single-apply': 'એકજ પ્રતિસાદ પસંદ કરો',
		'already-exist': 'પહેલેથી ખાતું છે? સાઇન ઈન કરો',
		'dont-exist': 'ખાતું નથી? સાઇન અપ કરો',
		signin: 'સાઇન ઇન',
		singup: 'સાઇન અપ',
		institutions: 'સંસ્થાનું નામ',
		'add-new-group': 'નવી ગૃપ ઉમેરો',
		'delete-group': 'ગૃપ કાઢી નાખો',
		jobtype: 'તમે કયા પ્રકારની નોકરી શોધી રહ્યા છો?',
		edu_type: 'શિક્ષણ',
		textarea_comment: 'ટાઇપિંગ શરૂ કરવા માટે અહીં ક્લિક કરો',
		'all-sum-100': 'તમામ મૂલ્યોએ 100% સત્તાવાર રીતે જોડાવું જોઈએ. કૃપા કરીને ફરીથી તપાસો',
		'benchmark-update': 'બેંચમાર્ક પ્રોફાઇલ સફળતાપૂર્વક અપડેટ થઈ છે',
		'create-profile': 'આજ જ તમારો પ્રોફાઇલ બનાવો!',
		'badge-unlock-message':
			'તમારા કારકિર્દી શ્રેષ્ઠતાઓને દર્શાવતી અનન્ય આવશ્યકતાઓ પૂરી કરીને બેજ લોક કરો. નોકરીદાતાઓ બેજ ધરાવતી ઉમેદવારોને 10x વધુ પસંદ કરે છે',
		badges: 'બેજેસ',
		'register-success': 'સફળતાપૂર્વક નોંધણી થઈ ગઈ!',
		'register-failure': 'નોંધણી નિષ્ફળ!',
		'enter-fullname': 'કૃપા કરીને તમારું સંપૂર્ણ નામ દાખલ કરો',
		'enter-firstname': 'કૃપા કરીને તમારું પહેલું નામ દાખલ કરો',
		'enter-lastname': 'કૃપા કરીને તમારું છેલ્લું નામ દાખલ કરો',
		'enter-location': 'કૃપા કરીને તમારી સ્થાન દાખલ કરો',
		'': 'કૃપા કરીને માન્ય લિંકડિન પ્રોફાઇલ દાખલ કરો',
		'use-point': 'તમારા પોઈન્ટનો ઉપયોગ કરવા માટેના માર્ગો જલ્દી જ આવી રહ્યા છે!',
		'working-on':
			'આ દરમિયાન, અમે તમને શ્રેષ્ઠ કંપનીઓ સાથે મેળ ખાવા માટે મહેનત કરી રહ્યા છીએ. જયારે મેળ મળશે, ત્યારે તમારે અમેથી ઇમેલ મળશે',
		'overall-fit': 'કુલ ફિટ',
		'setup-profile-desc':
			'આપણા એન્જિન તમારા પ્રાટે talentos શોધવામાં મદદ કરવા માટે છે. અમને તમારા વિશે થોડુંક જણાવો, જેથી અમે ક્યાંથી શરૂઆત કરવું તે જાણી શકીએ',
		'role-interests': 'ભૂમિકા રસ',
		languages: 'ભાષાઓ',
		'we-are-glad': 'અમે ખુશ છીએ કે તમે અહીં છો!',
		'sand-on-board-modal-content':
			'તમારા છુપાયેલા પ્રતિભાઓ છે અને નગેટ તમને તે શોધવામાં મદદ કરશે. તમારા પ્રોફાઇલ બનાવવાનું આરંભ કરો અને સુપરટેલેન્ટ શોધવા માટે સ centenas  ચેલેન્જોમાંથી પસંદ કરો',
		'opt-check':
			'અમારા મેલિંગ લિસ્ટમાં ઑપ્ટ-ઇન કરો અને નવા કોર્પોરેટ ભાગીદારો, ઉત્પાદન લક્ષણો અને અપડેટ્સ પર પ્રથમ અપડેટ પ્રાપ્ત કરો.',
		'let-get-it': 'ચાલો તે કરીએ',
		'complement-fit': 'પુરક ફિટ',
		'close-fit': 'સમೀಪ ફિટ',
		'target-fit': 'લક્ષ્ય ફિટ',
		'best-fit': 'સૌથી શ્રેષ્ઠ ફિટ',
		'user-no-exist': 'ઉમેદવાર અસ્તિત્વમાં નથી',
		'create-password': 'પાસવર્ડ બનાવો',
		'pwd-reset-success':
			'ઇમેલ મોકલવામાં આવી છે. પાસવર્ડ રિસેટ સૂચનાઓ માટે તમારા ઇનબોક્સની તપાસ કરો',
		'salary-range': 'તમારા પગાર શ્રેણી'
	},
	hi: {
		'tour-step-0':
			'आपकी चुनौती के निर्देश यहाँ मिलेंगे। जब आप शुरू करें, तो निर्देशों को ध्यान से पढ़ें।',
		'tour-step-1':
			'यह ओवरव्यू अनुभाग है। इस अनुभाग में, आप चुनौती और प्रदान किए गए संसाधनों तक पहुँच सकते हैं।',
		'tour-step-2':
			'यह एक सहायता आइकन है। चुनौती को पूरा करने के तरीके के बारे में अधिक जानने के लिए यहाँ क्लिक करें।',
		'tour-step-3':
			'यह आपका कार्यक्षेत्र है। इसमें चार भाग हैं: समस्या की पहचान, जानकारी एकत्र करना, विचार मंथन, और समाधान की सिफारिश करना।',
		'tour-step-4':
			'आपका मूल्यांकन इस बात पर होगा कि आप चुनौती और संसाधनों को कितनी अच्छी तरह समझते हैं। टेक्स्ट को हाइलाइट करें और उसे अनुभाग में खींचें।',
		'tour-step-5':
			'टेक्स्ट को लक्षित अनुभाग में रखें। "जानकारी एकत्र करना" यह दिखाने के लिए है कि आप चुनौती और मुख्य अवधारणाओं को समझते हैं।',
		'tour-step-6':
			'मूल्यांकन समयबद्ध है, इसलिए समय का ध्यान रखें। एक बार पूरा हो जाने पर, परिणाम सबमिट करने के लिए "समाप्त करें" बटन दबाएँ।',
		'start-test-title': 'क्या आप वाकई शुरू करना चाहते हैं?',
		'start-test-content':
			'सुनिश्चित करें कि आपका ब्राउज़र पूर्ण स्क्रीन में है और टैब बंद न करें, अन्यथा आपको पुनः आरंभ करना होगा। शुभकामनाएँ!',
		start: 'प्रारंभ करें',
		'show-me-again-u': 'मुझे फिर से दिखाओ!',
		consultant: 'परामर्श',
		next: 'आगे',

		prev: 'पिछला',
		finish: 'समाप्त करें',
		login_to_sandbox: 'सैंडबॉक्स में लॉगिन करें',
		'how-can-we-help': 'हम आपकी कैसे मदद कर सकते हैं?',
		'how-can-we-help-explain':
			'यह आपकी चुनौती पूरी करने के लिए गाइड है। समय चालू है, इसे मत भूलिए!',
		application: 'एप्लिकेशन',
		other: 'अन्य',
		help: 'सहायता',
		'add-new-section': 'नया अनुभाग जोड़ें',
		'identify-the-problem': 'समस्या की पहचान करें',
		'highlight-key-sentences':
			'उन वाक्यों को हाइलाइट करें जो आपके लिए महत्वपूर्ण हैं। यह बस ड्रैग और ड्रॉप जितना आसान है।',
		'brainstorm-viable': 'ऐसे व्यावहारिक विचार सोचें जो समस्या के दायरे में फिट बैठते हों',
		'use-your-creativity': 'अपनी रचनात्मकता का उपयोग करें और एक समाधान सुझाएँ',
		problem: 'समस्या',
		'collect-information-title': 'जानकारी एकत्र करें',
		ideas: 'विचार',

		solution: 'समाधान',
		resource: 'संसाधन',
		'no-card-name': 'कार्ड का नाम नहीं है',
		'challenge-instructions': 'चुनौती के निर्देश',
		'test-name-not-found': 'परीक्षण का नाम नहीं मिला',
		'drop-the-text-here': 'टेक्स्ट यहाँ छोड़ें',
		'type-away-what': 'लिखें... आप हमें और क्या बताना चाहते हैं?',
		title: 'शीर्षक',
		'are-you-sure': 'क्या आप सुनिश्चित हैं?',
		'content-exit-challenge':
			'लगता है कि आप चुनौती से बाहर निकलने की कोशिश कर रहे हैं। यदि आप ऐसा करते हैं तो आपकी सारी प्रगति खो जाएगी।',
		'continue-the-challenge': 'चुनौती जारी रखें',
		'content-finish-challenge': 'लगता है आप अपने परिणाम सबमिट करने वाले हैं',
		'time-up': 'समय समाप्त!',
		'hard-part-over':
			'मुश्किल हिस्सा खत्म हो गया है। अब बस बैठें और परिणामों का इंतजार करें।',
		'great-job-u': 'शानदार काम!',
		'u-finished-it': 'आपने इसे पूरा कर लिया!',
		'sit-tight-well':
			'शांत रहें! जैसे ही परिणाम उपलब्ध होंगे, हम आपको बताएंगे। यहाँ आपके प्रदर्शन का एक त्वरित सारांश है।',

		'sit-tight-well-short': 'शांत रहें! जैसे ही परिणाम उपलब्ध होंगे हम आपको बताएंगे।',
		'want-to-improve-ex': 'अनुभव को बेहतर बनाना चाहते हैं? इसे जल्दी से पूरा करें',
		survey: 'सर्वेक्षण',
		minutes: 'मिनट',
		'pace-of-writing': 'लेखन की गति',
		'words-per-minute': 'शब्द प्रति मिनट',
		'head-start': 'प्रारंभ',
		'how-long-takes': 'पहला शब्द लिखने में (सेकंड में) कितना समय लगा?',
		'quick-fix': 'त्वरित समाधान',
		'number-times-deleting': '3 सेकंड के भीतर कितनी बार मिटाया गया',
		'run-on': 'लंबे वाक्य',
		'number-long-sentences': '30 से अधिक शब्दों वाले वाक्यों की संख्या',
		'select-an-assessment': 'एक मूल्यांकन चुनें',
		'select-from-pre-built':
			'पूर्व-निर्मित मूल्यांकन चुनें। हम सामग्री और इनसाइट्स का ध्यान रखेंगे।',
		'business-to-business-sales': 'बिजनेस-टू-बिजनेस बिक्री',
		'business-to-business-sales-description':
			'आप एक बिजनेस-टू-बिजनेस (B2B) बिक्री प्रतिनिधि हैं। आपके प्रबंधक ने आपको एक संभावित नए ग्राहक के बारे में बताया है, जो एक कंपनी वेबसाइट विकसित करना चाहती है। इस चुनौती में, ग्राहक की ज़रूरतें पहचानें, दिए गए संसाधनों से जानकारी एकत्र करें, संभावित विकल्प बनाएं और अंत में सबसे अच्छा विकल्प सुझाएं।',
		'email-thread-between': 'प्रबंधक और ग्राहक के बीच ईमेल श्रृंखला',
		'descriptions-services-provided': 'कंपनी द्वारा प्रदान की गई सेवाओं का विवरण',
		'actionablet-tips-closing': 'B2B बिक्री पूरी करने के लिए उपयोगी सुझाव',
		'data-science': 'डेटा साइंस',
		'data-science-description':
			'आप एक डेटा वैज्ञानिक हैं जो एक नए ग्राहक के साथ काम कर रहे हैं — एक उभरता हुआ टेक उद्योग का व्यवसाय जिसमें 150 कर्मचारी हैं। ग्राहक ने अभी-अभी अपने कर्मचारियों और उनकी कार्यस्थल की अनुभवों पर आंतरिक डेटा एकत्र करना शुरू किया है। वे चाहते हैं कि आप उनके डेटा को समझें और उसमें से निष्कर्ष निकालें। इस चुनौती में, मुख्य समस्याओं की पहचान करें, साझा किए गए डेटा से जानकारी एकत्र करें, संभावित विकल्प सोचें, और फिर अंतिम सिफारिशें दें।',

		'interview-findings': 'साक्षात्कार निष्कर्ष',
		'correlation-table': 'सहसंबंध तालिका',
		'multiple-regression-table': 'मल्टीपल रिग्रेशन तालिका',
		'business-strategy-proposal': 'व्यावसायिक रणनीति प्रस्ताव',
		'business-strategy-proposal-description':
			'आप एक मध्यम आकार की कंपनी में पूर्णकालिक कर्मचारी के रूप में काम करते हैं। पिछले दो वर्षों में, आपकी कंपनी की परिचालन आय में लगातार गिरावट आई है। यह गिरावट औसत बिक्री में कमी और औसत खर्चों में वृद्धि के कारण हुई है। इस समस्या से निपटने के लिए कंपनी के अधिकारियों ने आंतरिक संसाधनों का उपयोग करने और मौजूदा कर्मचारियों की एक बहु-कार्यात्मक टीम बनाने का निर्णय लिया है। आपको इस टीम में शामिल होने के लिए चुना गया है। पहली मीटिंग के बाद, यह निर्णय हुआ कि अगली बार मिलने से पहले हर कोई व्यक्तिगत रूप से यह विचार करेगा कि समस्या क्या है, क्यों है, और इसे कैसे हल किया जा सकता है। आपकी प्रस्तुति 20 मिनट में है!',
		'customer-client-feedback': 'ग्राहक/क्लाइंट प्रतिक्रिया',
		'performance-management-results': 'प्रदर्शन प्रबंधन परिणाम',
		'profits-chart': 'लाभ चार्ट',
		'get-started': 'शुरू करें',
		welcome: 'स्वागत है',
		name: 'नाम',
		email: 'ईमेल',
		firstname: 'पहला नाम',
		age: 'आयु',
		gender: 'लिंग',
		male: 'पुरुष',
		female: 'महिला',
		'prefer-not-to-say': 'कहना नहीं चाहता',
		continue: 'जारी रखें',
		'what-ethnicity-cultural-group': 'आप किस जातीय/सांस्कृतिक समूह से पहचान रखते हैं?',
		caucasian: 'कोकेशियन',
		'latin-american': 'लैटिन अमेरिकी',

		african: 'अफ्रीकी',
		profile_image: 'प्रोफ़ाइल फ़ोटो',
		caribbean: 'कैरेबियन',
		'middle-east': 'मध्य पूर्व',
		'south-asian': 'दक्षिण एशियाई (जैसे, भारतीय, श्रीलंकाई)',
		'southeast-asian': 'दक्षिण-पूर्व एशियाई (जैसे, वियतनामी, चीनी, फिलिपीनो)',
		'west-asian': 'पश्चिमी एशियाई (जैसे, ईरानी, अफगानी)',
		aboriginal: 'आदिवासी (जैसे, उत्तर अमेरिकी भारतीय, इनुइट)',
		mixed: 'मिश्रित',
		'what-is-your-marital': 'आपकी वैवाहिक स्थिति क्या है?',
		'how-do-you-want-to-create': 'आप कैसे बनाना चाहते हैं?',
		'pre-built-assessment': 'पूर्व-निर्मित मूल्यांकन',
		'create-your-own': 'अपना खुद का बनाएं',
		'please-select-role-type': 'कृपया भूमिका का प्रकार चुनें!',
		'please-select-position-type': 'कृपया पद का प्रकार चुनें!',
		'what-are-you-hiring-for': 'आप किसके लिए भर्ती कर रहे हैं?',
		'help-us-define-your-role':
			'कृपया हमें आपकी भूमिका परिभाषित करने में मदद करें ताकि हम सबसे उपयुक्त मूल्यांकन सुझा सकें',
		'role-type': 'भूमिका का प्रकार',
		none: 'कोई नहीं',
		marketing: 'मार्केटिंग',
		'customer-service': 'ग्राहक सेवा',
		sales: 'बिक्री',
		'product-management': 'उत्पाद प्रबंधन',
		'business-management': 'व्यवसाय प्रबंधन',
		'business-strategy': 'व्यवसाय रणनीति',
		'position-type': 'पद का प्रकार',
		'co-op-internship': 'सहकारी/इंटर्नशिप',
		'entry-level': 'प्रवेश स्तर',

		'junior-manager': 'कनिष्ठ प्रबंधक',
		'middle-manager': 'मध्यम स्तर प्रबंधक',
		'add-the-keywords': 'कीवर्ड जोड़ें',
		cancel: 'रद्द करें',
		'please-select-the-assessment': 'कृपया मूल्यांकन चुनें!',
		'create-your-benchmark': 'अपना बेंचमार्क बनाएं',
		'create-a-benchmark-by-sending':
			'बेहतर प्रदर्शन करने वाले कर्मचारियों को मूल्यांकन भेजकर एक बेंचमार्क बनाएं',
		'share-the-link-below': 'नीचे दिए गए लिंक को साझा करें',
		launch: 'प्रारंभ करें',
		'create-challenge': 'चुनौती बनाएँ',
		search: 'खोजें',
		'example-challenge': 'उदाहरण चुनौती',
		'single-never-married': 'अविवाहित',
		widowed: 'विधवा/विधुर',
		separated: 'अलग हुआ',
		divorced: 'तलाकशुदा',
		married: 'विवाहित',
		'living-common-law': 'सहजीवन में रह रहे हैं',
		'what-is-the-highest-degree': 'आपकी उच्चतम शैक्षणिक योग्यता क्या है?',

		'less-than-high-school-diploma': 'हाई स्कूल डिप्लोमा से कम',
		'high-school-degree-or-equivalent': 'हाई स्कूल डिग्री या समकक्ष (जैसे, GED)',
		'some-scollege-no-degree': 'कुछ कॉलेज, लेकिन कोई डिग्री नहीं',
		'associate-degree': 'एसोसिएट डिग्री (जैसे, AA, AS)',
		'bachelors-degree': 'स्नातक डिग्री (जैसे, BA, BS)',
		'masters-degree': 'स्नातकोत्तर डिग्री (जैसे, MA, MS)',
		'professional-degree': 'व्यावसायिक डिग्री (जैसे, MD, DDS)',
		doctorate: 'डॉक्टरेट (जैसे, PhD, EdD)',
		'what-is-your-current-employment-status': 'आपकी वर्तमान रोजगार स्थिति क्या है?',
		'employed-full-time-40': 'पूर्णकालिक कर्मचारी (सप्ताह में 40 या अधिक घंटे)',
		'employed-part-time-39': 'आंशिककालिक कर्मचारी (सप्ताह में 39 घंटे तक)',
		'unemployed-and-currently-looking': 'बेरोजगार और वर्तमान में नौकरी की तलाश में हैं',
		'Unemployed-and-currently-not-looking':
			'बेरोजगार और वर्तमान में नौकरी की तलाश में नहीं हैं',
		student: 'छात्र',
		retired: 'सेवानिवृत्त',
		'self-employed': 'स्वरोज़गार',
		'unable-to-work': 'काम करने में असमर्थ',
		'to-tutorial': 'ट्यूटोरियल के साथ',
		'please-do-not-take-this-assessment-on-phone': 'कृपया यह मूल्यांकन फ़ोन पर न करें',
		company: 'कंपनी',
		'company-would-like':
			'देखना चाहती है कि आप उनकी टीम के लिए उपयुक्त हैं या नहीं। इसके लिए, आपको एक चुनौती पूरी करनी है जिसमें चार चरणों में समाधान प्रस्तुत करना है।',
		'company-to-prepare':
			'चुनौती के लिए तैयारी के तौर पर, आपको एक ट्यूटोरियल दिखाया जाएगा जो आपको इंटरफ़ेस से परिचित कराएगा। हम अनुशंसा करते हैं कि आप हमारे सुझाव पढ़ें।',

		'company-following-tutorial':
			'इस ट्यूटोरियल के बाद, आपके पास चुनौती पूरी करने के लिए {n} मिनट हैं। शुभकामनाएँ!',
		'assess-learn-evolve': 'मूल्यांकन करें। सीखें। विकसित हों।',
		'discover-your-soft-skills':
			'भूमिका से संबंधित चुनौतियों के माध्यम से अपनी सॉफ्ट स्किल्स खोजें।',
		'n-challenges-available': '{n} चुनौतियाँ उपलब्ध हैं',
		'search-challenge': 'चुनौती खोजें',
		'hi-{name}': 'नमस्ते {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, आप ऊँचाइयों तक पहुँचेंगे!',
		'discover-nuggets-about-your-soft-skills':
			'अपनी सॉफ्ट स्किल्स के बारे में महत्वपूर्ण बातें जानें',
		'register-login': 'लॉग इन करें',
		'add-pipeline-label': 'नई प्रतिभा पूल जोड़ें',
		'nugget-ai-science': 'Nugget.ai विज्ञान',
		'our-prediction-models':
			'हमारे भविष्यवाणी मॉडल I/O मनोविज्ञान में शैक्षणिक अनुसंधान पर आधारित हैं।',
		'performance-nugget': 'प्रदर्शन से जुड़ा नगेट',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'अपने फोकस को चिह्नित करें और सुधार के लिए अपने गैप्स पहचानें',
		'discover-your-path': 'अपना रास्ता खोजें',
		'keep-an-open-mind-and-try-something-new': 'खुले दिमाग से सोचें और कुछ नया आज़माएं!',
		'compare-to': 'से तुलना करें',
		'growth-tips': 'विकास के सुझाव',
		'machine-drive-advice-subtitle': 'शीर्ष 10% पेशेवरों की मशीन-चालित सलाह।',
		'growth-tips-2':
			'“एक ऐसे उद्योग में तकनीकी समाधानों के पोर्टफोलियो का प्रबंधन करना जहाँ तेजी से बदलाव हो रहा है, हमेशा आपको सतर्क रखता है...”',
		'growth-tips-3':
			'“ब्लॉकचेन में हर उद्योग को बाधित करने की क्षमता है, जैसे मशीन लर्निंग अभी कर रही है। नए खोजों का नेतृत्व करने के लिए रचनात्मक रूप से सोचने की क्षमता आपके करियर की सफलता के लिए महत्वपूर्ण है।”',
		'what-does-this-mean': 'इसका क्या मतलब है?',
		'project-coodinator': 'परियोजना समन्वयक',
		'financial-analyst': 'वित्तीय विश्लेषक',
		'project-manager': 'परियोजना प्रबंधक',
		'blue-sky-music-proposal': 'ब्लू-स्काई म्यूजिक प्रस्ताव',
		'blue-sky-music-proposal-description':
			'आप एक हस्ताक्षरित कलाकार हैं जो वर्तमान में संगीत उद्योग पर हावी रिकॉर्ड लेबल में से एक से जुड़े हैं। यह लेबल मासिक “ब्लू-स्काई” मीटिंग्स आयोजित करता है, जिसमें आप जैसे कलाकारों को किसी नई गीत योजना को प्रस्तुत करने के लिए प्रोत्साहित किया जाता है। यह योजना किसी भी शैली, संरचना या विषय की हो सकती है। आपसे अपेक्षा की जाती है कि आप बड़े सपने देखें। इस चुनौती के भीतर, अपनी योजना में शामिल किए जाने वाले घटकों की पहचान करें, दिए गए संसाधनों से जानकारी एकत्र करें, योजना बनाते समय कुछ विचार उत्पन्न करें और अपनी बड़ी विचार योजना में प्रस्तुत करें।',
		'blue-sky-music-proposal-resource-1': 'संसाधन 1: ट्रू कलर्स - सामान्य तत्व',
		'blue-sky-music-proposal-resource-2': 'संसाधन 2: ट्रू कलर्स - गीत',
		'help-a-first-time-homebuyer': 'पहली बार घर खरीदने वाले की सहायता करें',
		'help-a-first-time-homebuyer-description':
			'आप एक रियल एस्टेट सेल्स प्रतिनिधि हैं। एक संभावित खरीदार आपसे संपर्क करता है और अपना पहला घर खरीदने में रुचि दिखाता है। इस चुनौती में, नए ग्राहक की ज़रूरतों की पहचान करें, दिए गए संसाधनों से जानकारी एकत्र करें, उनके लिए संभावित विकल्पों के बारे में सोचें, और फिर सर्वोत्तम विकल्प और उसका कारण बताएं।',
		emails: 'ईमेल्स',
		'property-listings-table': 'संपत्ति लिस्टिंग तालिका',
		'find-your-perfect-home': 'अपना आदर्श घर खोजें',
		'marketing-description':
			'आप एक मार्केटिंग विशेषज्ञ हैं। आप एक मध्यम आकार की खुदरा कंपनी के लिए काम करते हैं जो उच्च गुणवत्ता वाले बाहरी कपड़े और गियर बेचती है। यह कंपनी पांच वर्षों से इस उद्योग में है और मुख्य रूप से ऑनलाइन बिक्री करती है। हाल ही में, वरिष्ठ प्रबंधन टीम केवल ई-कॉमर्स मॉडल से हटने पर विचार कर रही है। उन्होंने आपसे आपके अनुभव और उपलब्ध डेटा के आधार पर एक सिफारिश देने को कहा है।',
		'customer-demographics': 'ग्राहक जनसांख्यिकी',
		'customer-satisfaction-survey': 'ग्राहक संतुष्टि सर्वेक्षण',
		'our-science': 'हमारा विज्ञान',
		'{number}-assessments-take-so-far': 'अब तक ली गई {number} मूल्यांकन',

		'growth-tips-1':
			'“काम में सफलता या असफलता के लिए विवरणों पर ध्यान देना सबसे महत्वपूर्ण कारक रहा है।”',
		'growth-tips-2':
			'“एक ऐसे उद्योग में तकनीकी समाधानों के पोर्टफोलियो का प्रबंधन करना जहाँ तेजी से बदलाव हो रहा है, हमेशा आपको सतर्क रखता है...”',
		'growth-tips-3':
			'“ब्लॉकचेन में हर उद्योग को बाधित करने की क्षमता है, जैसे मशीन लर्निंग अभी कर रही है। नए खोजों का नेतृत्व करने के लिए रचनात्मक रूप से सोचने की क्षमता आपके करियर की सफलता के लिए महत्वपूर्ण है।”',
		'what-does-this-mean': 'इसका क्या मतलब है?',
		'project-coodinator': 'प्रोजेक्ट कोऑर्डिनेटर',
		'financial-analyst': 'वित्तीय विश्लेषक',
		'project-manager': 'प्रोजेक्ट मैनेजर',
		'blue-sky-music-proposal': 'ब्लू-स्काई संगीत प्रस्ताव',
		'blue-sky-music-proposal-description':
			'आप एक अनुबंधित कलाकार हैं जो वर्तमान में संगीत उद्योग पर हावी रिकॉर्ड लेबल में से एक के साथ हैं। यह रिकॉर्ड लेबल मासिक "ब्लू-स्काई" बैठकें आयोजित करता है, जिनमें आप जैसे कलाकारों को किसी भी शैली, रचना और विषय पर एक नए गीत के लिए एक विस्तृत योजना प्रस्तुत करने के लिए प्रोत्साहित किया जाता है। आपको बड़ा सोचने के लिए प्रोत्साहित किया जाता है। इस चुनौती के भीतर, आप अपने प्लान में शामिल करने के लिए आवश्यक तत्वों की पहचान करें, दिए गए संसाधनों से जानकारी एकत्र करें, कुछ विचार उत्पन्न करें और अपनी प्रमुख योजना को इस बैठक में प्रस्तुत करने के लिए तैयार करें।',
		'blue-sky-music-proposal-resource-1': 'संसाधन 1: ट्रू कलर्स - सामान्य तत्व',
		'blue-sky-music-proposal-resource-2': 'संसाधन 2: ट्रू कलर्स - गीत',
		'help-a-first-time-homebuyer': 'पहली बार घर खरीदने वाले की सहायता करें',
		'help-a-first-time-homebuyer-description':
			'आप एक रियल एस्टेट सेल्स प्रतिनिधि हैं। एक संभावित खरीदार ने आपसे संपर्क किया है और अपनी पहली संपत्ति खरीदने में रुचि व्यक्त की है। इस चुनौती के दौरान, ग्राहक की ज़रूरतों की पहचान करें, दिए गए संसाधनों से जानकारी इकट्ठा करें, कुछ विचार उत्पन्न करें और फिर सबसे अच्छा विकल्प और उसका तर्क सुझाएं।',
		emails: 'ईमेल्स',
		'property-listings-table': 'संपत्ति सूची तालिका',
		'find-your-perfect-home': 'अपना आदर्श घर खोजें',
		'marketing-description':
			'आप एक विपणन विशेषज्ञ हैं। आप एक मध्यम आकार की खुदरा कंपनी के लिए काम करते हैं जो बाहरी कपड़े और उच्च गुणवत्ता वाले परिधान बेचती है, और पिछले पांच वर्षों से इस उद्योग में काम कर रही है। आपकी कंपनी मुख्य रूप से ऑनलाइन उत्पाद बेचती है, लेकिन हाल ही में, वरिष्ठ प्रबंधन केवल ई-कॉमर्स मॉडल से हटने पर विचार कर रहा है। उन्होंने आपसे डेटा और अनुभव के आधार पर एक सिफारिश मांगी है।',
		'customer-demographics': 'ग्राहक जनसांख्यिकी',
		'customer-satisfaction-survey': 'ग्राहक संतुष्टि सर्वेक्षण',
		'our-science': 'हमारा विज्ञान',

		'{number}-assessments-take-so-far': '{number} मूल्यांकन अब तक लिए गए',
		'built-with-love-in-toronto': 'टोरंटो में प्यार से बनाया गया',
		whoops: 'उफ़!',
		'404-message': 'जो लिंक आपने डाला है वह टूटा हुआ है या अब मौजूद नहीं है',
		'take-me-home': 'मुझे होमपेज पर ले चलें',
		'what-does-this-mean-s1':
			'आपसे इस चुनौती में बिक्री भूमिका में संवाद और समस्या समाधान कौशल दिखाने को कहा गया था — और आपने ऐसा किया! जैसे ही आपने चुनौती शुरू की, हमने आपके उत्तरों और आपके द्वारा उठाए गए कदमों को ट्रैक किया। यहां कुछ जानकारी के अंश दिए गए हैं जो हमने अपने विश्लेषण से प्राप्त किए हैं।',
		'what-does-this-mean-s2':
			'हम अपनी सीक्रेट सॉस तो साझा नहीं कर सकते, लेकिन यहां एक उदाहरण है जिससे आपको सोचने में मदद मिले।',
		'what-does-this-mean-s3-bold': 'गति और चिंतन:',
		'what-does-this-mean-s3':
			'जैसे ही चुनौती शुरू हुई, तुरंत लिखना शुरू करना और फिर ईमेल खोलते समय या लेख पढ़ते समय मिटाना, जोड़ना और संशोधित करना — ऐसे प्रतियोगी गति और चिंतन में उच्च स्कोर प्राप्त कर पाए।',
		'what-does-this-mean-s4':
			'एक ऐसा कार्य जिसमें यह विशेषता लाभकारी हो सकती है: जब कोई कार्य अत्यंत जरूरी हो और तुरंत ध्यान देने की आवश्यकता हो।',
		speed: 'गति',
		'meticulousness-assertiveness': 'सूक्ष्मता और आत्मविश्वास',
		'attention-to-detail': 'विवरण पर ध्यान',
		'clarity-reasoning': 'स्पष्टता और तर्क',
		export: 'निर्यात करें',
		archieve: 'संग्रह करें',
		delete: 'हटाएं',
		'are-you-sure-you-want-to-delete': 'क्या आप वाकई इसे हटाना चाहते हैं?',
		'pick-a-challenge': 'एक चुनौती चुनें',
		'confirm-pick': 'चयन की पुष्टि करें',
		'challenge-added': 'चुनौती जोड़ दी गई!',
		'sharable-link': 'साझा करने योग्य लिंक',

		'sharable-link-copy': 'साझा करने योग्य लिंक कॉपी किया गया',
		music: 'संगीत',
		lyrics: 'गीत',
		artist: 'कलाकार',
		'creative-industries': 'रचनात्मक उद्योग',
		'song-proposal': 'गीत प्रस्ताव',
		voice: 'आवाज़',
		'real-estate': 'रियल एस्टेट',
		'customer-success': 'ग्राहक सफलता',
		software: 'सॉफ्टवेयर',
		customer: 'ग्राहक',
		experience: 'अनुभव',
		regression: 'रिग्रेशन',
		'data-analysis': 'डेटा विश्लेषण',
		'data-mining': 'डेटा माइनिंग',
		'digital-marketing': 'डिजिटल मार्केटिंग',
		'e-commernce': 'ई-कॉमर्स',
		retail: 'खुदरा',
		strategy: 'रणनीति',
		financial: 'वित्तीय',
		analysis: 'विश्लेषण',
		role: 'भूमिका',
		rolelevel: 'भूमिका का स्तर',
		function: 'कार्य',
		organization: 'संगठन',
		industry: 'उद्योग',
		'team-size': 'टीम का आकार',
		'update-profile': 'प्रोफ़ाइल अपडेट करें',
		'sign-out': 'साइन आउट',
		'delete-account': 'खाता हटाएं',
		'change-password': 'पासवर्ड बदलें',
		'Edit-profile': 'प्रोफ़ाइल संपादित करें',
		login: 'लॉग इन करें',
		signup: 'साइन अप करें',

		'enter-your-email': 'अपना ईमेल दर्ज करें',
		'enter-your-password': 'अपना पासवर्ड दर्ज करें',
		'referral-Code': 'संदर्भ कोड',
		'Ask-your-friend-to-get-one': 'अपने दोस्त से एक लाने के लिए कहो।',
		password: 'पासवर्ड',
		'login-as-employee': 'कर्मचारी के रूप में लॉगिन करें',
		'loggin-as-employer': 'नियोक्ता के रूप में लॉगिन करें',
		'forgot-password': 'पासवर्ड भूल गए?',
		username: 'उपयोगकर्ता नाम',
		firstname: 'पहला नाम',
		lastname: 'अंतिम नाम',
		'enter-your-firstname': 'अपना पहला नाम दर्ज करें',
		'enter-your-lastname': 'अपना अंतिम नाम दर्ज करें',
		'enter-your-username': 'अपना उपयोगकर्ता नाम दर्ज करें',
		'auth-no-user': 'उपयोगकर्ता नाम या पासवर्ड सही नहीं है',
		'signup-as-employer': 'नियोक्ता के रूप में साइन अप करें',
		'signup-as-employee': 'कर्मचारी के रूप में साइन अप करें',
		'invalid-username': 'अमान्य उपयोगकर्ता नाम!',
		'invalid-email': 'अमान्य ईमेल!',
		'invalid-password': 'अमान्य पासवर्ड!',
		'confirm-password': 'पासवर्ड की पुष्टि करें',
		'signup-failed1': 'साइनअप विफल रहा',
		'signup-failed2': 'आपका ईमेल पहले से मौजूद है',
		'verify-email-title': 'अपना ईमेल सत्यापित करें',
		'verify-email-content':
			'पंजीकरण के लिए धन्यवाद। कृपया अपनी खाता सत्यापित करने के लिए अपना ईमेल जांचें।',
		'repeat-your-password': 'अपना पासवर्ड दोहराएं',
		'password-not-match': 'पासवर्ड मेल नहीं खा रहे हैं',
		'password-reset': 'पासवर्ड रीसेट',
		'enter-your-email-and-well':
			'अपना ईमेल दर्ज करें और हम आपको पासवर्ड रीसेट लिंक भेजेंगे',

		'answer-some-questions': 'कुछ सवालों के जवाब दें',
		'tell-us-about-yourself': 'अपने बारे में बताएं',
		'tell-us-about-yourself-description':
			'इस फ़ॉर्म से एकत्र किए गए डेटा का उपयोग केवल अनुसंधान उद्देश्यों के लिए किया जाएगा। कोई भी निजी डेटा सहेजा या साझा नहीं किया जाएगा।',
		'we-want-your-feedback': 'हमें आपकी प्रतिक्रिया चाहिए!',
		'we-want-your-feedback-description':
			'इस सर्वे का उद्देश्य आपके अनुभव को समझना है, क्योंकि हम आपके लिए सबसे अच्छा अनुभव प्रदान करने का प्रयास कर रहे हैं! अनुमानित समय 3 मिनट से कम है।',
		'we-want-your-feedback-note': '* चिह्नित प्रश्न अनिवार्य हैं।',
		'how-this-assessment-colleague':
			'आप इस मूल्यांकन को किसी मित्र या सहकर्मी को कितनी संभावना से सिफारिश करेंगे?',
		'above-score-reason': 'आपके द्वारा दिए गए स्कोर का कारण क्या है?',
		'what-think-content-of-challenge': 'आपको इस चुनौती की सामग्री कैसी लगी? *',
		'additional-feedback-to-product-team':
			'हमारी प्रोडक्ट टीम सर्वोत्तम अनुभव प्रदान करने के लिए कड़ी मेहनत कर रही है। क्या आपके पास कोई अतिरिक्त फीडबैक है?',
		'enter-your-email-address': 'कृपया अपना ईमेल पता दर्ज करें',
		'go-take-a-look': 'जाइए और एक नज़र डालिए!',
		'for-2-minutes': '2 मिनट के लिए, इंटरफ़ेस से सहज हो जाइए और उसके तत्वों के साथ खेलिए।',
		'your-data-will-not-saved-in-the-preview':
			'पूर्वावलोकन के दौरान आपका डेटा सहेजा नहीं जाएगा।',
		'neat-let-me-see-it': 'ठीक है, मुझे इसे देखने दो',

		'preview-mode': 'पूर्वावलोकन मोड',
		skip: 'छोड़ें',
		userlist: 'उपयोगकर्ता सूची',
		challengelist: 'चुनौतियों की सूची',
		pipelinelist: 'पाइपलाइन सूची',
		'challenge-result-list': 'चुनौती परिणाम सूची',
		download: 'डाउनलोड',
		count: 'गिनती',
		'finance-accounting': 'वित्त और लेखा',
		'general-management': 'सामान्य प्रबंधन',
		'human-resources': 'मानव संसाधन',
		'information-technology': 'सूचना प्रौद्योगिकी',
		operations: 'संचालन',
		'individual-contributor': 'व्यक्तिगत योगदानकर्ता',
		'expert-individual-contributor': 'विशेषज्ञ व्यक्तिगत योगदानकर्ता',
		manager: 'प्रबंधक',
		'senior-manager': 'वरिष्ठ प्रबंधक',
		executive: 'कार्यकारी',
		'about-the-role': 'भूमिका के बारे में',
		'role-level': 'भूमिका स्तर',

		'mid-level-manager': 'मध्य-स्तरीय प्रबंधक',
		create: 'बनाएं',
		'solve-three-steps':
			'मैं यह देखना चाहता हूँ कि आप इस प्रोग्राम के लिए उपयुक्त हैं या नहीं। हम आपको एक चुनौती देंगे और आपसे इसे तीन चरणों में हल करने को कहेंगे।',
		'important-instructions': 'महत्वपूर्ण निर्देश',
		instructions:
			'चार कंटेनर होंगे जिनमें आपसे "समस्या की पहचान", "महत्वपूर्ण जानकारी एकत्रित करें" (आप टेक्स्ट को खींचकर छोड़ सकते हैं), "विकल्प उत्पन्न करें (3 विकल्पों तक चुनें)" और "एक समाधान सुझाएं" कहा जाएगा। आप बुलेट पॉइंट्स या पूर्ण वाक्य दोनों में उत्तर दे सकते हैं, यह आप पर निर्भर करता है। हम आपके निर्णय लेने की प्रक्रिया और समस्या-समाधान कौशल को माप रहे हैं।',
		'confirmation-message':
			'इस स्क्रीन के ठीक बाद एक पुष्टिकरण संदेश दिखाई देगा। आपके पास चुनौती को पूरा करने के लिए 20 मिनट होंगे!',
		'start-test': 'परीक्षा शुरू करें',
		'customize-your-assessment': 'अपना मूल्यांकन अनुकूलित करें',
		'control-assessment': 'अपनी सामग्री जोड़कर मूल्यांकन को नियंत्रित करें।',
		'assessment-name': 'मूल्यांकन का नाम',
		'assessment-description': 'मूल्यांकन का विवरण',
		'input-timer': 'इनपुट टाइमर',
		'upload-image-challenge': 'चुनौती के लिए छवि अपलोड करें',
		'plain-text': 'सादा पाठ',
		'audio-link': 'ऑडियो लिंक',
		'video-link': 'वीडियो लिंक',
		'image-link': 'छवि लिंक',
		'add-card': 'कार्ड जोड़ें',
		'thank-you': 'धन्यवाद',
		'challenge-submission': 'हो गया! हमने आपकी चुनौती प्रस्तुति प्राप्त कर ली है',
		'feedback-your-assessment':
			'यदि आप अपने मूल्यांकन पर प्रतिक्रिया प्राप्त करना चाहते हैं, तो नीचे अपना ईमेल पता दर्ज करें',
		'your-voice':
			'हमें आपकी आवाज़ चाहिए! अपने करियर के आधार पर आप किसी को क्या सलाह देना चाहेंगे?',
		save: 'सहेजें',
		success_time_feedback: 'सफलता! हम आपके समय और प्रतिक्रिया की सराहना करते हैं',

		'supposed-to-do': 'मुझे क्या करना है?',
		'supposed-to-do-answer':
			'Nugget.ai चुनौती में, आपसे अपेक्षा की जाती है कि आप उस भूमिका को निभाएँ जो चुनौती विवरण में दी गई है। चुनौती की भूमिका निभाते हुए, कृपया यह कल्पना करें कि आप उस स्थिति में क्या सोचते, क्या करते, कौन सी जानकारी पर विचार करते और क्या सिफारिश करते यदि आप वास्तव में उस भूमिका में कार्यरत होते।',

		'what-challenge': 'चुनौती क्या है?',
		'what-challenge-answer':
			"चुनौती एक विवरण है जिसमें वह भूमिका शामिल है जिसे आपको निभाना है और वह संदर्भ जिसमें यह सब हो रहा है। सबसे महत्वपूर्ण बात यह है कि चुनौती आपकी 'मिशन' को परिभाषित करती है — यानी उस समस्या को जिसे आपको हल करना है।",

		'retake-challenge': 'क्या मैं चुनौती को दोबारा ले सकता हूँ?',
		'retake-challenge-answer':
			'नहीं, एक बार चुनौती पूरी करने के बाद उसे दोबारा लेने का कोई अवसर नहीं होता। इसलिए हम आपसे अनुरोध करते हैं कि पहली बार में ही खुद को उस भूमिका में कल्पना करें और वह प्रक्रिया अपनाएँ जो आप असल जीवन में समस्या हल करने के लिए अपनाते।',

		'purpose-whole-activity': 'इस पूरी गतिविधि का उद्देश्य क्या है?',
		'purpose-whole-activity-answer':
			'इस गतिविधि का उद्देश्य यह समझना है कि आप कार्यस्थल में कैसे प्रदर्शन करेंगे — जैसे कि आप उस भूमिका में एक सामान्य कार्य कर रहे हों।',

		'challenge-problem':
			'क्या यह चुनौती किसी असली घटना / स्थिति / समस्या / कंपनी पर आधारित है?',
		'challenge-problem-answer':
			'Nugget.ai की चुनौतियाँ किसी भी वास्तविक घटना, समस्या या कंपनी पर आधारित नहीं होतीं। यदि किसी वास्तविक कंपनी या स्थिति से समानता प्रतीत होती है, तो वह संयोग मात्र है।',

		'content-information': 'मुझे कौन-सी सामग्री / जानकारी शामिल करनी चाहिए?',
		'content-information-answer':
			'जानकारी की मात्रा या प्रकार को लेकर कोई तयशुदा तरीका नहीं है। बस यह सोचें कि यदि आप सचमुच इस भूमिका में होते, तो आप किन जानकारियों पर ध्यान देते।',

		'what-resources': 'संसाधन क्या होते हैं?',
		'what-resources-answer':
			'संसाधन ऐसे उदाहरण होते हैं जो उन वास्तविक स्रोतों का प्रतिनिधित्व करते हैं जिन तक कर्मचारियों की पहुँच होती है जब वे इस प्रकार के कार्य करते हैं। इन संसाधनों में विभिन्न प्रकार की सामग्री और स्वरूप शामिल हो सकते हैं, ताकि वास्तविक कार्य अनुभव का अनुकरण किया जा सके। हमारे पास इन संसाधनों में दिए गए से परे कोई अतिरिक्त जानकारी नहीं होती।',

		'what-i-do-resources': 'मैं संसाधनों के साथ क्या करूँ?',
		'what-i-do-resources-answer':
			'बिल्कुल वैसे ही जैसे कार्यस्थल पर होता है, आप संसाधनों से जानकारी पढ़ सकते हैं और उसे चुनौती कार्यक्षेत्र में खींचकर छोड़ सकते हैं। आप चाहें तो अधिक या कम जानकारी का उपयोग कर सकते हैं — यह आपकी पसंद पर निर्भर करता है।',

		'do-use-resources': 'क्या मुझे सभी संसाधनों का उपयोग करना ज़रूरी है?',
		'do-use-resources-answer':
			'ज़रूरी नहीं है। यदि आप चाहें तो सभी संसाधनों का उपयोग कर सकते हैं, या फिर केवल कुछ हिस्सों को चुन सकते हैं। लोग अलग-अलग तरीकों को अपनाते हैं। फिर से याद रखें, बस इस बात की कल्पना करें कि आप उस भूमिका में एक कर्मचारी हैं और वैसा ही करें जैसा आप उस स्थिति में करते।',

		'inform-outside-resources':
			'क्या मैं संसाधनों के बाहर की जानकारी का उपयोग कर सकता हूँ?',
		'inform-outside-resources-answer':
			'हम आपसे अनुरोध करते हैं कि आप अपनी चुनौती की प्रतिक्रियाएँ केवल प्रदान किए गए संसाधनों पर आधारित करें। आप अपने दिमाग में मौजूद पहले से सीखी गई जानकारी का उपयोग कर सकते हैं, जब तक कि आप किसी विशिष्ट दस्तावेज़, लेख, पठन सामग्री या अन्य स्रोत को नहीं खोलते। यदि यह संदेह होता है कि आपने बाहरी संसाधनों का उपयोग किया है, तो आपकी प्रतिक्रियाएँ आवेदन समूह से हटा दी जा सकती हैं।',

		'identify-problem': '"समस्या की पहचान" अनुभाग में मुझे क्या करना है?',
		'identify-problem-answer':
			'इस अनुभाग में, आप उस मूल समस्या की पहचान कर सकते हैं और उस पर चर्चा कर सकते हैं जिसे आपको चुनौती के भाग के रूप में हल करना है।',

		'collect-information': '"जानकारी एकत्र करें" अनुभाग में मुझे क्या करना है?',
		'collect-information-answer':
			'इस अनुभाग में, आप प्रदान किए गए संसाधनों से जानकारी निकाल सकते हैं और उसे संग्रहीत कर सकते हैं।',

		'engender-ideas': '"विचार उत्पन्न करें" अनुभाग में मुझे क्या करना है?',
		'engender-ideas-answer':
			'इस अनुभाग में, आप उन विभिन्न विकल्पों / दिशाओं / दृष्टिकोणों पर चर्चा कर सकते हैं जिन पर आप विचार कर रहे हैं।',

		'recommend-solution': '"समाधान की सिफारिश करें" अनुभाग में मुझे क्या करना है?',
		'recommend-solution-answer':
			'इस अनुभाग में, आप एक अंतिम समाधान / उत्पाद / सेवा प्रस्तुत कर सकते हैं और उस पर चर्चा कर सकते हैं जो चुनौती को पूरा करने में आपकी मदद करेगा।',

		'complete-all-sections': 'क्या मुझे सभी अनुभागों को पूरा करना ज़रूरी है?',
		'complete-all-sections-answer':
			'ज़रूरी नहीं है। ध्यान रखें, लक्ष्य यह है कि यह दिखाया जाए कि आप उस भूमिका में एक कर्मचारी की तरह कैसे कार्य करते। यदि कुछ अनुभाग आपको कम प्रासंगिक लगते हैं, तो उन्हें पूरा करना आवश्यक नहीं है।',

		'format-responses': 'मुझे अपनी प्रतिक्रियाओं को कैसे स्वरूपित करना चाहिए?',
		'format-responses-answer':
			'प्रतिक्रियाओं को स्वरूपित करने का कोई सही या गलत तरीका नहीं है। सोचिए कि यदि आप वास्तव में इस भूमिका में काम कर रहे होते और किसी प्रबंधक को अपनी रिपोर्ट दे रहे होते तो आप उन्हें कैसे प्रस्तुत करते।',

		'complete-challenge-time': 'अगर मैं समय पर चुनौती पूरी नहीं कर पाया तो क्या होगा?',
		'complete-challenge-time-answer':
			'कोई बात नहीं! टाइमर सिर्फ यह सुनिश्चित करने के लिए है कि सभी प्रतिभागियों के लिए प्रक्रिया एक जैसी हो। इसका मतलब यह नहीं है कि आपकी प्रतिक्रियाओं को अस्वीकार कर दिया जाएगा यदि आपने उन्हें निर्धारित समय में पूरा नहीं किया। हम उस डेटा के आधार पर आपके द्वारा प्रस्तुत उत्तरों का विश्लेषण करते हैं।',

		'browser-continue-later': 'क्या मैं ब्राउज़र बंद कर बाद में फिर से शुरू कर सकता हूँ?',
		'browser-continue-later-answer':
			'नहीं, आपसे अनुरोध है कि चुनौती को एक ही सत्र में पूरा करें।',
		'interface-accommodations':
			'अगर मुझे ज़्यादा समय या इंटरफ़ेस में कोई और अनुकूलन चाहिए तो क्या होगा?',
		'interface-accommodations-answer':
			'इस प्लेटफ़ॉर्म में समय सीमा बढ़ाने की कोई इन-बिल्ट सुविधा नहीं है। इसी कारण, हम आपसे अनुरोध करते हैं कि आप चुनौती पूरी करते समय समय पर नज़र रखें। फिर भी, यदि आपको समय या इंटरफ़ेस से संबंधित किसी विशेष आवश्यकता के लिए अनुकूलन चाहिए, तो कृपया उस संपर्क व्यक्ति से बात करें जिसने आपको हमारे चैलेंज का लिंक भेजा था। वही व्यक्ति हमारे साथ संपर्क में आएगा ताकि कोई भी जरूरी व्यवस्था की जा सके।',

		'activity-chances-job':
			'इस गतिविधि में मेरा प्रदर्शन नौकरी पाने की मेरी संभावनाओं को कैसे प्रभावित करता है?',
		'activity-chances-job-answer':
			'चैलेंज को या तो भर्ती प्रक्रिया में एक स्वतंत्र माप के रूप में या भर्ती के व्यापक सेटअप का हिस्सा बनाकर उपयोग किया जा सकता है। हालाँकि हम अपने ग्राहकों को कुछ अनुशंसित दिशानिर्देश प्रदान कर सकते हैं, लेकिन यह हमारे नियंत्रण में नहीं है कि संगठन इन परिणामों को अपने निर्णयों में कैसे शामिल करते हैं। इसलिए, इस प्रकार के प्रश्नों के लिए कृपया उस संपर्क व्यक्ति से संपर्क करें जिसने आपको यह चुनौती भेजी थी।',

		'own-your-personal-space': 'अपने व्यक्तिगत स्थान का स्वामी बनें',
		'already-have-an-account': 'क्या आपके पास पहले से एक खाता है?',
		'employer-login': 'नियोक्ता लॉगिन',
		'post-have-an-account': 'डॉन के पास खाता नहीं है',
		register: 'पंजीकरण करें',
		'export-to-csv': 'CSV में निर्यात करें',
		type: 'प्रकार',
		data: 'डेटा',
		'select-pipeline': 'पाइपलाइन चुनें',
		rank: 'रैंक',
		'characteristic-reflects':
			'यह विशेषता दर्शाती है कि आप कितनी जल्दी काम शुरू करते हैं और अपने काम की समीक्षा करते हैं। जैसे ही आपने ईमेल खोले और लेख पढ़ा, तुरंत लिखना शुरू करना और फिर बाद में हटाना, जोड़ना और संपादित करना—यह गति और आत्म-चिंतन में उच्च स्कोर प्राप्त करने का तरीका था।',
		'characteristic-reflects_example':
			'ऐसे कार्य का उदाहरण जहाँ यह विशेषता लाभकारी होगी: जब कोई कार्य अत्यंत जरूरी हो और तुरंत शुरू किया जाना हो।',

		'characteristic-reflects-two':
			'यह विशेषता दर्शाती है कि आप पहले से योजना बनाने और अपने विचारों को व्यवस्थित करने में कितने अच्छे हैं। ईमेल थ्रेड और लेख को ध्यान से पढ़ने के लिए समय निकालना, फिर उत्तर लिखना, योजना और संगठन में उच्च स्कोर प्राप्त करने का एक तरीका है।',
		'characteristic-reflects-two-example':
			'ऐसे कार्य का उदाहरण जहाँ यह विशेषता लाभकारी होगी: जब कोई महत्वपूर्ण कार्य हो जो लगभग परिपूर्ण निष्पादन की मांग करता हो।',

		'characteristic-reflects-three':
			'यह विशेषता आपके काम में शामिल विवरण की मात्रा और आत्मविश्वास दिखाने के तरीके को दर्शाती है। ईमेल थ्रेड से ग्राहकों की ज़रूरतों को निकालना और उन्हें अपने उत्तरों में दोहराना, डिटेल ओरिएंटेशन और आत्मविश्वास (Assertiveness) में उच्च प्रदर्शन करने का तरीका है।',
		'characteristic-reflects-three-example':
			'ऐसे कार्य का उदाहरण जहाँ यह विशेषता लाभकारी होगी: जब कार्य ऐसा हो जिसमें आपको अपने ज्ञान का उपयोग करके किसी को अपने विचारों से सहमत कराना हो।',

		'characteristic-reflects-four':
			'यह विशेषता इस बात को दर्शाती है कि आप अपने विचारों को स्पष्ट रूप से व्यक्त करने और उद्देश्य पर ध्यान बनाए रखने में कितनी सावधानी बरतते हैं। भाषा के चयन में सतर्क रहना और उत्तरों का तटस्थ टोन में होना दर्शाता है कि किसी ने न्यूट्रैलिटी और केयरफुलनेस में अच्छा प्रदर्शन किया है।',
		'characteristic-reflects-four-example':
			'ऐसे कार्य का उदाहरण जहाँ यह विशेषता लाभकारी होगी: जब कार्य पेशेवर निष्पक्षता और वस्तुनिष्ठता की माँग करता हो।',

		'characteristic-reflects-five':
			'यह विशेषता दर्शाती है कि आप अपने विचारों को कितनी स्पष्टता और तार्किक रूप से जोड़कर प्रस्तुत करते हैं। उत्तरों में विचारों को स्पष्ट क्रम में रखना और ट्रांजिशन शब्दों का सही उपयोग करना स्पष्टता और तर्क (clarity and reasoning) में अच्छा स्कोर करने का तरीका है।',
		'characteristic-reflects-five-example':
			'ऐसे कार्य का उदाहरण जहाँ यह विशेषता लाभकारी होगी: जब कार्य में आपको स्थिति और अपने विचार प्रक्रिया को स्पष्ट रूप से और तार्किक ढंग से पेश करना हो।',

		'alert-dialog':
			'Google सहायता ऐप्स को स्थान निर्धारित करने की अनुमति दें। इसका मतलब है कि Google को गुमनाम स्थान डेटा भेजा जाएगा, भले ही ऐप्स चल न रहे हों।',
		disagree: 'असहमति',
		agree: 'सहमति',
		'talent-relationships': 'प्रतिभा संबंध',
		'talent-relationships-subtitle':
			'अपने प्रतिभा समूह के बीच छिपे हुए संबंधों की खोज करें। तुलना देखने के लिए किसी कौशल को अक्ष पर खींचें।',

		'talent-funnel-title': 'प्रतिभा फ़नल',
		'talent-funnel-subtitle':
			'चुनौती में आपकी रैंक की गई प्रतिभा की खोज करें। परिणाम देखने के लिए किसी श्रेणी का चयन करें।',

		'team-dynamic-title': 'टीम डायनामिक्स',
		'team-dynamic-subtitle':
			'अन्य पाइपलाइन से व्यक्तियों को जोड़कर यह सिमुलेट करें कि वे आपकी टीम के प्रदर्शन को कैसे प्रभावित करेंगे। सर्वोत्तम प्रदर्शन के लिए मिश्रण और मिलान करें।',

		'almost-there': 'लगभग हो गया',
		'users-pipeline':
			'जैसे ही आपके पाइपलाइन में कम से कम 50 उपयोगकर्ता होंगे, परिणाम दिखाई देंगे।',
		'copied-invite': 'निमंत्रण लिंक सफलतापूर्वक कॉपी किया गया:',

		'about-one':
			'Nugget.ai चुनौती में, आपको एक विशेष नौकरी की भूमिका निभाने के लिए कहा गया और यह दिखाने के लिए कि उस भूमिका में रहते हुए आप कैसे सोचते, क्या करते, कौन सी जानकारी पर ध्यान देते और क्या सिफारिश करते। जब से आपने चुनौती पृष्ठ खोला, हमने यह ट्रैक किया कि आपने संसाधनों के साथ कैसे बातचीत की और चुनौती कैसे पूरी की—यह सब यह समझने में मदद करता है कि आप किसी कार्य संदर्भ में समस्या समाधान और संचार कौशल कैसे प्रदर्शित करते हैं। फिर हम इन पहलुओं का विश्लेषण करते हैं ताकि यह जान सकें कि कौन से पैटर्न सामने आते हैं। इस पृष्ठ पर दिखाए गए परिणाम वही पैटर्न हैं और यह कि आपने दूसरों की तुलना में कैसा प्रदर्शन किया।',

		'about-two':
			'आपके स्कोर को उन सभी उपयोगकर्ताओं के समूह के साथ जो चुनौती में भाग ले चुके हैं, तुलना में रखा जाता है। हम एक अनूठा तरीका विकसित कर रहे हैं जिससे उपयोगकर्ता प्रदर्शन का विश्लेषण विभिन्न उद्योग मानकों, बाजार, कंपनी और टीम बेंचमार्क के साथ तुलना करके किया जाता है। विभिन्न बेंचमार्क अलग-अलग तरीके से व्यवहार करते हैं क्योंकि वे अलग-अलग जनसांख्यिकी में प्रतिभा की विविधता को दर्शाते हैं।',

		'about-three':
			'यदि आपका स्कोर बेंचमार्क से कम है, तो इसका मतलब यह नहीं है कि आप दूसरों से कमतर हैं—हर कंपनी विभिन्न गुणों के संयोजन को प्राथमिकता देती है।',

		'about-four':
			"हमारा उद्देश्य है कि हम आपको आपकी सामाजिक क्षमताओं के बारे में ऐसे 'नगेट्स' (महत्वपूर्ण जानकारी) खोजने में मदद करें जो यह दिखाए कि आपकी सोचने की शैली, संवाद करने का तरीका और समस्याओं को हल करने की क्षमता किन करियर रास्तों से मेल खा सकती है। आप ऐसे करियर विकल्प भी खोज सकते हैं जिन्हें आपने पहले कभी नहीं सोचा था कि वे आपके लिए उपयुक्त हो सकते हैं।",

		'account-details': 'खाता विवरण',
		'success-redirect': 'सफलतापूर्वक सहेजा गया और पुनर्निर्देशित किया गया',
		'usecase-one':
			"GE Appliances ने अपने वाई-फाई से जुड़े घरेलू उपकरणों को अपडेट करने की घोषणा की है, जो अब सीधे Google Assistant के साथ काम करते हैं, जो कि Google का वॉयस-सर्च डिजिटल असिस्टेंट है। लोग अब आदेश दे सकते हैं जैसे, 'हे Google, ओवन को 425 डिग्री पर प्रीहीट करो', या पूछ सकते हैं, 'हे Google, क्या मेरे बर्तन साफ हैं?'",

		'usecase-two':
			"Google Assistant के साथ सीधे कनेक्शन से GE डिवाइसेज़ से बात करते समय अतिरिक्त कमांड कहने की ज़रूरत नहीं रह जाती। पहले, उपयोगकर्ताओं को 'Google, जेनेवा होम से कहो कि ओवन को 425 डिग्री पर प्रीहीट करे' जैसे आदेशों के लिए Geneva Home एक्शन का उपयोग करना पड़ता था।",

		'usecase-three':
			'यह परिवर्तन GE के रेफ्रिजरेटर, ओवन, डिशवॉशर और वॉशिंग मशीन जैसे कनेक्टेड उपकरणों के साथ काम करता है, जो सभी U+ Connect ऐप से जुड़े होते हैं ताकि डिवाइस प्रबंधन आसान हो।',

		'usecase-four':
			"GE Appliances की Google Assistant के साथ गहरी एकीकरण की घोषणा उस समय हुई है जब Google स्मार्ट होम सर्विस मार्केट में Amazon से प्रतिस्पर्धा कर रहा है। डिजिटल असिस्टेंट के साथ सीधा कनेक्शन GE डिवाइसेज़ को Alexa की तुलना में उपयोग में आसान बना सकता है। Amazon और GE ने 2016 में Alexa के लिए Geneva स्किल लॉन्च की थी, जिसमें उपयोगकर्ता को 'Alexa, Geneva से कहो कि ओवन को 350 डिग्री पर प्रीहीट करे' जैसे आदेश देने पड़ते थे, CNet के अनुसार। यह अतिरिक्त कदम कुछ उपयोगकर्ताओं के लिए असुविधाजनक हो सकता है।",

		'usecase-five':
			'GE Appliances की घोषणा उस समय हुई है जब Electrolux—स्वीडिश घरेलू उपकरण निर्माता—ने भी अपने किचन उत्पादों को Google Assistant से जोड़ना शुरू कर दिया है। Electrolux ने पिछले हफ्ते घोषणा की कि वॉयस इंटीग्रेशन अगले साल स्मार्ट ओवन में शुरू होगा। जैसे-जैसे अधिक निर्माता कनेक्टेड होम डिवाइस के साथ प्रयोग कर रहे हैं, तकनीक और अधिक विकसित और उपभोक्ताओं के लिए आसान बनती जा रही है।',

		'usecase-six':
			'डिजिटल असिस्टेंट और स्मार्ट स्पीकर का क्षेत्र तेजी से बढ़ रहा है। 2018 की पहली तिमाही में वॉयस-पावर्ड स्मार्ट स्पीकर की वैश्विक शिपमेंट साल दर साल 278% बढ़कर 9.2 मिलियन यूनिट हो गई। भले ही Amazon ने तिमाही में 4 मिलियन यूनिट भेजीं, लेकिन उसकी मार्केट हिस्सेदारी 81.8% से घटकर 43.6% रह गई, Strategy Analytics के अनुसार। इंटरनेशनल डेटा कॉर्पोरेशन के अनुसार, स्मार्ट स्पीकर, डिजिटल मीडिया एडॉप्टर, लाइटिंग, थर्मोस्टैट और GE जैसे अन्य कनेक्टेड उपकरणों से बना वैश्विक स्मार्ट होम डिवाइस मार्केट इस साल 26.8% बढ़कर कुल 549.5 मिलियन शिपमेंट तक पहुंचने की उम्मीद है।',

		note:
			'नोट: ये संसाधन वे दस्तावेज़ हैं जो बैठक में सभी उपस्थित लोगों को पहले से दिए जाते हैं। इन संसाधनों के माध्यम से, उपस्थित लोगों को यादृच्छिक रूप से चुनी गई गीत की लिरिक्स दी जाती है। इसके अलावा, गीत के सामान्य तत्वों को पहचाना जाता है। साथ ही, कुछ विशेष तत्व भी निर्दिष्ट होते हैं—हालांकि ये ज़रूरी नहीं कि वही हों जिनकी रिकॉर्ड लेबल के अधिकारी तलाश कर रहे हों—लेकिन ये योजना बनाते समय किन चीजों को ध्यान में रखना है, इसका संकेत देते हैं।',

		'song-title': 'गीत का शीर्षक',
		'true-colours': 'सच्चे रंग',
		unnamed: 'बिना नाम',
		instrumentals: 'वाद्य संगीत',
		'no-decription-provided': 'कोई विवरण प्रदान नहीं किया गया',
		'vocal-type': 'वोकल प्रकार',
		'single-vocal-male': 'एकल पुरुष वोकल',
		'theme-song': 'गीत का विषय',
		'love-relationships': 'प्रेम और संबंध',
		'storyline-song': 'गीत की कहानी',
		'storyline-song-description':
			'गायक अपनी प्रेमिका के प्रति यह इच्छा व्यक्त करता है कि वह उसे गहराई से जानना और उसके साथ एक गहरा संबंध बनाना चाहता है। कलात्मक रूप से, गायक रंगों और चित्रों की उपमा का उपयोग करके यह भावना व्यक्त करता है।',

		insight: 'अंतर्दृष्टि',
		talent: 'प्रतिभा',
		'your-talent-pipelines': 'आपकी प्रतिभा पाइपलाइन्स',

		'add-challenge':
			'अपना लक्ष्य / चुनौती का विवरण यहां जोड़ें। टीम के सभी सदस्य इसे देख सकेंगे!',

		'digital-team': 'डिजिटल टीम',
		send: 'भेजें',

		'terms-and-condition': '<EsDescription />',

		'send-email-again-text': 'अब तक ईमेल नहीं मिला?',
		'send-email-again': 'फिर से भेजें',

		'create-new-password': 'नया पासवर्ड बनाएं',
		'create-new-password-info':
			'एक सुरक्षित पासवर्ड चुनें और इसे अन्य खातों में दोबारा उपयोग न करें। पासवर्ड बदलने से आप सभी डिवाइसों से साइन आउट हो जाएंगे, और आपको फिर से नया पासवर्ड दर्ज करना होगा।',

		'new-password': 'नया पासवर्ड',
		'change-your-password': 'अपना पासवर्ड बदलें',
		'current-password': 'वर्तमान पासवर्ड',

		'mail-sent': 'ईमेल सफलतापूर्वक भेजा गया',
		'error-mail-sent': 'ईमेल भेजने में त्रुटि हुई',

		'profile-update': 'आपकी प्रोफ़ाइल सफलतापूर्वक अपडेट कर दी गई है',

		'delete-confirmation': 'क्या आप वाकई अपना खाता हटाना चाहते हैं?',

		'current-password-incorrect': 'वर्तमान पासवर्ड गलत है',

		'password-change': 'पासवर्ड सफलतापूर्वक बदला गया',

		'accept-the': 'मैं स्वीकार करता हूँ',
		'terms-conditions': 'नियम और शर्तें',

		resume: 'बायोडाटा'
	},
	hi: {
		'tour-step-0':
			'मूल्यांकन का अवलोकन और पृष्ठभूमि यहां होगी। जब आप शुरू करें, तो इसे ध्यानपूर्वक पढ़ें।',
		'tour-step-1':
			'संसाधन सहायक सामग्री हैं। इस अनुभाग में, आपको वह संसाधन मिलेंगे जो परिदृश्य को बेहतर समझने में आपकी मदद करेंगे।',
		'tour-step-2':
			'आप यहां टाइप करके मूल्यांकन हल करेंगे। हो सकता है कि एक या अधिक उत्तर बॉक्स हों जिनमें उत्तर देना आवश्यक है।',
		'tour-step-3': '',
		'tour-step-4': '',
		'tour-step-5':
			'आपका मूल्यांकन स्थिर नहीं होगा—नई जानकारी यहां अधिसूचना आइकन के माध्यम से प्रस्तुत की जाएगी। घंटी की आवाज़ सुनने के लिए अपनी आवाज़ चालू रखें।',
		'tour-step-6':
			'हर मूल्यांकन समयबद्ध होता है, इसलिए घड़ी पर ध्यान रखें! जब आप तैयार हों, तो ‘Next’ पर क्लिक करें।',

		'start-test-title': 'क्या आप वाकई शुरू करना चाहते हैं?',
		'start-test-content':
			'सुनिश्चित करें कि ब्राउज़र पूर्ण स्क्रीन पर खुला हो और टैब को बंद न करें, नहीं तो आपको फिर से शुरू करना होगा। शुभकामनाएं!',

		start: 'प्रारंभ करें',
		'show-me-again-u': 'मुझे फिर से दिखाएँ',
		consultant: 'परामर्श',
		endPreview: 'पूर्वावलोकन समाप्त करें',
		next: 'आगे',
		back: 'वापस',
		prev: 'पिछला',
		finish: 'समाप्त करें',
		'how-can-we-help': 'हम आपकी कैसे मदद कर सकते हैं?',
		'how-can-we-help-explain':
			'यह आपके मूल्यांकन को पूरा करने के लिए आपका मार्गदर्शक है। खो मत जाइए, टाइमर अभी भी चल रहा है!',
		application: 'आवेदन',
		other: 'अन्य',
		help: 'मदद',
		'add-new-section': 'नया अनुभाग जोड़ें',
		'identify-the-problem': 'समस्या की पहचान करें',
		'highlight-key-sentences':
			'लेख से उन प्रमुख वाक्यों को हाइलाइट करें जो आपके लिए महत्वपूर्ण हैं। बस खींचें और छोड़ें, उतना ही आसान।',
		'brainstorm-viable': 'ऐसे व्यवहार्य विचार सुझाएं जो समस्या के दायरे में फिट हों',
		'use-your-creativity': 'अपनी रचनात्मकता का उपयोग करें और एक समाधान सुझाएं',
		problem: 'समस्या',
		'collect-information-title': 'जानकारी एकत्र करें',
		ideas: 'विचार',
		solution: 'समाधान',
		resource: 'संसाधन',
		'no-card-name': 'कोई कार्ड नाम नहीं',
		'challenge-description': 'चुनौती विवरण',
		'test-name-not-found': 'परीक्षण का नाम नहीं मिला',
		'drop-the-text-here': 'पाठ को यहाँ खींचें और छोड़ें',
		'type-away-what': 'लिखते जाएँ... और क्या आप हमें बताना चाहते हैं?',
		title: 'शीर्षक',
		'are-you-sure': 'क्या आप निश्चित हैं?',
		'content-exit-challenge':
			'ऐसा लग रहा है कि आप मूल्यांकन से बाहर निकलने की कोशिश कर रहे हैं। यदि आप ऐसा करते हैं, तो आपकी सारी प्रगति खो जाएगी।',
		'continue-the-challenge': 'मूल्यांकन जारी रखें',
		'continue-challenge': 'मूल्यांकन जारी रखें',
		'content-finish-challenge': 'ऐसा लग रहा है कि आप अपने परिणाम भेजने वाले हैं',
		'time-up': 'समय समाप्त!',
		'hard-part-over':
			'मुश्किल हिस्सा अब समाप्त हो गया है। बस आराम से बैठें और परिणामों का इंतजार करें',
		'great-job-u': 'शानदार काम!',
		'u-finished-it': 'आपने इसे पूरा कर लिया!',
		'sit-tight-well':
			'शांत रहें! हम आपको बताएंगे जब परिणाम आ जाएँगे। इस बीच, यहाँ कुछ आँकड़े हैं जिससे आप अपने परिणाम का अंदाज़ा लगा सकते हैं',
		'sit-tight-well-short': 'शांत रहें! हम आपको बताएंगे जब परिणाम आ जाएँगे।',
		'sign-up-in-msg': 'अपने परिणाम देखने के लिए नीचे साइन अप करें या साइन इन करें!',
		'assess-congratulations-sandbox':
			'बधाई हो! आपने इसे पूरा कर लिया। अपने प्रोफ़ाइल पृष्ठ पर जाकर अपने परिणाम देखें।',
		// 'assess-congratulations-analytics': `Congratulations! You finished it. We are now analyzing your results. Want to take a peak? Sign up or sign in below to see your results!`,
		'assess-congratulations-analytics':
			'बधाई हो! आपने इसे पूरा कर लिया है। हम अब आपके परिणामों का विश्लेषण कर रहे हैं और सर्वोत्तम मेल खोज रहे हैं। यहीं रहें, कोई आपसे जल्द ही संपर्क करेगा।',
		'companies-are-also':
			'कंपनियाँ पूरक कौशल भी ढूँढ रही हैं, इसलिए चिंता न करें! हो सकता है आप ही वही हों जिसकी उन्हें तलाश है!',
		'let-you-know-over-email':
			'जैसे ही हम आपके परिणामों को संसाधित करेंगे, हम आपको ईमेल के माध्यम से सूचित करेंगे! इस बीच, कुछ मजेदार आँकड़े देखें, बस जिज्ञासा के लिए।',
		'want-to-improve-ex': 'अनुभव को बेहतर बनाना चाहते हैं? यह त्वरित फ़ॉर्म भरें ',
		'questionniare-err-msg': 'लगता है आपने कुछ छोड़ दिया है। मान 1 से 7 के बीच होना चाहिए।',
		survey: 'सर्वेक्षण',
		minutes: 'मिनट',
		'pace-of-writing': 'लिखने की गति',
		'words-per-minute': 'शब्द प्रति मिनट',
		'head-start': 'शुरुआत में बढ़त',
		'how-long-takes': 'पहला शब्द लिखने में आपको कितने सेकंड लगे',
		'quick-fix': 'त्वरित सुधार',
		'number-times-deleting': '3 सेकंड के भीतर कितनी बार हटाने की क्रिया हुई',
		'run-on': 'चलती हुई पंक्तियाँ',
		'number-long-sentences': '30 शब्दों से अधिक की लंबी पंक्तियों की संख्या',
		'select-an-assessment': 'एक मूल्यांकन चुनें',
		'select-from-pre-built':
			'पूर्व-निर्मित मूल्यांकन से चुनें। हम सामग्री और अंतर्दृष्टि का ध्यान रखेंगे।',
		'business-to-business-sales': 'सही वेब सेवा को क्लाइंट को बेचना',
		'business-to-business-sales-description':
			'आप एक व्यवसाय-से-व्यवसाय (B2B) बिक्री प्रतिनिधि हैं। आपका प्रबंधक आपको एक संभावित नए ग्राहक के बारे में बता रहा है – एक व्यवसाय जो एक कंपनी वेबसाइट बनवाना चाहता है। इस मूल्यांकन में, अपने नए ग्राहक की ज़रूरतों की पहचान करें, प्रदान किए गए संसाधनों से जानकारी इकट्ठा करें, कुछ संभावित विकल्प सुझाएँ, और फिर इस नए ग्राहक को सर्वोत्तम विकल्प की सिफारिश करें।',
		'email-thread-between': 'प्रबंधक और ग्राहक के बीच ईमेल वार्तालाप',
		'descriptions-services-provided': 'कंपनी द्वारा प्रदान की गई सेवाओं का विवरण',
		'actionablet-tips-closing': 'अधिक B2B बिक्री को बंद करने के लिए व्यावहारिक सुझाव',
		'data-science': 'कंपनी को कर्मचारी डेटा की व्याख्या करने में मदद करें',
		'data-science-description':
			'आप एक डेटा वैज्ञानिक हैं जो एक नए ग्राहक के साथ काम कर रहे हैं, जो टेक उद्योग में एक उभरती हुई कंपनी है और जिसमें 150 कर्मचारी हैं। ग्राहक ने अभी अपने कर्मचारियों और उनके कार्य अनुभवों पर पहला आंतरिक डेटा संग्रह पूरा किया है। वे चाहते हैं कि आप उनके डेटा को समझने में मदद करें। वे अपनी नीतियों, प्रथाओं, और/या प्रशिक्षण में कुछ बदलाव करने के लिए इस डेटा का उपयोग करना चाहते हैं। इस चुनौती में, प्रमुख समस्याओं की पहचान करें, साझा किए गए डेटा से जानकारी एकत्र करें, ग्राहक के लिए संभावित विकल्पों पर विचार करें, और फिर अंतिम सिफारिशें करें।',
		'interview-findings': 'साक्षात्कार निष्कर्ष',
		'correlation-table': 'सहसंबंध तालिका',
		'multiple-regression-table': 'मल्टीपल रिग्रेशन तालिका',
		'business-strategy-proposal': 'कंपनी को लाभ कमाने में मदद करें',
		'business-strategy-proposal-description':
			'आप एक मध्यम आकार की कंपनी में पूर्णकालिक कर्मचारी के रूप में कार्य करते हैं। पिछले दो वर्षों में, आपकी कंपनी के परिचालन लाभ में लगातार गिरावट आ रही है। यह गिरावट औसत बिक्री में कमी और औसत खर्चों में वृद्धि दोनों के कारण है। इस समस्या को आंतरिक संसाधनों की मदद से हल करने की इच्छा के साथ, कंपनी के अधिकारियों ने मौजूदा कर्मचारियों में से चुने गए लोगों के साथ एक क्रॉस-फंक्शनल टीम बनाने का निर्णय लिया है। आपको इस टीम में शामिल होने के लिए चुना गया है। आपकी पहली बैठक हो चुकी है, और सभी ने सहमति व्यक्त की है कि अगली बैठक से पहले हर कोई व्यक्तिगत रूप से समस्या की पहचान करे, उसके कारणों को समझे, और समाधान सुझाए। आपकी प्रस्तुति 20 मिनट में है!',
		'software-engineering-challenge': 'एक नए उत्पाद के लिए योजना विकसित करें',
		'software-engineering-challenge-description':
			"आप देश की प्रमुख उत्पाद नवाचार फर्म के लिए एक टीम में एक पूर्णकालिक सॉफ्टवेयर इंजीनियर के रूप में कार्य करते हैं, जो नए सॉफ़्टवेयर को डिज़ाइन, विकसित और ट्रबलशूट करने की ज़िम्मेदारी रखती है। इस वर्ष कंपनी ने 'विफलताओं से सीखना' को रणनीतिक प्राथमिकता बनाया है। आपकी टीम का मौजूदा प्रोजेक्ट पिछले असफल प्रोजेक्ट्स का विश्लेषण करना, उनसे 'सीखना' और एक ऐसा उत्पाद बनाना है जिसे सफल बनाया जा सके। आपकी टीम ने पहले व्यक्तिगत रूप से विचार विकसित करने और फिर सामूहिक रूप से चर्चा करने का निर्णय लिया है। मामलों की समीक्षा करें, एक समस्या चुनें, जानकारी एकत्र करें, कुछ अच्छे विचार प्रस्तुत करें, और फिर वह अंतिम उत्पाद सिफारिश करें जिसे आप समूह के समक्ष प्रस्तुत करेंगे।",
		'software-engineering': 'सॉफ़्टवेयर इंजीनियरिंग',
		'product-design': 'उत्पाद डिज़ाइन',
		'product-development': 'उत्पाद विकास',
		innovation: 'नवाचार',
		'case-1-drama': 'मामला #1: ड्रामा',
		'case-2-highlighter': 'मामला #2: हाइलाइटर',
		'case-3-screenrest': 'मामला #3: स्क्रीनरेस्ट',
		'customer-client-feedback': 'ग्राहक/क्लाइंट प्रतिक्रिया',
		'performance-management-results': 'प्रदर्शन प्रबंधन परिणाम',
		'profits-chart': 'लाभ चार्ट',
		'get-started': 'शुरू करें',
		welcome: 'स्वागत है',
		name: 'नाम',
		email: 'ईमेल',
		age: 'आयु',
		gender: 'लिंग',
		male: 'पुरुष',
		female: 'महिला',
		'prefer-not-to-say': 'कहना नहीं चाहूंगा',
		continue: 'जारी रखें',
		'what-ethnicity-cultural-group': 'आप किस जातीय/सांस्कृतिक समूह से संबंधित हैं?',
		caucasian: 'कोकेशियान',
		'latin-american': 'लैटिन अमेरिकी',
		african: 'अफ्रीकी',
		caribbean: 'कैरेबियाई',
		'middle-east': 'मध्य पूर्व',
		'south-asian': 'दक्षिण एशियाई (जैसे, भारतीय, श्रीलंकाई)',
		'southeast-asian': 'दक्षिण-पूर्व एशियाई (जैसे, वियतनामी, चीनी, फिलिपिनो)',
		'west-asian': 'पश्चिम एशियाई (जैसे, ईरानी, अफगान)',
		aboriginal: 'आदिवासी (जैसे, उत्तर अमेरिकी भारतीय, इनुइट)',
		mixed: 'मिश्रित',
		'what-is-your-marital': 'आपकी वैवाहिक स्थिति क्या है?',
		'how-do-you-want-to-create': 'आप किस तरह से निर्माण करना चाहते हैं?',
		'pre-built-assessment': 'पूर्व-निर्मित मूल्यांकन',
		'create-your-own': 'अपना खुद का बनाएँ',
		'please-select-role-type': 'कृपया भूमिका प्रकार चुनें!',
		'please-select-position-type': 'कृपया पद का प्रकार चुनें!',
		'what-are-you-hiring-for': 'आप किस पद के लिए भर्ती कर रहे हैं?',
		'help-us-define-your-role':
			'कृपया हमें आपकी भूमिका परिभाषित करने में मदद करें ताकि हम सर्वोत्तम मूल्यांकन सुझा सकें',
		'role-type': 'भूमिका प्रकार',
		none: 'कोई नहीं',
		'customer-service': 'ग्राहक सेवा',
		sales: 'बिक्री',
		'product-management': 'उत्पाद प्रबंधन',
		'business-management': 'व्यवसाय प्रबंधन',
		'business-strategy': 'व्यवसाय रणनीति',
		'position-type': 'पद का प्रकार',
		'co-op-internship': 'को-ऑप/इंटर्नशिप',
		'entry-level': 'प्रवेश स्तर',
		'junior-manager': 'जूनियर प्रबंधक',
		'middle-manager': 'मिडिल मैनेजर',
		'add-the-keywords': 'कीवर्ड जोड़ें',
		cancel: 'रद्द करें',
		'please-select-the-assessment': 'कृपया मूल्यांकन चुनें!',
		'create-your-benchmark': 'अपना बेंचमार्क बनाएँ',
		'create-a-benchmark-by-sending':
			'शीर्ष प्रदर्शन करने वाले कर्मचारियों को पहले मूल्यांकन भेजकर एक बेंचमार्क बनाएं',
		'share-the-link-below': 'नीचे दिया गया लिंक साझा करें',
		launch: 'लॉन्च करें',
		'Add-team': 'टीम जोड़ें',
		search: 'खोजें',
		'example-challenge': 'डेमो',
		'single-never-married': 'अविवाहित, कभी विवाह नहीं किया',
		widowed: 'विधवा/विधुर',
		separated: 'अलग रह रहे हैं',
		divorced: 'तलाकशुदा',
		married: 'विवाहित',
		'living-common-law': 'कॉमन-लॉ में साथ रह रहे हैं',
		'what-is-the-highest-degree': 'आपकी शिक्षा का सर्वोच्च स्तर क्या है?',
		'less-than-high-school-diploma': 'हाई स्कूल डिप्लोमा से कम',
		'high-school-degree-or-equivalent': 'हाई स्कूल डिग्री या समकक्ष (जैसे GED)',
		'some-scollege-no-degree': 'कुछ कॉलेज किया है, डिग्री नहीं है',
		'associate-degree': 'एसोसिएट डिग्री (जैसे AA, AS)',
		'bachelors-degree': 'स्नातक डिग्री (जैसे BA, BS)',
		'masters-degree': 'स्नातकोत्तर डिग्री (जैसे MA, MS)',
		'professional-degree': 'पेशेवर डिग्री (जैसे MD, DDS)',
		doctorate: 'डॉक्टरेट (जैसे PhD, EdD)',
		'what-is-your-current-employment-status': 'आपकी वर्तमान रोजगार स्थिति क्या है?',
		'employed-full-time-40': 'पूर्णकालिक कार्यरत (सप्ताह में 40 या उससे अधिक घंटे)',
		'employed-part-time-39': 'आंशिककालिक कार्यरत (सप्ताह में 39 घंटे तक)',
		'unemployed-and-currently-looking': 'बेरोजगार और वर्तमान में काम की तलाश में',
		'Unemployed-and-currently-not-looking':
			'बेरोजगार और वर्तमान में काम की तलाश में नहीं हैं',
		student: 'छात्र',
		retired: 'सेवानिवृत्त',
		'self-employed': 'स्व-नियोजित',
		'unable-to-work': 'काम करने में असमर्थ',
		'to-tutorial': 'ट्यूटोरियल पर जाएँ',
		'please-do-not-take-this-assessment-on-phone':
			'कृपया इस मूल्यांकन को अपने फ़ोन पर न लें',
		company: 'कंपनी',
		'mobile-device-prompt':
			'लगता है आप इस मूल्यांकन को मोबाइल डिवाइस पर लेने की कोशिश कर रहे हैं। सर्वोत्तम अनुभव के लिए, कृपया इसे अपने डेस्कटॉप या लैपटॉप से एक्सेस करें।',
		'company-would-like':
			'आपको nugget.ai चुनौती में भाग लेने के लिए आमंत्रित किया गया है। इस चुनौती के माध्यम से, आपसे अपेक्षा की जाती है कि आप एक ऑनलाइन मिनी-नौकरी सिमुलेशन के माध्यम से अपने सॉफ्ट स्किल्स का प्रदर्शन करें।',
		'we-are-assessing':
			'हम आपकी सॉफ्ट स्किल्स का मूल्यांकन आपके कार्यप्रणाली के आधार पर कर रहे हैं — यानी आप जॉब सिमुलेशन को कैसे अपनाते हैं, विभिन्न इंटरफेस घटकों के साथ कैसे इंटरैक्ट करते हैं, और इस प्रक्रिया के दौरान क्या निर्णय लेते हैं। हम परिणाम के सही या गलत होने की बजाय आपकी कार्यशैली के पैटर्न पर ध्यान केंद्रित कर रहे हैं।',
		'we-at-nugget.ai':
			'हम nugget.ai में मानते हैं कि कोई उत्तर सही या गलत नहीं होता, इसलिए हम आपको प्रोत्साहित करते हैं कि आप सहज रहें और अपना सर्वश्रेष्ठ दें!',
		'company-following-tutorial':
			'इस चुनौती के लिए आपको तैयार करने हेतु, आपको इंटरफेस से परिचय कराने के लिए एक ट्यूटोरियल दिया जाएगा। हम सिफारिश करते हैं कि आप हमारे सुझावों को ध्यान से पढ़ें। इस ट्यूटोरियल के बाद, आपके पास चुनौती पूरी करने के लिए',
		'minutes-to-complete': 'मिनट होंगे।',
		'good-luck': 'शुभकामनाएँ!',
		goodluck: 'शुभकामनाएँ',
		'assess-learn-evolve': 'मूल्यांकन करें। सीखें। विकसित हों।',
		'discover-your-soft-skills':
			'भूमिका-संबंधित चुनौतियों के माध्यम से अपनी सॉफ्ट स्किल्स की खोज करें',
		'n-challenges-available': '{n} चुनौतियाँ उपलब्ध हैं',
		'search-challenge': 'चुनौती खोजें',
		'hi-{name}': 'नमस्ते {name}',
		'{name}-pam-beesly-youre-going-places': '{name}, आप बहुत आगे जाने वाले हैं!',
		'discover-nuggets-about-your-soft-skills':
			'अपनी सॉफ्ट स्किल्स के बारे में कीमती जानकारी खोजें',
		'register-login': 'लॉगिन करें',
		'nugget-ai-science': 'Nugget.ai विज्ञान',
		'our-prediction-models':
			'हमारे पूर्वानुमान मॉडल I/O साइकोलॉजी में अकादमिक अनुसंधान द्वारा समर्थित हैं',
		performance: 'प्रदर्शन',
		'people-skills': 'लोगों से जुड़ने की क्षमताएँ',
		'view-submission': 'सबमिशन देखें',
		'domain-skills': 'डोमेन कौशल',
		'mark-your-focus-and-find-your-gaps-to-improve':
			'अपना फोकस चिन्हित करें और सुधार के लिए अपने अंतर खोजें',
		'discover-your-path': 'अपना मार्ग खोजें',
		'keep-an-open-mind-and-try-something-new': 'खुले दिमाग से सोचें और कुछ नया आज़माएँ!',
		'compare-to': 'तुलना करें',
		'growth-tips': 'विकास सुझाव',
		'machine-drive-advice-subtitle': 'शीर्ष 10% पेशेवरों से मशीन-चालित सलाह',
		'growth-tips-1':
			'“काम में सफलता या विफलता के सबसे बड़े कारणों में से एक ध्यान की बारीकी रही है।”',
		'growth-tips-2':
			'“ऐसे उद्योग में तकनीकी समाधानों का पोर्टफोलियो प्रबंधित करना जहाँ तेजी से बदलाव हो रहे हैं, आपको हर समय सतर्क बनाए रखता है…”',
		'growth-tips-3':
			'“जैसे मशीन लर्निंग ने उद्योगों को बदला है, वैसे ही ब्लॉकचेन भी हर उद्योग में क्रांति ला सकता है। आपकी रचनात्मक सोच और नई खोजों का नेतृत्व करने की क्षमता आपके करियर की सफलता के लिए महत्वपूर्ण है।”',
		'what-does-this-mean': 'इसका क्या अर्थ है?',
		'project-coodinator': 'प्रोजेक्ट कोऑर्डिनेटर',
		'financial-analyst': 'वित्तीय विश्लेषक',
		'project-manager': 'प्रोजेक्ट मैनेजर',
		'blue-sky-music-proposal': 'ब्लू-स्काई म्यूजिक प्रस्ताव लिखें',
		'blue-sky-music-proposal-description':
			"आप एक अनुभवी कलाकार हैं जो एक अग्रणी रिकॉर्ड लेबल से जुड़े हैं। यह लेबल हर महीने 'ब्लू-स्काई' बैठकें आयोजित करता है, जहाँ कलाकारों को किसी भी शैली, रचना या विषय पर नए गाने के लिए विस्तृत योजना प्रस्तुत करने के लिए प्रोत्साहित किया जाता है। इस चुनौती में, आप अपनी योजना में शामिल करने के लिए घटकों की पहचान करें, प्रदान किए गए संसाधनों से जानकारी एकत्र करें, कुछ विचार उत्पन्न करें, और अंत में एक बड़ी योजना बनाकर उसे इस बैठक में प्रस्तुत करें।",
		'blue-sky-music-proposal-resource-1': 'संसाधन 1: ट्रू कलर्स - सामान्य तत्व',
		'blue-sky-music-proposal-resource-2': 'संसाधन 2: ट्रू कलर्स - गीत',
		'help-a-first-time-homebuyer': 'पहली बार घर खरीदने वाले की मदद करें',
		'help-a-first-time-homebuyer-description':
			'आप एक रियल एस्टेट बिक्री प्रतिनिधि हैं। एक संभावित खरीदार ने आपसे संपर्क किया है और अपना पहला घर खरीदने में रुचि जताई है। इस चुनौती में, अपने नए ग्राहक की आवश्यकताओं की पहचान करें, प्रदान किए गए संसाधनों से जानकारी एकत्र करें, संभावित विकल्प तैयार करें, और फिर सर्वोत्तम विकल्प और उसके पीछे की सोच की सिफारिश करें।',
		emails: 'ईमेल्स',
		'property-listings-table': 'संपत्ति सूची तालिका',
		'find-your-perfect-home': 'अपना परफेक्ट घर खोजें',
		'marketing-description':
			'आप एक मार्केटिंग विशेषज्ञ हैं। आप एक मध्यम आकार की खुदरा कंपनी के लिए काम करते हैं जो उच्च गुणवत्ता वाले आउटडोर गियर और बाहरी कपड़े बेचती है और पिछले पांच वर्षों से इस उद्योग में सक्रिय है। आपकी कंपनी मुख्य रूप से ऑनलाइन उत्पाद बेचती है, लेकिन हाल ही में, शीर्ष प्रबंधन टीम ने केवल ई-कॉमर्स मॉडल से आगे बढ़ने पर विचार करना शुरू किया है। उन्होंने आपसे डेटा और विशेषज्ञता के आधार पर सिफारिश करने को कहा है।',
		'customer-demographics': 'ग्राहक जनसांख्यिकी',
		'customer-satisfaction-survey': 'ग्राहक संतुष्टि सर्वेक्षण',
		'our-science': 'हमारा विज्ञान',
		'{number}-assessments-take-so-far': 'अब तक {number} मूल्यांकन पूरे किए गए',
		whoops: 'अरे नहीं!',
		'404-message': 'आपका डाला गया लिंक या तो टूटा हुआ है या अब मौजूद नहीं है',
		'take-me-home': 'मुझे होम पेज पर ले जाएँ',
		'what-does-this-mean-s1':
			'जिस चुनौती को आपने पूरा किया, उसमें आपने एक बिक्री भूमिका में अपनी समस्या समाधान और संचार कौशल प्रदर्शित किए — और आपने ठीक वही किया! जैसे ही आपने चुनौती शुरू की, हमने आपके उत्तरों और निर्णय प्रक्रिया पर नज़र रखनी शुरू कर दी। यहाँ, आप देख सकते हैं कुछ महत्वपूर्ण जानकारियाँ जो हमने अपने विश्लेषण से निकालीं।',
		'what-does-this-mean-s2':
			"हम अपना 'सीक्रेट सॉस' तो नहीं बता सकते, लेकिन यहाँ एक उदाहरण है जो आपको सोचने में मदद करेगा।",
		'what-does-this-mean-s3-bold': 'गति और चिंतनशीलता:',
		'what-does-this-mean-s3':
			'जिन प्रतिभागियों ने चुनौती में तेजी से लिखना शुरू किया और फिर जैसे-जैसे ईमेल खोले और लेख पढ़े, उन्होंने अपने काम को मिटाया, जोड़ा और संशोधित किया — उन्होंने Speed और Reflectiveness में उच्च अंक प्राप्त किए।',
		'what-does-this-mean-s4':
			'एक ऐसा कार्य जहाँ यह विशेषता फायदेमंद हो सकती है: जब कोई तात्कालिक कार्य हो जिसे तुरंत निपटाना हो।',
		speed: 'गति',
		'meticulousness-assertiveness': 'सूक्ष्मता और आत्मविश्वास',
		'attention-to-detail': 'विवरण पर ध्यान',
		'clarity-reasoning': 'स्पष्टता और तर्क',
		export: 'निर्यात करें',
		archieve: 'संग्रह करें',
		delete: 'हटाएं',
		'are-you-sure-you-want-to-delete': 'क्या आप वाकई इसे हटाना चाहते हैं?',
		'are-you-sure-you-want-to-delete-this': 'क्या आप वाकई इसको हटाना चाहते हैं?',
		'pick-a-challenge': 'कोई चुनौती चुनें',
		'confirm-pick': 'चुनाव की पुष्टि करें',
		'challenge-added': 'चुनौती जोड़ी गई!',
		'sharable-link': 'साझा करने योग्य लिंक',
		'sharable-link-copy': 'साझा करने योग्य लिंक कॉपी हो गया',
		music: 'संगीत',
		lyrics: 'गीत के बोल',
		artist: 'कलाकार',
		'creative-industries': 'रचनात्मक उद्योग',
		'song-proposal': 'गीत प्रस्ताव',
		voice: 'आवाज़',
		'real-estate': 'रियल एस्टेट',
		'customer-success': 'ग्राहक सफलता',
		software: 'सॉफ़्टवेयर',
		customer: 'ग्राहक',
		experience: 'अनुभव',
		regression: 'पश्चगमन विश्लेषण',
		'data-analysis': 'डेटा विश्लेषण',
		'data-mining': 'डेटा माइनिंग',
		'digital-marketing': 'डिजिटल मार्केटिंग',
		'e-commernce': 'ई-कॉमर्स',
		retail: 'खुदरा',
		strategy: 'रणनीति',
		financial: 'वित्तीय',
		analysis: 'विश्लेषण',
		role: 'भूमिका',
		rolelevel: 'भूमिका स्तर',
		function: 'भूमिका कार्य',
		organization: 'संगठन',
		industry: 'उद्योग',
		'team-size': 'टीम का आकार',
		'update-profile': 'प्रोफ़ाइल अपडेट करें',
		'sign-out': 'साइन आउट करें',
		'delete-account': 'खाता हटाएं',
		'change-password': 'पासवर्ड बदलें',
		'Edit-profile': 'प्रोफ़ाइल संपादित करें',
		login: 'साइन इन',
		googleLogin: 'Google से साइन इन करें',
		googleSignup: 'Google से साइन अप करें',
		facebookLogin: 'Facebook से साइन इन करें',
		facebookSignup: 'Facebook से साइन अप करें',
		signup: 'साइन अप',
		'enter-your-email': 'अपना ईमेल दर्ज करें',
		'enter-your-password': 'अपना पासवर्ड दर्ज करें',
		'referral-Code': 'संदर्भ कोड',
		'Ask-your-friend-to-get-one': 'अपने दोस्त से एक लाने के लिए कहो।',
		'signin-click': 'या साइन इन के लिए यहाँ क्लिक करें',
		'csignin-help':
			'क्या आप हमारी मदद करना चाहते हैं? आपका फीडबैक हमारे अनुभव को बेहतर बनाएगा',
		'btn-provide-feedback': 'फीडबैक दें',
		password: 'पासवर्ड',
		'login-as-employee': 'उपयोगकर्ता के रूप में लॉगिन करें',
		'loggin-as-employer': 'एडमिन के रूप में लॉगिन करें',
		'forgot-password': 'पासवर्ड भूल गए?',
		username: 'यूज़रनेम',
		'enter-your-firstname': 'अपना पहला नाम दर्ज करें',
		'enter-your-lastname': 'अपना अंतिम नाम दर्ज करें',
		'enter-your-username': 'अपना यूज़रनेम दर्ज करें',
		'auth-no-user': 'आपका ईमेल हमारे डेटाबेस में नहीं है। कृपया दोबारा जांचें।',
		'signup-as-employer': 'एडमिन के रूप में साइन अप करें',
		'signup-as-employee': 'उपयोगकर्ता के रूप में साइन अप करें',
		'invalid-username': 'अमान्य यूज़रनेम!',
		'invalid-email': 'अमान्य ईमेल!',
		'invalid-password': 'अमान्य पासवर्ड!',
		'confirm-password': 'पासवर्ड की पुष्टि करें',
		'verify-email-title': 'अपना ईमेल सत्यापित करें',
		'verify-email-content':
			'साइन अप के लिए धन्यवाद। कृपया अपना खाता शुरू करने से पहले अपना ईमेल चेक करें और सत्यापन करें।',
		'repeat-your-password': 'अपना पासवर्ड दोहराएं',
		'password-not-match': 'पासवर्ड मेल नहीं खा रहे हैं',
		'password-reset': 'पासवर्ड रीसेट',
		'enter-your-email-and-well':
			'अपना ईमेल दर्ज करें और हम आपको पासवर्ड रीसेट लिंक भेजेंगे',
		'answer-some-questions': 'कुछ प्रश्नों के उत्तर दें',
		'tell-us-about-yourself': 'हमें अपने बारे में बताएं!',
		'tell-us-about-yourself-description':
			'यह फ़ॉर्म केवल शोध उद्देश्य के लिए है। आपकी जानकारी गोपनीय रखी जाएगी और आपकी पूर्व अनुमति के बिना साझा नहीं की जाएगी। यह फ़ॉर्म वैकल्पिक है और आप किसी भी प्रश्न का उत्तर न देने का विकल्प चुन सकते हैं।',
		'we-want-your-feedback': 'हमें आपका फीडबैक चाहिए!',
		'we-want-your-feedback-description':
			'इस सर्वे का उद्देश्य आपके अनुभव को समझना है, ताकि हम आपको सर्वोत्तम अनुभव दे सकें! इसका अनुमानित समय 3 मिनट से कम है।',
		'we-want-your-feedback-note': '* वाले प्रश्न अनिवार्य हैं।',
		'how-this-assessment-colleague':
			'आप इस मूल्यांकन को अपने किसी मित्र या सहकर्मी को कितनी संभावना से सुझाएंगे?',
		'poor-excellent': '1 = खराब ; 7 = उत्कृष्ट',
		'above-score-reason': 'ऊपर दिए गए स्कोर का कारण क्या है?',
		'what-think-content-of-challenge': 'आपको इस चैलेंज की सामग्री कैसी लगी?',
		'additional-feedback-to-product-team':
			'हमारी प्रोडक्ट टीम आपको बेहतरीन अनुभव देने की पूरी कोशिश कर रही है। क्या आपके पास हमारे लिए कोई अतिरिक्त फीडबैक है?',
		'enter-your-email-address': 'कृपया अपना ईमेल पता दर्ज करें',
		'go-take-a-look': 'जाइए और एक नज़र डालिए!',
		'for-2-minutes':
			'2 मिनट तक, इंटरफ़ेस से खुद को सहज बनाएं और तत्वों के साथ प्रयोग करें।',
		'your-data-will-not-saved-in-the-preview':
			'आप टाइप या तत्वों को खींच/ड्रॉप नहीं कर पाएंगे।',
		'neat-let-me-see-it': 'बहुत अच्छा, मुझे दिखाओ',
		'preview-mode': 'पूर्वावलोकन मोड',
		skip: 'छोड़ें',
		userlist: 'उपयोगकर्ता सूची',
		challengelist: 'चैलेंज सूची',
		pipelinelist: 'पाइपलाइन सूची',
		'challenge-result-list': 'चैलेंज परिणाम सूची',
		download: 'डाउनलोड करें',
		count: 'गिनती',
		'finance-accounting': 'वित्त और लेखांकन',
		'general-management': 'सामान्य प्रबंधन',
		'human-resources': 'मानव संसाधन',
		'information-technology': 'सूचना प्रौद्योगिकी',
		operations: 'संचालन',
		'individual-contributor': 'व्यक्तिगत योगदानकर्ता',
		'expert-individual-contributor': 'विशेषज्ञ व्यक्तिगत योगदानकर्ता',
		manager: 'प्रबंधक',
		'senior-manager': 'वरिष्ठ प्रबंधक',
		executive: 'कार्यकारी',
		'junior-analyst': 'कनिष्ठ विश्लेषक',
		'senior-analyst': 'वरिष्ठ विश्लेषक',
		'actively-looking': 'सक्रिय रूप से तलाश में',
		'passively-looking': 'आंशिक रूप से तलाश में',
		'not-looking': 'तलाश में नहीं',
		associate: 'सहयोगी',
		'senior-associate': 'वरिष्ठ सहयोगी',
		'vice-president': 'उपाध्यक्ष',
		'senior-vice-president': 'वरिष्ठ उपाध्यक्ष',
		'about-the-role': 'भूमिका के बारे में',
		'mid-level-manager': 'मध्यम स्तर का प्रबंधक',
		create: 'बनाएं',
		'solve-three-steps':
			'हम देखना चाहते हैं कि आप इस कार्यक्रम के लिए उपयुक्त हैं या नहीं। हम आपको एक चुनौती देंगे और इसे तीन चरणों में हल करने के लिए कहेंगे।',
		'important-instructions': 'महत्वपूर्ण निर्देश',
		instructions:
			"चार कंटेनर हैं जिनमें आपसे 'समस्या की पहचान करें', 'महत्वपूर्ण जानकारी एकत्र करें' (आप टेक्स्ट को खींचकर छोड़ सकते हैं), 'विकल्प उत्पन्न करें (तीन तक विचार सोचें)', और 'समाधान की सिफारिश करें' कहा जाएगा। आप बुलेट पॉइंट्स या पूर्ण वाक्यों का उपयोग कर सकते हैं — यह आपकी पसंद है! हम आपके निर्णय लेने की प्रक्रिया और समस्या सुलझाने के कौशल को माप रहे हैं।",
		'confirmation-message':
			'इस स्क्रीन के ठीक बाद एक पुष्टिकरण संदेश पॉप अप होगा, इससे पहले कि आप शुरू करें। आपके पास चुनौती को पूरा करने के लिए 20 मिनट होंगे। शुभकामनाएं!',
		'start-test': 'परीक्षण शुरू करें',
		instruction: 'निर्देश',
		'customize-your-assessment': 'अपना मूल्यांकन कस्टमाइज़ करें',
		'control-assessment': 'अपनी सामग्री जोड़कर मूल्यांकन को नियंत्रित करें',
		'assessment-name': 'मूल्यांकन का नाम',
		'assessment-description': 'मूल्यांकन का विवरण',
		'input-timer': 'इनपुट टाइमर',
		'upload-image-challenge': 'चुनौती के लिए चित्र अपलोड करें',
		'plain-text': 'सादा पाठ',
		'audio-link': 'ऑडियो लिंक',
		'video-link': 'वीडियो लिंक',
		'image-link': 'इमेज लिंक',
		'add-card': 'कार्ड जोड़ें',
		'thank-you': 'धन्यवाद',
		'challenge-submission': 'बस हो गया! हमें आपकी चुनौती सबमिशन प्राप्त हो गई है।',
		'feedback-your-assessment':
			'यदि आप अपने मूल्यांकन पर फीडबैक प्राप्त करना चाहते हैं, तो कृपया नीचे अपना ईमेल पता दर्ज करें।',
		'your-voice':
			'हमें आपकी आवाज़ चाहिए! अपने करियर की शुरुआत करने वाले किसी व्यक्ति को आप क्या सलाह देंगे?',
		save: 'सहेजें',
		saving: 'सहेजा जा रहा है...',
		saved: 'सहेज लिया गया!',
		success_time_feedback: 'सफलता! हम आपके समय और फीडबैक की सराहना करते हैं।',
		'supposed-to-do': 'मुझे क्या करना है?',
		'supposed-to-do-answer':
			'Nugget.ai चुनौती में, आपसे उस भूमिका को निभाने के लिए कहा गया है जो चुनौती विवरण में बताई गई है। इस भूमिका को निभाते समय, हम चाहते हैं कि आप सोचें जैसे आप उस भूमिका में हैं, आप क्या करेंगे, कौन सी जानकारी पर विचार करेंगे, और क्या सिफारिश करेंगे जैसे आप वास्तव में उस भूमिका में काम कर रहे हों।',
		'what-challenge': 'चुनौती क्या है?',
		'what-challenge-answer':
			'चुनौती एक विवरण है जिसमें वह भूमिका शामिल होती है जिसे आपको निभाना है और वह संदर्भ जिसमें सब कुछ घट रहा है। सबसे महत्वपूर्ण बात यह है कि चुनौती आपके मिशन को स्पष्ट करती है – अर्थात वह समस्या जिसे आपको हल करना है।',
		'retake-challenge': 'क्या मैं चुनौती को दोबारा ले सकता/सकती हूँ?',
		'retake-challenge-answer':
			'नहीं, एक बार चुनौती पूरी कर लेने के बाद उसे दोबारा लेने का कोई अवसर नहीं होता। इसीलिए, हम आपसे अनुरोध करते हैं कि पहली बार में ही खुद को चुनौती की भूमिका में पूरी तरह कल्पना करें और उसी प्रक्रिया का पालन करें जैसा आप असल जीवन में इस समस्या को हल करने के लिए करते।',
		'purpose-whole-activity': 'इस पूरी गतिविधि का उद्देश्य क्या है?',
		'purpose-whole-activity-answer':
			'इस गतिविधि का उद्देश्य यह समझना है — एक त्वरित झलक — कि यदि आप नौकरी पर होते और उस नौकरी से संबंधित कोई सामान्य कार्य कर रहे होते, तो वह कैसा लगता।',
		'challenge-problem':
			'क्या यह चुनौती किसी वास्तविक घटना/स्थिति/समस्या/कंपनी पर आधारित है?',
		'challenge-problem-answer':
			'Nugget.ai चुनौतियाँ किसी वास्तविक घटना, समस्या, और/या कंपनी पर आधारित नहीं होतीं। किसी भी वास्तविक कंपनी या स्थिति से समानता मात्र संयोग है।',
		'content-information': 'मुझे किस प्रकार की सामग्री/जानकारी शामिल करनी चाहिए?',
		'content-information-answer':
			'सामग्री या जानकारी की मात्रा या प्रकार के संदर्भ में कोई निर्धारित सही तरीका नहीं है। बस यह सोचें कि यदि आप वास्तव में इस भूमिका में होते, तो आप किन जानकारियों पर ध्यान केंद्रित करते।',
		'what-resources': 'संसाधन क्या हैं?',
		'what-resources-answer':
			'संसाधन उन वास्तविक चीज़ों के उदाहरण हैं जिनका उपयोग लोग नौकरी करते समय करते हैं जब वे उसी प्रकार का काम कर रहे होते हैं जैसा चुनौती में बताया गया है। ये संसाधन कई प्रकार की सामग्री हो सकते हैं और विभिन्न स्वरूपों में हो सकते हैं — इसका उद्देश्य उस जानकारी और फॉर्मेट को सिमुलेट करना है जो नौकरी पर देखी जाती है। हम इन संसाधनों के अलावा अतिरिक्त जानकारी प्रदान नहीं करते — जो उपलब्ध है, वही है।',
		'what-i-do-resources': 'मुझे संसाधनों के साथ क्या करना है?',
		'what-i-do-resources-answer':
			'बिल्कुल वैसे ही जैसे नौकरी में होता है, आप इन संसाधनों की जानकारी का जितना चाहें उपयोग कर सकते हैं — पूरा या कुछ हिस्सा — जिससे आप चुनौती को पूरा कर सकें। आप जानकारी पढ़ सकते हैं और कुछ हिस्सों को ड्रैग-एंड-ड्रॉप करके चुनौती कार्यक्षेत्र में ला सकते हैं।',
		'do-use-resources': 'क्या मुझे सभी संसाधनों का उपयोग करना ज़रूरी है?',
		'do-use-resources-answer':
			'ज़रूरी नहीं है। आप चाहें तो सभी संसाधनों का उपयोग कर सकते हैं, या फिर केवल कुछ चुनिंदा हिस्सों का। लोग अलग-अलग कारणों से अलग दृष्टिकोण अपनाते हैं। फिर से कहें तो, बस यह सोचें कि यदि आप इस भूमिका में काम कर रहे कर्मचारी होते, तो क्या करते।',
		'inform-outside-resources':
			'क्या मैं संसाधनों के बाहर की जानकारी का उपयोग कर सकता/सकती हूँ?',
		'inform-outside-resources-answer':
			'हम आपसे अनुरोध करते हैं कि आप अपनी चुनौती की प्रतिक्रियाओं को केवल दिए गए संसाधनों की जानकारी के आधार पर दें। आप अपनी पहले से अर्जित जानकारी का उपयोग कर सकते हैं, जब तक आप कोई विशेष दस्तावेज़, लेख, पढ़ाई की सामग्री या अन्य स्रोत नहीं खोलते। यदि यह संदेह होता है कि आपने दिए गए संसाधनों के अलावा बाहरी जानकारी का उपयोग किया है, तो आपकी प्रतिक्रिया को आवेदन प्रक्रिया से बाहर किया जा सकता है।',
		'identify-problem': '“समस्या की पहचान करें” में मुझे क्या करना होता है?',
		'identify-problem-answer':
			'इस खंड में, आप उस मूल समस्या की पहचान और चर्चा कर सकते हैं जिसे आपको अपनी चुनौती के मिशन के तहत हल करना है।',
		'collect-information': 'जानकारी इकट्ठा करें',
		'collect-information-answer':
			'इस खंड में, आप दिए गए संसाधनों से जानकारी के टुकड़े खींच सकते हैं और उन्हें संग्रहित कर सकते हैं।',
		'engender-ideas': '“विचार उत्पन्न करें” में मुझे क्या करना होता है?',
		'engender-ideas-answer':
			'इस खंड में, आप विभिन्न विकल्पों/दिशाओं/दृष्टिकोणों पर चर्चा कर सकते हैं जिन्हें आप विचार कर रहे हैं।',
		'recommend-solution': '“समाधान सुझाएँ” में मुझे क्या करना होता है?',
		'recommend-solution-answer':
			'इस खंड में, आप एक अंतिम समाधान/उत्पाद/सेवा प्रस्तुत कर सकते हैं और उस पर चर्चा कर सकते हैं जो आपको चुनौती को पूरा करने में मदद करता है।',
		'complete-all-sections': 'क्या मुझे सभी खंड भरने ज़रूरी हैं?',
		'complete-all-sections-answer':
			'ज़रूरी नहीं है। याद रखें, उद्देश्य यह है कि आप उस भूमिका में कार्यरत कर्मचारी की तरह व्यवहार करें। यदि कुछ खंड आपको कम प्रासंगिक लगते हैं, तो उन्हें भरना अनिवार्य नहीं है।',
		'format-responses': 'मुझे अपनी प्रतिक्रियाओं का स्वरूप कैसा रखना चाहिए?',
		'format-responses-answer':
			'प्रतिक्रियाओं को स्वरूपित करने का कोई सही या गलत तरीका नहीं है। यह सोचें कि यदि आप वास्तव में इस भूमिका में काम कर रहे होते और किसी प्रबंधक को अपनी प्रतिक्रिया प्रस्तुत कर रहे होते, तो आप उसे कैसे प्रस्तुत करते।',
		'complete-challenge-time': 'अगर मैं समय पर चुनौती पूरी नहीं कर पाया/पाई तो क्या होगा?',
		'complete-challenge-time-answer':
			'कोई बात नहीं! टाइमर का उद्देश्य सिर्फ यह है कि सभी प्रतिभागियों के लिए प्रक्रिया समान रहे, लेकिन यह आवश्यक नहीं कि आपकी प्रतिक्रियाएं इसलिए खारिज कर दी जाएं क्योंकि आपने समय सीमा के भीतर कार्य पूरा नहीं किया। हम फिर भी आपकी प्रस्तुत प्रतिक्रियाओं का विश्लेषण करते हैं और उन्हीं के आधार पर परिणाम प्रदान करते हैं।',
		'browser-continue-later':
			'क्या मैं ब्राउज़र बंद करके बाद में चुनौती जारी रख सकता/सकती हूँ?',
		'browser-continue-later-answer':
			'नहीं, आपसे अनुरोध है कि आप चुनौती को एक ही बार में पूरा करें।',
		'interface-accommodations':
			'अगर मुझे अधिक समय या इंटरफेस में किसी विशेष सहायता की आवश्यकता हो तो क्या होगा?',
		'interface-accommodations-answer':
			'आपके समय को बढ़ाने के लिए कोई बिल्ट-इन सुविधा नहीं है। इसलिए, हम आपसे अनुरोध करते हैं कि आप चुनौती को पूरा करते समय समय पर नज़र रखें। फिर भी, यदि आप ऐसे व्यक्ति हैं जिन्हें समय-संबंधी या अन्य इंटरफेस सहायता की आवश्यकता है, तो कृपया उस संपर्क व्यक्ति से संपर्क करें जिसने आपको यह चुनौती लिंक भेजा है। वह व्यक्ति फिर हमसे संपर्क करेगा ताकि हम आवश्यक समायोजन पर चर्चा कर सकें।',

		'activity-chances-job':
			'इस गतिविधि में मेरे प्रदर्शन का नौकरी पाने की संभावना पर क्या असर होगा?',
		'activity-chances-job-answer':
			'यह चुनौती हायरिंग प्रक्रिया में एक स्वतंत्र उपाय के रूप में या कई उपायों में से एक के रूप में उपयोग की जा सकती है। हालाँकि हम अपने ग्राहकों को दिशानिर्देश प्रदान कर सकते हैं, हम इस बात पर नियंत्रण नहीं रखते कि संगठन परिणामों का उपयोग अपनी हायरिंग निर्णयों के लिए कैसे करते हैं। इसलिए, इस विषय से जुड़े किसी भी प्रश्न के लिए कृपया उस संपर्क व्यक्ति से संपर्क करें जिसने आपको यह चुनौती लिंक भेजा है।',

		'wild-card': 'वाइल्ड कार्ड',
		'wild-card-header-description':
			'आपको नई जानकारी प्रस्तुत की जा रही है और आपको अपनी कार्रवाई का निर्णय लेना है।',

		'consulting-card-header-description':
			'आपको किसी पुराने ग्राहक की मिस्ड कॉल दिखती है। तुरंत बाद, आप देखते हैं कि वे फिर से कॉल कर रहे हैं। आप निर्णय लेते हैं:',

		'certifier-card-header-description':
			'इनकमिंग ईमेल: “नमस्ते, मैं उस प्रयोगशाला तकनीशियन हूं जिसे प्रोजेक्ट #45667 में इलेक्ट्रिक व्हीकल चार्जिंग कंपोनेंट के लिए नियुक्त किया गया है। मैं पुष्टि करना चाहता हूं कि आपको टेस्ट रिपोर्ट मिल गई है और यह पूछना चाहता हूं कि क्या आपको उत्पाद के बारे में और जानकारी की आवश्यकता है। कृपया मुझे बताएं, मैं खुशी से मदद करूंगा।” आप क्या करना चाहेंगे?',

		'you-just-noticed':
			'आपने अभी एक ग्राहक की मिस्ड कॉल देखी है। तुरंत बाद, आप देखते हैं कि वे फिर से कॉल कर रहे हैं…',

		'dont-pick': 'कॉल न उठाएं',
		'take-the-call': 'कॉल उठाएं क्योंकि इसमें उपयोगी जानकारी हो सकती है।',
		'take-the-call-later':
			'कॉल उठाएं और बाद के लिए मीटिंग तय करें ताकि काम आगे बढ़ाया जा सके।',
		'nothing-for-you': 'यहाँ आपके लिए कुछ नहीं है। आपके पास काम है – आगे बढ़ें।',
		'the-client-tells-you-06':
			'ग्राहक आपको बताते हैं कि उन्हें उस उत्पाद के साथ गंभीर समस्या हो रही है जिसे आपने एक पूर्व परियोजना में विकसित करने में मदद की थी। आप फोन पर ही रहते हैं और उन्हें समस्या सुलझाने में मदद करते हैं।',
		'the-client-tells-you-1-30':
			'ग्राहक आपको बताते हैं कि उन्हें उस उत्पाद के साथ गंभीर समस्या हो रही है जिसे आपने एक पूर्व परियोजना में विकसित करने में मदद की थी। आप इस विषय पर चर्चा के लिए एक और बैठक निर्धारित करते हैं।',

		'time-desc': 'चुनौती से घटाए गए मिनट',

		'consult-card-desc-1': 'कॉल को एक बार फिर वॉइसमेल पर जाने दें',
		'consult-card-desc-2':
			'कॉल उठाएं। एक पूर्व ग्राहक आपको बताता है कि उन्हें उस उत्पाद के साथ गंभीर समस्या हो रही है जिसे आपने एक पूर्व परियोजना में विकसित करने में मदद की थी। आप फोन पर ही रहते हैं और उन्हें समस्या सुलझाने में मदद करते हैं।',
		'consult-card-desc-3':
			'कॉल उठाएं। एक पूर्व ग्राहक आपको बताता है कि उन्हें उस उत्पाद के साथ गंभीर समस्या हो रही है जिसे आपने एक पूर्व परियोजना में विकसित करने में मदद की थी। आप इस विषय पर चर्चा के लिए एक और बैठक निर्धारित करते हैं।',

		'why-software-development': 'सॉफ्टवेयर विकास परियोजनाएं क्यों असफल होती हैं',
		'own-your-personal-space': 'अपने व्यक्तिगत स्थान के मालिक बनें',
		'already-have-an-account': 'क्या आपके पास पहले से एक खाता है?',
		'employer-login': 'नियोक्ता लॉगिन',
		'post-have-an-account': 'कोई खाता नहीं है?',
		register: 'रजिस्टर करें',
		'export-to-csv': 'CSV में निर्यात करें',
		type: 'प्रकार',
		'l-type': 'प्रकार',
		data: 'डेटा',
		'select-pipeline': 'पाइपलाइन चुनें',
		rank: 'रैंक',
		'characteristic-reflects':
			'यह विशेषता यह दर्शाती है कि आप कितनी जल्दी काम शुरू करते हैं और अपने कार्य को संशोधित करते हैं। चुनौती लेने वालों ने जैसे ही ईमेल खोला और लेख पढ़ा, तुरंत लिखना शुरू किया और फिर उसमें बदलाव करते रहे – इस तरह वे गति और विचारशीलता में उच्च अंक प्राप्त कर पाए।',
		'characteristic-reflects_example':
			'एक उदाहरण जब यह विशेषता लाभदायक होगी: जब आपके पास एक तात्कालिक कार्य हो जिसे तुरंत निपटाना हो।',

		'characteristic-reflects-two':
			'यह विशेषता यह दर्शाती है कि आप कैसे सोचते हैं और पहले से योजना बनाते हैं, अपने विचारों को प्रभावी ढंग से संरचित करने पर ध्यान केंद्रित करते हैं। ईमेल थ्रेड और लेख को पढ़ने के बाद ही उत्तर लिखना शुरू करना योजना और संगठन में उच्च अंक प्राप्त करने का एक तरीका है।',
		'characteristic-reflects-two-example':
			'एक उदाहरण जब यह विशेषता लाभदायक होगी: जब आपके पास ऐसा महत्वपूर्ण कार्य हो जो लगभग पूर्णता की मांग करता हो।',

		'characteristic-reflects-three':
			'यह विशेषता यह दर्शाती है कि आप अपने काम में कितना विवरण शामिल करते हैं और इसका उपयोग आत्मविश्वास प्रदर्शित करने में कैसे करते हैं। ग्राहक की जरूरतों को ईमेल थ्रेड से लेना और उन्हें उत्तर में दृढ़ता से दोहराना – इसी तरह से चुनौती लेने वालों ने विस्तार और आत्मविश्वास में अच्छा प्रदर्शन किया।',
		'characteristic-reflects-three-example':
			'एक उदाहरण जब यह विशेषता लाभदायक होगी: जब आपको अपने विचारों से किसी को प्रभावित करने के लिए अपने ज्ञान का उपयोग करना हो।',

		'characteristic-reflects-four':
			'यह विशेषता यह दर्शाती है कि आप अपने विचारों को सही ढंग से व्यक्त करने और उद्देश्य बनाए रखने में कितनी सावधानी बरतते हैं। भाषा का सावधानीपूर्वक उपयोग और तटस्थ स्वर बनाए रखना – इसी तरह से चुनौती लेने वालों ने निष्पक्षता और सावधानी में उच्च स्कोर प्राप्त किया।',
		'characteristic-reflects-four-example':
			'एक उदाहरण जब यह विशेषता लाभदायक होगी: जब कार्य में आपकी निष्पक्षता और पेशेवर रवैये को प्रदर्शित करना आवश्यक हो।',

		'characteristic-reflects-five':
			'यह विशेषता यह दर्शाती है कि आप अपने विचारों को कितनी स्पष्टता से व्यक्त करते हैं और उन्हें तार्किक रूप से कैसे जोड़ते हैं। यह सुनिश्चित करने में समय लगाना कि प्रस्तुत विचार एक-दूसरे से तार्किक रूप से जुड़े हों और उचित ट्रांज़िशन शब्दों का प्रयोग किया गया हो – इसी तरह चुनौती लेने वालों ने स्पष्टता और तर्कशक्ति में अच्छा किया।',
		'characteristic-reflects-five-example':
			'एक उदाहरण जब यह विशेषता लाभदायक होगी: जब कार्य में आपको स्थिति और उसके पीछे की सोच को स्पष्ट और तार्किक रूप से प्रस्तुत करना हो।',

		'alert-dialog':
			'Google को ऐप्स की लोकेशन निर्धारित करने में मदद करने दें। इसका मतलब है कि Google को गुमनाम लोकेशन डेटा भेजना, भले ही कोई ऐप्स सक्रिय न हों।',
		disagree: 'असहमत',
		agree: 'सहमत',
		'talent-relationships': 'प्रतिभा संबंध',
		'talent-relationships-subtitle':
			'अपने टैलेंट पूल के बीच छिपे हुए संबंधों का पता लगाएं। किसी कौशल को अक्ष पर खींचें और देखें कि आपकी प्रतिभा की तुलना कैसे होती है।',
		'talent-funnel-title': 'टैलेंट फ़नल',
		'talent-funnel-subtitle':
			'चुनौती पर रैंक किए गए अपने प्रतिभागियों की खोज करें। परिणाम देखने के लिए एक श्रेणी चुनें।',
		'team-dynamic-title': 'टीम डायनामिक',
		'team-dynamic-subtitle':
			'अन्य पाइपलाइनों से व्यक्तियों को शामिल करके अपनी टीम के प्रदर्शन को बेहतर बनाएं। प्रदर्शन को बेहतर बनाने के लिए मिलाएं और मिलान करें।',
		'almost-there': 'लगभग पहुँच गए हैं',
		'users-pipeline':
			'परिणाम तभी दिखाई देंगे जब किसी पाइपलाइन में कम से कम 50 उपयोगकर्ता होंगे।',
		'copied-invite': 'आमंत्रण लिंक सफलतापूर्वक कॉपी किया गया',
		'about-one':
			'Nugget.ai चुनौती के साथ, आपको एक विशिष्ट नौकरी की भूमिका निभाने और यह दिखाने के लिए कहा गया था कि आप कैसे सोचते हैं, क्या करते हैं, किस जानकारी पर विचार करते हैं, और उस भूमिका में चुनौती पूरी करते समय आप क्या सिफारिश करते। जैसे ही आपने चुनौती का पेज खोला, हम आपके संसाधनों के साथ बातचीत करने और चुनौती को पूरा करने के तरीके के विभिन्न पहलुओं को ट्रैक करते हैं – जिससे हमें यह समझने में मदद मिल सके कि आप कार्य संदर्भ में अपनी समस्या-समाधान और संचार कौशल को कैसे प्रदर्शित करते हैं। फिर हमने इन पहलुओं का विश्लेषण किया ताकि यह पता लगाया जा सके कि कौन से पैटर्न उभर कर आए। इस पृष्ठ पर दिए गए परिणाम उन्हीं पैटर्न को दर्शाते हैं, और यह भी कि आपने इस चुनौती को लेने वाले अन्य लोगों की तुलना में कैसा प्रदर्शन किया।',
		'about-two':
			'आपके स्कोर उन सभी उपयोगकर्ताओं के स्कोर के पास पिन किए गए हैं जिन्होंने यह चुनौती ली थी। हम उपयोगकर्ता प्रदर्शन का विश्लेषण करने का एक अनूठा तरीका बना रहे हैं, जो उद्योग और बाजार से लेकर कंपनी और टीम तक के विभिन्न बेंचमार्क से तुलना करता है। विभिन्न बेंचमार्क प्रतिभा की विविधता को दर्शाते हुए अलग-अलग तरह से व्यवहार करते हैं।',
		'about-three':
			'अगर आपका स्कोर बेंचमार्क से कम है, तो इसका यह मतलब नहीं है कि आप बाकी सभी से कमजोर हैं – प्रत्येक कंपनी को विशेषताओं के विभिन्न संयोजन चाहिए होते हैं।',
		'about-four':
			'हमारा उद्देश्य आपको आपकी सॉफ्ट स्किल्स से जुड़ी जानकारी खोजने में मदद करना है, जो यह जानने में सहायता करती है कि कौन से करियर पथ वर्तमान में आपकी सोच, संचार और समस्या-समाधान के तरीके के साथ मेल खाते हैं। इन परिणामों का अन्वेषण करके उन करियर पथों की खोज करें जिन पर आपने शायद पहले कभी विचार नहीं किया हो – जो आपके लिए उपयुक्त हो सकते हैं।',
		'account-details': 'खाता विवरण',
		'success-redirect':
			'सफलतापूर्वक सहेजा गया। अब आपको nugget.ai पर पुनः निर्देशित किया जा रहा है।',
		'usecase-one':
			"GE Appliances ने अपने वाई-फाई कनेक्टेड होम अप्लायंसेज़ में अपडेट की घोषणा की है, जो अब सीधे Google Assistant के साथ काम करते हैं – यह गूगल का वॉयस असिस्टेंट है। लोग अब कह सकते हैं, 'हे Google, ओवन को 425 डिग्री पर प्रीहीट करें', या पूछ सकते हैं, 'हे Google, क्या मेरे बर्तन साफ़ हैं?'",
		'usecase-two':
			"Google Assistant से सीधा कनेक्शन अब GE Appliances को उपयोग करने में और भी आसान बनाता है। पहले उपयोगकर्ताओं को Geneva Home Action के ज़रिए आदेश देना होता था, जैसे 'हे Google, Geneva Home से कहो कि ओवन को 425 डिग्री पर प्रीहीट करे।'",
		'usecase-three':
			'यह बदलाव GE Appliances के कनेक्टेड रेफ्रिजरेटर, ओवन, डिशवॉशर और वॉशिंग मशीन सहित अन्य उपकरणों के साथ काम करता है, जो सभी U+ Connect ऐप से जुड़े हैं।',
		'usecase-four':
			"GE Appliances का Google Assistant के साथ गहरा एकीकरण ऐसे समय में आया है जब गूगल और अमेज़न स्मार्ट होम सर्विसेज की बाजार में बढ़त के लिए प्रतिस्पर्धा कर रहे हैं। डिजिटल असिस्टेंट से सीधा जुड़ाव GE उपकरणों को Alexa की तुलना में थोड़ा आसान बना सकता है। अमेज़न और GE ने 2016 में Alexa के लिए Geneva स्किल पेश किया था, जिसमें उपयोगकर्ताओं को आदेश देने के लिए अतिरिक्त चरण अपनाने पड़ते थे, जैसे 'Alexa, Geneva से कहो कि ओवन को 350 डिग्री पर प्रीहीट करे।'",
		'usecase-five':
			'GE Appliances की यह घोषणा ऐसे समय में आई है जब Electrolux – एक स्वीडिश घरेलू उपकरण निर्माता – भी Google Assistant के साथ अपने स्मार्ट किचन उत्पादों को एकीकृत करना शुरू कर रहा है। Electrolux ने घोषणा की है कि यह वॉइस इंटीग्रेशन अगले साल स्मार्ट ओवन से शुरू होगा।',
		'usecase-six':
			'डिजिटल असिस्टेंट और स्मार्ट स्पीकर का बाज़ार लगातार बढ़ रहा है। वॉयस-पावर्ड स्मार्ट स्पीकर्स की वैश्विक शिपमेंट में 2018 की पहली तिमाही में 278% की वृद्धि हुई और यह 9.2 मिलियन यूनिट तक पहुंच गई। हालांकि अमेज़न ने इस दौरान 4 मिलियन यूनिट भेजे, लेकिन इसकी बाजार हिस्सेदारी घटकर 43.6% हो गई जो कि पिछले साल 81.8% थी। International Data Corporation का अनुमान है कि स्मार्ट स्पीकर्स, डिजिटल मीडिया अडैप्टर्स, लाइटिंग, थर्मोस्टैट्स और GE जैसे कनेक्टेड उपकरणों सहित स्मार्ट होम डिवाइसेज़ का वैश्विक बाज़ार इस साल 26.8% की दर से बढ़कर 549.5 मिलियन यूनिट तक पहुँच सकता है।',
		note:
			'नोट: ये संसाधन वे दस्तावेज़ हैं जो सभी मीटिंग प्रतिभागियों को पहले से प्रदान किए जाते हैं। इन संसाधनों के माध्यम से, प्रतिभागियों को लेबल की सूची से किसी एक गाने के बोल प्रस्तुत किए जाते हैं। बोलों के अलावा, गाने के सामान्य तत्वों की पहचान की जाती है। साथ ही, गाने के विशिष्ट तत्वों की भी पहचान की जाती है — ये जरूरी नहीं कि वे तत्व हों जिन्हें लेबल के कार्यकारी ढूंढ़ रहे हैं, लेकिन ये आपको यह समझने में मदद करेंगे कि योजना बनाते समय किन प्रकार की जानकारियों पर विचार करना चाहिए।',
		'song-title': 'गाने का शीर्षक',
		'true-colours': 'सच्चे रंग',
		unnamed: 'बिना नाम',
		instrumentals: 'वाद्य संगीत',
		'no-decription-provided': 'कोई विवरण उपलब्ध नहीं',
		'vocal-type': 'स्वर प्रकार',
		'single-vocal-male': 'एकल प्रमुख पुरुष स्वर',
		'theme-song': 'गाने की थीम',
		'love-relationships': 'प्यार और रिश्ते',
		'storyline-song': 'गाने की कहानी',
		'storyline-song-description':
			'गायक अपनी प्रेमिका से गहराई से जुड़ने और उसे जानने की इच्छा व्यक्त कर रहा है। कलात्मक रूप से, वह रंगों और कल्पनाओं का उपयोग करके अपनी भावना को संप्रेषित करता है।',
		insight: 'अंतर्दृष्टि',
		talent: 'प्रतिभा',
		'your-talent-pipelines': 'आपकी टैलेंट पाइपलाइंस',
		'add-challenge':
			'यहाँ अपनी चुनौती का उद्देश्य/विवरण जोड़ें। टीम के सभी सदस्य इसे देख सकेंगे!',
		'digital-team': 'कर्मचारी',
		send: 'भेजें',
		'terms-and-condition': '<EnDescription />',
		merger: 'विलय',
		'm-a': 'विलय और अधिग्रहण',
		teamwork: 'टीमवर्क',
		'consulting-description':
			'आप एक प्रबंधन सलाहकार हैं। आपका नया क्लाइंट एक उभरती हुई हेल्थकेयर टेक कंपनी है, जो दो नवोदित हेल्थकेयर टेक स्टार्टअप्स के विलय का परिणाम है। क्लाइंट ने आपकी कंसल्टिंग फर्म से संपर्क किया है क्योंकि विलय के दो महीने बाद कार्यकारी टीम को टीमवर्क से संबंधित समस्याएं दिखाई देने लगी हैं। कंपनी ने खुद से समस्याओं को सुलझाने का प्रयास किया है, लेकिन ज्यादा सुधार नहीं हुआ है। दिए गए संसाधनों का उपयोग करके समस्या की पहचान करें, मुख्य जानकारी एकत्र करें, और अपने नए क्लाइंट के लिए समाधान की सिफारिश करें।',
		acquisition: 'अधिग्रहण',
		'organize-culture': 'संगठनात्मक संस्कृति',
		'consulting-resource-1': 'कर्मचारी प्रतिक्रिया',
		'consulting-resource-2': 'विलय रणनीति',
		'consulting-resource-3': 'सहकर्मी से नया ईमेल',
		'send-email-again-text': 'अभी तक ईमेल नहीं मिला?',
		'send-email-again': 'पुनः भेजें',
		'create-new-password': 'नया पासवर्ड बनाएं',
		'create-new-password-info':
			'मजबूत पासवर्ड चुनें और उसे अन्य खातों के लिए पुनः उपयोग न करें। पासवर्ड बदलने से आप सभी डिवाइसों से साइन आउट हो जाएंगे। आपको अपना नया पासवर्ड पुनः दर्ज करना होगा।',
		'new-password': 'नया पासवर्ड',
		'change-your-password': 'अपना पासवर्ड बदलें',
		'current-password': 'वर्तमान पासवर्ड',
		'mail-sent': 'ईमेल सफलतापूर्वक भेजा गया',
		'error-mail-sent': 'ईमेल भेजने में त्रुटि हुई',
		'profile-update': 'आपकी प्रोफ़ाइल सफलतापूर्वक अपडेट की गई',
		'delete-confirmation': 'क्या आप वाकई अपना खाता हटाना चाहते हैं?',
		'current-password-incorrect': 'वर्तमान पासवर्ड गलत है',
		'password-change': 'पासवर्ड सफलतापूर्वक बदला गया',
		'accept-the': 'स्वीकार करें',
		'terms-conditions': 'नियम और शर्तें',
		training: 'प्रशिक्षण',
		'crisis-manage': 'कंपनी की कर्मचारी समस्याओं को हल करें',
		'crisis-description':
			'आप एक प्रबंधन सलाहकार हैं। आपका नया क्लाइंट एक बढ़ती हुई हेल्थकेयर टेक कंपनी है, जिसने अपनी ग्राहक सेवा कर्मचारियों को लेकर चिंता व्यक्त की है। पिछले एक वर्ष में, ग्राहक शिकायतों की संख्या दोगुनी हो गई है, और 39% ग्राहकों ने प्राप्त सेवा को असंतोषजनक बताया है। संगठन ने इन कर्मचारियों को अतिरिक्त प्रशिक्षण सत्र प्रदान किए हैं, लेकिन कोई सुधार नहीं देखा गया है। दिए गए संसाधनों के साथ समस्या की पहचान करें, मुख्य जानकारी एकत्र करें, और अपने नए क्लाइंट को समाधान सुझाएं।',
		'crisis-res-1': 'ग्राहक शिकायतें',
		'crisis-res-2': 'एजेंडा',
		'crisis-res-3': 'सहकर्मी से नया ईमेल',
		close: 'बंद करें',
		notifications: 'सूचनाएं',
		'caught-all': 'आपने सब कुछ देख लिया है!',
		'comment-taketest':
			'जैसे ही आप इस अध्याय को पूरा करते हैं, हम यह समझने के लिए कुछ वैरिएबल्स ट्रैक कर रहे हैं कि आप कार्य कैसे हल करते हैं। ऊपर टाइमर पर नज़र रखें और शुभकामनाएं!',
		'new-information': 'नई जानकारी उपलब्ध है।',
		now: 'अभी',
		chapters: 'अध्याय',
		'wildcard-name': 'वाइल्ड कार्ड: इनबाउंड फोन कॉल',
		'wildcard-notify': 'महत्वपूर्ण निर्णय हर समय लिए जाते हैं। आपको एक समझौता करना है।',
		'mins-ago': '{time} मिनट पहले',
		'min-ago': '1 मिनट पहले',
		'take-other-challnge': 'सैंडबॉक्स - कोई अन्य चुनौती लें',
		'preview-desc':
			'यहाँ आपको चुनौती का विवरण मिलेगा। इस विवरण में वह भूमिका शामिल है जो आपको निभानी है और वह संदर्भ जिसमें चुनौती हो रही है। सबसे महत्वपूर्ण बात यह है कि यह विवरण आपके मिशन के उद्देश्य को स्पष्ट करता है।',
		'preview-res1':
			'यहाँ आपको संसाधन 1 मिलेगा। संसाधन उन वास्तविक सामग्रियों के उदाहरण हैं जिन तक नौकरी पर काम करने वाले लोगों की पहुंच होती है। संसाधनों में विभिन्न प्रकार की सामग्री शामिल हो सकती है और इनका स्वरूप भी अलग-अलग हो सकता है – इनका उद्देश्य यह दिखाना है कि नौकरी पर काम करने वाले लोगों को किस तरह की जानकारी और प्रारूप देखने को मिलते हैं। हम इसमें दिए गए संसाधनों के अलावा अतिरिक्त जानकारी नहीं देते – जो है, वही है।',
		'preview-res2':
			'यहाँ आपको संसाधन 2 मिलेगा। संसाधन उन वास्तविक सामग्रियों के उदाहरण हैं जिन तक नौकरी पर काम करने वाले लोगों की पहुंच होती है। संसाधनों में विभिन्न प्रकार की सामग्री शामिल हो सकती है और इनका स्वरूप भी अलग-अलग हो सकता है – इनका उद्देश्य यह दिखाना है कि नौकरी पर काम करने वाले लोगों को किस तरह की जानकारी और प्रारूप देखने को मिलते हैं। हम इसमें दिए गए संसाधनों के अलावा अतिरिक्त जानकारी नहीं देते – जो है, वही है।',
		language: 'भाषा',
		english: 'अंग्रेज़ी',
		spanish: 'स्पैनिश',
		french: 'फ़्रेंच (जल्द आ रही है)',
		'you-will-be-redirected':
			'इस फॉर्म को सबमिट करने के बाद आपको सैंडबॉक्स पर पुनर्निर्देशित किया जाएगा।',
		'tell-us-about-the-function':
			'हमें उस कार्य के बारे में बताएं जिसमें आप वर्तमान में हैं। यदि आप आवेदन कर रहे हैं, तो उस भूमिका के बारे में सोचें जिसमें आप रहना चाहते हैं।',
		'tell-us-about-the-role':
			"हमें उस भूमिका स्तर के बारे में बताएं जिसमें आप वर्तमान में हैं। यदि आप वर्तमान में कार्यरत नहीं हैं, तो 'मैं तलाश में हूं' चुनें।",
		'success-copied': 'सफलतापूर्वक कॉपी किया गया',
		'looks-like-you':
			'लगता है कि आप वापस जाने की कोशिश कर रहे हैं। आपने पहले ही अपनी चुनौती सबमिट कर दी है और अब करने के लिए कुछ नहीं बचा है।',
		keywords: 'कीवर्ड',
		analytics: 'विश्लेषण',
		'create-account-info': 'परिणाम देखने के लिए एक खाता बनाएं या साइन इन करें।',
		'create-account-info-signin': 'परिणाम देखने के लिए साइन इन करें।',
		'create-account-info-signup': 'परिणाम देखने के लिए साइन अप करें।',
		'you-about-submit':
			'आप अपने परिणाम सबमिट करने वाले हैं, क्या आप वाकई ऐसा करना चाहते हैं?',
		'iam-searching': 'मैं नौकरी की तलाश में हूं',
		'keep-edit': 'संपादन जारी रखें',
		'assess-content':
			'यह मूल्यांकन केवल एक दिशा में होता है। एक बार जब आप किसी अनुभाग को पूरा कर लेते हैं तो आप वापस नहीं जा सकते।',
		'submit-sentence': 'क्या आप वाकई अपने परिणाम सबमिट करना चाहते हैं?',
		'verify-email-success': 'सत्यापन ईमेल सफलतापूर्वक भेज दिया गया है',
		'click-for-submission': 'सबमिशन के लिए क्लिक करें',
		'looks-like-you-not-150-words':
			'लगता है कि आपने अभी तक न्यूनतम 150 शब्दों की आवश्यकता को पूरा नहीं किया है।',
		'you-will-solve-a-problem':
			'आगामी पृष्ठों पर जो ऑनलाइन अनुभव आपका इंतजार कर रहा है, उसका उद्देश्य इस नौकरी डोमेन में भूमिका का परिदृश्य सेट करना है। आपकी प्रतिक्रियाओं के आधार पर, हम उन कौशलों को निकालेंगे जो नौकरी के संदर्भ में प्रासंगिक हैं। आपसे ऐसे परिदृश्यों का जवाब देने के लिए कहा जाएगा जो इस भूमिका में आमतौर पर सामने आ सकते हैं, मानो आप उस स्थिति से वास्तविक समय में निपट रहे हों। आपसे उम्मीद की जाएगी कि आप किरदार में रहें और संदेश लिखें, ईमेल तैयार करें, योजनाओं की रूपरेखा बनाएं, और अन्य नौकरी-संबंधी कार्य करें! आपसे कुछ तकनीकी प्रश्न भी पूछे जा सकते हैं जो विशेष रूप से इस भूमिका से संबंधित होंगे — कृपया पूरी कोशिश करें ताकि हम आपके लिए सटीक परिणाम प्रदान कर सकें।',
		'believe-there-is':
			'Nugget.ai में, हम लोगों के कौशल और क्षमताओं को मापने के लिए वास्तविक नौकरी की सिमुलेशन का उपयोग करते हैं, जो वास्तव में कार्य-संबंधी स्थितियों में प्रासंगिक होती हैं।',
		'if-challenge': 'यदि आप पहली बार यह चुनौती ले रहे हैं, ',
		'click-tutorial': 'तो ट्यूटोरियल देखने के लिए यहाँ क्लिक करें',
		first: ' पहले।',
		'to-prepare-you-for-the-challenge':
			'ट्यूटोरियल के बाद, आपके पास यह चुनौती पूरी करने के लिए ',
		min: 'मिनट',
		'to-complete': ' होंगे। आप यह कर सकते हैं!',
		'dont-take-this-one-your-phone': 'इस मूल्यांकन को अपने फ़ोन पर न लें',
		'minimum-words': 'न्यूनतम शब्द सीमा: ',
		'150-words': '150 शब्द',
		'you-have-hidden-talent-external':
			'आपके भीतर छुपी हुई प्रतिभाएं हैं, और हम उन्हें मापने में मदद करते हैं। हम यह कैसे तय करते हैं कि कौन-से अवसर आपको दिखाएं — इसकी प्रक्रिया उस समय शुरू होती है जब आपने चुनौती खोलना भी शुरू नहीं किया होता, और यह हमारे करियर-मैचिंग इंजन को बेहतर बनाने के समर्पण से संचालित होती है।',
		'you-have-hidden-talent-internal':
			'आपके भीतर छुपी हुई प्रतिभाएं हैं, और हम उन्हें मापने में मदद करते हैं। हम यह कैसे तय करते हैं कि कौन-से अवसर दिखाने हैं — यह प्रक्रिया हमारी उस मिशन से प्रेरित होती है जिसमें हम आपको अप/रीस्किलिंग के ज़रिए करियर के रास्तों को बेहतर तरीके से समझने में सहायता करते हैं।',
		linkedin_profile: 'LinkedIn प्रोफ़ाइल',
		'i-am-ready': 'मैं तैयार हूँ',
		'i-am-authorized':
			'मैं कनाडा में काम करने के लिए अधिकृत हूँ या 30 दिनों के भीतर प्राधिकरण प्राप्त कर सकता/सकती हूँ। यदि नहीं, तो बॉक्स को खाली छोड़ दें और हम आपको प्रायोजित करने वाली कंपनियों से जोड़ेंगे।',
		'add-a-skill': 'एक कौशल जोड़ें और एंटर दबाएं',
		'select-roles': 'वह भूमिकाएं चुनें जिनमें आपकी रुचि है',
		'add-a-role': 'एक भूमिका जोड़ें और एंटर दबाएं',
		'add-a-lang': 'एक भाषा जोड़ें और एंटर दबाएं',
		'add-a-jobtype': 'एक नौकरी प्रकार जोड़ें और एंटर दबाएं',
		'click-here-or-drag-drop':
			'अपलोड करने के लिए यहाँ क्लिक करें या फ़ाइल को खींचकर यहाँ छोड़ें',
		'this-step-is-optional':
			'यह चरण वैकल्पिक है, लेकिन हमारी अनुशंसा प्रणाली को आपको सर्वोत्तम अनुभव प्रदान करने में मदद करता है। आपकी जानकारी का उपयोग आपको मूल्यवान जानकारियाँ वापस देने के लिए किया जाता है।',
		'how-was-your-experience': 'आपका अनुभव कैसा रहा?',
		'question-title': 'क्षमता प्रश्नावली',
		'question-comment':
			'निम्नलिखित प्रश्नावली केवल अनुसंधान उद्देश्य के लिए है। कृपया नीचे दिए गए प्रश्नों का उत्तर यथासंभव ईमानदारी से दें। ध्यान दें कि इन प्रश्नों के आपके परिणामों पर कोई प्रभाव नहीं पड़ेगा और इन्हें नियोक्ताओं को नहीं दिखाया जाएगा। हालांकि, एक वैधता परीक्षण किया जाएगा: यदि आपकी चुनौती के प्रदर्शन और प्रश्नावली के उत्तरों के बीच बड़ा अंतर पाया गया, तो आपकी दोनों प्रतिक्रियाएं अमान्य घोषित की जा सकती हैं।',
		'very-bad': 'बहुत खराब',
		'very-good': 'बहुत अच्छा',
		'we-appreciate-feedback': 'हम आपकी प्रतिक्रिया की सराहना करते हैं!',
		internal: 'आंतरिक',
		external: 'बाहरी',
		'challenge-experience':
			'कर्मचारियों और उम्मीदवारों के लिए चुनौती का अनुभव प्रत्येक समूह के लिए अद्वितीय होगा।',
		'must-input-pipeline-name': 'आपको पाइपलाइन का नाम दर्ज करना होगा',
		// 'upload-resume': 'Upload resume. Click or drag/drop file here',
		'raw-results': 'टेक्स्ट',
		'product-certifier': 'उत्पाद सुरक्षा प्रमाणक चुनौती',
		'product-certifier-description':
			'आप एक उत्पाद सुरक्षा प्रमाणक हैं। आपका क्लाइंट एक शीर्ष इलेक्ट्रिक वाहनों का आपूर्तिकर्ता है, जो अपने इलेक्ट्रिक वाहन चार्जिंग स्टेशन पर CSA समूह की स्वीकृति मुहर चाहता है। दिए गए संसाधनों के आधार पर, यह जानने की कोशिश करें कि क्या चार्जिंग स्टेशन CSA समूह के मानकों को पूरा करता है।',
		'electric-car': 'इलेक्ट्रिक कार',
		energy: 'ऊर्जा',
		'lab-testing': 'प्रयोगशाला परीक्षण',
		certification: 'प्रमाणीकरण',
		timestamp: 'समय मुहर',
		wildCardOption: 'वाइल्डकार्ड विकल्प',
		'sliderpane-lock-tooltip':
			'आप इस फ़ीचर को अनलॉक नहीं कर सकते क्योंकि हमारे पास प्रत्येक भूमिका के लिए पर्याप्त डेटा नहीं है!',
		inspection: 'निरीक्षण',
		'client-communication': 'क्लाइंट संचार',
		certifier: 'प्रमाणक',
		inspector: 'निरीक्षक',
		'product-safety-certifier-challenge-1': 'उत्पाद सुरक्षा प्रमाणक चुनौती - भाग 1',
		'product-safety-certifier-description-1':
			'आप एक उत्पाद सुरक्षा प्रमाणक हैं। आपका क्लाइंट टोरंटो स्थित एक फुटवियर कंपनी है, जिसकी एक नई पुरुषों की सुरक्षा जूतों की मॉडल है, जिसे वे CSA समूह के मानकों के अनुसार परीक्षण और तुलना करवाना चाहते हैं। इस चुनौती के लिए, कृपया एक ईमेल लिखें जिसे क्लाइंट को भेजा जाएगा ताकि उन्हें परीक्षण के परिणामों की जानकारी दी जा सके।',
		'leadership-title': 'कार्यकारी नेतृत्व',
		'leadership-desc':
			'आप अपने संगठन में एक नेता हैं और एक सेल्स टीम के प्रभारी हैं। मासिक बैठकों में संगठन के प्रमुख सदस्य बोर्ड को प्रदर्शन की जानकारी देते हैं। इन बैठकों का उद्देश्य यह सुनिश्चित करना है कि सभी सदस्य मासिक और त्रैमासिक लक्ष्यों की दिशा में काम कर रहे हैं। संगठन सहयोग, विकास और एक-दूसरे एवं ग्राहकों के सम्मान पर केंद्रित है। यह संगठन आमतौर पर उद्योग में एक मजबूत प्रतियोगी होता है और उच्च प्रदर्शन करने वाले व्यक्तियों को रोजगार देता है। हालांकि, पिछले वर्ष में आपकी टीम कुछ समस्याओं का सामना कर रही है। आपसे कहा गया है कि आज की बोर्ड बैठक में प्रदर्शन को गिरने से रोकने के लिए कुछ सिफारिशें लेकर आएं। दिए गए संसाधनों का उपयोग करते हुए, आपको 25 मिनट में बोर्ड बैठक में प्रस्तुत करने के लिए सिफारिशें तैयार करनी होंगी।',
		leadership: 'नेतृत्व',
		'employee-conflicts': 'कर्मचारी संघर्ष',
		'managing-teams': 'टीम प्रबंधन',
		'executive-leadership': 'कार्यकारी नेतृत्व',
		'executive-leadership-res-1': 'टीम प्रदर्शन मूल्यांकन',
		'executive-leadership-res-2': 'मानव संसाधन शिकायत - कर्मचारी शिकायत फॉर्म',
		'executive-leadership-res-3': 'वैकल्पिक शिकायत - कर्मचारी शिकायत फॉर्म',
		'executive-leadership-res-6': 'ईमेल थ्रेड',
		'take-a-quick-look-at-all-the-skills-we-can-measure':
			'झटपट एक नजर डालें उन सभी कौशलों पर जिन्हें हम माप सकते हैं',
		'hospitality-title': 'अतिथि सेवा',
		'hospitality-desc':
			'आप वंडरफुल होटल्स में एक सेवा सहयोगी हैं। आज आप अपनी नियमित शिफ्ट पर आए हैं और इस चुनौती के दौरान, आपसे वे कार्य पूरे करने को कहे जाएंगे जो आमतौर पर नौकरी के एक सामान्य दिन में सामने आ सकते हैं। आप नीचे दिए गए कार्यों को पाएंगे।',
		'hospitality-res1': 'सहकर्मी ने जल्दी छुट्टी ली',
		'hospitality-res2': 'ग्राहक से टकराव',
		hospitality: 'अतिथि सेवा',
		service: 'सेवा',
		'linkedin-profile': 'लिंक्डइन प्रोफाइल',
		fullname: 'पूरा नाम',
		'analysis-data': 'डेटा का विश्लेषण करें',
		firstname: 'पहला नाम',
		lastname: 'अंतिम नाम',
		location: 'स्थान',
		'add-skills': 'कौशल जोड़ें',
		'add-role-interests': 'रुचिकर भूमिकाएँ जोड़ें',
		'add-job-type': 'नौकरी के प्रकार जोड़ें',
		'add-certication': 'प्रमाणपत्र जोड़ें',
		'add-industry': 'उद्योग जोड़ें',
		'add-other-experience': 'अन्य अनुभव जोड़ें',
		'other-experience': 'अन्य अनुभव',
		industry: 'उद्योग',
		'role-function': 'भूमिका कार्य',
		'role-level': 'भूमिका स्तर',
		'highest-edu-achieved': 'प्राप्त की गई सर्वोच्च शिक्षा',
		'year-profess-exp': 'पेशेवर अनुभव (वर्षों में)',
		status: 'नौकरी की स्थिति',
		resume: 'रिज़्यूमे',
		'upload-resume': 'रिज़्यूमे अपलोड करें',
		'add-new': 'नया जोड़ें',
		'edit-title': 'संपादित करें',
		'setup-profile': 'अपनी प्रोफ़ाइल सेट करें',
		logout: 'लॉग आउट',
		Announcements: 'घोषणाएँ',
		FAQ: 'सामान्य प्रश्न',
		Notifications: 'सूचनाएँ',
		roles: 'भूमिकाएँ',
		skills: 'कौशल',
		general: 'सामान्य',
		profile_image: 'प्रोफ़ाइल चित्र',
		'complete-challenge': 'चुनौती पूरी करें',
		'to-see-your-fit': ' अपनी उपयुक्तता देखने और नौकरी के अवसरों से जुड़ने के लिए।',
		'enough-data': 'आपको कोई उपयोगी जानकारी दिखाने के लिए पर्याप्त डेटा नहीं है।',
		'user-tab-stories': 'चुनौतियाँ',
		'user-tab-profile': 'प्रोफ़ाइल',
		'user-tab-Assessments': 'मूल्यांकन',
		'user-tab-coins': 'सिक्के',
		'other-category-view': 'कुछ और खोज रहे हैं?',
		'stories-sub-title': 'एक करियर पथ पर क्लिक करें और अन्वेषण करें',
		'test-sentence':
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
		consulting: 'परामर्श',
		marketing: 'विपणन',
		'career-fit': 'करियर उपयुक्तता',
		'score-strength': 'स्कोर की ताक़त',
		submission: 'सबमिशन',
		management: 'प्रबंधन',
		'click-domain': 'अपने परिणाम देखने के लिए किसी डोमेन पर क्लिक करें',
		'all-apply': 'सभी लागू विकल्प चुनें',
		'single-apply': 'एक विकल्प चुनें',
		'already-exist': 'पहले से खाता है? साइन इन करें',
		'dont-exist': 'खाता नहीं है? साइन अप करें',
		signin: 'साइन इन करें',
		singup: 'साइन अप करें',
		institutions: 'संस्थान का नाम',
		'add-new-group': 'नया समूह जोड़ें',
		'delete-group': 'समूह हटाएँ',
		jobtype: 'आप किस प्रकार की नौकरी की तलाश कर रहे हैं?',
		edu_type: 'शिक्षा',
		textarea_comment: 'टाइप करना शुरू करने के लिए यहाँ क्लिक करें',
		'all-sum-100': 'सभी मानों का योग 100% होना चाहिए। कृपया दोबारा जांचें',
		'benchmark-update': 'बेंचमार्क प्रोफ़ाइल सफलतापूर्वक अपडेट की गई',
		'create-profile': 'आज ही अपना प्रोफ़ाइल बनाएं!',
		'badge-unlock-message':
			'ऐसे विशेष कार्यों को पूरा करके बैज अनलॉक करें जो आपके करियर की उपलब्धियों को दर्शाते हैं। नियोक्ता ऐसे उम्मीदवारों को 10 गुना अधिक प्राथमिकता देते हैं जिनके पास बैज होते हैं',
		badges: 'बैज',
		'register-success': 'पंजीकरण सफल रहा!',
		'register-failure': 'पंजीकरण विफल रहा!',
		'enter-fullname': 'कृपया अपना पूरा नाम दर्ज करें',
		'enter-firstname': 'कृपया अपना पहला नाम दर्ज करें',
		'enter-lastname': 'कृपया अपना अंतिम नाम दर्ज करें',
		'enter-location': 'कृपया अपना स्थान दर्ज करें',
		'': 'कृपया एक मान्य LinkedIn प्रोफ़ाइल दर्ज करें',
		'use-point': 'अपने पॉइंट्स का उपयोग करने के तरीके जल्द ही आ रहे हैं!',
		'working-on':
			'इस बीच, हम आपको शीर्ष कंपनियों से जोड़ने के लिए कड़ी मेहनत कर रहे हैं। एक बार मेल हो जाने पर, आपको हमारी ओर से एक ईमेल प्राप्त होगा',
		'overall-fit': 'कुल मिलाकर उपयुक्तता',
		'setup-profile-desc':
			'हमारा सिस्टम आपकी प्रतिभाओं की खोज में आपकी मदद करने के लिए तैयार है ताकि आप अपनी असली क्षमताएं उजागर कर सकें। हमें अपने बारे में थोड़ी जानकारी दें, ताकि हम सही जगह से शुरुआत कर सकें।',
		'role-interests': 'रोल में रुचियाँ',
		languages: 'भाषाएँ',
		'we-are-glad': 'हमें खुशी है कि आप यहाँ हैं!',
		'sand-on-board-modal-content':
			'आपके पास छिपी हुई प्रतिभाएं हैं और Nugget उन्हें खोजने में आपकी मदद करेगा। अपने प्रोफ़ाइल को बनाकर शुरुआत करें और सैकड़ों चैलेंज में से चुनें ताकि आप अपनी SuperTalent की पहचान कर सकें।',
		'opt-check':
			'हमारी मेलिंग सूची में शामिल हों ताकि आपको हमारे नए कॉर्पोरेट पार्टनर्स, उत्पाद फ़ीचर्स और अपडेट्स की जानकारी सबसे पहले मिल सके।',
		'let-get-it': 'चलिए शुरू करते हैं!',
		'complement-fit': 'पूरक उपयुक्तता',
		'close-fit': 'निकट उपयुक्तता',
		'target-fit': 'लक्ष्य उपयुक्तता',
		'best-fit': 'सर्वश्रेष्ठ उपयुक्तता',
		'user-no-exist': 'उपयोगकर्ता मौजूद नहीं है',
		'create-password': 'पासवर्ड बनाएं',
		'pwd-reset-success':
			'एक ईमेल भेजा गया है। पासवर्ड रीसेट के निर्देशों के लिए अपना इनबॉक्स देखें।',
		'salary-range': 'वेतन सीमा'
	}
}
